import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  _text: any;
  bigint: any;
  date: any;
  json: any;
  jsonb: any;
  smallint: any;
  timestamp: any;
  timestamptz: any;
  timetz: any;
  uuid: any;
};

/** expression to compare columns of type Boolean. All fields are combined with logical 'AND'. */
export type Boolean_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Boolean']>;
  _gt?: InputMaybe<Scalars['Boolean']>;
  _gte?: InputMaybe<Scalars['Boolean']>;
  _in?: InputMaybe<Array<Scalars['Boolean']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['Boolean']>;
  _lte?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Scalars['Boolean']>;
  _nin?: InputMaybe<Array<Scalars['Boolean']>>;
};

export type FillCtmRoundQuestionsInput = {
  category?: InputMaybe<Scalars['uuid']>;
  count?: InputMaybe<Scalars['Int']>;
  for_used_status?: InputMaybe<Scalars['String']>;
  game_id?: InputMaybe<Scalars['uuid']>;
  keyword?: InputMaybe<Scalars['String']>;
  pointValue?: InputMaybe<Scalars['Int']>;
  questionTypeId?: InputMaybe<Scalars['Int']>;
  question_rating?: InputMaybe<Scalars['Int']>;
  subCategory?: InputMaybe<Scalars['uuid']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type FillCtmRoundQuestionsOutput = {
  __typename?: 'FillCtmRoundQuestionsOutput';
  _fill_ctm_round_search_wf?: Maybe<Scalars['String']>;
};

export type FillFinalRoundQuestionsOutput = {
  __typename?: 'FillFinalRoundQuestionsOutput';
  _fill_default_final_round_search_wf?: Maybe<Scalars['String']>;
};

export type FillRoundQuestionsByTypeInput = {
  category?: InputMaybe<Scalars['uuid']>;
  count?: InputMaybe<Scalars['Int']>;
  for_round_type?: InputMaybe<Scalars['String']>;
  keyword?: InputMaybe<Scalars['String']>;
  questionTypeId?: InputMaybe<Scalars['Int']>;
  question_rating?: InputMaybe<Scalars['Int']>;
  subCategory?: InputMaybe<Scalars['uuid']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type FillRoundQuestionsInput = {
  category?: InputMaybe<Scalars['uuid']>;
  count?: InputMaybe<Scalars['Int']>;
  keyword?: InputMaybe<Scalars['String']>;
  questionTypeId?: InputMaybe<Scalars['Int']>;
  question_rating?: InputMaybe<Scalars['Int']>;
  subCategory?: InputMaybe<Scalars['uuid']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type FillRoundQuestionsOutput = {
  __typename?: 'FillRoundQuestionsOutput';
  _fill_default_round_search_wf?: Maybe<Scalars['String']>;
};

/** expression to compare columns of type Float. All fields are combined with logical 'AND'. */
export type Float_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Float']>;
  _gt?: InputMaybe<Scalars['Float']>;
  _gte?: InputMaybe<Scalars['Float']>;
  _in?: InputMaybe<Array<Scalars['Float']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['Float']>;
  _lte?: InputMaybe<Scalars['Float']>;
  _neq?: InputMaybe<Scalars['Float']>;
  _nin?: InputMaybe<Array<Scalars['Float']>>;
};

export type GenCtmRound = {
  is_premade?: InputMaybe<Scalars['Boolean']>;
};

export type GenRound = {
  __typename?: 'GenRound';
  id: Scalars['uuid'];
  title?: Maybe<Scalars['String']>;
  type_name: Scalars['String'];
};

export type GenRoundId = {
  roundId?: InputMaybe<Scalars['String']>;
};

export type GenRoundOutput = {
  __typename?: 'GenRoundOutput';
  generatedRound: Scalars['uuid'];
};

export type GenRoundQuestions = {
  questions?: InputMaybe<Array<InputMaybe<QuestionsData>>>;
  roundId?: InputMaybe<Scalars['uuid']>;
};

export type GenRound_ = {
  roundTemplateId?: InputMaybe<Scalars['String']>;
  roundType?: InputMaybe<Scalars['String']>;
};

export type GenSRoundOutput = {
  __typename?: 'GenSRoundOutput';
  generatedRound: Scalars['uuid'];
};

export type GenWarfareRoundId = {
  gameId?: InputMaybe<Scalars['String']>;
  isWarfare?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  questionOrder?: InputMaybe<Scalars['Int']>;
  questionTypeId?: InputMaybe<Scalars['Int']>;
  roundId?: InputMaybe<Scalars['String']>;
};

/** expression to compare columns of type Int. All fields are combined with logical 'AND'. */
export type Int_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Int']>;
  _gt?: InputMaybe<Scalars['Int']>;
  _gte?: InputMaybe<Scalars['Int']>;
  _in?: InputMaybe<Array<Scalars['Int']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['Int']>;
  _lte?: InputMaybe<Scalars['Int']>;
  _neq?: InputMaybe<Scalars['Int']>;
  _nin?: InputMaybe<Array<Scalars['Int']>>;
};

export type QuestionsData = {
  answerTypeId?: InputMaybe<Scalars['Int']>;
  orderNumber?: InputMaybe<Scalars['Int']>;
  questionId?: InputMaybe<Scalars['String']>;
};

export type Response = {
  __typename?: 'Response';
  response?: Maybe<Scalars['Boolean']>;
};

export type SampleInput = {
  password: Scalars['String'];
  username: Scalars['String'];
};

export type SampleOutput = {
  __typename?: 'SampleOutput';
  accessToken: Scalars['String'];
};

/** expression to compare columns of type String. All fields are combined with logical 'AND'. */
export type String_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['String']>;
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  _nlike?: InputMaybe<Scalars['String']>;
  _nsimilar?: InputMaybe<Scalars['String']>;
  _similar?: InputMaybe<Scalars['String']>;
};

export type X = {
  __typename?: 'X';
  x?: Maybe<Scalars['uuid']>;
  y?: Maybe<Scalars['uuid']>;
};

export type Y = {
  __typename?: 'Y';
  id?: Maybe<Scalars['uuid']>;
  title?: Maybe<Scalars['uuid']>;
};

export type Z = {
  __typename?: 'Z';
  id?: Maybe<Scalars['uuid']>;
  title?: Maybe<Scalars['String']>;
};

export type _Generate_Bonus_Round_Args = {
  f_game_template_id?: InputMaybe<Scalars['String']>;
};

export type _Generate_Ctm_Round_Args = {
  f_game_template_id?: InputMaybe<Scalars['String']>;
};

export type _Generate_Default_Final_Round_Args = {
  f_game_template_id?: InputMaybe<Scalars['String']>;
};

export type _Generate_Default_Round_Args = {
  f_game_template_id?: InputMaybe<Scalars['String']>;
};

export type _Get_Random_Question_For_Round_Args = {
  vcategory_id?: InputMaybe<Scalars['uuid']>;
  vfor_round_type?: InputMaybe<Scalars['String']>;
  vfor_used_status?: InputMaybe<Scalars['String']>;
  vgame_id?: InputMaybe<Scalars['uuid']>;
  vgame_template_id?: InputMaybe<Scalars['String']>;
  vis_mature?: InputMaybe<Scalars['Boolean']>;
  vmarket_id?: InputMaybe<Scalars['String']>;
  vpoint_value?: InputMaybe<Scalars['Int']>;
  vquestion_bonus_id?: InputMaybe<Scalars['Int']>;
  vquestion_difficulty_id?: InputMaybe<Scalars['Int']>;
  vquestion_text?: InputMaybe<Scalars['String']>;
  vquestion_type_id?: InputMaybe<Scalars['Int']>;
  vquestion_type_short_name?: InputMaybe<Scalars['_text']>;
  vsub_category_id?: InputMaybe<Scalars['uuid']>;
  vtags?: InputMaybe<Scalars['_text']>;
};

/** columns and relationships of "answer_types" */
export type Answer_Types = {
  __typename?: 'answer_types';
  answer_type_id: Scalars['Int'];
  answer_type_name: Scalars['String'];
};

/** aggregated selection of "answer_types" */
export type Answer_Types_Aggregate = {
  __typename?: 'answer_types_aggregate';
  aggregate?: Maybe<Answer_Types_Aggregate_Fields>;
  nodes: Array<Answer_Types>;
};

/** aggregate fields of "answer_types" */
export type Answer_Types_Aggregate_Fields = {
  __typename?: 'answer_types_aggregate_fields';
  avg?: Maybe<Answer_Types_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Answer_Types_Max_Fields>;
  min?: Maybe<Answer_Types_Min_Fields>;
  stddev?: Maybe<Answer_Types_Stddev_Fields>;
  stddev_pop?: Maybe<Answer_Types_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Answer_Types_Stddev_Samp_Fields>;
  sum?: Maybe<Answer_Types_Sum_Fields>;
  var_pop?: Maybe<Answer_Types_Var_Pop_Fields>;
  var_samp?: Maybe<Answer_Types_Var_Samp_Fields>;
  variance?: Maybe<Answer_Types_Variance_Fields>;
};


/** aggregate fields of "answer_types" */
export type Answer_Types_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Answer_Types_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "answer_types" */
export type Answer_Types_Aggregate_Order_By = {
  avg?: InputMaybe<Answer_Types_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Answer_Types_Max_Order_By>;
  min?: InputMaybe<Answer_Types_Min_Order_By>;
  stddev?: InputMaybe<Answer_Types_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Answer_Types_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Answer_Types_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Answer_Types_Sum_Order_By>;
  var_pop?: InputMaybe<Answer_Types_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Answer_Types_Var_Samp_Order_By>;
  variance?: InputMaybe<Answer_Types_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "answer_types" */
export type Answer_Types_Arr_Rel_Insert_Input = {
  data: Array<Answer_Types_Insert_Input>;
  on_conflict?: InputMaybe<Answer_Types_On_Conflict>;
};

/** aggregate avg on columns */
export type Answer_Types_Avg_Fields = {
  __typename?: 'answer_types_avg_fields';
  answer_type_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "answer_types" */
export type Answer_Types_Avg_Order_By = {
  answer_type_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "answer_types". All fields are combined with a logical 'AND'. */
export type Answer_Types_Bool_Exp = {
  _and?: InputMaybe<Array<InputMaybe<Answer_Types_Bool_Exp>>>;
  _not?: InputMaybe<Answer_Types_Bool_Exp>;
  _or?: InputMaybe<Array<InputMaybe<Answer_Types_Bool_Exp>>>;
  answer_type_id?: InputMaybe<Int_Comparison_Exp>;
  answer_type_name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "answer_types" */
export enum Answer_Types_Constraint {
  /** unique or primary key constraint */
  AnswerTypesPkey = 'answer_types_pkey'
}

/** input type for incrementing integer column in table "answer_types" */
export type Answer_Types_Inc_Input = {
  answer_type_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "answer_types" */
export type Answer_Types_Insert_Input = {
  answer_type_id?: InputMaybe<Scalars['Int']>;
  answer_type_name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Answer_Types_Max_Fields = {
  __typename?: 'answer_types_max_fields';
  answer_type_id?: Maybe<Scalars['Int']>;
  answer_type_name?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "answer_types" */
export type Answer_Types_Max_Order_By = {
  answer_type_id?: InputMaybe<Order_By>;
  answer_type_name?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Answer_Types_Min_Fields = {
  __typename?: 'answer_types_min_fields';
  answer_type_id?: Maybe<Scalars['Int']>;
  answer_type_name?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "answer_types" */
export type Answer_Types_Min_Order_By = {
  answer_type_id?: InputMaybe<Order_By>;
  answer_type_name?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "answer_types" */
export type Answer_Types_Mutation_Response = {
  __typename?: 'answer_types_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Answer_Types>;
};

/** input type for inserting object relation for remote table "answer_types" */
export type Answer_Types_Obj_Rel_Insert_Input = {
  data: Answer_Types_Insert_Input;
  on_conflict?: InputMaybe<Answer_Types_On_Conflict>;
};

/** on conflict condition type for table "answer_types" */
export type Answer_Types_On_Conflict = {
  constraint: Answer_Types_Constraint;
  update_columns: Array<Answer_Types_Update_Column>;
  where?: InputMaybe<Answer_Types_Bool_Exp>;
};

/** ordering options when selecting data from "answer_types" */
export type Answer_Types_Order_By = {
  answer_type_id?: InputMaybe<Order_By>;
  answer_type_name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: "answer_types" */
export type Answer_Types_Pk_Columns_Input = {
  answer_type_id: Scalars['Int'];
};

/** select columns of table "answer_types" */
export enum Answer_Types_Select_Column {
  /** column name */
  AnswerTypeId = 'answer_type_id',
  /** column name */
  AnswerTypeName = 'answer_type_name'
}

/** input type for updating data in table "answer_types" */
export type Answer_Types_Set_Input = {
  answer_type_id?: InputMaybe<Scalars['Int']>;
  answer_type_name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Answer_Types_Stddev_Fields = {
  __typename?: 'answer_types_stddev_fields';
  answer_type_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "answer_types" */
export type Answer_Types_Stddev_Order_By = {
  answer_type_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Answer_Types_Stddev_Pop_Fields = {
  __typename?: 'answer_types_stddev_pop_fields';
  answer_type_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "answer_types" */
export type Answer_Types_Stddev_Pop_Order_By = {
  answer_type_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Answer_Types_Stddev_Samp_Fields = {
  __typename?: 'answer_types_stddev_samp_fields';
  answer_type_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "answer_types" */
export type Answer_Types_Stddev_Samp_Order_By = {
  answer_type_id?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Answer_Types_Sum_Fields = {
  __typename?: 'answer_types_sum_fields';
  answer_type_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "answer_types" */
export type Answer_Types_Sum_Order_By = {
  answer_type_id?: InputMaybe<Order_By>;
};

/** update columns of table "answer_types" */
export enum Answer_Types_Update_Column {
  /** column name */
  AnswerTypeId = 'answer_type_id',
  /** column name */
  AnswerTypeName = 'answer_type_name'
}

/** aggregate var_pop on columns */
export type Answer_Types_Var_Pop_Fields = {
  __typename?: 'answer_types_var_pop_fields';
  answer_type_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "answer_types" */
export type Answer_Types_Var_Pop_Order_By = {
  answer_type_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Answer_Types_Var_Samp_Fields = {
  __typename?: 'answer_types_var_samp_fields';
  answer_type_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "answer_types" */
export type Answer_Types_Var_Samp_Order_By = {
  answer_type_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Answer_Types_Variance_Fields = {
  __typename?: 'answer_types_variance_fields';
  answer_type_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "answer_types" */
export type Answer_Types_Variance_Order_By = {
  answer_type_id?: InputMaybe<Order_By>;
};

/** expression to compare columns of type bigint. All fields are combined with logical 'AND'. */
export type Bigint_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['bigint']>;
  _gt?: InputMaybe<Scalars['bigint']>;
  _gte?: InputMaybe<Scalars['bigint']>;
  _in?: InputMaybe<Array<Scalars['bigint']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['bigint']>;
  _lte?: InputMaybe<Scalars['bigint']>;
  _neq?: InputMaybe<Scalars['bigint']>;
  _nin?: InputMaybe<Array<Scalars['bigint']>>;
};

/** columns and relationships of "categories" */
export type Categories = {
  __typename?: 'categories';
  archived: Scalars['Boolean'];
  category_id: Scalars['uuid'];
  category_name: Scalars['String'];
  parent_category_id?: Maybe<Scalars['uuid']>;
  sort_order_num?: Maybe<Scalars['Int']>;
};

/** aggregated selection of "categories" */
export type Categories_Aggregate = {
  __typename?: 'categories_aggregate';
  aggregate?: Maybe<Categories_Aggregate_Fields>;
  nodes: Array<Categories>;
};

/** aggregate fields of "categories" */
export type Categories_Aggregate_Fields = {
  __typename?: 'categories_aggregate_fields';
  avg?: Maybe<Categories_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Categories_Max_Fields>;
  min?: Maybe<Categories_Min_Fields>;
  stddev?: Maybe<Categories_Stddev_Fields>;
  stddev_pop?: Maybe<Categories_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Categories_Stddev_Samp_Fields>;
  sum?: Maybe<Categories_Sum_Fields>;
  var_pop?: Maybe<Categories_Var_Pop_Fields>;
  var_samp?: Maybe<Categories_Var_Samp_Fields>;
  variance?: Maybe<Categories_Variance_Fields>;
};


/** aggregate fields of "categories" */
export type Categories_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Categories_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "categories" */
export type Categories_Aggregate_Order_By = {
  avg?: InputMaybe<Categories_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Categories_Max_Order_By>;
  min?: InputMaybe<Categories_Min_Order_By>;
  stddev?: InputMaybe<Categories_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Categories_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Categories_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Categories_Sum_Order_By>;
  var_pop?: InputMaybe<Categories_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Categories_Var_Samp_Order_By>;
  variance?: InputMaybe<Categories_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "categories" */
export type Categories_Arr_Rel_Insert_Input = {
  data: Array<Categories_Insert_Input>;
  on_conflict?: InputMaybe<Categories_On_Conflict>;
};

/** aggregate avg on columns */
export type Categories_Avg_Fields = {
  __typename?: 'categories_avg_fields';
  sort_order_num?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "categories" */
export type Categories_Avg_Order_By = {
  sort_order_num?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "categories". All fields are combined with a logical 'AND'. */
export type Categories_Bool_Exp = {
  _and?: InputMaybe<Array<InputMaybe<Categories_Bool_Exp>>>;
  _not?: InputMaybe<Categories_Bool_Exp>;
  _or?: InputMaybe<Array<InputMaybe<Categories_Bool_Exp>>>;
  archived?: InputMaybe<Boolean_Comparison_Exp>;
  category_id?: InputMaybe<Uuid_Comparison_Exp>;
  category_name?: InputMaybe<String_Comparison_Exp>;
  parent_category_id?: InputMaybe<Uuid_Comparison_Exp>;
  sort_order_num?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "categories" */
export enum Categories_Constraint {
  /** unique or primary key constraint */
  CategoriesPkey = 'categories_pkey'
}

/** input type for incrementing integer column in table "categories" */
export type Categories_Inc_Input = {
  sort_order_num?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "categories" */
export type Categories_Insert_Input = {
  archived?: InputMaybe<Scalars['Boolean']>;
  category_id?: InputMaybe<Scalars['uuid']>;
  category_name?: InputMaybe<Scalars['String']>;
  parent_category_id?: InputMaybe<Scalars['uuid']>;
  sort_order_num?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Categories_Max_Fields = {
  __typename?: 'categories_max_fields';
  category_id?: Maybe<Scalars['uuid']>;
  category_name?: Maybe<Scalars['String']>;
  parent_category_id?: Maybe<Scalars['uuid']>;
  sort_order_num?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "categories" */
export type Categories_Max_Order_By = {
  category_id?: InputMaybe<Order_By>;
  category_name?: InputMaybe<Order_By>;
  parent_category_id?: InputMaybe<Order_By>;
  sort_order_num?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Categories_Min_Fields = {
  __typename?: 'categories_min_fields';
  category_id?: Maybe<Scalars['uuid']>;
  category_name?: Maybe<Scalars['String']>;
  parent_category_id?: Maybe<Scalars['uuid']>;
  sort_order_num?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "categories" */
export type Categories_Min_Order_By = {
  category_id?: InputMaybe<Order_By>;
  category_name?: InputMaybe<Order_By>;
  parent_category_id?: InputMaybe<Order_By>;
  sort_order_num?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "categories" */
export type Categories_Mutation_Response = {
  __typename?: 'categories_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Categories>;
};

/** input type for inserting object relation for remote table "categories" */
export type Categories_Obj_Rel_Insert_Input = {
  data: Categories_Insert_Input;
  on_conflict?: InputMaybe<Categories_On_Conflict>;
};

/** on conflict condition type for table "categories" */
export type Categories_On_Conflict = {
  constraint: Categories_Constraint;
  update_columns: Array<Categories_Update_Column>;
  where?: InputMaybe<Categories_Bool_Exp>;
};

/** ordering options when selecting data from "categories" */
export type Categories_Order_By = {
  archived?: InputMaybe<Order_By>;
  category_id?: InputMaybe<Order_By>;
  category_name?: InputMaybe<Order_By>;
  parent_category_id?: InputMaybe<Order_By>;
  sort_order_num?: InputMaybe<Order_By>;
};

/** primary key columns input for table: "categories" */
export type Categories_Pk_Columns_Input = {
  category_id: Scalars['uuid'];
};

/** select columns of table "categories" */
export enum Categories_Select_Column {
  /** column name */
  Archived = 'archived',
  /** column name */
  CategoryId = 'category_id',
  /** column name */
  CategoryName = 'category_name',
  /** column name */
  ParentCategoryId = 'parent_category_id',
  /** column name */
  SortOrderNum = 'sort_order_num'
}

/** input type for updating data in table "categories" */
export type Categories_Set_Input = {
  archived?: InputMaybe<Scalars['Boolean']>;
  category_id?: InputMaybe<Scalars['uuid']>;
  category_name?: InputMaybe<Scalars['String']>;
  parent_category_id?: InputMaybe<Scalars['uuid']>;
  sort_order_num?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Categories_Stddev_Fields = {
  __typename?: 'categories_stddev_fields';
  sort_order_num?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "categories" */
export type Categories_Stddev_Order_By = {
  sort_order_num?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Categories_Stddev_Pop_Fields = {
  __typename?: 'categories_stddev_pop_fields';
  sort_order_num?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "categories" */
export type Categories_Stddev_Pop_Order_By = {
  sort_order_num?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Categories_Stddev_Samp_Fields = {
  __typename?: 'categories_stddev_samp_fields';
  sort_order_num?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "categories" */
export type Categories_Stddev_Samp_Order_By = {
  sort_order_num?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Categories_Sum_Fields = {
  __typename?: 'categories_sum_fields';
  sort_order_num?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "categories" */
export type Categories_Sum_Order_By = {
  sort_order_num?: InputMaybe<Order_By>;
};

/** update columns of table "categories" */
export enum Categories_Update_Column {
  /** column name */
  Archived = 'archived',
  /** column name */
  CategoryId = 'category_id',
  /** column name */
  CategoryName = 'category_name',
  /** column name */
  ParentCategoryId = 'parent_category_id',
  /** column name */
  SortOrderNum = 'sort_order_num'
}

/** aggregate var_pop on columns */
export type Categories_Var_Pop_Fields = {
  __typename?: 'categories_var_pop_fields';
  sort_order_num?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "categories" */
export type Categories_Var_Pop_Order_By = {
  sort_order_num?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Categories_Var_Samp_Fields = {
  __typename?: 'categories_var_samp_fields';
  sort_order_num?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "categories" */
export type Categories_Var_Samp_Order_By = {
  sort_order_num?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Categories_Variance_Fields = {
  __typename?: 'categories_variance_fields';
  sort_order_num?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "categories" */
export type Categories_Variance_Order_By = {
  sort_order_num?: InputMaybe<Order_By>;
};

/** columns and relationships of "city_edit_log" */
export type City_Edit_Log = {
  __typename?: 'city_edit_log';
  edit_datetime: Scalars['timestamptz'];
  edit_type: Scalars['String'];
  editor_name_first: Scalars['String'];
  editor_name_last: Scalars['String'];
  id: Scalars['Int'];
  trivia_question_fk: Scalars['Int'];
};

/** aggregated selection of "city_edit_log" */
export type City_Edit_Log_Aggregate = {
  __typename?: 'city_edit_log_aggregate';
  aggregate?: Maybe<City_Edit_Log_Aggregate_Fields>;
  nodes: Array<City_Edit_Log>;
};

/** aggregate fields of "city_edit_log" */
export type City_Edit_Log_Aggregate_Fields = {
  __typename?: 'city_edit_log_aggregate_fields';
  avg?: Maybe<City_Edit_Log_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<City_Edit_Log_Max_Fields>;
  min?: Maybe<City_Edit_Log_Min_Fields>;
  stddev?: Maybe<City_Edit_Log_Stddev_Fields>;
  stddev_pop?: Maybe<City_Edit_Log_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<City_Edit_Log_Stddev_Samp_Fields>;
  sum?: Maybe<City_Edit_Log_Sum_Fields>;
  var_pop?: Maybe<City_Edit_Log_Var_Pop_Fields>;
  var_samp?: Maybe<City_Edit_Log_Var_Samp_Fields>;
  variance?: Maybe<City_Edit_Log_Variance_Fields>;
};


/** aggregate fields of "city_edit_log" */
export type City_Edit_Log_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<City_Edit_Log_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "city_edit_log" */
export type City_Edit_Log_Aggregate_Order_By = {
  avg?: InputMaybe<City_Edit_Log_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<City_Edit_Log_Max_Order_By>;
  min?: InputMaybe<City_Edit_Log_Min_Order_By>;
  stddev?: InputMaybe<City_Edit_Log_Stddev_Order_By>;
  stddev_pop?: InputMaybe<City_Edit_Log_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<City_Edit_Log_Stddev_Samp_Order_By>;
  sum?: InputMaybe<City_Edit_Log_Sum_Order_By>;
  var_pop?: InputMaybe<City_Edit_Log_Var_Pop_Order_By>;
  var_samp?: InputMaybe<City_Edit_Log_Var_Samp_Order_By>;
  variance?: InputMaybe<City_Edit_Log_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "city_edit_log" */
export type City_Edit_Log_Arr_Rel_Insert_Input = {
  data: Array<City_Edit_Log_Insert_Input>;
};

/** aggregate avg on columns */
export type City_Edit_Log_Avg_Fields = {
  __typename?: 'city_edit_log_avg_fields';
  id?: Maybe<Scalars['Float']>;
  trivia_question_fk?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "city_edit_log" */
export type City_Edit_Log_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  trivia_question_fk?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "city_edit_log". All fields are combined with a logical 'AND'. */
export type City_Edit_Log_Bool_Exp = {
  _and?: InputMaybe<Array<InputMaybe<City_Edit_Log_Bool_Exp>>>;
  _not?: InputMaybe<City_Edit_Log_Bool_Exp>;
  _or?: InputMaybe<Array<InputMaybe<City_Edit_Log_Bool_Exp>>>;
  edit_datetime?: InputMaybe<Timestamptz_Comparison_Exp>;
  edit_type?: InputMaybe<String_Comparison_Exp>;
  editor_name_first?: InputMaybe<String_Comparison_Exp>;
  editor_name_last?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  trivia_question_fk?: InputMaybe<Int_Comparison_Exp>;
};

/** input type for incrementing integer column in table "city_edit_log" */
export type City_Edit_Log_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  trivia_question_fk?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "city_edit_log" */
export type City_Edit_Log_Insert_Input = {
  edit_datetime?: InputMaybe<Scalars['timestamptz']>;
  edit_type?: InputMaybe<Scalars['String']>;
  editor_name_first?: InputMaybe<Scalars['String']>;
  editor_name_last?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  trivia_question_fk?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type City_Edit_Log_Max_Fields = {
  __typename?: 'city_edit_log_max_fields';
  edit_datetime?: Maybe<Scalars['timestamptz']>;
  edit_type?: Maybe<Scalars['String']>;
  editor_name_first?: Maybe<Scalars['String']>;
  editor_name_last?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  trivia_question_fk?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "city_edit_log" */
export type City_Edit_Log_Max_Order_By = {
  edit_datetime?: InputMaybe<Order_By>;
  edit_type?: InputMaybe<Order_By>;
  editor_name_first?: InputMaybe<Order_By>;
  editor_name_last?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  trivia_question_fk?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type City_Edit_Log_Min_Fields = {
  __typename?: 'city_edit_log_min_fields';
  edit_datetime?: Maybe<Scalars['timestamptz']>;
  edit_type?: Maybe<Scalars['String']>;
  editor_name_first?: Maybe<Scalars['String']>;
  editor_name_last?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  trivia_question_fk?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "city_edit_log" */
export type City_Edit_Log_Min_Order_By = {
  edit_datetime?: InputMaybe<Order_By>;
  edit_type?: InputMaybe<Order_By>;
  editor_name_first?: InputMaybe<Order_By>;
  editor_name_last?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  trivia_question_fk?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "city_edit_log" */
export type City_Edit_Log_Mutation_Response = {
  __typename?: 'city_edit_log_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<City_Edit_Log>;
};

/** input type for inserting object relation for remote table "city_edit_log" */
export type City_Edit_Log_Obj_Rel_Insert_Input = {
  data: City_Edit_Log_Insert_Input;
};

/** ordering options when selecting data from "city_edit_log" */
export type City_Edit_Log_Order_By = {
  edit_datetime?: InputMaybe<Order_By>;
  edit_type?: InputMaybe<Order_By>;
  editor_name_first?: InputMaybe<Order_By>;
  editor_name_last?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  trivia_question_fk?: InputMaybe<Order_By>;
};

/** select columns of table "city_edit_log" */
export enum City_Edit_Log_Select_Column {
  /** column name */
  EditDatetime = 'edit_datetime',
  /** column name */
  EditType = 'edit_type',
  /** column name */
  EditorNameFirst = 'editor_name_first',
  /** column name */
  EditorNameLast = 'editor_name_last',
  /** column name */
  Id = 'id',
  /** column name */
  TriviaQuestionFk = 'trivia_question_fk'
}

/** input type for updating data in table "city_edit_log" */
export type City_Edit_Log_Set_Input = {
  edit_datetime?: InputMaybe<Scalars['timestamptz']>;
  edit_type?: InputMaybe<Scalars['String']>;
  editor_name_first?: InputMaybe<Scalars['String']>;
  editor_name_last?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  trivia_question_fk?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type City_Edit_Log_Stddev_Fields = {
  __typename?: 'city_edit_log_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  trivia_question_fk?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "city_edit_log" */
export type City_Edit_Log_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  trivia_question_fk?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type City_Edit_Log_Stddev_Pop_Fields = {
  __typename?: 'city_edit_log_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  trivia_question_fk?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "city_edit_log" */
export type City_Edit_Log_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  trivia_question_fk?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type City_Edit_Log_Stddev_Samp_Fields = {
  __typename?: 'city_edit_log_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  trivia_question_fk?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "city_edit_log" */
export type City_Edit_Log_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  trivia_question_fk?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type City_Edit_Log_Sum_Fields = {
  __typename?: 'city_edit_log_sum_fields';
  id?: Maybe<Scalars['Int']>;
  trivia_question_fk?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "city_edit_log" */
export type City_Edit_Log_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  trivia_question_fk?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type City_Edit_Log_Var_Pop_Fields = {
  __typename?: 'city_edit_log_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  trivia_question_fk?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "city_edit_log" */
export type City_Edit_Log_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  trivia_question_fk?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type City_Edit_Log_Var_Samp_Fields = {
  __typename?: 'city_edit_log_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  trivia_question_fk?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "city_edit_log" */
export type City_Edit_Log_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  trivia_question_fk?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type City_Edit_Log_Variance_Fields = {
  __typename?: 'city_edit_log_variance_fields';
  id?: Maybe<Scalars['Float']>;
  trivia_question_fk?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "city_edit_log" */
export type City_Edit_Log_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  trivia_question_fk?: InputMaybe<Order_By>;
};

/** columns and relationships of "city_tqs" */
export type City_Tqs = {
  __typename?: 'city_tqs';
  id: Scalars['Int'];
  tqs_date?: Maybe<Scalars['date']>;
  tqs_number: Scalars['smallint'];
};

/** aggregated selection of "city_tqs" */
export type City_Tqs_Aggregate = {
  __typename?: 'city_tqs_aggregate';
  aggregate?: Maybe<City_Tqs_Aggregate_Fields>;
  nodes: Array<City_Tqs>;
};

/** aggregate fields of "city_tqs" */
export type City_Tqs_Aggregate_Fields = {
  __typename?: 'city_tqs_aggregate_fields';
  avg?: Maybe<City_Tqs_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<City_Tqs_Max_Fields>;
  min?: Maybe<City_Tqs_Min_Fields>;
  stddev?: Maybe<City_Tqs_Stddev_Fields>;
  stddev_pop?: Maybe<City_Tqs_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<City_Tqs_Stddev_Samp_Fields>;
  sum?: Maybe<City_Tqs_Sum_Fields>;
  var_pop?: Maybe<City_Tqs_Var_Pop_Fields>;
  var_samp?: Maybe<City_Tqs_Var_Samp_Fields>;
  variance?: Maybe<City_Tqs_Variance_Fields>;
};


/** aggregate fields of "city_tqs" */
export type City_Tqs_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<City_Tqs_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "city_tqs" */
export type City_Tqs_Aggregate_Order_By = {
  avg?: InputMaybe<City_Tqs_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<City_Tqs_Max_Order_By>;
  min?: InputMaybe<City_Tqs_Min_Order_By>;
  stddev?: InputMaybe<City_Tqs_Stddev_Order_By>;
  stddev_pop?: InputMaybe<City_Tqs_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<City_Tqs_Stddev_Samp_Order_By>;
  sum?: InputMaybe<City_Tqs_Sum_Order_By>;
  var_pop?: InputMaybe<City_Tqs_Var_Pop_Order_By>;
  var_samp?: InputMaybe<City_Tqs_Var_Samp_Order_By>;
  variance?: InputMaybe<City_Tqs_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "city_tqs" */
export type City_Tqs_Arr_Rel_Insert_Input = {
  data: Array<City_Tqs_Insert_Input>;
};

/** aggregate avg on columns */
export type City_Tqs_Avg_Fields = {
  __typename?: 'city_tqs_avg_fields';
  id?: Maybe<Scalars['Float']>;
  tqs_number?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "city_tqs" */
export type City_Tqs_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  tqs_number?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "city_tqs". All fields are combined with a logical 'AND'. */
export type City_Tqs_Bool_Exp = {
  _and?: InputMaybe<Array<InputMaybe<City_Tqs_Bool_Exp>>>;
  _not?: InputMaybe<City_Tqs_Bool_Exp>;
  _or?: InputMaybe<Array<InputMaybe<City_Tqs_Bool_Exp>>>;
  id?: InputMaybe<Int_Comparison_Exp>;
  tqs_date?: InputMaybe<Date_Comparison_Exp>;
  tqs_number?: InputMaybe<Smallint_Comparison_Exp>;
};

/** input type for incrementing integer column in table "city_tqs" */
export type City_Tqs_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  tqs_number?: InputMaybe<Scalars['smallint']>;
};

/** input type for inserting data into table "city_tqs" */
export type City_Tqs_Insert_Input = {
  id?: InputMaybe<Scalars['Int']>;
  tqs_date?: InputMaybe<Scalars['date']>;
  tqs_number?: InputMaybe<Scalars['smallint']>;
};

/** aggregate max on columns */
export type City_Tqs_Max_Fields = {
  __typename?: 'city_tqs_max_fields';
  id?: Maybe<Scalars['Int']>;
  tqs_date?: Maybe<Scalars['date']>;
  tqs_number?: Maybe<Scalars['smallint']>;
};

/** order by max() on columns of table "city_tqs" */
export type City_Tqs_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  tqs_date?: InputMaybe<Order_By>;
  tqs_number?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type City_Tqs_Min_Fields = {
  __typename?: 'city_tqs_min_fields';
  id?: Maybe<Scalars['Int']>;
  tqs_date?: Maybe<Scalars['date']>;
  tqs_number?: Maybe<Scalars['smallint']>;
};

/** order by min() on columns of table "city_tqs" */
export type City_Tqs_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  tqs_date?: InputMaybe<Order_By>;
  tqs_number?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "city_tqs" */
export type City_Tqs_Mutation_Response = {
  __typename?: 'city_tqs_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<City_Tqs>;
};

/** input type for inserting object relation for remote table "city_tqs" */
export type City_Tqs_Obj_Rel_Insert_Input = {
  data: City_Tqs_Insert_Input;
};

/** ordering options when selecting data from "city_tqs" */
export type City_Tqs_Order_By = {
  id?: InputMaybe<Order_By>;
  tqs_date?: InputMaybe<Order_By>;
  tqs_number?: InputMaybe<Order_By>;
};

/** select columns of table "city_tqs" */
export enum City_Tqs_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  TqsDate = 'tqs_date',
  /** column name */
  TqsNumber = 'tqs_number'
}

/** input type for updating data in table "city_tqs" */
export type City_Tqs_Set_Input = {
  id?: InputMaybe<Scalars['Int']>;
  tqs_date?: InputMaybe<Scalars['date']>;
  tqs_number?: InputMaybe<Scalars['smallint']>;
};

/** aggregate stddev on columns */
export type City_Tqs_Stddev_Fields = {
  __typename?: 'city_tqs_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  tqs_number?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "city_tqs" */
export type City_Tqs_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  tqs_number?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type City_Tqs_Stddev_Pop_Fields = {
  __typename?: 'city_tqs_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  tqs_number?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "city_tqs" */
export type City_Tqs_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  tqs_number?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type City_Tqs_Stddev_Samp_Fields = {
  __typename?: 'city_tqs_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  tqs_number?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "city_tqs" */
export type City_Tqs_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  tqs_number?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type City_Tqs_Sum_Fields = {
  __typename?: 'city_tqs_sum_fields';
  id?: Maybe<Scalars['Int']>;
  tqs_number?: Maybe<Scalars['smallint']>;
};

/** order by sum() on columns of table "city_tqs" */
export type City_Tqs_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  tqs_number?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type City_Tqs_Var_Pop_Fields = {
  __typename?: 'city_tqs_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  tqs_number?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "city_tqs" */
export type City_Tqs_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  tqs_number?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type City_Tqs_Var_Samp_Fields = {
  __typename?: 'city_tqs_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  tqs_number?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "city_tqs" */
export type City_Tqs_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  tqs_number?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type City_Tqs_Variance_Fields = {
  __typename?: 'city_tqs_variance_fields';
  id?: Maybe<Scalars['Float']>;
  tqs_number?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "city_tqs" */
export type City_Tqs_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  tqs_number?: InputMaybe<Order_By>;
};

/** columns and relationships of "city_trivia_category" */
export type City_Trivia_Category = {
  __typename?: 'city_trivia_category';
  category: Scalars['String'];
  id: Scalars['Int'];
  parent_category_fk?: Maybe<Scalars['Int']>;
};

/** aggregated selection of "city_trivia_category" */
export type City_Trivia_Category_Aggregate = {
  __typename?: 'city_trivia_category_aggregate';
  aggregate?: Maybe<City_Trivia_Category_Aggregate_Fields>;
  nodes: Array<City_Trivia_Category>;
};

/** aggregate fields of "city_trivia_category" */
export type City_Trivia_Category_Aggregate_Fields = {
  __typename?: 'city_trivia_category_aggregate_fields';
  avg?: Maybe<City_Trivia_Category_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<City_Trivia_Category_Max_Fields>;
  min?: Maybe<City_Trivia_Category_Min_Fields>;
  stddev?: Maybe<City_Trivia_Category_Stddev_Fields>;
  stddev_pop?: Maybe<City_Trivia_Category_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<City_Trivia_Category_Stddev_Samp_Fields>;
  sum?: Maybe<City_Trivia_Category_Sum_Fields>;
  var_pop?: Maybe<City_Trivia_Category_Var_Pop_Fields>;
  var_samp?: Maybe<City_Trivia_Category_Var_Samp_Fields>;
  variance?: Maybe<City_Trivia_Category_Variance_Fields>;
};


/** aggregate fields of "city_trivia_category" */
export type City_Trivia_Category_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<City_Trivia_Category_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "city_trivia_category" */
export type City_Trivia_Category_Aggregate_Order_By = {
  avg?: InputMaybe<City_Trivia_Category_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<City_Trivia_Category_Max_Order_By>;
  min?: InputMaybe<City_Trivia_Category_Min_Order_By>;
  stddev?: InputMaybe<City_Trivia_Category_Stddev_Order_By>;
  stddev_pop?: InputMaybe<City_Trivia_Category_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<City_Trivia_Category_Stddev_Samp_Order_By>;
  sum?: InputMaybe<City_Trivia_Category_Sum_Order_By>;
  var_pop?: InputMaybe<City_Trivia_Category_Var_Pop_Order_By>;
  var_samp?: InputMaybe<City_Trivia_Category_Var_Samp_Order_By>;
  variance?: InputMaybe<City_Trivia_Category_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "city_trivia_category" */
export type City_Trivia_Category_Arr_Rel_Insert_Input = {
  data: Array<City_Trivia_Category_Insert_Input>;
};

/** aggregate avg on columns */
export type City_Trivia_Category_Avg_Fields = {
  __typename?: 'city_trivia_category_avg_fields';
  id?: Maybe<Scalars['Float']>;
  parent_category_fk?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "city_trivia_category" */
export type City_Trivia_Category_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  parent_category_fk?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "city_trivia_category". All fields are combined with a logical 'AND'. */
export type City_Trivia_Category_Bool_Exp = {
  _and?: InputMaybe<Array<InputMaybe<City_Trivia_Category_Bool_Exp>>>;
  _not?: InputMaybe<City_Trivia_Category_Bool_Exp>;
  _or?: InputMaybe<Array<InputMaybe<City_Trivia_Category_Bool_Exp>>>;
  category?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  parent_category_fk?: InputMaybe<Int_Comparison_Exp>;
};

/** input type for incrementing integer column in table "city_trivia_category" */
export type City_Trivia_Category_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  parent_category_fk?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "city_trivia_category" */
export type City_Trivia_Category_Insert_Input = {
  category?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  parent_category_fk?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type City_Trivia_Category_Max_Fields = {
  __typename?: 'city_trivia_category_max_fields';
  category?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  parent_category_fk?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "city_trivia_category" */
export type City_Trivia_Category_Max_Order_By = {
  category?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_category_fk?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type City_Trivia_Category_Min_Fields = {
  __typename?: 'city_trivia_category_min_fields';
  category?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  parent_category_fk?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "city_trivia_category" */
export type City_Trivia_Category_Min_Order_By = {
  category?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_category_fk?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "city_trivia_category" */
export type City_Trivia_Category_Mutation_Response = {
  __typename?: 'city_trivia_category_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<City_Trivia_Category>;
};

/** input type for inserting object relation for remote table "city_trivia_category" */
export type City_Trivia_Category_Obj_Rel_Insert_Input = {
  data: City_Trivia_Category_Insert_Input;
};

/** ordering options when selecting data from "city_trivia_category" */
export type City_Trivia_Category_Order_By = {
  category?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_category_fk?: InputMaybe<Order_By>;
};

/** select columns of table "city_trivia_category" */
export enum City_Trivia_Category_Select_Column {
  /** column name */
  Category = 'category',
  /** column name */
  Id = 'id',
  /** column name */
  ParentCategoryFk = 'parent_category_fk'
}

/** input type for updating data in table "city_trivia_category" */
export type City_Trivia_Category_Set_Input = {
  category?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  parent_category_fk?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type City_Trivia_Category_Stddev_Fields = {
  __typename?: 'city_trivia_category_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  parent_category_fk?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "city_trivia_category" */
export type City_Trivia_Category_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  parent_category_fk?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type City_Trivia_Category_Stddev_Pop_Fields = {
  __typename?: 'city_trivia_category_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  parent_category_fk?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "city_trivia_category" */
export type City_Trivia_Category_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  parent_category_fk?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type City_Trivia_Category_Stddev_Samp_Fields = {
  __typename?: 'city_trivia_category_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  parent_category_fk?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "city_trivia_category" */
export type City_Trivia_Category_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  parent_category_fk?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type City_Trivia_Category_Sum_Fields = {
  __typename?: 'city_trivia_category_sum_fields';
  id?: Maybe<Scalars['Int']>;
  parent_category_fk?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "city_trivia_category" */
export type City_Trivia_Category_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  parent_category_fk?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type City_Trivia_Category_Var_Pop_Fields = {
  __typename?: 'city_trivia_category_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  parent_category_fk?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "city_trivia_category" */
export type City_Trivia_Category_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  parent_category_fk?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type City_Trivia_Category_Var_Samp_Fields = {
  __typename?: 'city_trivia_category_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  parent_category_fk?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "city_trivia_category" */
export type City_Trivia_Category_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  parent_category_fk?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type City_Trivia_Category_Variance_Fields = {
  __typename?: 'city_trivia_category_variance_fields';
  id?: Maybe<Scalars['Float']>;
  parent_category_fk?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "city_trivia_category" */
export type City_Trivia_Category_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  parent_category_fk?: InputMaybe<Order_By>;
};

/** columns and relationships of "city_trivia_question" */
export type City_Trivia_Question = {
  __typename?: 'city_trivia_question';
  answer: Scalars['String'];
  host_note?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  point_value?: Maybe<Scalars['smallint']>;
  question: Scalars['String'];
  source_primary?: Maybe<Scalars['String']>;
  source_secondary?: Maybe<Scalars['String']>;
  trivia_category_fk?: Maybe<Scalars['Int']>;
  wrong_answers?: Maybe<Scalars['String']>;
};

/** aggregated selection of "city_trivia_question" */
export type City_Trivia_Question_Aggregate = {
  __typename?: 'city_trivia_question_aggregate';
  aggregate?: Maybe<City_Trivia_Question_Aggregate_Fields>;
  nodes: Array<City_Trivia_Question>;
};

/** aggregate fields of "city_trivia_question" */
export type City_Trivia_Question_Aggregate_Fields = {
  __typename?: 'city_trivia_question_aggregate_fields';
  avg?: Maybe<City_Trivia_Question_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<City_Trivia_Question_Max_Fields>;
  min?: Maybe<City_Trivia_Question_Min_Fields>;
  stddev?: Maybe<City_Trivia_Question_Stddev_Fields>;
  stddev_pop?: Maybe<City_Trivia_Question_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<City_Trivia_Question_Stddev_Samp_Fields>;
  sum?: Maybe<City_Trivia_Question_Sum_Fields>;
  var_pop?: Maybe<City_Trivia_Question_Var_Pop_Fields>;
  var_samp?: Maybe<City_Trivia_Question_Var_Samp_Fields>;
  variance?: Maybe<City_Trivia_Question_Variance_Fields>;
};


/** aggregate fields of "city_trivia_question" */
export type City_Trivia_Question_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<City_Trivia_Question_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "city_trivia_question" */
export type City_Trivia_Question_Aggregate_Order_By = {
  avg?: InputMaybe<City_Trivia_Question_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<City_Trivia_Question_Max_Order_By>;
  min?: InputMaybe<City_Trivia_Question_Min_Order_By>;
  stddev?: InputMaybe<City_Trivia_Question_Stddev_Order_By>;
  stddev_pop?: InputMaybe<City_Trivia_Question_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<City_Trivia_Question_Stddev_Samp_Order_By>;
  sum?: InputMaybe<City_Trivia_Question_Sum_Order_By>;
  var_pop?: InputMaybe<City_Trivia_Question_Var_Pop_Order_By>;
  var_samp?: InputMaybe<City_Trivia_Question_Var_Samp_Order_By>;
  variance?: InputMaybe<City_Trivia_Question_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "city_trivia_question" */
export type City_Trivia_Question_Arr_Rel_Insert_Input = {
  data: Array<City_Trivia_Question_Insert_Input>;
};

/** aggregate avg on columns */
export type City_Trivia_Question_Avg_Fields = {
  __typename?: 'city_trivia_question_avg_fields';
  id?: Maybe<Scalars['Float']>;
  point_value?: Maybe<Scalars['Float']>;
  trivia_category_fk?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "city_trivia_question" */
export type City_Trivia_Question_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  point_value?: InputMaybe<Order_By>;
  trivia_category_fk?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "city_trivia_question". All fields are combined with a logical 'AND'. */
export type City_Trivia_Question_Bool_Exp = {
  _and?: InputMaybe<Array<InputMaybe<City_Trivia_Question_Bool_Exp>>>;
  _not?: InputMaybe<City_Trivia_Question_Bool_Exp>;
  _or?: InputMaybe<Array<InputMaybe<City_Trivia_Question_Bool_Exp>>>;
  answer?: InputMaybe<String_Comparison_Exp>;
  host_note?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  point_value?: InputMaybe<Smallint_Comparison_Exp>;
  question?: InputMaybe<String_Comparison_Exp>;
  source_primary?: InputMaybe<String_Comparison_Exp>;
  source_secondary?: InputMaybe<String_Comparison_Exp>;
  trivia_category_fk?: InputMaybe<Int_Comparison_Exp>;
  wrong_answers?: InputMaybe<String_Comparison_Exp>;
};

/** input type for incrementing integer column in table "city_trivia_question" */
export type City_Trivia_Question_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  point_value?: InputMaybe<Scalars['smallint']>;
  trivia_category_fk?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "city_trivia_question" */
export type City_Trivia_Question_Insert_Input = {
  answer?: InputMaybe<Scalars['String']>;
  host_note?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  point_value?: InputMaybe<Scalars['smallint']>;
  question?: InputMaybe<Scalars['String']>;
  source_primary?: InputMaybe<Scalars['String']>;
  source_secondary?: InputMaybe<Scalars['String']>;
  trivia_category_fk?: InputMaybe<Scalars['Int']>;
  wrong_answers?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type City_Trivia_Question_Max_Fields = {
  __typename?: 'city_trivia_question_max_fields';
  answer?: Maybe<Scalars['String']>;
  host_note?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  point_value?: Maybe<Scalars['smallint']>;
  question?: Maybe<Scalars['String']>;
  source_primary?: Maybe<Scalars['String']>;
  source_secondary?: Maybe<Scalars['String']>;
  trivia_category_fk?: Maybe<Scalars['Int']>;
  wrong_answers?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "city_trivia_question" */
export type City_Trivia_Question_Max_Order_By = {
  answer?: InputMaybe<Order_By>;
  host_note?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  point_value?: InputMaybe<Order_By>;
  question?: InputMaybe<Order_By>;
  source_primary?: InputMaybe<Order_By>;
  source_secondary?: InputMaybe<Order_By>;
  trivia_category_fk?: InputMaybe<Order_By>;
  wrong_answers?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type City_Trivia_Question_Min_Fields = {
  __typename?: 'city_trivia_question_min_fields';
  answer?: Maybe<Scalars['String']>;
  host_note?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  point_value?: Maybe<Scalars['smallint']>;
  question?: Maybe<Scalars['String']>;
  source_primary?: Maybe<Scalars['String']>;
  source_secondary?: Maybe<Scalars['String']>;
  trivia_category_fk?: Maybe<Scalars['Int']>;
  wrong_answers?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "city_trivia_question" */
export type City_Trivia_Question_Min_Order_By = {
  answer?: InputMaybe<Order_By>;
  host_note?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  point_value?: InputMaybe<Order_By>;
  question?: InputMaybe<Order_By>;
  source_primary?: InputMaybe<Order_By>;
  source_secondary?: InputMaybe<Order_By>;
  trivia_category_fk?: InputMaybe<Order_By>;
  wrong_answers?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "city_trivia_question" */
export type City_Trivia_Question_Mutation_Response = {
  __typename?: 'city_trivia_question_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<City_Trivia_Question>;
};

/** input type for inserting object relation for remote table "city_trivia_question" */
export type City_Trivia_Question_Obj_Rel_Insert_Input = {
  data: City_Trivia_Question_Insert_Input;
};

/** ordering options when selecting data from "city_trivia_question" */
export type City_Trivia_Question_Order_By = {
  answer?: InputMaybe<Order_By>;
  host_note?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  point_value?: InputMaybe<Order_By>;
  question?: InputMaybe<Order_By>;
  source_primary?: InputMaybe<Order_By>;
  source_secondary?: InputMaybe<Order_By>;
  trivia_category_fk?: InputMaybe<Order_By>;
  wrong_answers?: InputMaybe<Order_By>;
};

/** select columns of table "city_trivia_question" */
export enum City_Trivia_Question_Select_Column {
  /** column name */
  Answer = 'answer',
  /** column name */
  HostNote = 'host_note',
  /** column name */
  Id = 'id',
  /** column name */
  PointValue = 'point_value',
  /** column name */
  Question = 'question',
  /** column name */
  SourcePrimary = 'source_primary',
  /** column name */
  SourceSecondary = 'source_secondary',
  /** column name */
  TriviaCategoryFk = 'trivia_category_fk',
  /** column name */
  WrongAnswers = 'wrong_answers'
}

/** input type for updating data in table "city_trivia_question" */
export type City_Trivia_Question_Set_Input = {
  answer?: InputMaybe<Scalars['String']>;
  host_note?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  point_value?: InputMaybe<Scalars['smallint']>;
  question?: InputMaybe<Scalars['String']>;
  source_primary?: InputMaybe<Scalars['String']>;
  source_secondary?: InputMaybe<Scalars['String']>;
  trivia_category_fk?: InputMaybe<Scalars['Int']>;
  wrong_answers?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type City_Trivia_Question_Stddev_Fields = {
  __typename?: 'city_trivia_question_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  point_value?: Maybe<Scalars['Float']>;
  trivia_category_fk?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "city_trivia_question" */
export type City_Trivia_Question_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  point_value?: InputMaybe<Order_By>;
  trivia_category_fk?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type City_Trivia_Question_Stddev_Pop_Fields = {
  __typename?: 'city_trivia_question_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  point_value?: Maybe<Scalars['Float']>;
  trivia_category_fk?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "city_trivia_question" */
export type City_Trivia_Question_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  point_value?: InputMaybe<Order_By>;
  trivia_category_fk?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type City_Trivia_Question_Stddev_Samp_Fields = {
  __typename?: 'city_trivia_question_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  point_value?: Maybe<Scalars['Float']>;
  trivia_category_fk?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "city_trivia_question" */
export type City_Trivia_Question_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  point_value?: InputMaybe<Order_By>;
  trivia_category_fk?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type City_Trivia_Question_Sum_Fields = {
  __typename?: 'city_trivia_question_sum_fields';
  id?: Maybe<Scalars['Int']>;
  point_value?: Maybe<Scalars['smallint']>;
  trivia_category_fk?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "city_trivia_question" */
export type City_Trivia_Question_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  point_value?: InputMaybe<Order_By>;
  trivia_category_fk?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type City_Trivia_Question_Var_Pop_Fields = {
  __typename?: 'city_trivia_question_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  point_value?: Maybe<Scalars['Float']>;
  trivia_category_fk?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "city_trivia_question" */
export type City_Trivia_Question_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  point_value?: InputMaybe<Order_By>;
  trivia_category_fk?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type City_Trivia_Question_Var_Samp_Fields = {
  __typename?: 'city_trivia_question_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  point_value?: Maybe<Scalars['Float']>;
  trivia_category_fk?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "city_trivia_question" */
export type City_Trivia_Question_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  point_value?: InputMaybe<Order_By>;
  trivia_category_fk?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type City_Trivia_Question_Variance_Fields = {
  __typename?: 'city_trivia_question_variance_fields';
  id?: Maybe<Scalars['Float']>;
  point_value?: Maybe<Scalars['Float']>;
  trivia_category_fk?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "city_trivia_question" */
export type City_Trivia_Question_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  point_value?: InputMaybe<Order_By>;
  trivia_category_fk?: InputMaybe<Order_By>;
};

/** columns and relationships of "city_trivia_round" */
export type City_Trivia_Round = {
  __typename?: 'city_trivia_round';
  id: Scalars['Int'];
  round_abbr: Scalars['String'];
  round_name: Scalars['String'];
};

/** aggregated selection of "city_trivia_round" */
export type City_Trivia_Round_Aggregate = {
  __typename?: 'city_trivia_round_aggregate';
  aggregate?: Maybe<City_Trivia_Round_Aggregate_Fields>;
  nodes: Array<City_Trivia_Round>;
};

/** aggregate fields of "city_trivia_round" */
export type City_Trivia_Round_Aggregate_Fields = {
  __typename?: 'city_trivia_round_aggregate_fields';
  avg?: Maybe<City_Trivia_Round_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<City_Trivia_Round_Max_Fields>;
  min?: Maybe<City_Trivia_Round_Min_Fields>;
  stddev?: Maybe<City_Trivia_Round_Stddev_Fields>;
  stddev_pop?: Maybe<City_Trivia_Round_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<City_Trivia_Round_Stddev_Samp_Fields>;
  sum?: Maybe<City_Trivia_Round_Sum_Fields>;
  var_pop?: Maybe<City_Trivia_Round_Var_Pop_Fields>;
  var_samp?: Maybe<City_Trivia_Round_Var_Samp_Fields>;
  variance?: Maybe<City_Trivia_Round_Variance_Fields>;
};


/** aggregate fields of "city_trivia_round" */
export type City_Trivia_Round_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<City_Trivia_Round_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "city_trivia_round" */
export type City_Trivia_Round_Aggregate_Order_By = {
  avg?: InputMaybe<City_Trivia_Round_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<City_Trivia_Round_Max_Order_By>;
  min?: InputMaybe<City_Trivia_Round_Min_Order_By>;
  stddev?: InputMaybe<City_Trivia_Round_Stddev_Order_By>;
  stddev_pop?: InputMaybe<City_Trivia_Round_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<City_Trivia_Round_Stddev_Samp_Order_By>;
  sum?: InputMaybe<City_Trivia_Round_Sum_Order_By>;
  var_pop?: InputMaybe<City_Trivia_Round_Var_Pop_Order_By>;
  var_samp?: InputMaybe<City_Trivia_Round_Var_Samp_Order_By>;
  variance?: InputMaybe<City_Trivia_Round_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "city_trivia_round" */
export type City_Trivia_Round_Arr_Rel_Insert_Input = {
  data: Array<City_Trivia_Round_Insert_Input>;
};

/** aggregate avg on columns */
export type City_Trivia_Round_Avg_Fields = {
  __typename?: 'city_trivia_round_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "city_trivia_round" */
export type City_Trivia_Round_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "city_trivia_round". All fields are combined with a logical 'AND'. */
export type City_Trivia_Round_Bool_Exp = {
  _and?: InputMaybe<Array<InputMaybe<City_Trivia_Round_Bool_Exp>>>;
  _not?: InputMaybe<City_Trivia_Round_Bool_Exp>;
  _or?: InputMaybe<Array<InputMaybe<City_Trivia_Round_Bool_Exp>>>;
  id?: InputMaybe<Int_Comparison_Exp>;
  round_abbr?: InputMaybe<String_Comparison_Exp>;
  round_name?: InputMaybe<String_Comparison_Exp>;
};

/** input type for incrementing integer column in table "city_trivia_round" */
export type City_Trivia_Round_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "city_trivia_round" */
export type City_Trivia_Round_Insert_Input = {
  id?: InputMaybe<Scalars['Int']>;
  round_abbr?: InputMaybe<Scalars['String']>;
  round_name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type City_Trivia_Round_Max_Fields = {
  __typename?: 'city_trivia_round_max_fields';
  id?: Maybe<Scalars['Int']>;
  round_abbr?: Maybe<Scalars['String']>;
  round_name?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "city_trivia_round" */
export type City_Trivia_Round_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  round_abbr?: InputMaybe<Order_By>;
  round_name?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type City_Trivia_Round_Min_Fields = {
  __typename?: 'city_trivia_round_min_fields';
  id?: Maybe<Scalars['Int']>;
  round_abbr?: Maybe<Scalars['String']>;
  round_name?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "city_trivia_round" */
export type City_Trivia_Round_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  round_abbr?: InputMaybe<Order_By>;
  round_name?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "city_trivia_round" */
export type City_Trivia_Round_Mutation_Response = {
  __typename?: 'city_trivia_round_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<City_Trivia_Round>;
};

/** input type for inserting object relation for remote table "city_trivia_round" */
export type City_Trivia_Round_Obj_Rel_Insert_Input = {
  data: City_Trivia_Round_Insert_Input;
};

/** ordering options when selecting data from "city_trivia_round" */
export type City_Trivia_Round_Order_By = {
  id?: InputMaybe<Order_By>;
  round_abbr?: InputMaybe<Order_By>;
  round_name?: InputMaybe<Order_By>;
};

/** select columns of table "city_trivia_round" */
export enum City_Trivia_Round_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  RoundAbbr = 'round_abbr',
  /** column name */
  RoundName = 'round_name'
}

/** input type for updating data in table "city_trivia_round" */
export type City_Trivia_Round_Set_Input = {
  id?: InputMaybe<Scalars['Int']>;
  round_abbr?: InputMaybe<Scalars['String']>;
  round_name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type City_Trivia_Round_Stddev_Fields = {
  __typename?: 'city_trivia_round_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "city_trivia_round" */
export type City_Trivia_Round_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type City_Trivia_Round_Stddev_Pop_Fields = {
  __typename?: 'city_trivia_round_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "city_trivia_round" */
export type City_Trivia_Round_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type City_Trivia_Round_Stddev_Samp_Fields = {
  __typename?: 'city_trivia_round_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "city_trivia_round" */
export type City_Trivia_Round_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type City_Trivia_Round_Sum_Fields = {
  __typename?: 'city_trivia_round_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "city_trivia_round" */
export type City_Trivia_Round_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type City_Trivia_Round_Var_Pop_Fields = {
  __typename?: 'city_trivia_round_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "city_trivia_round" */
export type City_Trivia_Round_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type City_Trivia_Round_Var_Samp_Fields = {
  __typename?: 'city_trivia_round_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "city_trivia_round" */
export type City_Trivia_Round_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type City_Trivia_Round_Variance_Fields = {
  __typename?: 'city_trivia_round_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "city_trivia_round" */
export type City_Trivia_Round_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** expression to compare columns of type date. All fields are combined with logical 'AND'. */
export type Date_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['date']>;
  _gt?: InputMaybe<Scalars['date']>;
  _gte?: InputMaybe<Scalars['date']>;
  _in?: InputMaybe<Array<Scalars['date']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['date']>;
  _lte?: InputMaybe<Scalars['date']>;
  _neq?: InputMaybe<Scalars['date']>;
  _nin?: InputMaybe<Array<Scalars['date']>>;
};

/** columns and relationships of "dayle_sessions" */
export type Dayle_Sessions = {
  __typename?: 'dayle_sessions';
  dayle_session_id: Scalars['Int'];
  end_time: Scalars['timetz'];
  start_time: Scalars['timetz'];
};

/** aggregated selection of "dayle_sessions" */
export type Dayle_Sessions_Aggregate = {
  __typename?: 'dayle_sessions_aggregate';
  aggregate?: Maybe<Dayle_Sessions_Aggregate_Fields>;
  nodes: Array<Dayle_Sessions>;
};

/** aggregate fields of "dayle_sessions" */
export type Dayle_Sessions_Aggregate_Fields = {
  __typename?: 'dayle_sessions_aggregate_fields';
  avg?: Maybe<Dayle_Sessions_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Dayle_Sessions_Max_Fields>;
  min?: Maybe<Dayle_Sessions_Min_Fields>;
  stddev?: Maybe<Dayle_Sessions_Stddev_Fields>;
  stddev_pop?: Maybe<Dayle_Sessions_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Dayle_Sessions_Stddev_Samp_Fields>;
  sum?: Maybe<Dayle_Sessions_Sum_Fields>;
  var_pop?: Maybe<Dayle_Sessions_Var_Pop_Fields>;
  var_samp?: Maybe<Dayle_Sessions_Var_Samp_Fields>;
  variance?: Maybe<Dayle_Sessions_Variance_Fields>;
};


/** aggregate fields of "dayle_sessions" */
export type Dayle_Sessions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Dayle_Sessions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "dayle_sessions" */
export type Dayle_Sessions_Aggregate_Order_By = {
  avg?: InputMaybe<Dayle_Sessions_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Dayle_Sessions_Max_Order_By>;
  min?: InputMaybe<Dayle_Sessions_Min_Order_By>;
  stddev?: InputMaybe<Dayle_Sessions_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Dayle_Sessions_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Dayle_Sessions_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Dayle_Sessions_Sum_Order_By>;
  var_pop?: InputMaybe<Dayle_Sessions_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Dayle_Sessions_Var_Samp_Order_By>;
  variance?: InputMaybe<Dayle_Sessions_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "dayle_sessions" */
export type Dayle_Sessions_Arr_Rel_Insert_Input = {
  data: Array<Dayle_Sessions_Insert_Input>;
  on_conflict?: InputMaybe<Dayle_Sessions_On_Conflict>;
};

/** aggregate avg on columns */
export type Dayle_Sessions_Avg_Fields = {
  __typename?: 'dayle_sessions_avg_fields';
  dayle_session_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "dayle_sessions" */
export type Dayle_Sessions_Avg_Order_By = {
  dayle_session_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "dayle_sessions". All fields are combined with a logical 'AND'. */
export type Dayle_Sessions_Bool_Exp = {
  _and?: InputMaybe<Array<InputMaybe<Dayle_Sessions_Bool_Exp>>>;
  _not?: InputMaybe<Dayle_Sessions_Bool_Exp>;
  _or?: InputMaybe<Array<InputMaybe<Dayle_Sessions_Bool_Exp>>>;
  dayle_session_id?: InputMaybe<Int_Comparison_Exp>;
  end_time?: InputMaybe<Timetz_Comparison_Exp>;
  start_time?: InputMaybe<Timetz_Comparison_Exp>;
};

/** unique or primary key constraints on table "dayle_sessions" */
export enum Dayle_Sessions_Constraint {
  /** unique or primary key constraint */
  DayleSessionsPkey = 'dayle_sessions_pkey'
}

/** input type for incrementing integer column in table "dayle_sessions" */
export type Dayle_Sessions_Inc_Input = {
  dayle_session_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "dayle_sessions" */
export type Dayle_Sessions_Insert_Input = {
  dayle_session_id?: InputMaybe<Scalars['Int']>;
  end_time?: InputMaybe<Scalars['timetz']>;
  start_time?: InputMaybe<Scalars['timetz']>;
};

/** aggregate max on columns */
export type Dayle_Sessions_Max_Fields = {
  __typename?: 'dayle_sessions_max_fields';
  dayle_session_id?: Maybe<Scalars['Int']>;
  end_time?: Maybe<Scalars['timetz']>;
  start_time?: Maybe<Scalars['timetz']>;
};

/** order by max() on columns of table "dayle_sessions" */
export type Dayle_Sessions_Max_Order_By = {
  dayle_session_id?: InputMaybe<Order_By>;
  end_time?: InputMaybe<Order_By>;
  start_time?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Dayle_Sessions_Min_Fields = {
  __typename?: 'dayle_sessions_min_fields';
  dayle_session_id?: Maybe<Scalars['Int']>;
  end_time?: Maybe<Scalars['timetz']>;
  start_time?: Maybe<Scalars['timetz']>;
};

/** order by min() on columns of table "dayle_sessions" */
export type Dayle_Sessions_Min_Order_By = {
  dayle_session_id?: InputMaybe<Order_By>;
  end_time?: InputMaybe<Order_By>;
  start_time?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "dayle_sessions" */
export type Dayle_Sessions_Mutation_Response = {
  __typename?: 'dayle_sessions_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Dayle_Sessions>;
};

/** input type for inserting object relation for remote table "dayle_sessions" */
export type Dayle_Sessions_Obj_Rel_Insert_Input = {
  data: Dayle_Sessions_Insert_Input;
  on_conflict?: InputMaybe<Dayle_Sessions_On_Conflict>;
};

/** on conflict condition type for table "dayle_sessions" */
export type Dayle_Sessions_On_Conflict = {
  constraint: Dayle_Sessions_Constraint;
  update_columns: Array<Dayle_Sessions_Update_Column>;
  where?: InputMaybe<Dayle_Sessions_Bool_Exp>;
};

/** ordering options when selecting data from "dayle_sessions" */
export type Dayle_Sessions_Order_By = {
  dayle_session_id?: InputMaybe<Order_By>;
  end_time?: InputMaybe<Order_By>;
  start_time?: InputMaybe<Order_By>;
};

/** primary key columns input for table: "dayle_sessions" */
export type Dayle_Sessions_Pk_Columns_Input = {
  dayle_session_id: Scalars['Int'];
};

/** select columns of table "dayle_sessions" */
export enum Dayle_Sessions_Select_Column {
  /** column name */
  DayleSessionId = 'dayle_session_id',
  /** column name */
  EndTime = 'end_time',
  /** column name */
  StartTime = 'start_time'
}

/** input type for updating data in table "dayle_sessions" */
export type Dayle_Sessions_Set_Input = {
  dayle_session_id?: InputMaybe<Scalars['Int']>;
  end_time?: InputMaybe<Scalars['timetz']>;
  start_time?: InputMaybe<Scalars['timetz']>;
};

/** aggregate stddev on columns */
export type Dayle_Sessions_Stddev_Fields = {
  __typename?: 'dayle_sessions_stddev_fields';
  dayle_session_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "dayle_sessions" */
export type Dayle_Sessions_Stddev_Order_By = {
  dayle_session_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Dayle_Sessions_Stddev_Pop_Fields = {
  __typename?: 'dayle_sessions_stddev_pop_fields';
  dayle_session_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "dayle_sessions" */
export type Dayle_Sessions_Stddev_Pop_Order_By = {
  dayle_session_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Dayle_Sessions_Stddev_Samp_Fields = {
  __typename?: 'dayle_sessions_stddev_samp_fields';
  dayle_session_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "dayle_sessions" */
export type Dayle_Sessions_Stddev_Samp_Order_By = {
  dayle_session_id?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Dayle_Sessions_Sum_Fields = {
  __typename?: 'dayle_sessions_sum_fields';
  dayle_session_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "dayle_sessions" */
export type Dayle_Sessions_Sum_Order_By = {
  dayle_session_id?: InputMaybe<Order_By>;
};

/** update columns of table "dayle_sessions" */
export enum Dayle_Sessions_Update_Column {
  /** column name */
  DayleSessionId = 'dayle_session_id',
  /** column name */
  EndTime = 'end_time',
  /** column name */
  StartTime = 'start_time'
}

/** aggregate var_pop on columns */
export type Dayle_Sessions_Var_Pop_Fields = {
  __typename?: 'dayle_sessions_var_pop_fields';
  dayle_session_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "dayle_sessions" */
export type Dayle_Sessions_Var_Pop_Order_By = {
  dayle_session_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Dayle_Sessions_Var_Samp_Fields = {
  __typename?: 'dayle_sessions_var_samp_fields';
  dayle_session_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "dayle_sessions" */
export type Dayle_Sessions_Var_Samp_Order_By = {
  dayle_session_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Dayle_Sessions_Variance_Fields = {
  __typename?: 'dayle_sessions_variance_fields';
  dayle_session_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "dayle_sessions" */
export type Dayle_Sessions_Variance_Order_By = {
  dayle_session_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "edit_log" */
export type Edit_Log = {
  __typename?: 'edit_log';
  approved_user_id?: Maybe<Scalars['uuid']>;
  edit_datetime: Scalars['timestamp'];
  edit_log_id: Scalars['uuid'];
  /** An object relationship */
  edit_log_type?: Maybe<Edit_Log_Types>;
  edit_log_type_id?: Maybe<Scalars['Int']>;
  edit_note?: Maybe<Scalars['String']>;
  editor_user_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  question: Questions;
  question_id: Scalars['uuid'];
  rejection_note?: Maybe<Scalars['String']>;
  rejection_reason_id?: Maybe<Scalars['Int']>;
  rejector_user_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  trivia_user?: Maybe<Trivia_Users>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** aggregated selection of "edit_log" */
export type Edit_Log_Aggregate = {
  __typename?: 'edit_log_aggregate';
  aggregate?: Maybe<Edit_Log_Aggregate_Fields>;
  nodes: Array<Edit_Log>;
};

/** aggregate fields of "edit_log" */
export type Edit_Log_Aggregate_Fields = {
  __typename?: 'edit_log_aggregate_fields';
  avg?: Maybe<Edit_Log_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Edit_Log_Max_Fields>;
  min?: Maybe<Edit_Log_Min_Fields>;
  stddev?: Maybe<Edit_Log_Stddev_Fields>;
  stddev_pop?: Maybe<Edit_Log_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Edit_Log_Stddev_Samp_Fields>;
  sum?: Maybe<Edit_Log_Sum_Fields>;
  var_pop?: Maybe<Edit_Log_Var_Pop_Fields>;
  var_samp?: Maybe<Edit_Log_Var_Samp_Fields>;
  variance?: Maybe<Edit_Log_Variance_Fields>;
};


/** aggregate fields of "edit_log" */
export type Edit_Log_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Edit_Log_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "edit_log" */
export type Edit_Log_Aggregate_Order_By = {
  avg?: InputMaybe<Edit_Log_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Edit_Log_Max_Order_By>;
  min?: InputMaybe<Edit_Log_Min_Order_By>;
  stddev?: InputMaybe<Edit_Log_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Edit_Log_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Edit_Log_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Edit_Log_Sum_Order_By>;
  var_pop?: InputMaybe<Edit_Log_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Edit_Log_Var_Samp_Order_By>;
  variance?: InputMaybe<Edit_Log_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "edit_log" */
export type Edit_Log_Arr_Rel_Insert_Input = {
  data: Array<Edit_Log_Insert_Input>;
  on_conflict?: InputMaybe<Edit_Log_On_Conflict>;
};

/** aggregate avg on columns */
export type Edit_Log_Avg_Fields = {
  __typename?: 'edit_log_avg_fields';
  edit_log_type_id?: Maybe<Scalars['Float']>;
  rejection_reason_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "edit_log" */
export type Edit_Log_Avg_Order_By = {
  edit_log_type_id?: InputMaybe<Order_By>;
  rejection_reason_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "edit_log". All fields are combined with a logical 'AND'. */
export type Edit_Log_Bool_Exp = {
  _and?: InputMaybe<Array<InputMaybe<Edit_Log_Bool_Exp>>>;
  _not?: InputMaybe<Edit_Log_Bool_Exp>;
  _or?: InputMaybe<Array<InputMaybe<Edit_Log_Bool_Exp>>>;
  approved_user_id?: InputMaybe<Uuid_Comparison_Exp>;
  edit_datetime?: InputMaybe<Timestamp_Comparison_Exp>;
  edit_log_id?: InputMaybe<Uuid_Comparison_Exp>;
  edit_log_type?: InputMaybe<Edit_Log_Types_Bool_Exp>;
  edit_log_type_id?: InputMaybe<Int_Comparison_Exp>;
  edit_note?: InputMaybe<String_Comparison_Exp>;
  editor_user_id?: InputMaybe<Uuid_Comparison_Exp>;
  question?: InputMaybe<Questions_Bool_Exp>;
  question_id?: InputMaybe<Uuid_Comparison_Exp>;
  rejection_note?: InputMaybe<String_Comparison_Exp>;
  rejection_reason_id?: InputMaybe<Int_Comparison_Exp>;
  rejector_user_id?: InputMaybe<Uuid_Comparison_Exp>;
  trivia_user?: InputMaybe<Trivia_Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "edit_log" */
export enum Edit_Log_Constraint {
  /** unique or primary key constraint */
  EditLogPkey = 'edit_log_pkey'
}

/** input type for incrementing integer column in table "edit_log" */
export type Edit_Log_Inc_Input = {
  edit_log_type_id?: InputMaybe<Scalars['Int']>;
  rejection_reason_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "edit_log" */
export type Edit_Log_Insert_Input = {
  approved_user_id?: InputMaybe<Scalars['uuid']>;
  edit_datetime?: InputMaybe<Scalars['timestamp']>;
  edit_log_id?: InputMaybe<Scalars['uuid']>;
  edit_log_type?: InputMaybe<Edit_Log_Types_Obj_Rel_Insert_Input>;
  edit_log_type_id?: InputMaybe<Scalars['Int']>;
  edit_note?: InputMaybe<Scalars['String']>;
  editor_user_id?: InputMaybe<Scalars['uuid']>;
  question?: InputMaybe<Questions_Obj_Rel_Insert_Input>;
  question_id?: InputMaybe<Scalars['uuid']>;
  rejection_note?: InputMaybe<Scalars['String']>;
  rejection_reason_id?: InputMaybe<Scalars['Int']>;
  rejector_user_id?: InputMaybe<Scalars['uuid']>;
  trivia_user?: InputMaybe<Trivia_Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Edit_Log_Max_Fields = {
  __typename?: 'edit_log_max_fields';
  approved_user_id?: Maybe<Scalars['uuid']>;
  edit_datetime?: Maybe<Scalars['timestamp']>;
  edit_log_id?: Maybe<Scalars['uuid']>;
  edit_log_type_id?: Maybe<Scalars['Int']>;
  edit_note?: Maybe<Scalars['String']>;
  editor_user_id?: Maybe<Scalars['uuid']>;
  question_id?: Maybe<Scalars['uuid']>;
  rejection_note?: Maybe<Scalars['String']>;
  rejection_reason_id?: Maybe<Scalars['Int']>;
  rejector_user_id?: Maybe<Scalars['uuid']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "edit_log" */
export type Edit_Log_Max_Order_By = {
  approved_user_id?: InputMaybe<Order_By>;
  edit_datetime?: InputMaybe<Order_By>;
  edit_log_id?: InputMaybe<Order_By>;
  edit_log_type_id?: InputMaybe<Order_By>;
  edit_note?: InputMaybe<Order_By>;
  editor_user_id?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
  rejection_note?: InputMaybe<Order_By>;
  rejection_reason_id?: InputMaybe<Order_By>;
  rejector_user_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Edit_Log_Min_Fields = {
  __typename?: 'edit_log_min_fields';
  approved_user_id?: Maybe<Scalars['uuid']>;
  edit_datetime?: Maybe<Scalars['timestamp']>;
  edit_log_id?: Maybe<Scalars['uuid']>;
  edit_log_type_id?: Maybe<Scalars['Int']>;
  edit_note?: Maybe<Scalars['String']>;
  editor_user_id?: Maybe<Scalars['uuid']>;
  question_id?: Maybe<Scalars['uuid']>;
  rejection_note?: Maybe<Scalars['String']>;
  rejection_reason_id?: Maybe<Scalars['Int']>;
  rejector_user_id?: Maybe<Scalars['uuid']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "edit_log" */
export type Edit_Log_Min_Order_By = {
  approved_user_id?: InputMaybe<Order_By>;
  edit_datetime?: InputMaybe<Order_By>;
  edit_log_id?: InputMaybe<Order_By>;
  edit_log_type_id?: InputMaybe<Order_By>;
  edit_note?: InputMaybe<Order_By>;
  editor_user_id?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
  rejection_note?: InputMaybe<Order_By>;
  rejection_reason_id?: InputMaybe<Order_By>;
  rejector_user_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "edit_log" */
export type Edit_Log_Mutation_Response = {
  __typename?: 'edit_log_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Edit_Log>;
};

/** input type for inserting object relation for remote table "edit_log" */
export type Edit_Log_Obj_Rel_Insert_Input = {
  data: Edit_Log_Insert_Input;
  on_conflict?: InputMaybe<Edit_Log_On_Conflict>;
};

/** on conflict condition type for table "edit_log" */
export type Edit_Log_On_Conflict = {
  constraint: Edit_Log_Constraint;
  update_columns: Array<Edit_Log_Update_Column>;
  where?: InputMaybe<Edit_Log_Bool_Exp>;
};

/** ordering options when selecting data from "edit_log" */
export type Edit_Log_Order_By = {
  approved_user_id?: InputMaybe<Order_By>;
  edit_datetime?: InputMaybe<Order_By>;
  edit_log_id?: InputMaybe<Order_By>;
  edit_log_type?: InputMaybe<Edit_Log_Types_Order_By>;
  edit_log_type_id?: InputMaybe<Order_By>;
  edit_note?: InputMaybe<Order_By>;
  editor_user_id?: InputMaybe<Order_By>;
  question?: InputMaybe<Questions_Order_By>;
  question_id?: InputMaybe<Order_By>;
  rejection_note?: InputMaybe<Order_By>;
  rejection_reason_id?: InputMaybe<Order_By>;
  rejector_user_id?: InputMaybe<Order_By>;
  trivia_user?: InputMaybe<Trivia_Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: "edit_log" */
export type Edit_Log_Pk_Columns_Input = {
  edit_log_id: Scalars['uuid'];
};

/** select columns of table "edit_log" */
export enum Edit_Log_Select_Column {
  /** column name */
  ApprovedUserId = 'approved_user_id',
  /** column name */
  EditDatetime = 'edit_datetime',
  /** column name */
  EditLogId = 'edit_log_id',
  /** column name */
  EditLogTypeId = 'edit_log_type_id',
  /** column name */
  EditNote = 'edit_note',
  /** column name */
  EditorUserId = 'editor_user_id',
  /** column name */
  QuestionId = 'question_id',
  /** column name */
  RejectionNote = 'rejection_note',
  /** column name */
  RejectionReasonId = 'rejection_reason_id',
  /** column name */
  RejectorUserId = 'rejector_user_id',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "edit_log" */
export type Edit_Log_Set_Input = {
  approved_user_id?: InputMaybe<Scalars['uuid']>;
  edit_datetime?: InputMaybe<Scalars['timestamp']>;
  edit_log_id?: InputMaybe<Scalars['uuid']>;
  edit_log_type_id?: InputMaybe<Scalars['Int']>;
  edit_note?: InputMaybe<Scalars['String']>;
  editor_user_id?: InputMaybe<Scalars['uuid']>;
  question_id?: InputMaybe<Scalars['uuid']>;
  rejection_note?: InputMaybe<Scalars['String']>;
  rejection_reason_id?: InputMaybe<Scalars['Int']>;
  rejector_user_id?: InputMaybe<Scalars['uuid']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Edit_Log_Stddev_Fields = {
  __typename?: 'edit_log_stddev_fields';
  edit_log_type_id?: Maybe<Scalars['Float']>;
  rejection_reason_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "edit_log" */
export type Edit_Log_Stddev_Order_By = {
  edit_log_type_id?: InputMaybe<Order_By>;
  rejection_reason_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Edit_Log_Stddev_Pop_Fields = {
  __typename?: 'edit_log_stddev_pop_fields';
  edit_log_type_id?: Maybe<Scalars['Float']>;
  rejection_reason_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "edit_log" */
export type Edit_Log_Stddev_Pop_Order_By = {
  edit_log_type_id?: InputMaybe<Order_By>;
  rejection_reason_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Edit_Log_Stddev_Samp_Fields = {
  __typename?: 'edit_log_stddev_samp_fields';
  edit_log_type_id?: Maybe<Scalars['Float']>;
  rejection_reason_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "edit_log" */
export type Edit_Log_Stddev_Samp_Order_By = {
  edit_log_type_id?: InputMaybe<Order_By>;
  rejection_reason_id?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Edit_Log_Sum_Fields = {
  __typename?: 'edit_log_sum_fields';
  edit_log_type_id?: Maybe<Scalars['Int']>;
  rejection_reason_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "edit_log" */
export type Edit_Log_Sum_Order_By = {
  edit_log_type_id?: InputMaybe<Order_By>;
  rejection_reason_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "edit_log_types" */
export type Edit_Log_Types = {
  __typename?: 'edit_log_types';
  auto_generate: Scalars['Boolean'];
  edit_log_type_id: Scalars['Int'];
  edit_log_type_name: Scalars['String'];
};

/** aggregated selection of "edit_log_types" */
export type Edit_Log_Types_Aggregate = {
  __typename?: 'edit_log_types_aggregate';
  aggregate?: Maybe<Edit_Log_Types_Aggregate_Fields>;
  nodes: Array<Edit_Log_Types>;
};

/** aggregate fields of "edit_log_types" */
export type Edit_Log_Types_Aggregate_Fields = {
  __typename?: 'edit_log_types_aggregate_fields';
  avg?: Maybe<Edit_Log_Types_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Edit_Log_Types_Max_Fields>;
  min?: Maybe<Edit_Log_Types_Min_Fields>;
  stddev?: Maybe<Edit_Log_Types_Stddev_Fields>;
  stddev_pop?: Maybe<Edit_Log_Types_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Edit_Log_Types_Stddev_Samp_Fields>;
  sum?: Maybe<Edit_Log_Types_Sum_Fields>;
  var_pop?: Maybe<Edit_Log_Types_Var_Pop_Fields>;
  var_samp?: Maybe<Edit_Log_Types_Var_Samp_Fields>;
  variance?: Maybe<Edit_Log_Types_Variance_Fields>;
};


/** aggregate fields of "edit_log_types" */
export type Edit_Log_Types_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Edit_Log_Types_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "edit_log_types" */
export type Edit_Log_Types_Aggregate_Order_By = {
  avg?: InputMaybe<Edit_Log_Types_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Edit_Log_Types_Max_Order_By>;
  min?: InputMaybe<Edit_Log_Types_Min_Order_By>;
  stddev?: InputMaybe<Edit_Log_Types_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Edit_Log_Types_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Edit_Log_Types_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Edit_Log_Types_Sum_Order_By>;
  var_pop?: InputMaybe<Edit_Log_Types_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Edit_Log_Types_Var_Samp_Order_By>;
  variance?: InputMaybe<Edit_Log_Types_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "edit_log_types" */
export type Edit_Log_Types_Arr_Rel_Insert_Input = {
  data: Array<Edit_Log_Types_Insert_Input>;
  on_conflict?: InputMaybe<Edit_Log_Types_On_Conflict>;
};

/** aggregate avg on columns */
export type Edit_Log_Types_Avg_Fields = {
  __typename?: 'edit_log_types_avg_fields';
  edit_log_type_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "edit_log_types" */
export type Edit_Log_Types_Avg_Order_By = {
  edit_log_type_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "edit_log_types". All fields are combined with a logical 'AND'. */
export type Edit_Log_Types_Bool_Exp = {
  _and?: InputMaybe<Array<InputMaybe<Edit_Log_Types_Bool_Exp>>>;
  _not?: InputMaybe<Edit_Log_Types_Bool_Exp>;
  _or?: InputMaybe<Array<InputMaybe<Edit_Log_Types_Bool_Exp>>>;
  auto_generate?: InputMaybe<Boolean_Comparison_Exp>;
  edit_log_type_id?: InputMaybe<Int_Comparison_Exp>;
  edit_log_type_name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "edit_log_types" */
export enum Edit_Log_Types_Constraint {
  /** unique or primary key constraint */
  EditLogTypesPkey = 'edit_log_types_pkey'
}

/** input type for incrementing integer column in table "edit_log_types" */
export type Edit_Log_Types_Inc_Input = {
  edit_log_type_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "edit_log_types" */
export type Edit_Log_Types_Insert_Input = {
  auto_generate?: InputMaybe<Scalars['Boolean']>;
  edit_log_type_id?: InputMaybe<Scalars['Int']>;
  edit_log_type_name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Edit_Log_Types_Max_Fields = {
  __typename?: 'edit_log_types_max_fields';
  edit_log_type_id?: Maybe<Scalars['Int']>;
  edit_log_type_name?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "edit_log_types" */
export type Edit_Log_Types_Max_Order_By = {
  edit_log_type_id?: InputMaybe<Order_By>;
  edit_log_type_name?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Edit_Log_Types_Min_Fields = {
  __typename?: 'edit_log_types_min_fields';
  edit_log_type_id?: Maybe<Scalars['Int']>;
  edit_log_type_name?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "edit_log_types" */
export type Edit_Log_Types_Min_Order_By = {
  edit_log_type_id?: InputMaybe<Order_By>;
  edit_log_type_name?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "edit_log_types" */
export type Edit_Log_Types_Mutation_Response = {
  __typename?: 'edit_log_types_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Edit_Log_Types>;
};

/** input type for inserting object relation for remote table "edit_log_types" */
export type Edit_Log_Types_Obj_Rel_Insert_Input = {
  data: Edit_Log_Types_Insert_Input;
  on_conflict?: InputMaybe<Edit_Log_Types_On_Conflict>;
};

/** on conflict condition type for table "edit_log_types" */
export type Edit_Log_Types_On_Conflict = {
  constraint: Edit_Log_Types_Constraint;
  update_columns: Array<Edit_Log_Types_Update_Column>;
  where?: InputMaybe<Edit_Log_Types_Bool_Exp>;
};

/** ordering options when selecting data from "edit_log_types" */
export type Edit_Log_Types_Order_By = {
  auto_generate?: InputMaybe<Order_By>;
  edit_log_type_id?: InputMaybe<Order_By>;
  edit_log_type_name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: "edit_log_types" */
export type Edit_Log_Types_Pk_Columns_Input = {
  edit_log_type_id: Scalars['Int'];
};

/** select columns of table "edit_log_types" */
export enum Edit_Log_Types_Select_Column {
  /** column name */
  AutoGenerate = 'auto_generate',
  /** column name */
  EditLogTypeId = 'edit_log_type_id',
  /** column name */
  EditLogTypeName = 'edit_log_type_name'
}

/** input type for updating data in table "edit_log_types" */
export type Edit_Log_Types_Set_Input = {
  auto_generate?: InputMaybe<Scalars['Boolean']>;
  edit_log_type_id?: InputMaybe<Scalars['Int']>;
  edit_log_type_name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Edit_Log_Types_Stddev_Fields = {
  __typename?: 'edit_log_types_stddev_fields';
  edit_log_type_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "edit_log_types" */
export type Edit_Log_Types_Stddev_Order_By = {
  edit_log_type_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Edit_Log_Types_Stddev_Pop_Fields = {
  __typename?: 'edit_log_types_stddev_pop_fields';
  edit_log_type_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "edit_log_types" */
export type Edit_Log_Types_Stddev_Pop_Order_By = {
  edit_log_type_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Edit_Log_Types_Stddev_Samp_Fields = {
  __typename?: 'edit_log_types_stddev_samp_fields';
  edit_log_type_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "edit_log_types" */
export type Edit_Log_Types_Stddev_Samp_Order_By = {
  edit_log_type_id?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Edit_Log_Types_Sum_Fields = {
  __typename?: 'edit_log_types_sum_fields';
  edit_log_type_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "edit_log_types" */
export type Edit_Log_Types_Sum_Order_By = {
  edit_log_type_id?: InputMaybe<Order_By>;
};

/** update columns of table "edit_log_types" */
export enum Edit_Log_Types_Update_Column {
  /** column name */
  AutoGenerate = 'auto_generate',
  /** column name */
  EditLogTypeId = 'edit_log_type_id',
  /** column name */
  EditLogTypeName = 'edit_log_type_name'
}

/** aggregate var_pop on columns */
export type Edit_Log_Types_Var_Pop_Fields = {
  __typename?: 'edit_log_types_var_pop_fields';
  edit_log_type_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "edit_log_types" */
export type Edit_Log_Types_Var_Pop_Order_By = {
  edit_log_type_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Edit_Log_Types_Var_Samp_Fields = {
  __typename?: 'edit_log_types_var_samp_fields';
  edit_log_type_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "edit_log_types" */
export type Edit_Log_Types_Var_Samp_Order_By = {
  edit_log_type_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Edit_Log_Types_Variance_Fields = {
  __typename?: 'edit_log_types_variance_fields';
  edit_log_type_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "edit_log_types" */
export type Edit_Log_Types_Variance_Order_By = {
  edit_log_type_id?: InputMaybe<Order_By>;
};

/** update columns of table "edit_log" */
export enum Edit_Log_Update_Column {
  /** column name */
  ApprovedUserId = 'approved_user_id',
  /** column name */
  EditDatetime = 'edit_datetime',
  /** column name */
  EditLogId = 'edit_log_id',
  /** column name */
  EditLogTypeId = 'edit_log_type_id',
  /** column name */
  EditNote = 'edit_note',
  /** column name */
  EditorUserId = 'editor_user_id',
  /** column name */
  QuestionId = 'question_id',
  /** column name */
  RejectionNote = 'rejection_note',
  /** column name */
  RejectionReasonId = 'rejection_reason_id',
  /** column name */
  RejectorUserId = 'rejector_user_id',
  /** column name */
  UserId = 'user_id'
}

/** aggregate var_pop on columns */
export type Edit_Log_Var_Pop_Fields = {
  __typename?: 'edit_log_var_pop_fields';
  edit_log_type_id?: Maybe<Scalars['Float']>;
  rejection_reason_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "edit_log" */
export type Edit_Log_Var_Pop_Order_By = {
  edit_log_type_id?: InputMaybe<Order_By>;
  rejection_reason_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Edit_Log_Var_Samp_Fields = {
  __typename?: 'edit_log_var_samp_fields';
  edit_log_type_id?: Maybe<Scalars['Float']>;
  rejection_reason_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "edit_log" */
export type Edit_Log_Var_Samp_Order_By = {
  edit_log_type_id?: InputMaybe<Order_By>;
  rejection_reason_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Edit_Log_Variance_Fields = {
  __typename?: 'edit_log_variance_fields';
  edit_log_type_id?: Maybe<Scalars['Float']>;
  rejection_reason_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "edit_log" */
export type Edit_Log_Variance_Order_By = {
  edit_log_type_id?: InputMaybe<Order_By>;
  rejection_reason_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "forgot_password" */
export type Forgot_Password = {
  __typename?: 'forgot_password';
  endtime: Scalars['timestamptz'];
  forgot_password_id: Scalars['uuid'];
  token: Scalars['String'];
  user_id: Scalars['uuid'];
  user_key: Scalars['Int'];
};

/** aggregated selection of "forgot_password" */
export type Forgot_Password_Aggregate = {
  __typename?: 'forgot_password_aggregate';
  aggregate?: Maybe<Forgot_Password_Aggregate_Fields>;
  nodes: Array<Forgot_Password>;
};

/** aggregate fields of "forgot_password" */
export type Forgot_Password_Aggregate_Fields = {
  __typename?: 'forgot_password_aggregate_fields';
  avg?: Maybe<Forgot_Password_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Forgot_Password_Max_Fields>;
  min?: Maybe<Forgot_Password_Min_Fields>;
  stddev?: Maybe<Forgot_Password_Stddev_Fields>;
  stddev_pop?: Maybe<Forgot_Password_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Forgot_Password_Stddev_Samp_Fields>;
  sum?: Maybe<Forgot_Password_Sum_Fields>;
  var_pop?: Maybe<Forgot_Password_Var_Pop_Fields>;
  var_samp?: Maybe<Forgot_Password_Var_Samp_Fields>;
  variance?: Maybe<Forgot_Password_Variance_Fields>;
};


/** aggregate fields of "forgot_password" */
export type Forgot_Password_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Forgot_Password_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "forgot_password" */
export type Forgot_Password_Aggregate_Order_By = {
  avg?: InputMaybe<Forgot_Password_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Forgot_Password_Max_Order_By>;
  min?: InputMaybe<Forgot_Password_Min_Order_By>;
  stddev?: InputMaybe<Forgot_Password_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Forgot_Password_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Forgot_Password_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Forgot_Password_Sum_Order_By>;
  var_pop?: InputMaybe<Forgot_Password_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Forgot_Password_Var_Samp_Order_By>;
  variance?: InputMaybe<Forgot_Password_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "forgot_password" */
export type Forgot_Password_Arr_Rel_Insert_Input = {
  data: Array<Forgot_Password_Insert_Input>;
  on_conflict?: InputMaybe<Forgot_Password_On_Conflict>;
};

/** aggregate avg on columns */
export type Forgot_Password_Avg_Fields = {
  __typename?: 'forgot_password_avg_fields';
  user_key?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "forgot_password" */
export type Forgot_Password_Avg_Order_By = {
  user_key?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "forgot_password". All fields are combined with a logical 'AND'. */
export type Forgot_Password_Bool_Exp = {
  _and?: InputMaybe<Array<InputMaybe<Forgot_Password_Bool_Exp>>>;
  _not?: InputMaybe<Forgot_Password_Bool_Exp>;
  _or?: InputMaybe<Array<InputMaybe<Forgot_Password_Bool_Exp>>>;
  endtime?: InputMaybe<Timestamptz_Comparison_Exp>;
  forgot_password_id?: InputMaybe<Uuid_Comparison_Exp>;
  token?: InputMaybe<String_Comparison_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
  user_key?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "forgot_password" */
export enum Forgot_Password_Constraint {
  /** unique or primary key constraint */
  ForgotPasswordPkey = 'forgot_password_pkey',
  /** unique or primary key constraint */
  ForgotPasswordTokenKey = 'forgot_password_token_key',
  /** unique or primary key constraint */
  ForgotPasswordUserIdKey = 'forgot_password_user_id_key',
  /** unique or primary key constraint */
  ForgotPasswordUserKeyKey = 'forgot_password_user_key_key'
}

/** input type for incrementing integer column in table "forgot_password" */
export type Forgot_Password_Inc_Input = {
  user_key?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "forgot_password" */
export type Forgot_Password_Insert_Input = {
  endtime?: InputMaybe<Scalars['timestamptz']>;
  forgot_password_id?: InputMaybe<Scalars['uuid']>;
  token?: InputMaybe<Scalars['String']>;
  user_id?: InputMaybe<Scalars['uuid']>;
  user_key?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Forgot_Password_Max_Fields = {
  __typename?: 'forgot_password_max_fields';
  endtime?: Maybe<Scalars['timestamptz']>;
  forgot_password_id?: Maybe<Scalars['uuid']>;
  token?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['uuid']>;
  user_key?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "forgot_password" */
export type Forgot_Password_Max_Order_By = {
  endtime?: InputMaybe<Order_By>;
  forgot_password_id?: InputMaybe<Order_By>;
  token?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  user_key?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Forgot_Password_Min_Fields = {
  __typename?: 'forgot_password_min_fields';
  endtime?: Maybe<Scalars['timestamptz']>;
  forgot_password_id?: Maybe<Scalars['uuid']>;
  token?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['uuid']>;
  user_key?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "forgot_password" */
export type Forgot_Password_Min_Order_By = {
  endtime?: InputMaybe<Order_By>;
  forgot_password_id?: InputMaybe<Order_By>;
  token?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  user_key?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "forgot_password" */
export type Forgot_Password_Mutation_Response = {
  __typename?: 'forgot_password_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Forgot_Password>;
};

/** input type for inserting object relation for remote table "forgot_password" */
export type Forgot_Password_Obj_Rel_Insert_Input = {
  data: Forgot_Password_Insert_Input;
  on_conflict?: InputMaybe<Forgot_Password_On_Conflict>;
};

/** on conflict condition type for table "forgot_password" */
export type Forgot_Password_On_Conflict = {
  constraint: Forgot_Password_Constraint;
  update_columns: Array<Forgot_Password_Update_Column>;
  where?: InputMaybe<Forgot_Password_Bool_Exp>;
};

/** ordering options when selecting data from "forgot_password" */
export type Forgot_Password_Order_By = {
  endtime?: InputMaybe<Order_By>;
  forgot_password_id?: InputMaybe<Order_By>;
  token?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  user_key?: InputMaybe<Order_By>;
};

/** primary key columns input for table: "forgot_password" */
export type Forgot_Password_Pk_Columns_Input = {
  forgot_password_id: Scalars['uuid'];
};

/** select columns of table "forgot_password" */
export enum Forgot_Password_Select_Column {
  /** column name */
  Endtime = 'endtime',
  /** column name */
  ForgotPasswordId = 'forgot_password_id',
  /** column name */
  Token = 'token',
  /** column name */
  UserId = 'user_id',
  /** column name */
  UserKey = 'user_key'
}

/** input type for updating data in table "forgot_password" */
export type Forgot_Password_Set_Input = {
  endtime?: InputMaybe<Scalars['timestamptz']>;
  forgot_password_id?: InputMaybe<Scalars['uuid']>;
  token?: InputMaybe<Scalars['String']>;
  user_id?: InputMaybe<Scalars['uuid']>;
  user_key?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Forgot_Password_Stddev_Fields = {
  __typename?: 'forgot_password_stddev_fields';
  user_key?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "forgot_password" */
export type Forgot_Password_Stddev_Order_By = {
  user_key?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Forgot_Password_Stddev_Pop_Fields = {
  __typename?: 'forgot_password_stddev_pop_fields';
  user_key?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "forgot_password" */
export type Forgot_Password_Stddev_Pop_Order_By = {
  user_key?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Forgot_Password_Stddev_Samp_Fields = {
  __typename?: 'forgot_password_stddev_samp_fields';
  user_key?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "forgot_password" */
export type Forgot_Password_Stddev_Samp_Order_By = {
  user_key?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Forgot_Password_Sum_Fields = {
  __typename?: 'forgot_password_sum_fields';
  user_key?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "forgot_password" */
export type Forgot_Password_Sum_Order_By = {
  user_key?: InputMaybe<Order_By>;
};

/** update columns of table "forgot_password" */
export enum Forgot_Password_Update_Column {
  /** column name */
  Endtime = 'endtime',
  /** column name */
  ForgotPasswordId = 'forgot_password_id',
  /** column name */
  Token = 'token',
  /** column name */
  UserId = 'user_id',
  /** column name */
  UserKey = 'user_key'
}

/** aggregate var_pop on columns */
export type Forgot_Password_Var_Pop_Fields = {
  __typename?: 'forgot_password_var_pop_fields';
  user_key?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "forgot_password" */
export type Forgot_Password_Var_Pop_Order_By = {
  user_key?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Forgot_Password_Var_Samp_Fields = {
  __typename?: 'forgot_password_var_samp_fields';
  user_key?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "forgot_password" */
export type Forgot_Password_Var_Samp_Order_By = {
  user_key?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Forgot_Password_Variance_Fields = {
  __typename?: 'forgot_password_variance_fields';
  user_key?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "forgot_password" */
export type Forgot_Password_Variance_Order_By = {
  user_key?: InputMaybe<Order_By>;
};

/** columns and relationships of "game_difficulties" */
export type Game_Difficulties = {
  __typename?: 'game_difficulties';
  game_difficult_id: Scalars['Int'];
  game_difficult_name: Scalars['String'];
};

/** aggregated selection of "game_difficulties" */
export type Game_Difficulties_Aggregate = {
  __typename?: 'game_difficulties_aggregate';
  aggregate?: Maybe<Game_Difficulties_Aggregate_Fields>;
  nodes: Array<Game_Difficulties>;
};

/** aggregate fields of "game_difficulties" */
export type Game_Difficulties_Aggregate_Fields = {
  __typename?: 'game_difficulties_aggregate_fields';
  avg?: Maybe<Game_Difficulties_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Game_Difficulties_Max_Fields>;
  min?: Maybe<Game_Difficulties_Min_Fields>;
  stddev?: Maybe<Game_Difficulties_Stddev_Fields>;
  stddev_pop?: Maybe<Game_Difficulties_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Game_Difficulties_Stddev_Samp_Fields>;
  sum?: Maybe<Game_Difficulties_Sum_Fields>;
  var_pop?: Maybe<Game_Difficulties_Var_Pop_Fields>;
  var_samp?: Maybe<Game_Difficulties_Var_Samp_Fields>;
  variance?: Maybe<Game_Difficulties_Variance_Fields>;
};


/** aggregate fields of "game_difficulties" */
export type Game_Difficulties_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Game_Difficulties_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "game_difficulties" */
export type Game_Difficulties_Aggregate_Order_By = {
  avg?: InputMaybe<Game_Difficulties_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Game_Difficulties_Max_Order_By>;
  min?: InputMaybe<Game_Difficulties_Min_Order_By>;
  stddev?: InputMaybe<Game_Difficulties_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Game_Difficulties_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Game_Difficulties_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Game_Difficulties_Sum_Order_By>;
  var_pop?: InputMaybe<Game_Difficulties_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Game_Difficulties_Var_Samp_Order_By>;
  variance?: InputMaybe<Game_Difficulties_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "game_difficulties" */
export type Game_Difficulties_Arr_Rel_Insert_Input = {
  data: Array<Game_Difficulties_Insert_Input>;
  on_conflict?: InputMaybe<Game_Difficulties_On_Conflict>;
};

/** aggregate avg on columns */
export type Game_Difficulties_Avg_Fields = {
  __typename?: 'game_difficulties_avg_fields';
  game_difficult_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "game_difficulties" */
export type Game_Difficulties_Avg_Order_By = {
  game_difficult_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "game_difficulties". All fields are combined with a logical 'AND'. */
export type Game_Difficulties_Bool_Exp = {
  _and?: InputMaybe<Array<InputMaybe<Game_Difficulties_Bool_Exp>>>;
  _not?: InputMaybe<Game_Difficulties_Bool_Exp>;
  _or?: InputMaybe<Array<InputMaybe<Game_Difficulties_Bool_Exp>>>;
  game_difficult_id?: InputMaybe<Int_Comparison_Exp>;
  game_difficult_name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "game_difficulties" */
export enum Game_Difficulties_Constraint {
  /** unique or primary key constraint */
  GameDifficultiesPkey = 'game_difficulties_pkey'
}

/** input type for incrementing integer column in table "game_difficulties" */
export type Game_Difficulties_Inc_Input = {
  game_difficult_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "game_difficulties" */
export type Game_Difficulties_Insert_Input = {
  game_difficult_id?: InputMaybe<Scalars['Int']>;
  game_difficult_name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Game_Difficulties_Max_Fields = {
  __typename?: 'game_difficulties_max_fields';
  game_difficult_id?: Maybe<Scalars['Int']>;
  game_difficult_name?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "game_difficulties" */
export type Game_Difficulties_Max_Order_By = {
  game_difficult_id?: InputMaybe<Order_By>;
  game_difficult_name?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Game_Difficulties_Min_Fields = {
  __typename?: 'game_difficulties_min_fields';
  game_difficult_id?: Maybe<Scalars['Int']>;
  game_difficult_name?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "game_difficulties" */
export type Game_Difficulties_Min_Order_By = {
  game_difficult_id?: InputMaybe<Order_By>;
  game_difficult_name?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "game_difficulties" */
export type Game_Difficulties_Mutation_Response = {
  __typename?: 'game_difficulties_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Game_Difficulties>;
};

/** input type for inserting object relation for remote table "game_difficulties" */
export type Game_Difficulties_Obj_Rel_Insert_Input = {
  data: Game_Difficulties_Insert_Input;
  on_conflict?: InputMaybe<Game_Difficulties_On_Conflict>;
};

/** on conflict condition type for table "game_difficulties" */
export type Game_Difficulties_On_Conflict = {
  constraint: Game_Difficulties_Constraint;
  update_columns: Array<Game_Difficulties_Update_Column>;
  where?: InputMaybe<Game_Difficulties_Bool_Exp>;
};

/** ordering options when selecting data from "game_difficulties" */
export type Game_Difficulties_Order_By = {
  game_difficult_id?: InputMaybe<Order_By>;
  game_difficult_name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: "game_difficulties" */
export type Game_Difficulties_Pk_Columns_Input = {
  game_difficult_id: Scalars['Int'];
};

/** select columns of table "game_difficulties" */
export enum Game_Difficulties_Select_Column {
  /** column name */
  GameDifficultId = 'game_difficult_id',
  /** column name */
  GameDifficultName = 'game_difficult_name'
}

/** input type for updating data in table "game_difficulties" */
export type Game_Difficulties_Set_Input = {
  game_difficult_id?: InputMaybe<Scalars['Int']>;
  game_difficult_name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Game_Difficulties_Stddev_Fields = {
  __typename?: 'game_difficulties_stddev_fields';
  game_difficult_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "game_difficulties" */
export type Game_Difficulties_Stddev_Order_By = {
  game_difficult_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Game_Difficulties_Stddev_Pop_Fields = {
  __typename?: 'game_difficulties_stddev_pop_fields';
  game_difficult_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "game_difficulties" */
export type Game_Difficulties_Stddev_Pop_Order_By = {
  game_difficult_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Game_Difficulties_Stddev_Samp_Fields = {
  __typename?: 'game_difficulties_stddev_samp_fields';
  game_difficult_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "game_difficulties" */
export type Game_Difficulties_Stddev_Samp_Order_By = {
  game_difficult_id?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Game_Difficulties_Sum_Fields = {
  __typename?: 'game_difficulties_sum_fields';
  game_difficult_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "game_difficulties" */
export type Game_Difficulties_Sum_Order_By = {
  game_difficult_id?: InputMaybe<Order_By>;
};

/** update columns of table "game_difficulties" */
export enum Game_Difficulties_Update_Column {
  /** column name */
  GameDifficultId = 'game_difficult_id',
  /** column name */
  GameDifficultName = 'game_difficult_name'
}

/** aggregate var_pop on columns */
export type Game_Difficulties_Var_Pop_Fields = {
  __typename?: 'game_difficulties_var_pop_fields';
  game_difficult_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "game_difficulties" */
export type Game_Difficulties_Var_Pop_Order_By = {
  game_difficult_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Game_Difficulties_Var_Samp_Fields = {
  __typename?: 'game_difficulties_var_samp_fields';
  game_difficult_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "game_difficulties" */
export type Game_Difficulties_Var_Samp_Order_By = {
  game_difficult_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Game_Difficulties_Variance_Fields = {
  __typename?: 'game_difficulties_variance_fields';
  game_difficult_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "game_difficulties" */
export type Game_Difficulties_Variance_Order_By = {
  game_difficult_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "game_formats" */
export type Game_Formats = {
  __typename?: 'game_formats';
  game_format: Scalars['String'];
  game_format_id: Scalars['Int'];
};

/** aggregated selection of "game_formats" */
export type Game_Formats_Aggregate = {
  __typename?: 'game_formats_aggregate';
  aggregate?: Maybe<Game_Formats_Aggregate_Fields>;
  nodes: Array<Game_Formats>;
};

/** aggregate fields of "game_formats" */
export type Game_Formats_Aggregate_Fields = {
  __typename?: 'game_formats_aggregate_fields';
  avg?: Maybe<Game_Formats_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Game_Formats_Max_Fields>;
  min?: Maybe<Game_Formats_Min_Fields>;
  stddev?: Maybe<Game_Formats_Stddev_Fields>;
  stddev_pop?: Maybe<Game_Formats_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Game_Formats_Stddev_Samp_Fields>;
  sum?: Maybe<Game_Formats_Sum_Fields>;
  var_pop?: Maybe<Game_Formats_Var_Pop_Fields>;
  var_samp?: Maybe<Game_Formats_Var_Samp_Fields>;
  variance?: Maybe<Game_Formats_Variance_Fields>;
};


/** aggregate fields of "game_formats" */
export type Game_Formats_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Game_Formats_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "game_formats" */
export type Game_Formats_Aggregate_Order_By = {
  avg?: InputMaybe<Game_Formats_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Game_Formats_Max_Order_By>;
  min?: InputMaybe<Game_Formats_Min_Order_By>;
  stddev?: InputMaybe<Game_Formats_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Game_Formats_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Game_Formats_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Game_Formats_Sum_Order_By>;
  var_pop?: InputMaybe<Game_Formats_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Game_Formats_Var_Samp_Order_By>;
  variance?: InputMaybe<Game_Formats_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "game_formats" */
export type Game_Formats_Arr_Rel_Insert_Input = {
  data: Array<Game_Formats_Insert_Input>;
  on_conflict?: InputMaybe<Game_Formats_On_Conflict>;
};

/** aggregate avg on columns */
export type Game_Formats_Avg_Fields = {
  __typename?: 'game_formats_avg_fields';
  game_format_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "game_formats" */
export type Game_Formats_Avg_Order_By = {
  game_format_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "game_formats". All fields are combined with a logical 'AND'. */
export type Game_Formats_Bool_Exp = {
  _and?: InputMaybe<Array<InputMaybe<Game_Formats_Bool_Exp>>>;
  _not?: InputMaybe<Game_Formats_Bool_Exp>;
  _or?: InputMaybe<Array<InputMaybe<Game_Formats_Bool_Exp>>>;
  game_format?: InputMaybe<String_Comparison_Exp>;
  game_format_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "game_formats" */
export enum Game_Formats_Constraint {
  /** unique or primary key constraint */
  GameFormatsPkey = 'game_formats_pkey'
}

/** input type for incrementing integer column in table "game_formats" */
export type Game_Formats_Inc_Input = {
  game_format_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "game_formats" */
export type Game_Formats_Insert_Input = {
  game_format?: InputMaybe<Scalars['String']>;
  game_format_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Game_Formats_Max_Fields = {
  __typename?: 'game_formats_max_fields';
  game_format?: Maybe<Scalars['String']>;
  game_format_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "game_formats" */
export type Game_Formats_Max_Order_By = {
  game_format?: InputMaybe<Order_By>;
  game_format_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Game_Formats_Min_Fields = {
  __typename?: 'game_formats_min_fields';
  game_format?: Maybe<Scalars['String']>;
  game_format_id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "game_formats" */
export type Game_Formats_Min_Order_By = {
  game_format?: InputMaybe<Order_By>;
  game_format_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "game_formats" */
export type Game_Formats_Mutation_Response = {
  __typename?: 'game_formats_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Game_Formats>;
};

/** input type for inserting object relation for remote table "game_formats" */
export type Game_Formats_Obj_Rel_Insert_Input = {
  data: Game_Formats_Insert_Input;
  on_conflict?: InputMaybe<Game_Formats_On_Conflict>;
};

/** on conflict condition type for table "game_formats" */
export type Game_Formats_On_Conflict = {
  constraint: Game_Formats_Constraint;
  update_columns: Array<Game_Formats_Update_Column>;
  where?: InputMaybe<Game_Formats_Bool_Exp>;
};

/** ordering options when selecting data from "game_formats" */
export type Game_Formats_Order_By = {
  game_format?: InputMaybe<Order_By>;
  game_format_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: "game_formats" */
export type Game_Formats_Pk_Columns_Input = {
  game_format_id: Scalars['Int'];
};

/** select columns of table "game_formats" */
export enum Game_Formats_Select_Column {
  /** column name */
  GameFormat = 'game_format',
  /** column name */
  GameFormatId = 'game_format_id'
}

/** input type for updating data in table "game_formats" */
export type Game_Formats_Set_Input = {
  game_format?: InputMaybe<Scalars['String']>;
  game_format_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Game_Formats_Stddev_Fields = {
  __typename?: 'game_formats_stddev_fields';
  game_format_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "game_formats" */
export type Game_Formats_Stddev_Order_By = {
  game_format_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Game_Formats_Stddev_Pop_Fields = {
  __typename?: 'game_formats_stddev_pop_fields';
  game_format_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "game_formats" */
export type Game_Formats_Stddev_Pop_Order_By = {
  game_format_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Game_Formats_Stddev_Samp_Fields = {
  __typename?: 'game_formats_stddev_samp_fields';
  game_format_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "game_formats" */
export type Game_Formats_Stddev_Samp_Order_By = {
  game_format_id?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Game_Formats_Sum_Fields = {
  __typename?: 'game_formats_sum_fields';
  game_format_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "game_formats" */
export type Game_Formats_Sum_Order_By = {
  game_format_id?: InputMaybe<Order_By>;
};

/** update columns of table "game_formats" */
export enum Game_Formats_Update_Column {
  /** column name */
  GameFormat = 'game_format',
  /** column name */
  GameFormatId = 'game_format_id'
}

/** aggregate var_pop on columns */
export type Game_Formats_Var_Pop_Fields = {
  __typename?: 'game_formats_var_pop_fields';
  game_format_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "game_formats" */
export type Game_Formats_Var_Pop_Order_By = {
  game_format_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Game_Formats_Var_Samp_Fields = {
  __typename?: 'game_formats_var_samp_fields';
  game_format_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "game_formats" */
export type Game_Formats_Var_Samp_Order_By = {
  game_format_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Game_Formats_Variance_Fields = {
  __typename?: 'game_formats_variance_fields';
  game_format_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "game_formats" */
export type Game_Formats_Variance_Order_By = {
  game_format_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "game_ratings" */
export type Game_Ratings = {
  __typename?: 'game_ratings';
  id: Scalars['String'];
  name: Scalars['String'];
};

/** aggregated selection of "game_ratings" */
export type Game_Ratings_Aggregate = {
  __typename?: 'game_ratings_aggregate';
  aggregate?: Maybe<Game_Ratings_Aggregate_Fields>;
  nodes: Array<Game_Ratings>;
};

/** aggregate fields of "game_ratings" */
export type Game_Ratings_Aggregate_Fields = {
  __typename?: 'game_ratings_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Game_Ratings_Max_Fields>;
  min?: Maybe<Game_Ratings_Min_Fields>;
};


/** aggregate fields of "game_ratings" */
export type Game_Ratings_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Game_Ratings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "game_ratings" */
export type Game_Ratings_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Game_Ratings_Max_Order_By>;
  min?: InputMaybe<Game_Ratings_Min_Order_By>;
};

/** input type for inserting array relation for remote table "game_ratings" */
export type Game_Ratings_Arr_Rel_Insert_Input = {
  data: Array<Game_Ratings_Insert_Input>;
  on_conflict?: InputMaybe<Game_Ratings_On_Conflict>;
};

/** Boolean expression to filter rows from the table "game_ratings". All fields are combined with a logical 'AND'. */
export type Game_Ratings_Bool_Exp = {
  _and?: InputMaybe<Array<InputMaybe<Game_Ratings_Bool_Exp>>>;
  _not?: InputMaybe<Game_Ratings_Bool_Exp>;
  _or?: InputMaybe<Array<InputMaybe<Game_Ratings_Bool_Exp>>>;
  id?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "game_ratings" */
export enum Game_Ratings_Constraint {
  /** unique or primary key constraint */
  GameRatingsPkey = 'game_ratings_pkey'
}

/** input type for inserting data into table "game_ratings" */
export type Game_Ratings_Insert_Input = {
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Game_Ratings_Max_Fields = {
  __typename?: 'game_ratings_max_fields';
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "game_ratings" */
export type Game_Ratings_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Game_Ratings_Min_Fields = {
  __typename?: 'game_ratings_min_fields';
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "game_ratings" */
export type Game_Ratings_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "game_ratings" */
export type Game_Ratings_Mutation_Response = {
  __typename?: 'game_ratings_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Game_Ratings>;
};

/** input type for inserting object relation for remote table "game_ratings" */
export type Game_Ratings_Obj_Rel_Insert_Input = {
  data: Game_Ratings_Insert_Input;
  on_conflict?: InputMaybe<Game_Ratings_On_Conflict>;
};

/** on conflict condition type for table "game_ratings" */
export type Game_Ratings_On_Conflict = {
  constraint: Game_Ratings_Constraint;
  update_columns: Array<Game_Ratings_Update_Column>;
  where?: InputMaybe<Game_Ratings_Bool_Exp>;
};

/** ordering options when selecting data from "game_ratings" */
export type Game_Ratings_Order_By = {
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: "game_ratings" */
export type Game_Ratings_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** select columns of table "game_ratings" */
export enum Game_Ratings_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "game_ratings" */
export type Game_Ratings_Set_Input = {
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "game_ratings" */
export enum Game_Ratings_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** columns and relationships of "game_status" */
export type Game_Status = {
  __typename?: 'game_status';
  id: Scalars['Int'];
  name: Scalars['String'];
};

/** aggregated selection of "game_status" */
export type Game_Status_Aggregate = {
  __typename?: 'game_status_aggregate';
  aggregate?: Maybe<Game_Status_Aggregate_Fields>;
  nodes: Array<Game_Status>;
};

/** aggregate fields of "game_status" */
export type Game_Status_Aggregate_Fields = {
  __typename?: 'game_status_aggregate_fields';
  avg?: Maybe<Game_Status_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Game_Status_Max_Fields>;
  min?: Maybe<Game_Status_Min_Fields>;
  stddev?: Maybe<Game_Status_Stddev_Fields>;
  stddev_pop?: Maybe<Game_Status_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Game_Status_Stddev_Samp_Fields>;
  sum?: Maybe<Game_Status_Sum_Fields>;
  var_pop?: Maybe<Game_Status_Var_Pop_Fields>;
  var_samp?: Maybe<Game_Status_Var_Samp_Fields>;
  variance?: Maybe<Game_Status_Variance_Fields>;
};


/** aggregate fields of "game_status" */
export type Game_Status_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Game_Status_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "game_status" */
export type Game_Status_Aggregate_Order_By = {
  avg?: InputMaybe<Game_Status_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Game_Status_Max_Order_By>;
  min?: InputMaybe<Game_Status_Min_Order_By>;
  stddev?: InputMaybe<Game_Status_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Game_Status_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Game_Status_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Game_Status_Sum_Order_By>;
  var_pop?: InputMaybe<Game_Status_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Game_Status_Var_Samp_Order_By>;
  variance?: InputMaybe<Game_Status_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "game_status" */
export type Game_Status_Arr_Rel_Insert_Input = {
  data: Array<Game_Status_Insert_Input>;
  on_conflict?: InputMaybe<Game_Status_On_Conflict>;
};

/** aggregate avg on columns */
export type Game_Status_Avg_Fields = {
  __typename?: 'game_status_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "game_status" */
export type Game_Status_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "game_status". All fields are combined with a logical 'AND'. */
export type Game_Status_Bool_Exp = {
  _and?: InputMaybe<Array<InputMaybe<Game_Status_Bool_Exp>>>;
  _not?: InputMaybe<Game_Status_Bool_Exp>;
  _or?: InputMaybe<Array<InputMaybe<Game_Status_Bool_Exp>>>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "game_status" */
export enum Game_Status_Constraint {
  /** unique or primary key constraint */
  GameStatusPkey = 'game_status_pkey'
}

/** input type for incrementing integer column in table "game_status" */
export type Game_Status_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "game_status" */
export type Game_Status_Insert_Input = {
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Game_Status_Max_Fields = {
  __typename?: 'game_status_max_fields';
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "game_status" */
export type Game_Status_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Game_Status_Min_Fields = {
  __typename?: 'game_status_min_fields';
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "game_status" */
export type Game_Status_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "game_status" */
export type Game_Status_Mutation_Response = {
  __typename?: 'game_status_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Game_Status>;
};

/** input type for inserting object relation for remote table "game_status" */
export type Game_Status_Obj_Rel_Insert_Input = {
  data: Game_Status_Insert_Input;
  on_conflict?: InputMaybe<Game_Status_On_Conflict>;
};

/** on conflict condition type for table "game_status" */
export type Game_Status_On_Conflict = {
  constraint: Game_Status_Constraint;
  update_columns: Array<Game_Status_Update_Column>;
  where?: InputMaybe<Game_Status_Bool_Exp>;
};

/** ordering options when selecting data from "game_status" */
export type Game_Status_Order_By = {
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: "game_status" */
export type Game_Status_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "game_status" */
export enum Game_Status_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "game_status" */
export type Game_Status_Set_Input = {
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Game_Status_Stddev_Fields = {
  __typename?: 'game_status_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "game_status" */
export type Game_Status_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Game_Status_Stddev_Pop_Fields = {
  __typename?: 'game_status_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "game_status" */
export type Game_Status_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Game_Status_Stddev_Samp_Fields = {
  __typename?: 'game_status_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "game_status" */
export type Game_Status_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Game_Status_Sum_Fields = {
  __typename?: 'game_status_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "game_status" */
export type Game_Status_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** update columns of table "game_status" */
export enum Game_Status_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** aggregate var_pop on columns */
export type Game_Status_Var_Pop_Fields = {
  __typename?: 'game_status_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "game_status" */
export type Game_Status_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Game_Status_Var_Samp_Fields = {
  __typename?: 'game_status_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "game_status" */
export type Game_Status_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Game_Status_Variance_Fields = {
  __typename?: 'game_status_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "game_status" */
export type Game_Status_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "game_themes" */
export type Game_Themes = {
  __typename?: 'game_themes';
  id: Scalars['uuid'];
  name: Scalars['String'];
};

/** aggregated selection of "game_themes" */
export type Game_Themes_Aggregate = {
  __typename?: 'game_themes_aggregate';
  aggregate?: Maybe<Game_Themes_Aggregate_Fields>;
  nodes: Array<Game_Themes>;
};

/** aggregate fields of "game_themes" */
export type Game_Themes_Aggregate_Fields = {
  __typename?: 'game_themes_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Game_Themes_Max_Fields>;
  min?: Maybe<Game_Themes_Min_Fields>;
};


/** aggregate fields of "game_themes" */
export type Game_Themes_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Game_Themes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "game_themes" */
export type Game_Themes_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Game_Themes_Max_Order_By>;
  min?: InputMaybe<Game_Themes_Min_Order_By>;
};

/** input type for inserting array relation for remote table "game_themes" */
export type Game_Themes_Arr_Rel_Insert_Input = {
  data: Array<Game_Themes_Insert_Input>;
  on_conflict?: InputMaybe<Game_Themes_On_Conflict>;
};

/** Boolean expression to filter rows from the table "game_themes". All fields are combined with a logical 'AND'. */
export type Game_Themes_Bool_Exp = {
  _and?: InputMaybe<Array<InputMaybe<Game_Themes_Bool_Exp>>>;
  _not?: InputMaybe<Game_Themes_Bool_Exp>;
  _or?: InputMaybe<Array<InputMaybe<Game_Themes_Bool_Exp>>>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "game_themes" */
export enum Game_Themes_Constraint {
  /** unique or primary key constraint */
  GameThemesPkey = 'game_themes_pkey'
}

/** input type for inserting data into table "game_themes" */
export type Game_Themes_Insert_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Game_Themes_Max_Fields = {
  __typename?: 'game_themes_max_fields';
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "game_themes" */
export type Game_Themes_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Game_Themes_Min_Fields = {
  __typename?: 'game_themes_min_fields';
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "game_themes" */
export type Game_Themes_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "game_themes" */
export type Game_Themes_Mutation_Response = {
  __typename?: 'game_themes_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Game_Themes>;
};

/** input type for inserting object relation for remote table "game_themes" */
export type Game_Themes_Obj_Rel_Insert_Input = {
  data: Game_Themes_Insert_Input;
  on_conflict?: InputMaybe<Game_Themes_On_Conflict>;
};

/** on conflict condition type for table "game_themes" */
export type Game_Themes_On_Conflict = {
  constraint: Game_Themes_Constraint;
  update_columns: Array<Game_Themes_Update_Column>;
  where?: InputMaybe<Game_Themes_Bool_Exp>;
};

/** ordering options when selecting data from "game_themes" */
export type Game_Themes_Order_By = {
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: "game_themes" */
export type Game_Themes_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "game_themes" */
export enum Game_Themes_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "game_themes" */
export type Game_Themes_Set_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "game_themes" */
export enum Game_Themes_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** columns and relationships of "gen_round" */
export type Gen_Round = {
  __typename?: 'gen_round';
  id: Scalars['uuid'];
  title: Scalars['String'];
  type_name: Scalars['String'];
};

/** aggregated selection of "gen_round" */
export type Gen_Round_Aggregate = {
  __typename?: 'gen_round_aggregate';
  aggregate?: Maybe<Gen_Round_Aggregate_Fields>;
  nodes: Array<Gen_Round>;
};

/** aggregate fields of "gen_round" */
export type Gen_Round_Aggregate_Fields = {
  __typename?: 'gen_round_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Gen_Round_Max_Fields>;
  min?: Maybe<Gen_Round_Min_Fields>;
};


/** aggregate fields of "gen_round" */
export type Gen_Round_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Gen_Round_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "gen_round" */
export type Gen_Round_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Gen_Round_Max_Order_By>;
  min?: InputMaybe<Gen_Round_Min_Order_By>;
};

/** input type for inserting array relation for remote table "gen_round" */
export type Gen_Round_Arr_Rel_Insert_Input = {
  data: Array<Gen_Round_Insert_Input>;
  on_conflict?: InputMaybe<Gen_Round_On_Conflict>;
};

/** Boolean expression to filter rows from the table "gen_round". All fields are combined with a logical 'AND'. */
export type Gen_Round_Bool_Exp = {
  _and?: InputMaybe<Array<InputMaybe<Gen_Round_Bool_Exp>>>;
  _not?: InputMaybe<Gen_Round_Bool_Exp>;
  _or?: InputMaybe<Array<InputMaybe<Gen_Round_Bool_Exp>>>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  type_name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "gen_round" */
export enum Gen_Round_Constraint {
  /** unique or primary key constraint */
  GenRoundPkey = 'gen_round_pkey'
}

/** input type for inserting data into table "gen_round" */
export type Gen_Round_Insert_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  title?: InputMaybe<Scalars['String']>;
  type_name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Gen_Round_Max_Fields = {
  __typename?: 'gen_round_max_fields';
  id?: Maybe<Scalars['uuid']>;
  title?: Maybe<Scalars['String']>;
  type_name?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "gen_round" */
export type Gen_Round_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  type_name?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Gen_Round_Min_Fields = {
  __typename?: 'gen_round_min_fields';
  id?: Maybe<Scalars['uuid']>;
  title?: Maybe<Scalars['String']>;
  type_name?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "gen_round" */
export type Gen_Round_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  type_name?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "gen_round" */
export type Gen_Round_Mutation_Response = {
  __typename?: 'gen_round_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Gen_Round>;
};

/** input type for inserting object relation for remote table "gen_round" */
export type Gen_Round_Obj_Rel_Insert_Input = {
  data: Gen_Round_Insert_Input;
  on_conflict?: InputMaybe<Gen_Round_On_Conflict>;
};

/** on conflict condition type for table "gen_round" */
export type Gen_Round_On_Conflict = {
  constraint: Gen_Round_Constraint;
  update_columns: Array<Gen_Round_Update_Column>;
  where?: InputMaybe<Gen_Round_Bool_Exp>;
};

/** ordering options when selecting data from "gen_round" */
export type Gen_Round_Order_By = {
  id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  type_name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: "gen_round" */
export type Gen_Round_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "gen_round" */
export enum Gen_Round_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Title = 'title',
  /** column name */
  TypeName = 'type_name'
}

/** input type for updating data in table "gen_round" */
export type Gen_Round_Set_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  title?: InputMaybe<Scalars['String']>;
  type_name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "gen_round" */
export enum Gen_Round_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Title = 'title',
  /** column name */
  TypeName = 'type_name'
}

/** columns and relationships of "gen_uuid" */
export type Gen_Uuid = {
  __typename?: 'gen_uuid';
  id: Scalars['uuid'];
};

/** aggregated selection of "gen_uuid" */
export type Gen_Uuid_Aggregate = {
  __typename?: 'gen_uuid_aggregate';
  aggregate?: Maybe<Gen_Uuid_Aggregate_Fields>;
  nodes: Array<Gen_Uuid>;
};

/** aggregate fields of "gen_uuid" */
export type Gen_Uuid_Aggregate_Fields = {
  __typename?: 'gen_uuid_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Gen_Uuid_Max_Fields>;
  min?: Maybe<Gen_Uuid_Min_Fields>;
};


/** aggregate fields of "gen_uuid" */
export type Gen_Uuid_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Gen_Uuid_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "gen_uuid" */
export type Gen_Uuid_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Gen_Uuid_Max_Order_By>;
  min?: InputMaybe<Gen_Uuid_Min_Order_By>;
};

/** input type for inserting array relation for remote table "gen_uuid" */
export type Gen_Uuid_Arr_Rel_Insert_Input = {
  data: Array<Gen_Uuid_Insert_Input>;
  on_conflict?: InputMaybe<Gen_Uuid_On_Conflict>;
};

/** Boolean expression to filter rows from the table "gen_uuid". All fields are combined with a logical 'AND'. */
export type Gen_Uuid_Bool_Exp = {
  _and?: InputMaybe<Array<InputMaybe<Gen_Uuid_Bool_Exp>>>;
  _not?: InputMaybe<Gen_Uuid_Bool_Exp>;
  _or?: InputMaybe<Array<InputMaybe<Gen_Uuid_Bool_Exp>>>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "gen_uuid" */
export enum Gen_Uuid_Constraint {
  /** unique or primary key constraint */
  GenUuidPkey = 'gen_uuid_pkey'
}

/** input type for inserting data into table "gen_uuid" */
export type Gen_Uuid_Insert_Input = {
  id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Gen_Uuid_Max_Fields = {
  __typename?: 'gen_uuid_max_fields';
  id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "gen_uuid" */
export type Gen_Uuid_Max_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Gen_Uuid_Min_Fields = {
  __typename?: 'gen_uuid_min_fields';
  id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "gen_uuid" */
export type Gen_Uuid_Min_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "gen_uuid" */
export type Gen_Uuid_Mutation_Response = {
  __typename?: 'gen_uuid_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Gen_Uuid>;
};

/** input type for inserting object relation for remote table "gen_uuid" */
export type Gen_Uuid_Obj_Rel_Insert_Input = {
  data: Gen_Uuid_Insert_Input;
  on_conflict?: InputMaybe<Gen_Uuid_On_Conflict>;
};

/** on conflict condition type for table "gen_uuid" */
export type Gen_Uuid_On_Conflict = {
  constraint: Gen_Uuid_Constraint;
  update_columns: Array<Gen_Uuid_Update_Column>;
  where?: InputMaybe<Gen_Uuid_Bool_Exp>;
};

/** ordering options when selecting data from "gen_uuid" */
export type Gen_Uuid_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: "gen_uuid" */
export type Gen_Uuid_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "gen_uuid" */
export enum Gen_Uuid_Select_Column {
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "gen_uuid" */
export type Gen_Uuid_Set_Input = {
  id?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "gen_uuid" */
export enum Gen_Uuid_Update_Column {
  /** column name */
  Id = 'id'
}

/** expression to compare columns of type json. All fields are combined with logical 'AND'. */
export type Json_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['json']>;
  _gt?: InputMaybe<Scalars['json']>;
  _gte?: InputMaybe<Scalars['json']>;
  _in?: InputMaybe<Array<Scalars['json']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['json']>;
  _lte?: InputMaybe<Scalars['json']>;
  _neq?: InputMaybe<Scalars['json']>;
  _nin?: InputMaybe<Array<Scalars['json']>>;
};

/** expression to compare columns of type jsonb. All fields are combined with logical 'AND'. */
export type Jsonb_Comparison_Exp = {
  /** is the column contained in the given json value */
  _contained_in?: InputMaybe<Scalars['jsonb']>;
  /** does the column contain the given json value at the top level */
  _contains?: InputMaybe<Scalars['jsonb']>;
  _eq?: InputMaybe<Scalars['jsonb']>;
  _gt?: InputMaybe<Scalars['jsonb']>;
  _gte?: InputMaybe<Scalars['jsonb']>;
  /** does the string exist as a top-level key in the column */
  _has_key?: InputMaybe<Scalars['String']>;
  /** do all of these strings exist as top-level keys in the column */
  _has_keys_all?: InputMaybe<Array<Scalars['String']>>;
  /** do any of these strings exist as top-level keys in the column */
  _has_keys_any?: InputMaybe<Array<Scalars['String']>>;
  _in?: InputMaybe<Array<Scalars['jsonb']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['jsonb']>;
  _lte?: InputMaybe<Scalars['jsonb']>;
  _neq?: InputMaybe<Scalars['jsonb']>;
  _nin?: InputMaybe<Array<Scalars['jsonb']>>;
};

/** columns and relationships of "markets" */
export type Markets = {
  __typename?: 'markets';
  language_id?: Maybe<Scalars['String']>;
  market_id: Scalars['String'];
  market_name: Scalars['String'];
};

/** aggregated selection of "markets" */
export type Markets_Aggregate = {
  __typename?: 'markets_aggregate';
  aggregate?: Maybe<Markets_Aggregate_Fields>;
  nodes: Array<Markets>;
};

/** aggregate fields of "markets" */
export type Markets_Aggregate_Fields = {
  __typename?: 'markets_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Markets_Max_Fields>;
  min?: Maybe<Markets_Min_Fields>;
};


/** aggregate fields of "markets" */
export type Markets_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Markets_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "markets" */
export type Markets_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Markets_Max_Order_By>;
  min?: InputMaybe<Markets_Min_Order_By>;
};

/** input type for inserting array relation for remote table "markets" */
export type Markets_Arr_Rel_Insert_Input = {
  data: Array<Markets_Insert_Input>;
  on_conflict?: InputMaybe<Markets_On_Conflict>;
};

/** Boolean expression to filter rows from the table "markets". All fields are combined with a logical 'AND'. */
export type Markets_Bool_Exp = {
  _and?: InputMaybe<Array<InputMaybe<Markets_Bool_Exp>>>;
  _not?: InputMaybe<Markets_Bool_Exp>;
  _or?: InputMaybe<Array<InputMaybe<Markets_Bool_Exp>>>;
  language_id?: InputMaybe<String_Comparison_Exp>;
  market_id?: InputMaybe<String_Comparison_Exp>;
  market_name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "markets" */
export enum Markets_Constraint {
  /** unique or primary key constraint */
  MarketsPkey = 'markets_pkey'
}

/** input type for inserting data into table "markets" */
export type Markets_Insert_Input = {
  language_id?: InputMaybe<Scalars['String']>;
  market_id?: InputMaybe<Scalars['String']>;
  market_name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Markets_Max_Fields = {
  __typename?: 'markets_max_fields';
  language_id?: Maybe<Scalars['String']>;
  market_id?: Maybe<Scalars['String']>;
  market_name?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "markets" */
export type Markets_Max_Order_By = {
  language_id?: InputMaybe<Order_By>;
  market_id?: InputMaybe<Order_By>;
  market_name?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Markets_Min_Fields = {
  __typename?: 'markets_min_fields';
  language_id?: Maybe<Scalars['String']>;
  market_id?: Maybe<Scalars['String']>;
  market_name?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "markets" */
export type Markets_Min_Order_By = {
  language_id?: InputMaybe<Order_By>;
  market_id?: InputMaybe<Order_By>;
  market_name?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "markets" */
export type Markets_Mutation_Response = {
  __typename?: 'markets_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Markets>;
};

/** input type for inserting object relation for remote table "markets" */
export type Markets_Obj_Rel_Insert_Input = {
  data: Markets_Insert_Input;
  on_conflict?: InputMaybe<Markets_On_Conflict>;
};

/** on conflict condition type for table "markets" */
export type Markets_On_Conflict = {
  constraint: Markets_Constraint;
  update_columns: Array<Markets_Update_Column>;
  where?: InputMaybe<Markets_Bool_Exp>;
};

/** ordering options when selecting data from "markets" */
export type Markets_Order_By = {
  language_id?: InputMaybe<Order_By>;
  market_id?: InputMaybe<Order_By>;
  market_name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: "markets" */
export type Markets_Pk_Columns_Input = {
  market_id: Scalars['String'];
};

/** select columns of table "markets" */
export enum Markets_Select_Column {
  /** column name */
  LanguageId = 'language_id',
  /** column name */
  MarketId = 'market_id',
  /** column name */
  MarketName = 'market_name'
}

/** input type for updating data in table "markets" */
export type Markets_Set_Input = {
  language_id?: InputMaybe<Scalars['String']>;
  market_id?: InputMaybe<Scalars['String']>;
  market_name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "markets" */
export enum Markets_Update_Column {
  /** column name */
  LanguageId = 'language_id',
  /** column name */
  MarketId = 'market_id',
  /** column name */
  MarketName = 'market_name'
}

/** mutation root */
export type Mutation_Root = {
  __typename?: 'mutation_root';
  /** delete data from the table: "answer_types" */
  delete_answer_types?: Maybe<Answer_Types_Mutation_Response>;
  /** delete single row from the table: "answer_types" */
  delete_answer_types_by_pk?: Maybe<Answer_Types>;
  /** delete data from the table: "categories" */
  delete_categories?: Maybe<Categories_Mutation_Response>;
  /** delete single row from the table: "categories" */
  delete_categories_by_pk?: Maybe<Categories>;
  /** delete data from the table: "city_edit_log" */
  delete_city_edit_log?: Maybe<City_Edit_Log_Mutation_Response>;
  /** delete data from the table: "city_tqs" */
  delete_city_tqs?: Maybe<City_Tqs_Mutation_Response>;
  /** delete data from the table: "city_trivia_category" */
  delete_city_trivia_category?: Maybe<City_Trivia_Category_Mutation_Response>;
  /** delete data from the table: "city_trivia_question" */
  delete_city_trivia_question?: Maybe<City_Trivia_Question_Mutation_Response>;
  /** delete data from the table: "city_trivia_round" */
  delete_city_trivia_round?: Maybe<City_Trivia_Round_Mutation_Response>;
  /** delete data from the table: "dayle_sessions" */
  delete_dayle_sessions?: Maybe<Dayle_Sessions_Mutation_Response>;
  /** delete single row from the table: "dayle_sessions" */
  delete_dayle_sessions_by_pk?: Maybe<Dayle_Sessions>;
  /** delete data from the table: "edit_log" */
  delete_edit_log?: Maybe<Edit_Log_Mutation_Response>;
  /** delete single row from the table: "edit_log" */
  delete_edit_log_by_pk?: Maybe<Edit_Log>;
  /** delete data from the table: "edit_log_types" */
  delete_edit_log_types?: Maybe<Edit_Log_Types_Mutation_Response>;
  /** delete single row from the table: "edit_log_types" */
  delete_edit_log_types_by_pk?: Maybe<Edit_Log_Types>;
  /** delete data from the table: "forgot_password" */
  delete_forgot_password?: Maybe<Forgot_Password_Mutation_Response>;
  /** delete single row from the table: "forgot_password" */
  delete_forgot_password_by_pk?: Maybe<Forgot_Password>;
  /** delete data from the table: "game_difficulties" */
  delete_game_difficulties?: Maybe<Game_Difficulties_Mutation_Response>;
  /** delete single row from the table: "game_difficulties" */
  delete_game_difficulties_by_pk?: Maybe<Game_Difficulties>;
  /** delete data from the table: "game_formats" */
  delete_game_formats?: Maybe<Game_Formats_Mutation_Response>;
  /** delete single row from the table: "game_formats" */
  delete_game_formats_by_pk?: Maybe<Game_Formats>;
  /** delete data from the table: "game_ratings" */
  delete_game_ratings?: Maybe<Game_Ratings_Mutation_Response>;
  /** delete single row from the table: "game_ratings" */
  delete_game_ratings_by_pk?: Maybe<Game_Ratings>;
  /** delete data from the table: "game_status" */
  delete_game_status?: Maybe<Game_Status_Mutation_Response>;
  /** delete single row from the table: "game_status" */
  delete_game_status_by_pk?: Maybe<Game_Status>;
  /** delete data from the table: "game_themes" */
  delete_game_themes?: Maybe<Game_Themes_Mutation_Response>;
  /** delete single row from the table: "game_themes" */
  delete_game_themes_by_pk?: Maybe<Game_Themes>;
  /** delete data from the table: "gen_round" */
  delete_gen_round?: Maybe<Gen_Round_Mutation_Response>;
  /** delete single row from the table: "gen_round" */
  delete_gen_round_by_pk?: Maybe<Gen_Round>;
  /** delete data from the table: "gen_uuid" */
  delete_gen_uuid?: Maybe<Gen_Uuid_Mutation_Response>;
  /** delete single row from the table: "gen_uuid" */
  delete_gen_uuid_by_pk?: Maybe<Gen_Uuid>;
  /** delete data from the table: "markets" */
  delete_markets?: Maybe<Markets_Mutation_Response>;
  /** delete single row from the table: "markets" */
  delete_markets_by_pk?: Maybe<Markets>;
  /** delete data from the table: "question_bonuses" */
  delete_question_bonuses?: Maybe<Question_Bonuses_Mutation_Response>;
  /** delete single row from the table: "question_bonuses" */
  delete_question_bonuses_by_pk?: Maybe<Question_Bonuses>;
  /** delete data from the table: "question_difficulties" */
  delete_question_difficulties?: Maybe<Question_Difficulties_Mutation_Response>;
  /** delete single row from the table: "question_difficulties" */
  delete_question_difficulties_by_pk?: Maybe<Question_Difficulties>;
  /** delete data from the table: "question_languages" */
  delete_question_languages?: Maybe<Question_Languages_Mutation_Response>;
  /** delete single row from the table: "question_languages" */
  delete_question_languages_by_pk?: Maybe<Question_Languages>;
  /** delete data from the table: "question_ratings" */
  delete_question_ratings?: Maybe<Question_Ratings_Mutation_Response>;
  /** delete single row from the table: "question_ratings" */
  delete_question_ratings_by_pk?: Maybe<Question_Ratings>;
  /** delete data from the table: "question_status" */
  delete_question_status?: Maybe<Question_Status_Mutation_Response>;
  /** delete single row from the table: "question_status" */
  delete_question_status_by_pk?: Maybe<Question_Status>;
  /** delete data from the table: "question_tags" */
  delete_question_tags?: Maybe<Question_Tags_Mutation_Response>;
  /** delete single row from the table: "question_tags" */
  delete_question_tags_by_pk?: Maybe<Question_Tags>;
  /** delete data from the table: "question_texts_similarities" */
  delete_question_texts_similarities?: Maybe<Question_Texts_Similarities_Mutation_Response>;
  /** delete single row from the table: "question_texts_similarities" */
  delete_question_texts_similarities_by_pk?: Maybe<Question_Texts_Similarities>;
  /** delete data from the table: "question_types" */
  delete_question_types?: Maybe<Question_Types_Mutation_Response>;
  /** delete single row from the table: "question_types" */
  delete_question_types_by_pk?: Maybe<Question_Types>;
  /** delete data from the table: "questions" */
  delete_questions?: Maybe<Questions_Mutation_Response>;
  /** delete single row from the table: "questions" */
  delete_questions_by_pk?: Maybe<Questions>;
  /** delete data from the table: "rejection_reasons" */
  delete_rejection_reasons?: Maybe<Rejection_Reasons_Mutation_Response>;
  /** delete single row from the table: "rejection_reasons" */
  delete_rejection_reasons_by_pk?: Maybe<Rejection_Reasons>;
  /** delete data from the table: "report_reasons" */
  delete_report_reasons?: Maybe<Report_Reasons_Mutation_Response>;
  /** delete single row from the table: "report_reasons" */
  delete_report_reasons_by_pk?: Maybe<Report_Reasons>;
  /** delete data from the table: "reports" */
  delete_reports?: Maybe<Reports_Mutation_Response>;
  /** delete single row from the table: "reports" */
  delete_reports_by_pk?: Maybe<Reports>;
  /** delete data from the table: "rounds" */
  delete_rounds?: Maybe<Rounds_Mutation_Response>;
  /** delete single row from the table: "rounds" */
  delete_rounds_by_pk?: Maybe<Rounds>;
  /** delete data from the table: "settings" */
  delete_settings?: Maybe<Settings_Mutation_Response>;
  /** delete single row from the table: "settings" */
  delete_settings_by_pk?: Maybe<Settings>;
  /** delete data from the table: "sponsor_questions" */
  delete_sponsor_questions?: Maybe<Sponsor_Questions_Mutation_Response>;
  /** delete single row from the table: "sponsor_questions" */
  delete_sponsor_questions_by_pk?: Maybe<Sponsor_Questions>;
  /** delete data from the table: "sponsors" */
  delete_sponsors?: Maybe<Sponsors_Mutation_Response>;
  /** delete single row from the table: "sponsors" */
  delete_sponsors_by_pk?: Maybe<Sponsors>;
  /** delete data from the table: "trivia_event_types" */
  delete_trivia_event_types?: Maybe<Trivia_Event_Types_Mutation_Response>;
  /** delete single row from the table: "trivia_event_types" */
  delete_trivia_event_types_by_pk?: Maybe<Trivia_Event_Types>;
  /** delete data from the table: "trivia_events" */
  delete_trivia_events?: Maybe<Trivia_Events_Mutation_Response>;
  /** delete single row from the table: "trivia_events" */
  delete_trivia_events_by_pk?: Maybe<Trivia_Events>;
  /** delete data from the table: "trivia_game_category" */
  delete_trivia_game_category?: Maybe<Trivia_Game_Category_Mutation_Response>;
  /** delete single row from the table: "trivia_game_category" */
  delete_trivia_game_category_by_pk?: Maybe<Trivia_Game_Category>;
  /** delete data from the table: "trivia_game_rounds" */
  delete_trivia_game_rounds?: Maybe<Trivia_Game_Rounds_Mutation_Response>;
  /** delete single row from the table: "trivia_game_rounds" */
  delete_trivia_game_rounds_by_pk?: Maybe<Trivia_Game_Rounds>;
  /** delete data from the table: "trivia_game_templates" */
  delete_trivia_game_templates?: Maybe<Trivia_Game_Templates_Mutation_Response>;
  /** delete single row from the table: "trivia_game_templates" */
  delete_trivia_game_templates_by_pk?: Maybe<Trivia_Game_Templates>;
  /** delete data from the table: "trivia_game_themes" */
  delete_trivia_game_themes?: Maybe<Trivia_Game_Themes_Mutation_Response>;
  /** delete single row from the table: "trivia_game_themes" */
  delete_trivia_game_themes_by_pk?: Maybe<Trivia_Game_Themes>;
  /** delete data from the table: "trivia_games" */
  delete_trivia_games?: Maybe<Trivia_Games_Mutation_Response>;
  /** delete single row from the table: "trivia_games" */
  delete_trivia_games_by_pk?: Maybe<Trivia_Games>;
  /** delete data from the table: "trivia_question" */
  delete_trivia_question?: Maybe<Trivia_Question_Mutation_Response>;
  /** delete data from the table: "trivia_round_questions" */
  delete_trivia_round_questions?: Maybe<Trivia_Round_Questions_Mutation_Response>;
  /** delete single row from the table: "trivia_round_questions" */
  delete_trivia_round_questions_by_pk?: Maybe<Trivia_Round_Questions>;
  /** delete data from the table: "trivia_round_templates" */
  delete_trivia_round_templates?: Maybe<Trivia_Round_Templates_Mutation_Response>;
  /** delete single row from the table: "trivia_round_templates" */
  delete_trivia_round_templates_by_pk?: Maybe<Trivia_Round_Templates>;
  /** delete data from the table: "trivia_round_themes" */
  delete_trivia_round_themes?: Maybe<Trivia_Round_Themes_Mutation_Response>;
  /** delete single row from the table: "trivia_round_themes" */
  delete_trivia_round_themes_by_pk?: Maybe<Trivia_Round_Themes>;
  /** delete data from the table: "trivia_round_types" */
  delete_trivia_round_types?: Maybe<Trivia_Round_Types_Mutation_Response>;
  /** delete single row from the table: "trivia_round_types" */
  delete_trivia_round_types_by_pk?: Maybe<Trivia_Round_Types>;
  /** delete data from the table: "trivia_rounds" */
  delete_trivia_rounds?: Maybe<Trivia_Rounds_Mutation_Response>;
  /** delete single row from the table: "trivia_rounds" */
  delete_trivia_rounds_by_pk?: Maybe<Trivia_Rounds>;
  /** delete data from the table: "trivia_users" */
  delete_trivia_users?: Maybe<Trivia_Users_Mutation_Response>;
  /** delete single row from the table: "trivia_users" */
  delete_trivia_users_by_pk?: Maybe<Trivia_Users>;
  /** delete data from the table: "user_types" */
  delete_user_types?: Maybe<User_Types_Mutation_Response>;
  /** delete single row from the table: "user_types" */
  delete_user_types_by_pk?: Maybe<User_Types>;
  /** perform the action: "generate_bonus_round" */
  generate_bonus_round?: Maybe<GenRound>;
  /** perform the action: "generate_ctm_round" */
  generate_ctm_round?: Maybe<GenRound>;
  /** perform the action: "generate_final_round" */
  generate_final_round?: Maybe<GenRound>;
  /** perform the action: "generate_standard_round" */
  generate_standard_round?: Maybe<GenRound>;
  /** perform the action: "generate_warfare_round" */
  generate_warfare_round?: Maybe<GenRound>;
  /** insert data into the table: "answer_types" */
  insert_answer_types?: Maybe<Answer_Types_Mutation_Response>;
  /** insert a single row into the table: "answer_types" */
  insert_answer_types_one?: Maybe<Answer_Types>;
  /** insert data into the table: "categories" */
  insert_categories?: Maybe<Categories_Mutation_Response>;
  /** insert a single row into the table: "categories" */
  insert_categories_one?: Maybe<Categories>;
  /** insert data into the table: "city_edit_log" */
  insert_city_edit_log?: Maybe<City_Edit_Log_Mutation_Response>;
  /** insert a single row into the table: "city_edit_log" */
  insert_city_edit_log_one?: Maybe<City_Edit_Log>;
  /** insert data into the table: "city_tqs" */
  insert_city_tqs?: Maybe<City_Tqs_Mutation_Response>;
  /** insert a single row into the table: "city_tqs" */
  insert_city_tqs_one?: Maybe<City_Tqs>;
  /** insert data into the table: "city_trivia_category" */
  insert_city_trivia_category?: Maybe<City_Trivia_Category_Mutation_Response>;
  /** insert a single row into the table: "city_trivia_category" */
  insert_city_trivia_category_one?: Maybe<City_Trivia_Category>;
  /** insert data into the table: "city_trivia_question" */
  insert_city_trivia_question?: Maybe<City_Trivia_Question_Mutation_Response>;
  /** insert a single row into the table: "city_trivia_question" */
  insert_city_trivia_question_one?: Maybe<City_Trivia_Question>;
  /** insert data into the table: "city_trivia_round" */
  insert_city_trivia_round?: Maybe<City_Trivia_Round_Mutation_Response>;
  /** insert a single row into the table: "city_trivia_round" */
  insert_city_trivia_round_one?: Maybe<City_Trivia_Round>;
  /** insert data into the table: "dayle_sessions" */
  insert_dayle_sessions?: Maybe<Dayle_Sessions_Mutation_Response>;
  /** insert a single row into the table: "dayle_sessions" */
  insert_dayle_sessions_one?: Maybe<Dayle_Sessions>;
  /** insert data into the table: "edit_log" */
  insert_edit_log?: Maybe<Edit_Log_Mutation_Response>;
  /** insert a single row into the table: "edit_log" */
  insert_edit_log_one?: Maybe<Edit_Log>;
  /** insert data into the table: "edit_log_types" */
  insert_edit_log_types?: Maybe<Edit_Log_Types_Mutation_Response>;
  /** insert a single row into the table: "edit_log_types" */
  insert_edit_log_types_one?: Maybe<Edit_Log_Types>;
  /** insert data into the table: "forgot_password" */
  insert_forgot_password?: Maybe<Forgot_Password_Mutation_Response>;
  /** insert a single row into the table: "forgot_password" */
  insert_forgot_password_one?: Maybe<Forgot_Password>;
  /** insert data into the table: "game_difficulties" */
  insert_game_difficulties?: Maybe<Game_Difficulties_Mutation_Response>;
  /** insert a single row into the table: "game_difficulties" */
  insert_game_difficulties_one?: Maybe<Game_Difficulties>;
  /** insert data into the table: "game_formats" */
  insert_game_formats?: Maybe<Game_Formats_Mutation_Response>;
  /** insert a single row into the table: "game_formats" */
  insert_game_formats_one?: Maybe<Game_Formats>;
  /** insert data into the table: "game_ratings" */
  insert_game_ratings?: Maybe<Game_Ratings_Mutation_Response>;
  /** insert a single row into the table: "game_ratings" */
  insert_game_ratings_one?: Maybe<Game_Ratings>;
  /** insert data into the table: "game_status" */
  insert_game_status?: Maybe<Game_Status_Mutation_Response>;
  /** insert a single row into the table: "game_status" */
  insert_game_status_one?: Maybe<Game_Status>;
  /** insert data into the table: "game_themes" */
  insert_game_themes?: Maybe<Game_Themes_Mutation_Response>;
  /** insert a single row into the table: "game_themes" */
  insert_game_themes_one?: Maybe<Game_Themes>;
  /** insert data into the table: "gen_round" */
  insert_gen_round?: Maybe<Gen_Round_Mutation_Response>;
  /** insert a single row into the table: "gen_round" */
  insert_gen_round_one?: Maybe<Gen_Round>;
  /** insert data into the table: "gen_uuid" */
  insert_gen_uuid?: Maybe<Gen_Uuid_Mutation_Response>;
  /** insert a single row into the table: "gen_uuid" */
  insert_gen_uuid_one?: Maybe<Gen_Uuid>;
  /** insert data into the table: "markets" */
  insert_markets?: Maybe<Markets_Mutation_Response>;
  /** insert a single row into the table: "markets" */
  insert_markets_one?: Maybe<Markets>;
  /** insert data into the table: "question_bonuses" */
  insert_question_bonuses?: Maybe<Question_Bonuses_Mutation_Response>;
  /** insert a single row into the table: "question_bonuses" */
  insert_question_bonuses_one?: Maybe<Question_Bonuses>;
  /** insert data into the table: "question_difficulties" */
  insert_question_difficulties?: Maybe<Question_Difficulties_Mutation_Response>;
  /** insert a single row into the table: "question_difficulties" */
  insert_question_difficulties_one?: Maybe<Question_Difficulties>;
  /** insert data into the table: "question_languages" */
  insert_question_languages?: Maybe<Question_Languages_Mutation_Response>;
  /** insert a single row into the table: "question_languages" */
  insert_question_languages_one?: Maybe<Question_Languages>;
  /** insert data into the table: "question_ratings" */
  insert_question_ratings?: Maybe<Question_Ratings_Mutation_Response>;
  /** insert a single row into the table: "question_ratings" */
  insert_question_ratings_one?: Maybe<Question_Ratings>;
  /** insert data into the table: "question_status" */
  insert_question_status?: Maybe<Question_Status_Mutation_Response>;
  /** insert a single row into the table: "question_status" */
  insert_question_status_one?: Maybe<Question_Status>;
  /** insert data into the table: "question_tags" */
  insert_question_tags?: Maybe<Question_Tags_Mutation_Response>;
  /** insert a single row into the table: "question_tags" */
  insert_question_tags_one?: Maybe<Question_Tags>;
  /** insert data into the table: "question_texts_similarities" */
  insert_question_texts_similarities?: Maybe<Question_Texts_Similarities_Mutation_Response>;
  /** insert a single row into the table: "question_texts_similarities" */
  insert_question_texts_similarities_one?: Maybe<Question_Texts_Similarities>;
  /** insert data into the table: "question_types" */
  insert_question_types?: Maybe<Question_Types_Mutation_Response>;
  /** insert a single row into the table: "question_types" */
  insert_question_types_one?: Maybe<Question_Types>;
  /** insert data into the table: "questions" */
  insert_questions?: Maybe<Questions_Mutation_Response>;
  /** insert a single row into the table: "questions" */
  insert_questions_one?: Maybe<Questions>;
  /** insert data into the table: "rejection_reasons" */
  insert_rejection_reasons?: Maybe<Rejection_Reasons_Mutation_Response>;
  /** insert a single row into the table: "rejection_reasons" */
  insert_rejection_reasons_one?: Maybe<Rejection_Reasons>;
  /** insert data into the table: "report_reasons" */
  insert_report_reasons?: Maybe<Report_Reasons_Mutation_Response>;
  /** insert a single row into the table: "report_reasons" */
  insert_report_reasons_one?: Maybe<Report_Reasons>;
  /** insert data into the table: "reports" */
  insert_reports?: Maybe<Reports_Mutation_Response>;
  /** insert a single row into the table: "reports" */
  insert_reports_one?: Maybe<Reports>;
  /** insert data into the table: "rounds" */
  insert_rounds?: Maybe<Rounds_Mutation_Response>;
  /** insert a single row into the table: "rounds" */
  insert_rounds_one?: Maybe<Rounds>;
  /** insert data into the table: "settings" */
  insert_settings?: Maybe<Settings_Mutation_Response>;
  /** insert a single row into the table: "settings" */
  insert_settings_one?: Maybe<Settings>;
  /** insert data into the table: "sponsor_questions" */
  insert_sponsor_questions?: Maybe<Sponsor_Questions_Mutation_Response>;
  /** insert a single row into the table: "sponsor_questions" */
  insert_sponsor_questions_one?: Maybe<Sponsor_Questions>;
  /** insert data into the table: "sponsors" */
  insert_sponsors?: Maybe<Sponsors_Mutation_Response>;
  /** insert a single row into the table: "sponsors" */
  insert_sponsors_one?: Maybe<Sponsors>;
  /** insert data into the table: "trivia_event_types" */
  insert_trivia_event_types?: Maybe<Trivia_Event_Types_Mutation_Response>;
  /** insert a single row into the table: "trivia_event_types" */
  insert_trivia_event_types_one?: Maybe<Trivia_Event_Types>;
  /** insert data into the table: "trivia_events" */
  insert_trivia_events?: Maybe<Trivia_Events_Mutation_Response>;
  /** insert a single row into the table: "trivia_events" */
  insert_trivia_events_one?: Maybe<Trivia_Events>;
  /** insert data into the table: "trivia_game_category" */
  insert_trivia_game_category?: Maybe<Trivia_Game_Category_Mutation_Response>;
  /** insert a single row into the table: "trivia_game_category" */
  insert_trivia_game_category_one?: Maybe<Trivia_Game_Category>;
  /** insert data into the table: "trivia_game_rounds" */
  insert_trivia_game_rounds?: Maybe<Trivia_Game_Rounds_Mutation_Response>;
  /** insert a single row into the table: "trivia_game_rounds" */
  insert_trivia_game_rounds_one?: Maybe<Trivia_Game_Rounds>;
  /** insert data into the table: "trivia_game_templates" */
  insert_trivia_game_templates?: Maybe<Trivia_Game_Templates_Mutation_Response>;
  /** insert a single row into the table: "trivia_game_templates" */
  insert_trivia_game_templates_one?: Maybe<Trivia_Game_Templates>;
  /** insert data into the table: "trivia_game_themes" */
  insert_trivia_game_themes?: Maybe<Trivia_Game_Themes_Mutation_Response>;
  /** insert a single row into the table: "trivia_game_themes" */
  insert_trivia_game_themes_one?: Maybe<Trivia_Game_Themes>;
  /** insert data into the table: "trivia_games" */
  insert_trivia_games?: Maybe<Trivia_Games_Mutation_Response>;
  /** insert a single row into the table: "trivia_games" */
  insert_trivia_games_one?: Maybe<Trivia_Games>;
  /** insert data into the table: "trivia_question" */
  insert_trivia_question?: Maybe<Trivia_Question_Mutation_Response>;
  /** insert a single row into the table: "trivia_question" */
  insert_trivia_question_one?: Maybe<Trivia_Question>;
  /** insert data into the table: "trivia_round_questions" */
  insert_trivia_round_questions?: Maybe<Trivia_Round_Questions_Mutation_Response>;
  /** insert a single row into the table: "trivia_round_questions" */
  insert_trivia_round_questions_one?: Maybe<Trivia_Round_Questions>;
  /** insert data into the table: "trivia_round_templates" */
  insert_trivia_round_templates?: Maybe<Trivia_Round_Templates_Mutation_Response>;
  /** insert a single row into the table: "trivia_round_templates" */
  insert_trivia_round_templates_one?: Maybe<Trivia_Round_Templates>;
  /** insert data into the table: "trivia_round_themes" */
  insert_trivia_round_themes?: Maybe<Trivia_Round_Themes_Mutation_Response>;
  /** insert a single row into the table: "trivia_round_themes" */
  insert_trivia_round_themes_one?: Maybe<Trivia_Round_Themes>;
  /** insert data into the table: "trivia_round_types" */
  insert_trivia_round_types?: Maybe<Trivia_Round_Types_Mutation_Response>;
  /** insert a single row into the table: "trivia_round_types" */
  insert_trivia_round_types_one?: Maybe<Trivia_Round_Types>;
  /** insert data into the table: "trivia_rounds" */
  insert_trivia_rounds?: Maybe<Trivia_Rounds_Mutation_Response>;
  /** insert a single row into the table: "trivia_rounds" */
  insert_trivia_rounds_one?: Maybe<Trivia_Rounds>;
  /** insert data into the table: "trivia_users" */
  insert_trivia_users?: Maybe<Trivia_Users_Mutation_Response>;
  /** insert a single row into the table: "trivia_users" */
  insert_trivia_users_one?: Maybe<Trivia_Users>;
  /** insert data into the table: "user_types" */
  insert_user_types?: Maybe<User_Types_Mutation_Response>;
  /** insert a single row into the table: "user_types" */
  insert_user_types_one?: Maybe<User_Types>;
  /** update data of the table: "answer_types" */
  update_answer_types?: Maybe<Answer_Types_Mutation_Response>;
  /** update single row of the table: "answer_types" */
  update_answer_types_by_pk?: Maybe<Answer_Types>;
  /** update data of the table: "categories" */
  update_categories?: Maybe<Categories_Mutation_Response>;
  /** update single row of the table: "categories" */
  update_categories_by_pk?: Maybe<Categories>;
  /** update data of the table: "city_edit_log" */
  update_city_edit_log?: Maybe<City_Edit_Log_Mutation_Response>;
  /** update data of the table: "city_tqs" */
  update_city_tqs?: Maybe<City_Tqs_Mutation_Response>;
  /** update data of the table: "city_trivia_category" */
  update_city_trivia_category?: Maybe<City_Trivia_Category_Mutation_Response>;
  /** update data of the table: "city_trivia_question" */
  update_city_trivia_question?: Maybe<City_Trivia_Question_Mutation_Response>;
  /** update data of the table: "city_trivia_round" */
  update_city_trivia_round?: Maybe<City_Trivia_Round_Mutation_Response>;
  /** update data of the table: "dayle_sessions" */
  update_dayle_sessions?: Maybe<Dayle_Sessions_Mutation_Response>;
  /** update single row of the table: "dayle_sessions" */
  update_dayle_sessions_by_pk?: Maybe<Dayle_Sessions>;
  /** update data of the table: "edit_log" */
  update_edit_log?: Maybe<Edit_Log_Mutation_Response>;
  /** update single row of the table: "edit_log" */
  update_edit_log_by_pk?: Maybe<Edit_Log>;
  /** update data of the table: "edit_log_types" */
  update_edit_log_types?: Maybe<Edit_Log_Types_Mutation_Response>;
  /** update single row of the table: "edit_log_types" */
  update_edit_log_types_by_pk?: Maybe<Edit_Log_Types>;
  /** update data of the table: "forgot_password" */
  update_forgot_password?: Maybe<Forgot_Password_Mutation_Response>;
  /** update single row of the table: "forgot_password" */
  update_forgot_password_by_pk?: Maybe<Forgot_Password>;
  /** update data of the table: "game_difficulties" */
  update_game_difficulties?: Maybe<Game_Difficulties_Mutation_Response>;
  /** update single row of the table: "game_difficulties" */
  update_game_difficulties_by_pk?: Maybe<Game_Difficulties>;
  /** update data of the table: "game_formats" */
  update_game_formats?: Maybe<Game_Formats_Mutation_Response>;
  /** update single row of the table: "game_formats" */
  update_game_formats_by_pk?: Maybe<Game_Formats>;
  /** update data of the table: "game_ratings" */
  update_game_ratings?: Maybe<Game_Ratings_Mutation_Response>;
  /** update single row of the table: "game_ratings" */
  update_game_ratings_by_pk?: Maybe<Game_Ratings>;
  /** update data of the table: "game_status" */
  update_game_status?: Maybe<Game_Status_Mutation_Response>;
  /** update single row of the table: "game_status" */
  update_game_status_by_pk?: Maybe<Game_Status>;
  /** update data of the table: "game_themes" */
  update_game_themes?: Maybe<Game_Themes_Mutation_Response>;
  /** update single row of the table: "game_themes" */
  update_game_themes_by_pk?: Maybe<Game_Themes>;
  /** update data of the table: "gen_round" */
  update_gen_round?: Maybe<Gen_Round_Mutation_Response>;
  /** update single row of the table: "gen_round" */
  update_gen_round_by_pk?: Maybe<Gen_Round>;
  /** update data of the table: "gen_uuid" */
  update_gen_uuid?: Maybe<Gen_Uuid_Mutation_Response>;
  /** update single row of the table: "gen_uuid" */
  update_gen_uuid_by_pk?: Maybe<Gen_Uuid>;
  /** update data of the table: "markets" */
  update_markets?: Maybe<Markets_Mutation_Response>;
  /** update single row of the table: "markets" */
  update_markets_by_pk?: Maybe<Markets>;
  /** update data of the table: "question_bonuses" */
  update_question_bonuses?: Maybe<Question_Bonuses_Mutation_Response>;
  /** update single row of the table: "question_bonuses" */
  update_question_bonuses_by_pk?: Maybe<Question_Bonuses>;
  /** update data of the table: "question_difficulties" */
  update_question_difficulties?: Maybe<Question_Difficulties_Mutation_Response>;
  /** update single row of the table: "question_difficulties" */
  update_question_difficulties_by_pk?: Maybe<Question_Difficulties>;
  /** update data of the table: "question_languages" */
  update_question_languages?: Maybe<Question_Languages_Mutation_Response>;
  /** update single row of the table: "question_languages" */
  update_question_languages_by_pk?: Maybe<Question_Languages>;
  /** update data of the table: "question_ratings" */
  update_question_ratings?: Maybe<Question_Ratings_Mutation_Response>;
  /** update single row of the table: "question_ratings" */
  update_question_ratings_by_pk?: Maybe<Question_Ratings>;
  /** update data of the table: "question_status" */
  update_question_status?: Maybe<Question_Status_Mutation_Response>;
  /** update single row of the table: "question_status" */
  update_question_status_by_pk?: Maybe<Question_Status>;
  /** update data of the table: "question_tags" */
  update_question_tags?: Maybe<Question_Tags_Mutation_Response>;
  /** update single row of the table: "question_tags" */
  update_question_tags_by_pk?: Maybe<Question_Tags>;
  /** update data of the table: "question_texts_similarities" */
  update_question_texts_similarities?: Maybe<Question_Texts_Similarities_Mutation_Response>;
  /** update single row of the table: "question_texts_similarities" */
  update_question_texts_similarities_by_pk?: Maybe<Question_Texts_Similarities>;
  /** update data of the table: "question_types" */
  update_question_types?: Maybe<Question_Types_Mutation_Response>;
  /** update single row of the table: "question_types" */
  update_question_types_by_pk?: Maybe<Question_Types>;
  /** update data of the table: "questions" */
  update_questions?: Maybe<Questions_Mutation_Response>;
  /** update single row of the table: "questions" */
  update_questions_by_pk?: Maybe<Questions>;
  /** update data of the table: "rejection_reasons" */
  update_rejection_reasons?: Maybe<Rejection_Reasons_Mutation_Response>;
  /** update single row of the table: "rejection_reasons" */
  update_rejection_reasons_by_pk?: Maybe<Rejection_Reasons>;
  /** update data of the table: "report_reasons" */
  update_report_reasons?: Maybe<Report_Reasons_Mutation_Response>;
  /** update single row of the table: "report_reasons" */
  update_report_reasons_by_pk?: Maybe<Report_Reasons>;
  /** update data of the table: "reports" */
  update_reports?: Maybe<Reports_Mutation_Response>;
  /** update single row of the table: "reports" */
  update_reports_by_pk?: Maybe<Reports>;
  /** update data of the table: "rounds" */
  update_rounds?: Maybe<Rounds_Mutation_Response>;
  /** update single row of the table: "rounds" */
  update_rounds_by_pk?: Maybe<Rounds>;
  /** update data of the table: "settings" */
  update_settings?: Maybe<Settings_Mutation_Response>;
  /** update single row of the table: "settings" */
  update_settings_by_pk?: Maybe<Settings>;
  /** update data of the table: "sponsor_questions" */
  update_sponsor_questions?: Maybe<Sponsor_Questions_Mutation_Response>;
  /** update single row of the table: "sponsor_questions" */
  update_sponsor_questions_by_pk?: Maybe<Sponsor_Questions>;
  /** update data of the table: "sponsors" */
  update_sponsors?: Maybe<Sponsors_Mutation_Response>;
  /** update single row of the table: "sponsors" */
  update_sponsors_by_pk?: Maybe<Sponsors>;
  /** update data of the table: "trivia_event_types" */
  update_trivia_event_types?: Maybe<Trivia_Event_Types_Mutation_Response>;
  /** update single row of the table: "trivia_event_types" */
  update_trivia_event_types_by_pk?: Maybe<Trivia_Event_Types>;
  /** update data of the table: "trivia_events" */
  update_trivia_events?: Maybe<Trivia_Events_Mutation_Response>;
  /** update single row of the table: "trivia_events" */
  update_trivia_events_by_pk?: Maybe<Trivia_Events>;
  /** update data of the table: "trivia_game_category" */
  update_trivia_game_category?: Maybe<Trivia_Game_Category_Mutation_Response>;
  /** update single row of the table: "trivia_game_category" */
  update_trivia_game_category_by_pk?: Maybe<Trivia_Game_Category>;
  /** update data of the table: "trivia_game_rounds" */
  update_trivia_game_rounds?: Maybe<Trivia_Game_Rounds_Mutation_Response>;
  /** update single row of the table: "trivia_game_rounds" */
  update_trivia_game_rounds_by_pk?: Maybe<Trivia_Game_Rounds>;
  /** update data of the table: "trivia_game_templates" */
  update_trivia_game_templates?: Maybe<Trivia_Game_Templates_Mutation_Response>;
  /** update single row of the table: "trivia_game_templates" */
  update_trivia_game_templates_by_pk?: Maybe<Trivia_Game_Templates>;
  /** update data of the table: "trivia_game_themes" */
  update_trivia_game_themes?: Maybe<Trivia_Game_Themes_Mutation_Response>;
  /** update single row of the table: "trivia_game_themes" */
  update_trivia_game_themes_by_pk?: Maybe<Trivia_Game_Themes>;
  /** update data of the table: "trivia_games" */
  update_trivia_games?: Maybe<Trivia_Games_Mutation_Response>;
  /** update single row of the table: "trivia_games" */
  update_trivia_games_by_pk?: Maybe<Trivia_Games>;
  /** update data of the table: "trivia_question" */
  update_trivia_question?: Maybe<Trivia_Question_Mutation_Response>;
  /** update data of the table: "trivia_round_questions" */
  update_trivia_round_questions?: Maybe<Trivia_Round_Questions_Mutation_Response>;
  /** update single row of the table: "trivia_round_questions" */
  update_trivia_round_questions_by_pk?: Maybe<Trivia_Round_Questions>;
  /** update data of the table: "trivia_round_templates" */
  update_trivia_round_templates?: Maybe<Trivia_Round_Templates_Mutation_Response>;
  /** update single row of the table: "trivia_round_templates" */
  update_trivia_round_templates_by_pk?: Maybe<Trivia_Round_Templates>;
  /** update data of the table: "trivia_round_themes" */
  update_trivia_round_themes?: Maybe<Trivia_Round_Themes_Mutation_Response>;
  /** update single row of the table: "trivia_round_themes" */
  update_trivia_round_themes_by_pk?: Maybe<Trivia_Round_Themes>;
  /** update data of the table: "trivia_round_types" */
  update_trivia_round_types?: Maybe<Trivia_Round_Types_Mutation_Response>;
  /** update single row of the table: "trivia_round_types" */
  update_trivia_round_types_by_pk?: Maybe<Trivia_Round_Types>;
  /** update data of the table: "trivia_rounds" */
  update_trivia_rounds?: Maybe<Trivia_Rounds_Mutation_Response>;
  /** update single row of the table: "trivia_rounds" */
  update_trivia_rounds_by_pk?: Maybe<Trivia_Rounds>;
  /** update data of the table: "trivia_users" */
  update_trivia_users?: Maybe<Trivia_Users_Mutation_Response>;
  /** update single row of the table: "trivia_users" */
  update_trivia_users_by_pk?: Maybe<Trivia_Users>;
  /** update data of the table: "user_types" */
  update_user_types?: Maybe<User_Types_Mutation_Response>;
  /** update single row of the table: "user_types" */
  update_user_types_by_pk?: Maybe<User_Types>;
};


/** mutation root */
export type Mutation_RootDelete_Answer_TypesArgs = {
  where: Answer_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Answer_Types_By_PkArgs = {
  answer_type_id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_CategoriesArgs = {
  where: Categories_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Categories_By_PkArgs = {
  category_id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_City_Edit_LogArgs = {
  where: City_Edit_Log_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_City_TqsArgs = {
  where: City_Tqs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_City_Trivia_CategoryArgs = {
  where: City_Trivia_Category_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_City_Trivia_QuestionArgs = {
  where: City_Trivia_Question_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_City_Trivia_RoundArgs = {
  where: City_Trivia_Round_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Dayle_SessionsArgs = {
  where: Dayle_Sessions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Dayle_Sessions_By_PkArgs = {
  dayle_session_id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Edit_LogArgs = {
  where: Edit_Log_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Edit_Log_By_PkArgs = {
  edit_log_id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Edit_Log_TypesArgs = {
  where: Edit_Log_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Edit_Log_Types_By_PkArgs = {
  edit_log_type_id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Forgot_PasswordArgs = {
  where: Forgot_Password_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Forgot_Password_By_PkArgs = {
  forgot_password_id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Game_DifficultiesArgs = {
  where: Game_Difficulties_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Game_Difficulties_By_PkArgs = {
  game_difficult_id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Game_FormatsArgs = {
  where: Game_Formats_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Game_Formats_By_PkArgs = {
  game_format_id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Game_RatingsArgs = {
  where: Game_Ratings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Game_Ratings_By_PkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Game_StatusArgs = {
  where: Game_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Game_Status_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Game_ThemesArgs = {
  where: Game_Themes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Game_Themes_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Gen_RoundArgs = {
  where: Gen_Round_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Gen_Round_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Gen_UuidArgs = {
  where: Gen_Uuid_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Gen_Uuid_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_MarketsArgs = {
  where: Markets_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Markets_By_PkArgs = {
  market_id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Question_BonusesArgs = {
  where: Question_Bonuses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Question_Bonuses_By_PkArgs = {
  question_bonus_id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Question_DifficultiesArgs = {
  where: Question_Difficulties_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Question_Difficulties_By_PkArgs = {
  question_difficulty_id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Question_LanguagesArgs = {
  where: Question_Languages_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Question_Languages_By_PkArgs = {
  market_id: Scalars['String'];
  question_id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Question_RatingsArgs = {
  where: Question_Ratings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Question_Ratings_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Question_StatusArgs = {
  where: Question_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Question_Status_By_PkArgs = {
  question_status_id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Question_TagsArgs = {
  where: Question_Tags_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Question_Tags_By_PkArgs = {
  question_id: Scalars['uuid'];
  tag: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Question_Texts_SimilaritiesArgs = {
  where: Question_Texts_Similarities_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Question_Texts_Similarities_By_PkArgs = {
  question_text: Scalars['String'];
  sim: Scalars['Float'];
};


/** mutation root */
export type Mutation_RootDelete_Question_TypesArgs = {
  where: Question_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Question_Types_By_PkArgs = {
  question_type_id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_QuestionsArgs = {
  where: Questions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Questions_By_PkArgs = {
  question_id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Rejection_ReasonsArgs = {
  where: Rejection_Reasons_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Rejection_Reasons_By_PkArgs = {
  rejection_reason_id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Report_ReasonsArgs = {
  where: Report_Reasons_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Report_Reasons_By_PkArgs = {
  report_reason_id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_ReportsArgs = {
  where: Reports_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Reports_By_PkArgs = {
  report_id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_RoundsArgs = {
  where: Rounds_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Rounds_By_PkArgs = {
  round_id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_SettingsArgs = {
  where: Settings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Settings_By_PkArgs = {
  setting_name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Sponsor_QuestionsArgs = {
  where: Sponsor_Questions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Sponsor_Questions_By_PkArgs = {
  question_id: Scalars['uuid'];
  sponsor_id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_SponsorsArgs = {
  where: Sponsors_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Sponsors_By_PkArgs = {
  sponsor_id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Trivia_Event_TypesArgs = {
  where: Trivia_Event_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Trivia_Event_Types_By_PkArgs = {
  event_type_id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Trivia_EventsArgs = {
  where: Trivia_Events_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Trivia_Events_By_PkArgs = {
  event_id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Trivia_Game_CategoryArgs = {
  where: Trivia_Game_Category_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Trivia_Game_Category_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Trivia_Game_RoundsArgs = {
  where: Trivia_Game_Rounds_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Trivia_Game_Rounds_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Trivia_Game_TemplatesArgs = {
  where: Trivia_Game_Templates_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Trivia_Game_Templates_By_PkArgs = {
  template_id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Trivia_Game_ThemesArgs = {
  where: Trivia_Game_Themes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Trivia_Game_Themes_By_PkArgs = {
  game_theme_id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Trivia_GamesArgs = {
  where: Trivia_Games_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Trivia_Games_By_PkArgs = {
  game_id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Trivia_QuestionArgs = {
  where: Trivia_Question_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Trivia_Round_QuestionsArgs = {
  where: Trivia_Round_Questions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Trivia_Round_Questions_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Trivia_Round_TemplatesArgs = {
  where: Trivia_Round_Templates_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Trivia_Round_Templates_By_PkArgs = {
  template_id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Trivia_Round_ThemesArgs = {
  where: Trivia_Round_Themes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Trivia_Round_Themes_By_PkArgs = {
  round_theme_id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Trivia_Round_TypesArgs = {
  where: Trivia_Round_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Trivia_Round_Types_By_PkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Trivia_RoundsArgs = {
  where: Trivia_Rounds_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Trivia_Rounds_By_PkArgs = {
  round_id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Trivia_UsersArgs = {
  where: Trivia_Users_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Trivia_Users_By_PkArgs = {
  trivia_user_id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_User_TypesArgs = {
  where: User_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Types_By_PkArgs = {
  user_type_id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootInsert_Answer_TypesArgs = {
  objects: Array<Answer_Types_Insert_Input>;
  on_conflict?: InputMaybe<Answer_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Answer_Types_OneArgs = {
  object: Answer_Types_Insert_Input;
  on_conflict?: InputMaybe<Answer_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_CategoriesArgs = {
  objects: Array<Categories_Insert_Input>;
  on_conflict?: InputMaybe<Categories_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Categories_OneArgs = {
  object: Categories_Insert_Input;
  on_conflict?: InputMaybe<Categories_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_City_Edit_LogArgs = {
  objects: Array<City_Edit_Log_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_City_Edit_Log_OneArgs = {
  object: City_Edit_Log_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_City_TqsArgs = {
  objects: Array<City_Tqs_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_City_Tqs_OneArgs = {
  object: City_Tqs_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_City_Trivia_CategoryArgs = {
  objects: Array<City_Trivia_Category_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_City_Trivia_Category_OneArgs = {
  object: City_Trivia_Category_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_City_Trivia_QuestionArgs = {
  objects: Array<City_Trivia_Question_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_City_Trivia_Question_OneArgs = {
  object: City_Trivia_Question_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_City_Trivia_RoundArgs = {
  objects: Array<City_Trivia_Round_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_City_Trivia_Round_OneArgs = {
  object: City_Trivia_Round_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_Dayle_SessionsArgs = {
  objects: Array<Dayle_Sessions_Insert_Input>;
  on_conflict?: InputMaybe<Dayle_Sessions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Dayle_Sessions_OneArgs = {
  object: Dayle_Sessions_Insert_Input;
  on_conflict?: InputMaybe<Dayle_Sessions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Edit_LogArgs = {
  objects: Array<Edit_Log_Insert_Input>;
  on_conflict?: InputMaybe<Edit_Log_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Edit_Log_OneArgs = {
  object: Edit_Log_Insert_Input;
  on_conflict?: InputMaybe<Edit_Log_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Edit_Log_TypesArgs = {
  objects: Array<Edit_Log_Types_Insert_Input>;
  on_conflict?: InputMaybe<Edit_Log_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Edit_Log_Types_OneArgs = {
  object: Edit_Log_Types_Insert_Input;
  on_conflict?: InputMaybe<Edit_Log_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Forgot_PasswordArgs = {
  objects: Array<Forgot_Password_Insert_Input>;
  on_conflict?: InputMaybe<Forgot_Password_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Forgot_Password_OneArgs = {
  object: Forgot_Password_Insert_Input;
  on_conflict?: InputMaybe<Forgot_Password_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Game_DifficultiesArgs = {
  objects: Array<Game_Difficulties_Insert_Input>;
  on_conflict?: InputMaybe<Game_Difficulties_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Game_Difficulties_OneArgs = {
  object: Game_Difficulties_Insert_Input;
  on_conflict?: InputMaybe<Game_Difficulties_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Game_FormatsArgs = {
  objects: Array<Game_Formats_Insert_Input>;
  on_conflict?: InputMaybe<Game_Formats_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Game_Formats_OneArgs = {
  object: Game_Formats_Insert_Input;
  on_conflict?: InputMaybe<Game_Formats_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Game_RatingsArgs = {
  objects: Array<Game_Ratings_Insert_Input>;
  on_conflict?: InputMaybe<Game_Ratings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Game_Ratings_OneArgs = {
  object: Game_Ratings_Insert_Input;
  on_conflict?: InputMaybe<Game_Ratings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Game_StatusArgs = {
  objects: Array<Game_Status_Insert_Input>;
  on_conflict?: InputMaybe<Game_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Game_Status_OneArgs = {
  object: Game_Status_Insert_Input;
  on_conflict?: InputMaybe<Game_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Game_ThemesArgs = {
  objects: Array<Game_Themes_Insert_Input>;
  on_conflict?: InputMaybe<Game_Themes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Game_Themes_OneArgs = {
  object: Game_Themes_Insert_Input;
  on_conflict?: InputMaybe<Game_Themes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Gen_RoundArgs = {
  objects: Array<Gen_Round_Insert_Input>;
  on_conflict?: InputMaybe<Gen_Round_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Gen_Round_OneArgs = {
  object: Gen_Round_Insert_Input;
  on_conflict?: InputMaybe<Gen_Round_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Gen_UuidArgs = {
  objects: Array<Gen_Uuid_Insert_Input>;
  on_conflict?: InputMaybe<Gen_Uuid_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Gen_Uuid_OneArgs = {
  object: Gen_Uuid_Insert_Input;
  on_conflict?: InputMaybe<Gen_Uuid_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_MarketsArgs = {
  objects: Array<Markets_Insert_Input>;
  on_conflict?: InputMaybe<Markets_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Markets_OneArgs = {
  object: Markets_Insert_Input;
  on_conflict?: InputMaybe<Markets_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Question_BonusesArgs = {
  objects: Array<Question_Bonuses_Insert_Input>;
  on_conflict?: InputMaybe<Question_Bonuses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Question_Bonuses_OneArgs = {
  object: Question_Bonuses_Insert_Input;
  on_conflict?: InputMaybe<Question_Bonuses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Question_DifficultiesArgs = {
  objects: Array<Question_Difficulties_Insert_Input>;
  on_conflict?: InputMaybe<Question_Difficulties_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Question_Difficulties_OneArgs = {
  object: Question_Difficulties_Insert_Input;
  on_conflict?: InputMaybe<Question_Difficulties_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Question_LanguagesArgs = {
  objects: Array<Question_Languages_Insert_Input>;
  on_conflict?: InputMaybe<Question_Languages_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Question_Languages_OneArgs = {
  object: Question_Languages_Insert_Input;
  on_conflict?: InputMaybe<Question_Languages_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Question_RatingsArgs = {
  objects: Array<Question_Ratings_Insert_Input>;
  on_conflict?: InputMaybe<Question_Ratings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Question_Ratings_OneArgs = {
  object: Question_Ratings_Insert_Input;
  on_conflict?: InputMaybe<Question_Ratings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Question_StatusArgs = {
  objects: Array<Question_Status_Insert_Input>;
  on_conflict?: InputMaybe<Question_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Question_Status_OneArgs = {
  object: Question_Status_Insert_Input;
  on_conflict?: InputMaybe<Question_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Question_TagsArgs = {
  objects: Array<Question_Tags_Insert_Input>;
  on_conflict?: InputMaybe<Question_Tags_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Question_Tags_OneArgs = {
  object: Question_Tags_Insert_Input;
  on_conflict?: InputMaybe<Question_Tags_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Question_Texts_SimilaritiesArgs = {
  objects: Array<Question_Texts_Similarities_Insert_Input>;
  on_conflict?: InputMaybe<Question_Texts_Similarities_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Question_Texts_Similarities_OneArgs = {
  object: Question_Texts_Similarities_Insert_Input;
  on_conflict?: InputMaybe<Question_Texts_Similarities_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Question_TypesArgs = {
  objects: Array<Question_Types_Insert_Input>;
  on_conflict?: InputMaybe<Question_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Question_Types_OneArgs = {
  object: Question_Types_Insert_Input;
  on_conflict?: InputMaybe<Question_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_QuestionsArgs = {
  objects: Array<Questions_Insert_Input>;
  on_conflict?: InputMaybe<Questions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Questions_OneArgs = {
  object: Questions_Insert_Input;
  on_conflict?: InputMaybe<Questions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Rejection_ReasonsArgs = {
  objects: Array<Rejection_Reasons_Insert_Input>;
  on_conflict?: InputMaybe<Rejection_Reasons_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Rejection_Reasons_OneArgs = {
  object: Rejection_Reasons_Insert_Input;
  on_conflict?: InputMaybe<Rejection_Reasons_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Report_ReasonsArgs = {
  objects: Array<Report_Reasons_Insert_Input>;
  on_conflict?: InputMaybe<Report_Reasons_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Report_Reasons_OneArgs = {
  object: Report_Reasons_Insert_Input;
  on_conflict?: InputMaybe<Report_Reasons_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ReportsArgs = {
  objects: Array<Reports_Insert_Input>;
  on_conflict?: InputMaybe<Reports_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Reports_OneArgs = {
  object: Reports_Insert_Input;
  on_conflict?: InputMaybe<Reports_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_RoundsArgs = {
  objects: Array<Rounds_Insert_Input>;
  on_conflict?: InputMaybe<Rounds_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Rounds_OneArgs = {
  object: Rounds_Insert_Input;
  on_conflict?: InputMaybe<Rounds_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_SettingsArgs = {
  objects: Array<Settings_Insert_Input>;
  on_conflict?: InputMaybe<Settings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Settings_OneArgs = {
  object: Settings_Insert_Input;
  on_conflict?: InputMaybe<Settings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Sponsor_QuestionsArgs = {
  objects: Array<Sponsor_Questions_Insert_Input>;
  on_conflict?: InputMaybe<Sponsor_Questions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Sponsor_Questions_OneArgs = {
  object: Sponsor_Questions_Insert_Input;
  on_conflict?: InputMaybe<Sponsor_Questions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_SponsorsArgs = {
  objects: Array<Sponsors_Insert_Input>;
  on_conflict?: InputMaybe<Sponsors_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Sponsors_OneArgs = {
  object: Sponsors_Insert_Input;
  on_conflict?: InputMaybe<Sponsors_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Trivia_Event_TypesArgs = {
  objects: Array<Trivia_Event_Types_Insert_Input>;
  on_conflict?: InputMaybe<Trivia_Event_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Trivia_Event_Types_OneArgs = {
  object: Trivia_Event_Types_Insert_Input;
  on_conflict?: InputMaybe<Trivia_Event_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Trivia_EventsArgs = {
  objects: Array<Trivia_Events_Insert_Input>;
  on_conflict?: InputMaybe<Trivia_Events_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Trivia_Events_OneArgs = {
  object: Trivia_Events_Insert_Input;
  on_conflict?: InputMaybe<Trivia_Events_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Trivia_Game_CategoryArgs = {
  objects: Array<Trivia_Game_Category_Insert_Input>;
  on_conflict?: InputMaybe<Trivia_Game_Category_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Trivia_Game_Category_OneArgs = {
  object: Trivia_Game_Category_Insert_Input;
  on_conflict?: InputMaybe<Trivia_Game_Category_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Trivia_Game_RoundsArgs = {
  objects: Array<Trivia_Game_Rounds_Insert_Input>;
  on_conflict?: InputMaybe<Trivia_Game_Rounds_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Trivia_Game_Rounds_OneArgs = {
  object: Trivia_Game_Rounds_Insert_Input;
  on_conflict?: InputMaybe<Trivia_Game_Rounds_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Trivia_Game_TemplatesArgs = {
  objects: Array<Trivia_Game_Templates_Insert_Input>;
  on_conflict?: InputMaybe<Trivia_Game_Templates_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Trivia_Game_Templates_OneArgs = {
  object: Trivia_Game_Templates_Insert_Input;
  on_conflict?: InputMaybe<Trivia_Game_Templates_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Trivia_Game_ThemesArgs = {
  objects: Array<Trivia_Game_Themes_Insert_Input>;
  on_conflict?: InputMaybe<Trivia_Game_Themes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Trivia_Game_Themes_OneArgs = {
  object: Trivia_Game_Themes_Insert_Input;
  on_conflict?: InputMaybe<Trivia_Game_Themes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Trivia_GamesArgs = {
  objects: Array<Trivia_Games_Insert_Input>;
  on_conflict?: InputMaybe<Trivia_Games_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Trivia_Games_OneArgs = {
  object: Trivia_Games_Insert_Input;
  on_conflict?: InputMaybe<Trivia_Games_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Trivia_QuestionArgs = {
  objects: Array<Trivia_Question_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Trivia_Question_OneArgs = {
  object: Trivia_Question_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_Trivia_Round_QuestionsArgs = {
  objects: Array<Trivia_Round_Questions_Insert_Input>;
  on_conflict?: InputMaybe<Trivia_Round_Questions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Trivia_Round_Questions_OneArgs = {
  object: Trivia_Round_Questions_Insert_Input;
  on_conflict?: InputMaybe<Trivia_Round_Questions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Trivia_Round_TemplatesArgs = {
  objects: Array<Trivia_Round_Templates_Insert_Input>;
  on_conflict?: InputMaybe<Trivia_Round_Templates_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Trivia_Round_Templates_OneArgs = {
  object: Trivia_Round_Templates_Insert_Input;
  on_conflict?: InputMaybe<Trivia_Round_Templates_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Trivia_Round_ThemesArgs = {
  objects: Array<Trivia_Round_Themes_Insert_Input>;
  on_conflict?: InputMaybe<Trivia_Round_Themes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Trivia_Round_Themes_OneArgs = {
  object: Trivia_Round_Themes_Insert_Input;
  on_conflict?: InputMaybe<Trivia_Round_Themes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Trivia_Round_TypesArgs = {
  objects: Array<Trivia_Round_Types_Insert_Input>;
  on_conflict?: InputMaybe<Trivia_Round_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Trivia_Round_Types_OneArgs = {
  object: Trivia_Round_Types_Insert_Input;
  on_conflict?: InputMaybe<Trivia_Round_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Trivia_RoundsArgs = {
  objects: Array<Trivia_Rounds_Insert_Input>;
  on_conflict?: InputMaybe<Trivia_Rounds_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Trivia_Rounds_OneArgs = {
  object: Trivia_Rounds_Insert_Input;
  on_conflict?: InputMaybe<Trivia_Rounds_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Trivia_UsersArgs = {
  objects: Array<Trivia_Users_Insert_Input>;
  on_conflict?: InputMaybe<Trivia_Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Trivia_Users_OneArgs = {
  object: Trivia_Users_Insert_Input;
  on_conflict?: InputMaybe<Trivia_Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_TypesArgs = {
  objects: Array<User_Types_Insert_Input>;
  on_conflict?: InputMaybe<User_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Types_OneArgs = {
  object: User_Types_Insert_Input;
  on_conflict?: InputMaybe<User_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootUpdate_Answer_TypesArgs = {
  _inc?: InputMaybe<Answer_Types_Inc_Input>;
  _set?: InputMaybe<Answer_Types_Set_Input>;
  where: Answer_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Answer_Types_By_PkArgs = {
  _inc?: InputMaybe<Answer_Types_Inc_Input>;
  _set?: InputMaybe<Answer_Types_Set_Input>;
  pk_columns: Answer_Types_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_CategoriesArgs = {
  _inc?: InputMaybe<Categories_Inc_Input>;
  _set?: InputMaybe<Categories_Set_Input>;
  where: Categories_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Categories_By_PkArgs = {
  _inc?: InputMaybe<Categories_Inc_Input>;
  _set?: InputMaybe<Categories_Set_Input>;
  pk_columns: Categories_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_City_Edit_LogArgs = {
  _inc?: InputMaybe<City_Edit_Log_Inc_Input>;
  _set?: InputMaybe<City_Edit_Log_Set_Input>;
  where: City_Edit_Log_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_City_TqsArgs = {
  _inc?: InputMaybe<City_Tqs_Inc_Input>;
  _set?: InputMaybe<City_Tqs_Set_Input>;
  where: City_Tqs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_City_Trivia_CategoryArgs = {
  _inc?: InputMaybe<City_Trivia_Category_Inc_Input>;
  _set?: InputMaybe<City_Trivia_Category_Set_Input>;
  where: City_Trivia_Category_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_City_Trivia_QuestionArgs = {
  _inc?: InputMaybe<City_Trivia_Question_Inc_Input>;
  _set?: InputMaybe<City_Trivia_Question_Set_Input>;
  where: City_Trivia_Question_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_City_Trivia_RoundArgs = {
  _inc?: InputMaybe<City_Trivia_Round_Inc_Input>;
  _set?: InputMaybe<City_Trivia_Round_Set_Input>;
  where: City_Trivia_Round_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Dayle_SessionsArgs = {
  _inc?: InputMaybe<Dayle_Sessions_Inc_Input>;
  _set?: InputMaybe<Dayle_Sessions_Set_Input>;
  where: Dayle_Sessions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Dayle_Sessions_By_PkArgs = {
  _inc?: InputMaybe<Dayle_Sessions_Inc_Input>;
  _set?: InputMaybe<Dayle_Sessions_Set_Input>;
  pk_columns: Dayle_Sessions_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Edit_LogArgs = {
  _inc?: InputMaybe<Edit_Log_Inc_Input>;
  _set?: InputMaybe<Edit_Log_Set_Input>;
  where: Edit_Log_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Edit_Log_By_PkArgs = {
  _inc?: InputMaybe<Edit_Log_Inc_Input>;
  _set?: InputMaybe<Edit_Log_Set_Input>;
  pk_columns: Edit_Log_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Edit_Log_TypesArgs = {
  _inc?: InputMaybe<Edit_Log_Types_Inc_Input>;
  _set?: InputMaybe<Edit_Log_Types_Set_Input>;
  where: Edit_Log_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Edit_Log_Types_By_PkArgs = {
  _inc?: InputMaybe<Edit_Log_Types_Inc_Input>;
  _set?: InputMaybe<Edit_Log_Types_Set_Input>;
  pk_columns: Edit_Log_Types_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Forgot_PasswordArgs = {
  _inc?: InputMaybe<Forgot_Password_Inc_Input>;
  _set?: InputMaybe<Forgot_Password_Set_Input>;
  where: Forgot_Password_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Forgot_Password_By_PkArgs = {
  _inc?: InputMaybe<Forgot_Password_Inc_Input>;
  _set?: InputMaybe<Forgot_Password_Set_Input>;
  pk_columns: Forgot_Password_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Game_DifficultiesArgs = {
  _inc?: InputMaybe<Game_Difficulties_Inc_Input>;
  _set?: InputMaybe<Game_Difficulties_Set_Input>;
  where: Game_Difficulties_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Game_Difficulties_By_PkArgs = {
  _inc?: InputMaybe<Game_Difficulties_Inc_Input>;
  _set?: InputMaybe<Game_Difficulties_Set_Input>;
  pk_columns: Game_Difficulties_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Game_FormatsArgs = {
  _inc?: InputMaybe<Game_Formats_Inc_Input>;
  _set?: InputMaybe<Game_Formats_Set_Input>;
  where: Game_Formats_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Game_Formats_By_PkArgs = {
  _inc?: InputMaybe<Game_Formats_Inc_Input>;
  _set?: InputMaybe<Game_Formats_Set_Input>;
  pk_columns: Game_Formats_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Game_RatingsArgs = {
  _set?: InputMaybe<Game_Ratings_Set_Input>;
  where: Game_Ratings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Game_Ratings_By_PkArgs = {
  _set?: InputMaybe<Game_Ratings_Set_Input>;
  pk_columns: Game_Ratings_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Game_StatusArgs = {
  _inc?: InputMaybe<Game_Status_Inc_Input>;
  _set?: InputMaybe<Game_Status_Set_Input>;
  where: Game_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Game_Status_By_PkArgs = {
  _inc?: InputMaybe<Game_Status_Inc_Input>;
  _set?: InputMaybe<Game_Status_Set_Input>;
  pk_columns: Game_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Game_ThemesArgs = {
  _set?: InputMaybe<Game_Themes_Set_Input>;
  where: Game_Themes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Game_Themes_By_PkArgs = {
  _set?: InputMaybe<Game_Themes_Set_Input>;
  pk_columns: Game_Themes_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Gen_RoundArgs = {
  _set?: InputMaybe<Gen_Round_Set_Input>;
  where: Gen_Round_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Gen_Round_By_PkArgs = {
  _set?: InputMaybe<Gen_Round_Set_Input>;
  pk_columns: Gen_Round_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Gen_UuidArgs = {
  _set?: InputMaybe<Gen_Uuid_Set_Input>;
  where: Gen_Uuid_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Gen_Uuid_By_PkArgs = {
  _set?: InputMaybe<Gen_Uuid_Set_Input>;
  pk_columns: Gen_Uuid_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_MarketsArgs = {
  _set?: InputMaybe<Markets_Set_Input>;
  where: Markets_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Markets_By_PkArgs = {
  _set?: InputMaybe<Markets_Set_Input>;
  pk_columns: Markets_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Question_BonusesArgs = {
  _inc?: InputMaybe<Question_Bonuses_Inc_Input>;
  _set?: InputMaybe<Question_Bonuses_Set_Input>;
  where: Question_Bonuses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Question_Bonuses_By_PkArgs = {
  _inc?: InputMaybe<Question_Bonuses_Inc_Input>;
  _set?: InputMaybe<Question_Bonuses_Set_Input>;
  pk_columns: Question_Bonuses_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Question_DifficultiesArgs = {
  _inc?: InputMaybe<Question_Difficulties_Inc_Input>;
  _set?: InputMaybe<Question_Difficulties_Set_Input>;
  where: Question_Difficulties_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Question_Difficulties_By_PkArgs = {
  _inc?: InputMaybe<Question_Difficulties_Inc_Input>;
  _set?: InputMaybe<Question_Difficulties_Set_Input>;
  pk_columns: Question_Difficulties_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Question_LanguagesArgs = {
  _set?: InputMaybe<Question_Languages_Set_Input>;
  where: Question_Languages_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Question_Languages_By_PkArgs = {
  _set?: InputMaybe<Question_Languages_Set_Input>;
  pk_columns: Question_Languages_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Question_RatingsArgs = {
  _inc?: InputMaybe<Question_Ratings_Inc_Input>;
  _set?: InputMaybe<Question_Ratings_Set_Input>;
  where: Question_Ratings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Question_Ratings_By_PkArgs = {
  _inc?: InputMaybe<Question_Ratings_Inc_Input>;
  _set?: InputMaybe<Question_Ratings_Set_Input>;
  pk_columns: Question_Ratings_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Question_StatusArgs = {
  _inc?: InputMaybe<Question_Status_Inc_Input>;
  _set?: InputMaybe<Question_Status_Set_Input>;
  where: Question_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Question_Status_By_PkArgs = {
  _inc?: InputMaybe<Question_Status_Inc_Input>;
  _set?: InputMaybe<Question_Status_Set_Input>;
  pk_columns: Question_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Question_TagsArgs = {
  _set?: InputMaybe<Question_Tags_Set_Input>;
  where: Question_Tags_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Question_Tags_By_PkArgs = {
  _set?: InputMaybe<Question_Tags_Set_Input>;
  pk_columns: Question_Tags_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Question_Texts_SimilaritiesArgs = {
  _inc?: InputMaybe<Question_Texts_Similarities_Inc_Input>;
  _set?: InputMaybe<Question_Texts_Similarities_Set_Input>;
  where: Question_Texts_Similarities_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Question_Texts_Similarities_By_PkArgs = {
  _inc?: InputMaybe<Question_Texts_Similarities_Inc_Input>;
  _set?: InputMaybe<Question_Texts_Similarities_Set_Input>;
  pk_columns: Question_Texts_Similarities_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Question_TypesArgs = {
  _inc?: InputMaybe<Question_Types_Inc_Input>;
  _set?: InputMaybe<Question_Types_Set_Input>;
  where: Question_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Question_Types_By_PkArgs = {
  _inc?: InputMaybe<Question_Types_Inc_Input>;
  _set?: InputMaybe<Question_Types_Set_Input>;
  pk_columns: Question_Types_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_QuestionsArgs = {
  _append?: InputMaybe<Questions_Append_Input>;
  _delete_at_path?: InputMaybe<Questions_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Questions_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Questions_Delete_Key_Input>;
  _inc?: InputMaybe<Questions_Inc_Input>;
  _prepend?: InputMaybe<Questions_Prepend_Input>;
  _set?: InputMaybe<Questions_Set_Input>;
  where: Questions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Questions_By_PkArgs = {
  _append?: InputMaybe<Questions_Append_Input>;
  _delete_at_path?: InputMaybe<Questions_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Questions_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Questions_Delete_Key_Input>;
  _inc?: InputMaybe<Questions_Inc_Input>;
  _prepend?: InputMaybe<Questions_Prepend_Input>;
  _set?: InputMaybe<Questions_Set_Input>;
  pk_columns: Questions_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Rejection_ReasonsArgs = {
  _inc?: InputMaybe<Rejection_Reasons_Inc_Input>;
  _set?: InputMaybe<Rejection_Reasons_Set_Input>;
  where: Rejection_Reasons_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Rejection_Reasons_By_PkArgs = {
  _inc?: InputMaybe<Rejection_Reasons_Inc_Input>;
  _set?: InputMaybe<Rejection_Reasons_Set_Input>;
  pk_columns: Rejection_Reasons_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Report_ReasonsArgs = {
  _inc?: InputMaybe<Report_Reasons_Inc_Input>;
  _set?: InputMaybe<Report_Reasons_Set_Input>;
  where: Report_Reasons_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Report_Reasons_By_PkArgs = {
  _inc?: InputMaybe<Report_Reasons_Inc_Input>;
  _set?: InputMaybe<Report_Reasons_Set_Input>;
  pk_columns: Report_Reasons_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_ReportsArgs = {
  _inc?: InputMaybe<Reports_Inc_Input>;
  _set?: InputMaybe<Reports_Set_Input>;
  where: Reports_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Reports_By_PkArgs = {
  _inc?: InputMaybe<Reports_Inc_Input>;
  _set?: InputMaybe<Reports_Set_Input>;
  pk_columns: Reports_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_RoundsArgs = {
  _append?: InputMaybe<Rounds_Append_Input>;
  _delete_at_path?: InputMaybe<Rounds_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Rounds_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Rounds_Delete_Key_Input>;
  _inc?: InputMaybe<Rounds_Inc_Input>;
  _prepend?: InputMaybe<Rounds_Prepend_Input>;
  _set?: InputMaybe<Rounds_Set_Input>;
  where: Rounds_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Rounds_By_PkArgs = {
  _append?: InputMaybe<Rounds_Append_Input>;
  _delete_at_path?: InputMaybe<Rounds_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Rounds_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Rounds_Delete_Key_Input>;
  _inc?: InputMaybe<Rounds_Inc_Input>;
  _prepend?: InputMaybe<Rounds_Prepend_Input>;
  _set?: InputMaybe<Rounds_Set_Input>;
  pk_columns: Rounds_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_SettingsArgs = {
  _set?: InputMaybe<Settings_Set_Input>;
  where: Settings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Settings_By_PkArgs = {
  _set?: InputMaybe<Settings_Set_Input>;
  pk_columns: Settings_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Sponsor_QuestionsArgs = {
  _set?: InputMaybe<Sponsor_Questions_Set_Input>;
  where: Sponsor_Questions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Sponsor_Questions_By_PkArgs = {
  _set?: InputMaybe<Sponsor_Questions_Set_Input>;
  pk_columns: Sponsor_Questions_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_SponsorsArgs = {
  _set?: InputMaybe<Sponsors_Set_Input>;
  where: Sponsors_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Sponsors_By_PkArgs = {
  _set?: InputMaybe<Sponsors_Set_Input>;
  pk_columns: Sponsors_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Trivia_Event_TypesArgs = {
  _inc?: InputMaybe<Trivia_Event_Types_Inc_Input>;
  _set?: InputMaybe<Trivia_Event_Types_Set_Input>;
  where: Trivia_Event_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Trivia_Event_Types_By_PkArgs = {
  _inc?: InputMaybe<Trivia_Event_Types_Inc_Input>;
  _set?: InputMaybe<Trivia_Event_Types_Set_Input>;
  pk_columns: Trivia_Event_Types_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Trivia_EventsArgs = {
  _inc?: InputMaybe<Trivia_Events_Inc_Input>;
  _set?: InputMaybe<Trivia_Events_Set_Input>;
  where: Trivia_Events_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Trivia_Events_By_PkArgs = {
  _inc?: InputMaybe<Trivia_Events_Inc_Input>;
  _set?: InputMaybe<Trivia_Events_Set_Input>;
  pk_columns: Trivia_Events_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Trivia_Game_CategoryArgs = {
  _inc?: InputMaybe<Trivia_Game_Category_Inc_Input>;
  _set?: InputMaybe<Trivia_Game_Category_Set_Input>;
  where: Trivia_Game_Category_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Trivia_Game_Category_By_PkArgs = {
  _inc?: InputMaybe<Trivia_Game_Category_Inc_Input>;
  _set?: InputMaybe<Trivia_Game_Category_Set_Input>;
  pk_columns: Trivia_Game_Category_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Trivia_Game_RoundsArgs = {
  _inc?: InputMaybe<Trivia_Game_Rounds_Inc_Input>;
  _set?: InputMaybe<Trivia_Game_Rounds_Set_Input>;
  where: Trivia_Game_Rounds_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Trivia_Game_Rounds_By_PkArgs = {
  _inc?: InputMaybe<Trivia_Game_Rounds_Inc_Input>;
  _set?: InputMaybe<Trivia_Game_Rounds_Set_Input>;
  pk_columns: Trivia_Game_Rounds_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Trivia_Game_TemplatesArgs = {
  _inc?: InputMaybe<Trivia_Game_Templates_Inc_Input>;
  _set?: InputMaybe<Trivia_Game_Templates_Set_Input>;
  where: Trivia_Game_Templates_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Trivia_Game_Templates_By_PkArgs = {
  _inc?: InputMaybe<Trivia_Game_Templates_Inc_Input>;
  _set?: InputMaybe<Trivia_Game_Templates_Set_Input>;
  pk_columns: Trivia_Game_Templates_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Trivia_Game_ThemesArgs = {
  _set?: InputMaybe<Trivia_Game_Themes_Set_Input>;
  where: Trivia_Game_Themes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Trivia_Game_Themes_By_PkArgs = {
  _set?: InputMaybe<Trivia_Game_Themes_Set_Input>;
  pk_columns: Trivia_Game_Themes_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Trivia_GamesArgs = {
  _inc?: InputMaybe<Trivia_Games_Inc_Input>;
  _set?: InputMaybe<Trivia_Games_Set_Input>;
  where: Trivia_Games_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Trivia_Games_By_PkArgs = {
  _inc?: InputMaybe<Trivia_Games_Inc_Input>;
  _set?: InputMaybe<Trivia_Games_Set_Input>;
  pk_columns: Trivia_Games_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Trivia_QuestionArgs = {
  _set?: InputMaybe<Trivia_Question_Set_Input>;
  where: Trivia_Question_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Trivia_Round_QuestionsArgs = {
  _inc?: InputMaybe<Trivia_Round_Questions_Inc_Input>;
  _set?: InputMaybe<Trivia_Round_Questions_Set_Input>;
  where: Trivia_Round_Questions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Trivia_Round_Questions_By_PkArgs = {
  _inc?: InputMaybe<Trivia_Round_Questions_Inc_Input>;
  _set?: InputMaybe<Trivia_Round_Questions_Set_Input>;
  pk_columns: Trivia_Round_Questions_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Trivia_Round_TemplatesArgs = {
  _set?: InputMaybe<Trivia_Round_Templates_Set_Input>;
  where: Trivia_Round_Templates_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Trivia_Round_Templates_By_PkArgs = {
  _set?: InputMaybe<Trivia_Round_Templates_Set_Input>;
  pk_columns: Trivia_Round_Templates_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Trivia_Round_ThemesArgs = {
  _set?: InputMaybe<Trivia_Round_Themes_Set_Input>;
  where: Trivia_Round_Themes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Trivia_Round_Themes_By_PkArgs = {
  _set?: InputMaybe<Trivia_Round_Themes_Set_Input>;
  pk_columns: Trivia_Round_Themes_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Trivia_Round_TypesArgs = {
  _set?: InputMaybe<Trivia_Round_Types_Set_Input>;
  where: Trivia_Round_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Trivia_Round_Types_By_PkArgs = {
  _set?: InputMaybe<Trivia_Round_Types_Set_Input>;
  pk_columns: Trivia_Round_Types_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Trivia_RoundsArgs = {
  _set?: InputMaybe<Trivia_Rounds_Set_Input>;
  where: Trivia_Rounds_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Trivia_Rounds_By_PkArgs = {
  _set?: InputMaybe<Trivia_Rounds_Set_Input>;
  pk_columns: Trivia_Rounds_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Trivia_UsersArgs = {
  _append?: InputMaybe<Trivia_Users_Append_Input>;
  _delete_at_path?: InputMaybe<Trivia_Users_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Trivia_Users_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Trivia_Users_Delete_Key_Input>;
  _inc?: InputMaybe<Trivia_Users_Inc_Input>;
  _prepend?: InputMaybe<Trivia_Users_Prepend_Input>;
  _set?: InputMaybe<Trivia_Users_Set_Input>;
  where: Trivia_Users_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Trivia_Users_By_PkArgs = {
  _append?: InputMaybe<Trivia_Users_Append_Input>;
  _delete_at_path?: InputMaybe<Trivia_Users_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Trivia_Users_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Trivia_Users_Delete_Key_Input>;
  _inc?: InputMaybe<Trivia_Users_Inc_Input>;
  _prepend?: InputMaybe<Trivia_Users_Prepend_Input>;
  _set?: InputMaybe<Trivia_Users_Set_Input>;
  pk_columns: Trivia_Users_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_TypesArgs = {
  _inc?: InputMaybe<User_Types_Inc_Input>;
  _set?: InputMaybe<User_Types_Set_Input>;
  where: User_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Types_By_PkArgs = {
  _inc?: InputMaybe<User_Types_Inc_Input>;
  _set?: InputMaybe<User_Types_Set_Input>;
  pk_columns: User_Types_Pk_Columns_Input;
};

/** column ordering options */
export enum Order_By {
  /** in the ascending order, nulls last */
  Asc = 'asc',
  /** in the ascending order, nulls first */
  AscNullsFirst = 'asc_nulls_first',
  /** in the ascending order, nulls last */
  AscNullsLast = 'asc_nulls_last',
  /** in the descending order, nulls first */
  Desc = 'desc',
  /** in the descending order, nulls first */
  DescNullsFirst = 'desc_nulls_first',
  /** in the descending order, nulls last */
  DescNullsLast = 'desc_nulls_last'
}

/** query root */
export type Query_Root = {
  __typename?: 'query_root';
  /** execute function "_generate_bonus_round" which returns "gen_round" */
  _generate_bonus_round: Array<Gen_Round>;
  /** execute function "_generate_bonus_round" and query aggregates on result of table type "gen_round" */
  _generate_bonus_round_aggregate: Gen_Round_Aggregate;
  /** execute function "_generate_ctm_round" which returns "gen_round" */
  _generate_ctm_round: Array<Gen_Round>;
  /** execute function "_generate_ctm_round" and query aggregates on result of table type "gen_round" */
  _generate_ctm_round_aggregate: Gen_Round_Aggregate;
  /** execute function "_generate_default_final_round" which returns "gen_round" */
  _generate_default_final_round: Array<Gen_Round>;
  /** execute function "_generate_default_final_round" and query aggregates on result of table type "gen_round" */
  _generate_default_final_round_aggregate: Gen_Round_Aggregate;
  /** execute function "_generate_default_round" which returns "gen_round" */
  _generate_default_round: Array<Gen_Round>;
  /** execute function "_generate_default_round" and query aggregates on result of table type "gen_round" */
  _generate_default_round_aggregate: Gen_Round_Aggregate;
  /** execute function "_get_random_question_for_round" which returns "questions" */
  _get_random_question_for_round: Array<Questions>;
  /** execute function "_get_random_question_for_round" and query aggregates on result of table type "questions" */
  _get_random_question_for_round_aggregate: Questions_Aggregate;
  /** fetch data from the table: "answer_types" */
  answer_types: Array<Answer_Types>;
  /** fetch aggregated fields from the table: "answer_types" */
  answer_types_aggregate: Answer_Types_Aggregate;
  /** fetch data from the table: "answer_types" using primary key columns */
  answer_types_by_pk?: Maybe<Answer_Types>;
  /** fetch data from the table: "categories" */
  categories: Array<Categories>;
  /** fetch aggregated fields from the table: "categories" */
  categories_aggregate: Categories_Aggregate;
  /** fetch data from the table: "categories" using primary key columns */
  categories_by_pk?: Maybe<Categories>;
  /** fetch data from the table: "city_edit_log" */
  city_edit_log: Array<City_Edit_Log>;
  /** fetch aggregated fields from the table: "city_edit_log" */
  city_edit_log_aggregate: City_Edit_Log_Aggregate;
  /** fetch data from the table: "city_tqs" */
  city_tqs: Array<City_Tqs>;
  /** fetch aggregated fields from the table: "city_tqs" */
  city_tqs_aggregate: City_Tqs_Aggregate;
  /** fetch data from the table: "city_trivia_category" */
  city_trivia_category: Array<City_Trivia_Category>;
  /** fetch aggregated fields from the table: "city_trivia_category" */
  city_trivia_category_aggregate: City_Trivia_Category_Aggregate;
  /** fetch data from the table: "city_trivia_question" */
  city_trivia_question: Array<City_Trivia_Question>;
  /** fetch aggregated fields from the table: "city_trivia_question" */
  city_trivia_question_aggregate: City_Trivia_Question_Aggregate;
  /** fetch data from the table: "city_trivia_round" */
  city_trivia_round: Array<City_Trivia_Round>;
  /** fetch aggregated fields from the table: "city_trivia_round" */
  city_trivia_round_aggregate: City_Trivia_Round_Aggregate;
  /** fetch data from the table: "dayle_sessions" */
  dayle_sessions: Array<Dayle_Sessions>;
  /** fetch aggregated fields from the table: "dayle_sessions" */
  dayle_sessions_aggregate: Dayle_Sessions_Aggregate;
  /** fetch data from the table: "dayle_sessions" using primary key columns */
  dayle_sessions_by_pk?: Maybe<Dayle_Sessions>;
  /** fetch data from the table: "edit_log" */
  edit_log: Array<Edit_Log>;
  /** fetch aggregated fields from the table: "edit_log" */
  edit_log_aggregate: Edit_Log_Aggregate;
  /** fetch data from the table: "edit_log" using primary key columns */
  edit_log_by_pk?: Maybe<Edit_Log>;
  /** fetch data from the table: "edit_log_types" */
  edit_log_types: Array<Edit_Log_Types>;
  /** fetch aggregated fields from the table: "edit_log_types" */
  edit_log_types_aggregate: Edit_Log_Types_Aggregate;
  /** fetch data from the table: "edit_log_types" using primary key columns */
  edit_log_types_by_pk?: Maybe<Edit_Log_Types>;
  /** perform the action: "fillCtmRoundQuestions" */
  fillCtmRoundQuestions?: Maybe<Array<Maybe<FillCtmRoundQuestionsOutput>>>;
  /** perform the action: "fillFinalRoundQuestions" */
  fillFinalRoundQuestions?: Maybe<Array<Maybe<FillFinalRoundQuestionsOutput>>>;
  /** perform the action: "fillRoundQuestions" */
  fillRoundQuestions?: Maybe<Array<Maybe<FillRoundQuestionsOutput>>>;
  /** fetch data from the table: "forgot_password" */
  forgot_password: Array<Forgot_Password>;
  /** fetch aggregated fields from the table: "forgot_password" */
  forgot_password_aggregate: Forgot_Password_Aggregate;
  /** fetch data from the table: "forgot_password" using primary key columns */
  forgot_password_by_pk?: Maybe<Forgot_Password>;
  /** fetch data from the table: "game_difficulties" */
  game_difficulties: Array<Game_Difficulties>;
  /** fetch aggregated fields from the table: "game_difficulties" */
  game_difficulties_aggregate: Game_Difficulties_Aggregate;
  /** fetch data from the table: "game_difficulties" using primary key columns */
  game_difficulties_by_pk?: Maybe<Game_Difficulties>;
  /** fetch data from the table: "game_formats" */
  game_formats: Array<Game_Formats>;
  /** fetch aggregated fields from the table: "game_formats" */
  game_formats_aggregate: Game_Formats_Aggregate;
  /** fetch data from the table: "game_formats" using primary key columns */
  game_formats_by_pk?: Maybe<Game_Formats>;
  /** fetch data from the table: "game_ratings" */
  game_ratings: Array<Game_Ratings>;
  /** fetch aggregated fields from the table: "game_ratings" */
  game_ratings_aggregate: Game_Ratings_Aggregate;
  /** fetch data from the table: "game_ratings" using primary key columns */
  game_ratings_by_pk?: Maybe<Game_Ratings>;
  /** fetch data from the table: "game_status" */
  game_status: Array<Game_Status>;
  /** fetch aggregated fields from the table: "game_status" */
  game_status_aggregate: Game_Status_Aggregate;
  /** fetch data from the table: "game_status" using primary key columns */
  game_status_by_pk?: Maybe<Game_Status>;
  /** fetch data from the table: "game_themes" */
  game_themes: Array<Game_Themes>;
  /** fetch aggregated fields from the table: "game_themes" */
  game_themes_aggregate: Game_Themes_Aggregate;
  /** fetch data from the table: "game_themes" using primary key columns */
  game_themes_by_pk?: Maybe<Game_Themes>;
  /** fetch data from the table: "gen_round" */
  gen_round: Array<Gen_Round>;
  /** fetch aggregated fields from the table: "gen_round" */
  gen_round_aggregate: Gen_Round_Aggregate;
  /** fetch data from the table: "gen_round" using primary key columns */
  gen_round_by_pk?: Maybe<Gen_Round>;
  /** fetch data from the table: "gen_uuid" */
  gen_uuid: Array<Gen_Uuid>;
  /** fetch aggregated fields from the table: "gen_uuid" */
  gen_uuid_aggregate: Gen_Uuid_Aggregate;
  /** fetch data from the table: "gen_uuid" using primary key columns */
  gen_uuid_by_pk?: Maybe<Gen_Uuid>;
  /** perform the action: "generateBonusRoundQuestions" */
  generateBonusRoundQuestions?: Maybe<GenRound>;
  /** perform the action: "generateCtmRoundQuestions" */
  generateCtmRoundQuestions?: Maybe<GenRound>;
  /** perform the action: "generateCtmRoundQuestionsById" */
  generateCtmRoundQuestionsById?: Maybe<GenRound>;
  /** perform the action: "generateRound" */
  generateRound?: Maybe<GenRound>;
  /** perform the action: "generateRoundQuestions" */
  generateRoundQuestions?: Maybe<Response>;
  /** perform the action: "generateStandardRoundQuestions" */
  generateStandardRoundQuestions?: Maybe<GenRound>;
  /** perform the action: "generateTwoColumnRoundQuestions" */
  generateTwoColumnRoundQuestions?: Maybe<GenRound>;
  /** perform the action: "generateWarfareRoundQuestions" */
  generateWarfareRoundQuestions?: Maybe<GenRound>;
  /** fetch data from the table: "markets" */
  markets: Array<Markets>;
  /** fetch aggregated fields from the table: "markets" */
  markets_aggregate: Markets_Aggregate;
  /** fetch data from the table: "markets" using primary key columns */
  markets_by_pk?: Maybe<Markets>;
  /** fetch data from the table: "question_bonuses" */
  question_bonuses: Array<Question_Bonuses>;
  /** fetch aggregated fields from the table: "question_bonuses" */
  question_bonuses_aggregate: Question_Bonuses_Aggregate;
  /** fetch data from the table: "question_bonuses" using primary key columns */
  question_bonuses_by_pk?: Maybe<Question_Bonuses>;
  /** fetch data from the table: "question_difficulties" */
  question_difficulties: Array<Question_Difficulties>;
  /** fetch aggregated fields from the table: "question_difficulties" */
  question_difficulties_aggregate: Question_Difficulties_Aggregate;
  /** fetch data from the table: "question_difficulties" using primary key columns */
  question_difficulties_by_pk?: Maybe<Question_Difficulties>;
  /** fetch data from the table: "question_languages" */
  question_languages: Array<Question_Languages>;
  /** fetch aggregated fields from the table: "question_languages" */
  question_languages_aggregate: Question_Languages_Aggregate;
  /** fetch data from the table: "question_languages" using primary key columns */
  question_languages_by_pk?: Maybe<Question_Languages>;
  /** fetch data from the table: "question_ratings" */
  question_ratings: Array<Question_Ratings>;
  /** fetch aggregated fields from the table: "question_ratings" */
  question_ratings_aggregate: Question_Ratings_Aggregate;
  /** fetch data from the table: "question_ratings" using primary key columns */
  question_ratings_by_pk?: Maybe<Question_Ratings>;
  /** fetch data from the table: "question_status" */
  question_status: Array<Question_Status>;
  /** fetch aggregated fields from the table: "question_status" */
  question_status_aggregate: Question_Status_Aggregate;
  /** fetch data from the table: "question_status" using primary key columns */
  question_status_by_pk?: Maybe<Question_Status>;
  /** fetch data from the table: "question_tags" */
  question_tags: Array<Question_Tags>;
  /** fetch aggregated fields from the table: "question_tags" */
  question_tags_aggregate: Question_Tags_Aggregate;
  /** fetch data from the table: "question_tags_by_count" */
  question_tags_by_count: Array<Question_Tags_By_Count>;
  /** fetch aggregated fields from the table: "question_tags_by_count" */
  question_tags_by_count_aggregate: Question_Tags_By_Count_Aggregate;
  /** fetch data from the table: "question_tags" using primary key columns */
  question_tags_by_pk?: Maybe<Question_Tags>;
  /** fetch data from the table: "question_texts_similarities" */
  question_texts_similarities: Array<Question_Texts_Similarities>;
  /** fetch aggregated fields from the table: "question_texts_similarities" */
  question_texts_similarities_aggregate: Question_Texts_Similarities_Aggregate;
  /** fetch data from the table: "question_texts_similarities" using primary key columns */
  question_texts_similarities_by_pk?: Maybe<Question_Texts_Similarities>;
  /** fetch data from the table: "question_types" */
  question_types: Array<Question_Types>;
  /** fetch aggregated fields from the table: "question_types" */
  question_types_aggregate: Question_Types_Aggregate;
  /** fetch data from the table: "question_types" using primary key columns */
  question_types_by_pk?: Maybe<Question_Types>;
  /** fetch data from the table: "questions" */
  questions: Array<Questions>;
  /** fetch aggregated fields from the table: "questions" */
  questions_aggregate: Questions_Aggregate;
  /** fetch data from the table: "questions" using primary key columns */
  questions_by_pk?: Maybe<Questions>;
  /** fetch data from the table: "rejection_reasons" */
  rejection_reasons: Array<Rejection_Reasons>;
  /** fetch aggregated fields from the table: "rejection_reasons" */
  rejection_reasons_aggregate: Rejection_Reasons_Aggregate;
  /** fetch data from the table: "rejection_reasons" using primary key columns */
  rejection_reasons_by_pk?: Maybe<Rejection_Reasons>;
  /** fetch data from the table: "report_reasons" */
  report_reasons: Array<Report_Reasons>;
  /** fetch aggregated fields from the table: "report_reasons" */
  report_reasons_aggregate: Report_Reasons_Aggregate;
  /** fetch data from the table: "report_reasons" using primary key columns */
  report_reasons_by_pk?: Maybe<Report_Reasons>;
  /** fetch data from the table: "reports" */
  reports: Array<Reports>;
  /** fetch aggregated fields from the table: "reports" */
  reports_aggregate: Reports_Aggregate;
  /** fetch data from the table: "reports" using primary key columns */
  reports_by_pk?: Maybe<Reports>;
  /** fetch data from the table: "rounds" */
  rounds: Array<Rounds>;
  /** fetch aggregated fields from the table: "rounds" */
  rounds_aggregate: Rounds_Aggregate;
  /** fetch data from the table: "rounds" using primary key columns */
  rounds_by_pk?: Maybe<Rounds>;
  /** execute function "search_question_text" which returns "question_texts_similarities" */
  search_question_text: Array<Question_Texts_Similarities>;
  /** execute function "search_question_text" and query aggregates on result of table type "question_texts_similarities" */
  search_question_text_aggregate: Question_Texts_Similarities_Aggregate;
  selected_game_template?: Maybe<Trivia_Game_Templates>;
  /** fetch data from the table: "settings" */
  settings: Array<Settings>;
  /** fetch aggregated fields from the table: "settings" */
  settings_aggregate: Settings_Aggregate;
  /** fetch data from the table: "settings" using primary key columns */
  settings_by_pk?: Maybe<Settings>;
  /** fetch data from the table: "sponsor_questions" */
  sponsor_questions: Array<Sponsor_Questions>;
  /** fetch aggregated fields from the table: "sponsor_questions" */
  sponsor_questions_aggregate: Sponsor_Questions_Aggregate;
  /** fetch data from the table: "sponsor_questions" using primary key columns */
  sponsor_questions_by_pk?: Maybe<Sponsor_Questions>;
  /** fetch data from the table: "sponsors" */
  sponsors: Array<Sponsors>;
  /** fetch aggregated fields from the table: "sponsors" */
  sponsors_aggregate: Sponsors_Aggregate;
  /** fetch data from the table: "sponsors" using primary key columns */
  sponsors_by_pk?: Maybe<Sponsors>;
  /** fetch data from the table: "test_sm" */
  test_sm: Array<Test_Sm>;
  /** fetch aggregated fields from the table: "test_sm" */
  test_sm_aggregate: Test_Sm_Aggregate;
  /** perform the action: "triviaGameRoundDelete" */
  triviaGameRoundDelete?: Maybe<Response>;
  /** fetch data from the table: "trivia_event_types" */
  trivia_event_types: Array<Trivia_Event_Types>;
  /** fetch aggregated fields from the table: "trivia_event_types" */
  trivia_event_types_aggregate: Trivia_Event_Types_Aggregate;
  /** fetch data from the table: "trivia_event_types" using primary key columns */
  trivia_event_types_by_pk?: Maybe<Trivia_Event_Types>;
  /** fetch data from the table: "trivia_events" */
  trivia_events: Array<Trivia_Events>;
  /** fetch aggregated fields from the table: "trivia_events" */
  trivia_events_aggregate: Trivia_Events_Aggregate;
  /** fetch data from the table: "trivia_events" using primary key columns */
  trivia_events_by_pk?: Maybe<Trivia_Events>;
  /** fetch data from the table: "trivia_game_category" */
  trivia_game_category: Array<Trivia_Game_Category>;
  /** fetch aggregated fields from the table: "trivia_game_category" */
  trivia_game_category_aggregate: Trivia_Game_Category_Aggregate;
  /** fetch data from the table: "trivia_game_category" using primary key columns */
  trivia_game_category_by_pk?: Maybe<Trivia_Game_Category>;
  /** fetch data from the table: "trivia_game_rounds" */
  trivia_game_rounds: Array<Trivia_Game_Rounds>;
  /** fetch aggregated fields from the table: "trivia_game_rounds" */
  trivia_game_rounds_aggregate: Trivia_Game_Rounds_Aggregate;
  /** fetch data from the table: "trivia_game_rounds" using primary key columns */
  trivia_game_rounds_by_pk?: Maybe<Trivia_Game_Rounds>;
  /** fetch data from the table: "trivia_game_templates" */
  trivia_game_templates: Array<Trivia_Game_Templates>;
  /** fetch aggregated fields from the table: "trivia_game_templates" */
  trivia_game_templates_aggregate: Trivia_Game_Templates_Aggregate;
  /** fetch data from the table: "trivia_game_templates" using primary key columns */
  trivia_game_templates_by_pk?: Maybe<Trivia_Game_Templates>;
  /** fetch data from the table: "trivia_game_themes" */
  trivia_game_themes: Array<Trivia_Game_Themes>;
  /** fetch aggregated fields from the table: "trivia_game_themes" */
  trivia_game_themes_aggregate: Trivia_Game_Themes_Aggregate;
  /** fetch data from the table: "trivia_game_themes" using primary key columns */
  trivia_game_themes_by_pk?: Maybe<Trivia_Game_Themes>;
  /** fetch data from the table: "trivia_games" */
  trivia_games: Array<Trivia_Games>;
  /** fetch aggregated fields from the table: "trivia_games" */
  trivia_games_aggregate: Trivia_Games_Aggregate;
  /** fetch data from the table: "trivia_games" using primary key columns */
  trivia_games_by_pk?: Maybe<Trivia_Games>;
  /** fetch data from the table: "trivia_question" */
  trivia_question: Array<Trivia_Question>;
  /** fetch aggregated fields from the table: "trivia_question" */
  trivia_question_aggregate: Trivia_Question_Aggregate;
  /** fetch data from the table: "trivia_round_questions" */
  trivia_round_questions: Array<Trivia_Round_Questions>;
  /** fetch aggregated fields from the table: "trivia_round_questions" */
  trivia_round_questions_aggregate: Trivia_Round_Questions_Aggregate;
  /** fetch data from the table: "trivia_round_questions" using primary key columns */
  trivia_round_questions_by_pk?: Maybe<Trivia_Round_Questions>;
  /** fetch data from the table: "trivia_round_templates" */
  trivia_round_templates: Array<Trivia_Round_Templates>;
  /** fetch aggregated fields from the table: "trivia_round_templates" */
  trivia_round_templates_aggregate: Trivia_Round_Templates_Aggregate;
  /** fetch data from the table: "trivia_round_templates" using primary key columns */
  trivia_round_templates_by_pk?: Maybe<Trivia_Round_Templates>;
  /** fetch data from the table: "trivia_round_themes" */
  trivia_round_themes: Array<Trivia_Round_Themes>;
  /** fetch aggregated fields from the table: "trivia_round_themes" */
  trivia_round_themes_aggregate: Trivia_Round_Themes_Aggregate;
  /** fetch data from the table: "trivia_round_themes" using primary key columns */
  trivia_round_themes_by_pk?: Maybe<Trivia_Round_Themes>;
  /** fetch data from the table: "trivia_round_types" */
  trivia_round_types: Array<Trivia_Round_Types>;
  /** fetch aggregated fields from the table: "trivia_round_types" */
  trivia_round_types_aggregate: Trivia_Round_Types_Aggregate;
  /** fetch data from the table: "trivia_round_types" using primary key columns */
  trivia_round_types_by_pk?: Maybe<Trivia_Round_Types>;
  /** fetch data from the table: "trivia_rounds" */
  trivia_rounds: Array<Trivia_Rounds>;
  /** fetch aggregated fields from the table: "trivia_rounds" */
  trivia_rounds_aggregate: Trivia_Rounds_Aggregate;
  /** fetch data from the table: "trivia_rounds" using primary key columns */
  trivia_rounds_by_pk?: Maybe<Trivia_Rounds>;
  /** fetch data from the table: "trivia_users" */
  trivia_users: Array<Trivia_Users>;
  /** fetch aggregated fields from the table: "trivia_users" */
  trivia_users_aggregate: Trivia_Users_Aggregate;
  /** fetch data from the table: "trivia_users" using primary key columns */
  trivia_users_by_pk?: Maybe<Trivia_Users>;
  /** fetch data from the table: "user_types" */
  user_types: Array<User_Types>;
  /** fetch aggregated fields from the table: "user_types" */
  user_types_aggregate: User_Types_Aggregate;
  /** fetch data from the table: "user_types" using primary key columns */
  user_types_by_pk?: Maybe<User_Types>;
};


/** query root */
export type Query_Root_Generate_Bonus_RoundArgs = {
  args: _Generate_Bonus_Round_Args;
  distinct_on?: InputMaybe<Array<Gen_Round_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Gen_Round_Order_By>>;
  where?: InputMaybe<Gen_Round_Bool_Exp>;
};


/** query root */
export type Query_Root_Generate_Bonus_Round_AggregateArgs = {
  args: _Generate_Bonus_Round_Args;
  distinct_on?: InputMaybe<Array<Gen_Round_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Gen_Round_Order_By>>;
  where?: InputMaybe<Gen_Round_Bool_Exp>;
};


/** query root */
export type Query_Root_Generate_Ctm_RoundArgs = {
  args: _Generate_Ctm_Round_Args;
  distinct_on?: InputMaybe<Array<Gen_Round_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Gen_Round_Order_By>>;
  where?: InputMaybe<Gen_Round_Bool_Exp>;
};


/** query root */
export type Query_Root_Generate_Ctm_Round_AggregateArgs = {
  args: _Generate_Ctm_Round_Args;
  distinct_on?: InputMaybe<Array<Gen_Round_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Gen_Round_Order_By>>;
  where?: InputMaybe<Gen_Round_Bool_Exp>;
};


/** query root */
export type Query_Root_Generate_Default_Final_RoundArgs = {
  args: _Generate_Default_Final_Round_Args;
  distinct_on?: InputMaybe<Array<Gen_Round_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Gen_Round_Order_By>>;
  where?: InputMaybe<Gen_Round_Bool_Exp>;
};


/** query root */
export type Query_Root_Generate_Default_Final_Round_AggregateArgs = {
  args: _Generate_Default_Final_Round_Args;
  distinct_on?: InputMaybe<Array<Gen_Round_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Gen_Round_Order_By>>;
  where?: InputMaybe<Gen_Round_Bool_Exp>;
};


/** query root */
export type Query_Root_Generate_Default_RoundArgs = {
  args: _Generate_Default_Round_Args;
  distinct_on?: InputMaybe<Array<Gen_Round_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Gen_Round_Order_By>>;
  where?: InputMaybe<Gen_Round_Bool_Exp>;
};


/** query root */
export type Query_Root_Generate_Default_Round_AggregateArgs = {
  args: _Generate_Default_Round_Args;
  distinct_on?: InputMaybe<Array<Gen_Round_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Gen_Round_Order_By>>;
  where?: InputMaybe<Gen_Round_Bool_Exp>;
};


/** query root */
export type Query_Root_Get_Random_Question_For_RoundArgs = {
  args: _Get_Random_Question_For_Round_Args;
  distinct_on?: InputMaybe<Array<Questions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Questions_Order_By>>;
  where?: InputMaybe<Questions_Bool_Exp>;
};


/** query root */
export type Query_Root_Get_Random_Question_For_Round_AggregateArgs = {
  args: _Get_Random_Question_For_Round_Args;
  distinct_on?: InputMaybe<Array<Questions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Questions_Order_By>>;
  where?: InputMaybe<Questions_Bool_Exp>;
};


/** query root */
export type Query_RootAnswer_TypesArgs = {
  distinct_on?: InputMaybe<Array<Answer_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Answer_Types_Order_By>>;
  where?: InputMaybe<Answer_Types_Bool_Exp>;
};


/** query root */
export type Query_RootAnswer_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Answer_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Answer_Types_Order_By>>;
  where?: InputMaybe<Answer_Types_Bool_Exp>;
};


/** query root */
export type Query_RootAnswer_Types_By_PkArgs = {
  answer_type_id: Scalars['Int'];
};


/** query root */
export type Query_RootCategoriesArgs = {
  distinct_on?: InputMaybe<Array<Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Categories_Order_By>>;
  where?: InputMaybe<Categories_Bool_Exp>;
};


/** query root */
export type Query_RootCategories_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Categories_Order_By>>;
  where?: InputMaybe<Categories_Bool_Exp>;
};


/** query root */
export type Query_RootCategories_By_PkArgs = {
  category_id: Scalars['uuid'];
};


/** query root */
export type Query_RootCity_Edit_LogArgs = {
  distinct_on?: InputMaybe<Array<City_Edit_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<City_Edit_Log_Order_By>>;
  where?: InputMaybe<City_Edit_Log_Bool_Exp>;
};


/** query root */
export type Query_RootCity_Edit_Log_AggregateArgs = {
  distinct_on?: InputMaybe<Array<City_Edit_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<City_Edit_Log_Order_By>>;
  where?: InputMaybe<City_Edit_Log_Bool_Exp>;
};


/** query root */
export type Query_RootCity_TqsArgs = {
  distinct_on?: InputMaybe<Array<City_Tqs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<City_Tqs_Order_By>>;
  where?: InputMaybe<City_Tqs_Bool_Exp>;
};


/** query root */
export type Query_RootCity_Tqs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<City_Tqs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<City_Tqs_Order_By>>;
  where?: InputMaybe<City_Tqs_Bool_Exp>;
};


/** query root */
export type Query_RootCity_Trivia_CategoryArgs = {
  distinct_on?: InputMaybe<Array<City_Trivia_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<City_Trivia_Category_Order_By>>;
  where?: InputMaybe<City_Trivia_Category_Bool_Exp>;
};


/** query root */
export type Query_RootCity_Trivia_Category_AggregateArgs = {
  distinct_on?: InputMaybe<Array<City_Trivia_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<City_Trivia_Category_Order_By>>;
  where?: InputMaybe<City_Trivia_Category_Bool_Exp>;
};


/** query root */
export type Query_RootCity_Trivia_QuestionArgs = {
  distinct_on?: InputMaybe<Array<City_Trivia_Question_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<City_Trivia_Question_Order_By>>;
  where?: InputMaybe<City_Trivia_Question_Bool_Exp>;
};


/** query root */
export type Query_RootCity_Trivia_Question_AggregateArgs = {
  distinct_on?: InputMaybe<Array<City_Trivia_Question_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<City_Trivia_Question_Order_By>>;
  where?: InputMaybe<City_Trivia_Question_Bool_Exp>;
};


/** query root */
export type Query_RootCity_Trivia_RoundArgs = {
  distinct_on?: InputMaybe<Array<City_Trivia_Round_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<City_Trivia_Round_Order_By>>;
  where?: InputMaybe<City_Trivia_Round_Bool_Exp>;
};


/** query root */
export type Query_RootCity_Trivia_Round_AggregateArgs = {
  distinct_on?: InputMaybe<Array<City_Trivia_Round_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<City_Trivia_Round_Order_By>>;
  where?: InputMaybe<City_Trivia_Round_Bool_Exp>;
};


/** query root */
export type Query_RootDayle_SessionsArgs = {
  distinct_on?: InputMaybe<Array<Dayle_Sessions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Dayle_Sessions_Order_By>>;
  where?: InputMaybe<Dayle_Sessions_Bool_Exp>;
};


/** query root */
export type Query_RootDayle_Sessions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Dayle_Sessions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Dayle_Sessions_Order_By>>;
  where?: InputMaybe<Dayle_Sessions_Bool_Exp>;
};


/** query root */
export type Query_RootDayle_Sessions_By_PkArgs = {
  dayle_session_id: Scalars['Int'];
};


/** query root */
export type Query_RootEdit_LogArgs = {
  distinct_on?: InputMaybe<Array<Edit_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Edit_Log_Order_By>>;
  where?: InputMaybe<Edit_Log_Bool_Exp>;
};


/** query root */
export type Query_RootEdit_Log_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Edit_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Edit_Log_Order_By>>;
  where?: InputMaybe<Edit_Log_Bool_Exp>;
};


/** query root */
export type Query_RootEdit_Log_By_PkArgs = {
  edit_log_id: Scalars['uuid'];
};


/** query root */
export type Query_RootEdit_Log_TypesArgs = {
  distinct_on?: InputMaybe<Array<Edit_Log_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Edit_Log_Types_Order_By>>;
  where?: InputMaybe<Edit_Log_Types_Bool_Exp>;
};


/** query root */
export type Query_RootEdit_Log_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Edit_Log_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Edit_Log_Types_Order_By>>;
  where?: InputMaybe<Edit_Log_Types_Bool_Exp>;
};


/** query root */
export type Query_RootEdit_Log_Types_By_PkArgs = {
  edit_log_type_id: Scalars['Int'];
};


/** query root */
export type Query_RootFillCtmRoundQuestionsArgs = {
  args: FillCtmRoundQuestionsInput;
};


/** query root */
export type Query_RootFillFinalRoundQuestionsArgs = {
  args: FillRoundQuestionsInput;
};


/** query root */
export type Query_RootFillRoundQuestionsArgs = {
  args: FillRoundQuestionsByTypeInput;
};


/** query root */
export type Query_RootForgot_PasswordArgs = {
  distinct_on?: InputMaybe<Array<Forgot_Password_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Forgot_Password_Order_By>>;
  where?: InputMaybe<Forgot_Password_Bool_Exp>;
};


/** query root */
export type Query_RootForgot_Password_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Forgot_Password_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Forgot_Password_Order_By>>;
  where?: InputMaybe<Forgot_Password_Bool_Exp>;
};


/** query root */
export type Query_RootForgot_Password_By_PkArgs = {
  forgot_password_id: Scalars['uuid'];
};


/** query root */
export type Query_RootGame_DifficultiesArgs = {
  distinct_on?: InputMaybe<Array<Game_Difficulties_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Game_Difficulties_Order_By>>;
  where?: InputMaybe<Game_Difficulties_Bool_Exp>;
};


/** query root */
export type Query_RootGame_Difficulties_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Game_Difficulties_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Game_Difficulties_Order_By>>;
  where?: InputMaybe<Game_Difficulties_Bool_Exp>;
};


/** query root */
export type Query_RootGame_Difficulties_By_PkArgs = {
  game_difficult_id: Scalars['Int'];
};


/** query root */
export type Query_RootGame_FormatsArgs = {
  distinct_on?: InputMaybe<Array<Game_Formats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Game_Formats_Order_By>>;
  where?: InputMaybe<Game_Formats_Bool_Exp>;
};


/** query root */
export type Query_RootGame_Formats_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Game_Formats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Game_Formats_Order_By>>;
  where?: InputMaybe<Game_Formats_Bool_Exp>;
};


/** query root */
export type Query_RootGame_Formats_By_PkArgs = {
  game_format_id: Scalars['Int'];
};


/** query root */
export type Query_RootGame_RatingsArgs = {
  distinct_on?: InputMaybe<Array<Game_Ratings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Game_Ratings_Order_By>>;
  where?: InputMaybe<Game_Ratings_Bool_Exp>;
};


/** query root */
export type Query_RootGame_Ratings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Game_Ratings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Game_Ratings_Order_By>>;
  where?: InputMaybe<Game_Ratings_Bool_Exp>;
};


/** query root */
export type Query_RootGame_Ratings_By_PkArgs = {
  id: Scalars['String'];
};


/** query root */
export type Query_RootGame_StatusArgs = {
  distinct_on?: InputMaybe<Array<Game_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Game_Status_Order_By>>;
  where?: InputMaybe<Game_Status_Bool_Exp>;
};


/** query root */
export type Query_RootGame_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Game_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Game_Status_Order_By>>;
  where?: InputMaybe<Game_Status_Bool_Exp>;
};


/** query root */
export type Query_RootGame_Status_By_PkArgs = {
  id: Scalars['Int'];
};


/** query root */
export type Query_RootGame_ThemesArgs = {
  distinct_on?: InputMaybe<Array<Game_Themes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Game_Themes_Order_By>>;
  where?: InputMaybe<Game_Themes_Bool_Exp>;
};


/** query root */
export type Query_RootGame_Themes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Game_Themes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Game_Themes_Order_By>>;
  where?: InputMaybe<Game_Themes_Bool_Exp>;
};


/** query root */
export type Query_RootGame_Themes_By_PkArgs = {
  id: Scalars['uuid'];
};


/** query root */
export type Query_RootGen_RoundArgs = {
  distinct_on?: InputMaybe<Array<Gen_Round_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Gen_Round_Order_By>>;
  where?: InputMaybe<Gen_Round_Bool_Exp>;
};


/** query root */
export type Query_RootGen_Round_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Gen_Round_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Gen_Round_Order_By>>;
  where?: InputMaybe<Gen_Round_Bool_Exp>;
};


/** query root */
export type Query_RootGen_Round_By_PkArgs = {
  id: Scalars['uuid'];
};


/** query root */
export type Query_RootGen_UuidArgs = {
  distinct_on?: InputMaybe<Array<Gen_Uuid_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Gen_Uuid_Order_By>>;
  where?: InputMaybe<Gen_Uuid_Bool_Exp>;
};


/** query root */
export type Query_RootGen_Uuid_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Gen_Uuid_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Gen_Uuid_Order_By>>;
  where?: InputMaybe<Gen_Uuid_Bool_Exp>;
};


/** query root */
export type Query_RootGen_Uuid_By_PkArgs = {
  id: Scalars['uuid'];
};


/** query root */
export type Query_RootGenerateBonusRoundQuestionsArgs = {
  args?: InputMaybe<GenRoundId>;
};


/** query root */
export type Query_RootGenerateCtmRoundQuestionsArgs = {
  args?: InputMaybe<GenRoundId>;
};


/** query root */
export type Query_RootGenerateCtmRoundQuestionsByIdArgs = {
  args?: InputMaybe<GenRoundId>;
};


/** query root */
export type Query_RootGenerateRoundArgs = {
  args?: InputMaybe<GenRound_>;
};


/** query root */
export type Query_RootGenerateRoundQuestionsArgs = {
  args?: InputMaybe<GenRoundQuestions>;
};


/** query root */
export type Query_RootGenerateStandardRoundQuestionsArgs = {
  args?: InputMaybe<GenRoundId>;
};


/** query root */
export type Query_RootGenerateTwoColumnRoundQuestionsArgs = {
  args?: InputMaybe<GenRoundId>;
};


/** query root */
export type Query_RootGenerateWarfareRoundQuestionsArgs = {
  args?: InputMaybe<GenWarfareRoundId>;
};


/** query root */
export type Query_RootMarketsArgs = {
  distinct_on?: InputMaybe<Array<Markets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Markets_Order_By>>;
  where?: InputMaybe<Markets_Bool_Exp>;
};


/** query root */
export type Query_RootMarkets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Markets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Markets_Order_By>>;
  where?: InputMaybe<Markets_Bool_Exp>;
};


/** query root */
export type Query_RootMarkets_By_PkArgs = {
  market_id: Scalars['String'];
};


/** query root */
export type Query_RootQuestion_BonusesArgs = {
  distinct_on?: InputMaybe<Array<Question_Bonuses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Question_Bonuses_Order_By>>;
  where?: InputMaybe<Question_Bonuses_Bool_Exp>;
};


/** query root */
export type Query_RootQuestion_Bonuses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Question_Bonuses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Question_Bonuses_Order_By>>;
  where?: InputMaybe<Question_Bonuses_Bool_Exp>;
};


/** query root */
export type Query_RootQuestion_Bonuses_By_PkArgs = {
  question_bonus_id: Scalars['Int'];
};


/** query root */
export type Query_RootQuestion_DifficultiesArgs = {
  distinct_on?: InputMaybe<Array<Question_Difficulties_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Question_Difficulties_Order_By>>;
  where?: InputMaybe<Question_Difficulties_Bool_Exp>;
};


/** query root */
export type Query_RootQuestion_Difficulties_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Question_Difficulties_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Question_Difficulties_Order_By>>;
  where?: InputMaybe<Question_Difficulties_Bool_Exp>;
};


/** query root */
export type Query_RootQuestion_Difficulties_By_PkArgs = {
  question_difficulty_id: Scalars['Int'];
};


/** query root */
export type Query_RootQuestion_LanguagesArgs = {
  distinct_on?: InputMaybe<Array<Question_Languages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Question_Languages_Order_By>>;
  where?: InputMaybe<Question_Languages_Bool_Exp>;
};


/** query root */
export type Query_RootQuestion_Languages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Question_Languages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Question_Languages_Order_By>>;
  where?: InputMaybe<Question_Languages_Bool_Exp>;
};


/** query root */
export type Query_RootQuestion_Languages_By_PkArgs = {
  market_id: Scalars['String'];
  question_id: Scalars['uuid'];
};


/** query root */
export type Query_RootQuestion_RatingsArgs = {
  distinct_on?: InputMaybe<Array<Question_Ratings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Question_Ratings_Order_By>>;
  where?: InputMaybe<Question_Ratings_Bool_Exp>;
};


/** query root */
export type Query_RootQuestion_Ratings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Question_Ratings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Question_Ratings_Order_By>>;
  where?: InputMaybe<Question_Ratings_Bool_Exp>;
};


/** query root */
export type Query_RootQuestion_Ratings_By_PkArgs = {
  id: Scalars['Int'];
};


/** query root */
export type Query_RootQuestion_StatusArgs = {
  distinct_on?: InputMaybe<Array<Question_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Question_Status_Order_By>>;
  where?: InputMaybe<Question_Status_Bool_Exp>;
};


/** query root */
export type Query_RootQuestion_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Question_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Question_Status_Order_By>>;
  where?: InputMaybe<Question_Status_Bool_Exp>;
};


/** query root */
export type Query_RootQuestion_Status_By_PkArgs = {
  question_status_id: Scalars['Int'];
};


/** query root */
export type Query_RootQuestion_TagsArgs = {
  distinct_on?: InputMaybe<Array<Question_Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Question_Tags_Order_By>>;
  where?: InputMaybe<Question_Tags_Bool_Exp>;
};


/** query root */
export type Query_RootQuestion_Tags_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Question_Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Question_Tags_Order_By>>;
  where?: InputMaybe<Question_Tags_Bool_Exp>;
};


/** query root */
export type Query_RootQuestion_Tags_By_CountArgs = {
  distinct_on?: InputMaybe<Array<Question_Tags_By_Count_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Question_Tags_By_Count_Order_By>>;
  where?: InputMaybe<Question_Tags_By_Count_Bool_Exp>;
};


/** query root */
export type Query_RootQuestion_Tags_By_Count_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Question_Tags_By_Count_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Question_Tags_By_Count_Order_By>>;
  where?: InputMaybe<Question_Tags_By_Count_Bool_Exp>;
};


/** query root */
export type Query_RootQuestion_Tags_By_PkArgs = {
  question_id: Scalars['uuid'];
  tag: Scalars['String'];
};


/** query root */
export type Query_RootQuestion_Texts_SimilaritiesArgs = {
  distinct_on?: InputMaybe<Array<Question_Texts_Similarities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Question_Texts_Similarities_Order_By>>;
  where?: InputMaybe<Question_Texts_Similarities_Bool_Exp>;
};


/** query root */
export type Query_RootQuestion_Texts_Similarities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Question_Texts_Similarities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Question_Texts_Similarities_Order_By>>;
  where?: InputMaybe<Question_Texts_Similarities_Bool_Exp>;
};


/** query root */
export type Query_RootQuestion_Texts_Similarities_By_PkArgs = {
  question_text: Scalars['String'];
  sim: Scalars['Float'];
};


/** query root */
export type Query_RootQuestion_TypesArgs = {
  distinct_on?: InputMaybe<Array<Question_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Question_Types_Order_By>>;
  where?: InputMaybe<Question_Types_Bool_Exp>;
};


/** query root */
export type Query_RootQuestion_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Question_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Question_Types_Order_By>>;
  where?: InputMaybe<Question_Types_Bool_Exp>;
};


/** query root */
export type Query_RootQuestion_Types_By_PkArgs = {
  question_type_id: Scalars['Int'];
};


/** query root */
export type Query_RootQuestionsArgs = {
  distinct_on?: InputMaybe<Array<Questions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Questions_Order_By>>;
  where?: InputMaybe<Questions_Bool_Exp>;
};


/** query root */
export type Query_RootQuestions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Questions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Questions_Order_By>>;
  where?: InputMaybe<Questions_Bool_Exp>;
};


/** query root */
export type Query_RootQuestions_By_PkArgs = {
  question_id: Scalars['uuid'];
};


/** query root */
export type Query_RootRejection_ReasonsArgs = {
  distinct_on?: InputMaybe<Array<Rejection_Reasons_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Rejection_Reasons_Order_By>>;
  where?: InputMaybe<Rejection_Reasons_Bool_Exp>;
};


/** query root */
export type Query_RootRejection_Reasons_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Rejection_Reasons_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Rejection_Reasons_Order_By>>;
  where?: InputMaybe<Rejection_Reasons_Bool_Exp>;
};


/** query root */
export type Query_RootRejection_Reasons_By_PkArgs = {
  rejection_reason_id: Scalars['Int'];
};


/** query root */
export type Query_RootReport_ReasonsArgs = {
  distinct_on?: InputMaybe<Array<Report_Reasons_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Report_Reasons_Order_By>>;
  where?: InputMaybe<Report_Reasons_Bool_Exp>;
};


/** query root */
export type Query_RootReport_Reasons_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Report_Reasons_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Report_Reasons_Order_By>>;
  where?: InputMaybe<Report_Reasons_Bool_Exp>;
};


/** query root */
export type Query_RootReport_Reasons_By_PkArgs = {
  report_reason_id: Scalars['Int'];
};


/** query root */
export type Query_RootReportsArgs = {
  distinct_on?: InputMaybe<Array<Reports_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Reports_Order_By>>;
  where?: InputMaybe<Reports_Bool_Exp>;
};


/** query root */
export type Query_RootReports_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Reports_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Reports_Order_By>>;
  where?: InputMaybe<Reports_Bool_Exp>;
};


/** query root */
export type Query_RootReports_By_PkArgs = {
  report_id: Scalars['uuid'];
};


/** query root */
export type Query_RootRoundsArgs = {
  distinct_on?: InputMaybe<Array<Rounds_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Rounds_Order_By>>;
  where?: InputMaybe<Rounds_Bool_Exp>;
};


/** query root */
export type Query_RootRounds_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Rounds_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Rounds_Order_By>>;
  where?: InputMaybe<Rounds_Bool_Exp>;
};


/** query root */
export type Query_RootRounds_By_PkArgs = {
  round_id: Scalars['uuid'];
};


/** query root */
export type Query_RootSearch_Question_TextArgs = {
  args: Search_Question_Text_Args;
  distinct_on?: InputMaybe<Array<Question_Texts_Similarities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Question_Texts_Similarities_Order_By>>;
  where?: InputMaybe<Question_Texts_Similarities_Bool_Exp>;
};


/** query root */
export type Query_RootSearch_Question_Text_AggregateArgs = {
  args: Search_Question_Text_Args;
  distinct_on?: InputMaybe<Array<Question_Texts_Similarities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Question_Texts_Similarities_Order_By>>;
  where?: InputMaybe<Question_Texts_Similarities_Bool_Exp>;
};


/** query root */
export type Query_RootSettingsArgs = {
  distinct_on?: InputMaybe<Array<Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Settings_Order_By>>;
  where?: InputMaybe<Settings_Bool_Exp>;
};


/** query root */
export type Query_RootSettings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Settings_Order_By>>;
  where?: InputMaybe<Settings_Bool_Exp>;
};


/** query root */
export type Query_RootSettings_By_PkArgs = {
  setting_name: Scalars['String'];
};


/** query root */
export type Query_RootSponsor_QuestionsArgs = {
  distinct_on?: InputMaybe<Array<Sponsor_Questions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sponsor_Questions_Order_By>>;
  where?: InputMaybe<Sponsor_Questions_Bool_Exp>;
};


/** query root */
export type Query_RootSponsor_Questions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sponsor_Questions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sponsor_Questions_Order_By>>;
  where?: InputMaybe<Sponsor_Questions_Bool_Exp>;
};


/** query root */
export type Query_RootSponsor_Questions_By_PkArgs = {
  question_id: Scalars['uuid'];
  sponsor_id: Scalars['uuid'];
};


/** query root */
export type Query_RootSponsorsArgs = {
  distinct_on?: InputMaybe<Array<Sponsors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sponsors_Order_By>>;
  where?: InputMaybe<Sponsors_Bool_Exp>;
};


/** query root */
export type Query_RootSponsors_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sponsors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sponsors_Order_By>>;
  where?: InputMaybe<Sponsors_Bool_Exp>;
};


/** query root */
export type Query_RootSponsors_By_PkArgs = {
  sponsor_id: Scalars['uuid'];
};


/** query root */
export type Query_RootTest_SmArgs = {
  distinct_on?: InputMaybe<Array<Test_Sm_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Test_Sm_Order_By>>;
  where?: InputMaybe<Test_Sm_Bool_Exp>;
};


/** query root */
export type Query_RootTest_Sm_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Test_Sm_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Test_Sm_Order_By>>;
  where?: InputMaybe<Test_Sm_Bool_Exp>;
};


/** query root */
export type Query_RootTriviaGameRoundDeleteArgs = {
  args?: InputMaybe<GenRoundId>;
};


/** query root */
export type Query_RootTrivia_Event_TypesArgs = {
  distinct_on?: InputMaybe<Array<Trivia_Event_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trivia_Event_Types_Order_By>>;
  where?: InputMaybe<Trivia_Event_Types_Bool_Exp>;
};


/** query root */
export type Query_RootTrivia_Event_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trivia_Event_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trivia_Event_Types_Order_By>>;
  where?: InputMaybe<Trivia_Event_Types_Bool_Exp>;
};


/** query root */
export type Query_RootTrivia_Event_Types_By_PkArgs = {
  event_type_id: Scalars['Int'];
};


/** query root */
export type Query_RootTrivia_EventsArgs = {
  distinct_on?: InputMaybe<Array<Trivia_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trivia_Events_Order_By>>;
  where?: InputMaybe<Trivia_Events_Bool_Exp>;
};


/** query root */
export type Query_RootTrivia_Events_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trivia_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trivia_Events_Order_By>>;
  where?: InputMaybe<Trivia_Events_Bool_Exp>;
};


/** query root */
export type Query_RootTrivia_Events_By_PkArgs = {
  event_id: Scalars['uuid'];
};


/** query root */
export type Query_RootTrivia_Game_CategoryArgs = {
  distinct_on?: InputMaybe<Array<Trivia_Game_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trivia_Game_Category_Order_By>>;
  where?: InputMaybe<Trivia_Game_Category_Bool_Exp>;
};


/** query root */
export type Query_RootTrivia_Game_Category_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trivia_Game_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trivia_Game_Category_Order_By>>;
  where?: InputMaybe<Trivia_Game_Category_Bool_Exp>;
};


/** query root */
export type Query_RootTrivia_Game_Category_By_PkArgs = {
  id: Scalars['Int'];
};


/** query root */
export type Query_RootTrivia_Game_RoundsArgs = {
  distinct_on?: InputMaybe<Array<Trivia_Game_Rounds_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trivia_Game_Rounds_Order_By>>;
  where?: InputMaybe<Trivia_Game_Rounds_Bool_Exp>;
};


/** query root */
export type Query_RootTrivia_Game_Rounds_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trivia_Game_Rounds_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trivia_Game_Rounds_Order_By>>;
  where?: InputMaybe<Trivia_Game_Rounds_Bool_Exp>;
};


/** query root */
export type Query_RootTrivia_Game_Rounds_By_PkArgs = {
  id: Scalars['uuid'];
};


/** query root */
export type Query_RootTrivia_Game_TemplatesArgs = {
  distinct_on?: InputMaybe<Array<Trivia_Game_Templates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trivia_Game_Templates_Order_By>>;
  where?: InputMaybe<Trivia_Game_Templates_Bool_Exp>;
};


/** query root */
export type Query_RootTrivia_Game_Templates_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trivia_Game_Templates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trivia_Game_Templates_Order_By>>;
  where?: InputMaybe<Trivia_Game_Templates_Bool_Exp>;
};


/** query root */
export type Query_RootTrivia_Game_Templates_By_PkArgs = {
  template_id: Scalars['String'];
};


/** query root */
export type Query_RootTrivia_Game_ThemesArgs = {
  distinct_on?: InputMaybe<Array<Trivia_Game_Themes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trivia_Game_Themes_Order_By>>;
  where?: InputMaybe<Trivia_Game_Themes_Bool_Exp>;
};


/** query root */
export type Query_RootTrivia_Game_Themes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trivia_Game_Themes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trivia_Game_Themes_Order_By>>;
  where?: InputMaybe<Trivia_Game_Themes_Bool_Exp>;
};


/** query root */
export type Query_RootTrivia_Game_Themes_By_PkArgs = {
  game_theme_id: Scalars['uuid'];
};


/** query root */
export type Query_RootTrivia_GamesArgs = {
  distinct_on?: InputMaybe<Array<Trivia_Games_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trivia_Games_Order_By>>;
  where?: InputMaybe<Trivia_Games_Bool_Exp>;
};


/** query root */
export type Query_RootTrivia_Games_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trivia_Games_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trivia_Games_Order_By>>;
  where?: InputMaybe<Trivia_Games_Bool_Exp>;
};


/** query root */
export type Query_RootTrivia_Games_By_PkArgs = {
  game_id: Scalars['uuid'];
};


/** query root */
export type Query_RootTrivia_QuestionArgs = {
  distinct_on?: InputMaybe<Array<Trivia_Question_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trivia_Question_Order_By>>;
  where?: InputMaybe<Trivia_Question_Bool_Exp>;
};


/** query root */
export type Query_RootTrivia_Question_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trivia_Question_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trivia_Question_Order_By>>;
  where?: InputMaybe<Trivia_Question_Bool_Exp>;
};


/** query root */
export type Query_RootTrivia_Round_QuestionsArgs = {
  distinct_on?: InputMaybe<Array<Trivia_Round_Questions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trivia_Round_Questions_Order_By>>;
  where?: InputMaybe<Trivia_Round_Questions_Bool_Exp>;
};


/** query root */
export type Query_RootTrivia_Round_Questions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trivia_Round_Questions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trivia_Round_Questions_Order_By>>;
  where?: InputMaybe<Trivia_Round_Questions_Bool_Exp>;
};


/** query root */
export type Query_RootTrivia_Round_Questions_By_PkArgs = {
  id: Scalars['uuid'];
};


/** query root */
export type Query_RootTrivia_Round_TemplatesArgs = {
  distinct_on?: InputMaybe<Array<Trivia_Round_Templates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trivia_Round_Templates_Order_By>>;
  where?: InputMaybe<Trivia_Round_Templates_Bool_Exp>;
};


/** query root */
export type Query_RootTrivia_Round_Templates_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trivia_Round_Templates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trivia_Round_Templates_Order_By>>;
  where?: InputMaybe<Trivia_Round_Templates_Bool_Exp>;
};


/** query root */
export type Query_RootTrivia_Round_Templates_By_PkArgs = {
  template_id: Scalars['String'];
};


/** query root */
export type Query_RootTrivia_Round_ThemesArgs = {
  distinct_on?: InputMaybe<Array<Trivia_Round_Themes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trivia_Round_Themes_Order_By>>;
  where?: InputMaybe<Trivia_Round_Themes_Bool_Exp>;
};


/** query root */
export type Query_RootTrivia_Round_Themes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trivia_Round_Themes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trivia_Round_Themes_Order_By>>;
  where?: InputMaybe<Trivia_Round_Themes_Bool_Exp>;
};


/** query root */
export type Query_RootTrivia_Round_Themes_By_PkArgs = {
  round_theme_id: Scalars['uuid'];
};


/** query root */
export type Query_RootTrivia_Round_TypesArgs = {
  distinct_on?: InputMaybe<Array<Trivia_Round_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trivia_Round_Types_Order_By>>;
  where?: InputMaybe<Trivia_Round_Types_Bool_Exp>;
};


/** query root */
export type Query_RootTrivia_Round_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trivia_Round_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trivia_Round_Types_Order_By>>;
  where?: InputMaybe<Trivia_Round_Types_Bool_Exp>;
};


/** query root */
export type Query_RootTrivia_Round_Types_By_PkArgs = {
  id: Scalars['String'];
};


/** query root */
export type Query_RootTrivia_RoundsArgs = {
  distinct_on?: InputMaybe<Array<Trivia_Rounds_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trivia_Rounds_Order_By>>;
  where?: InputMaybe<Trivia_Rounds_Bool_Exp>;
};


/** query root */
export type Query_RootTrivia_Rounds_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trivia_Rounds_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trivia_Rounds_Order_By>>;
  where?: InputMaybe<Trivia_Rounds_Bool_Exp>;
};


/** query root */
export type Query_RootTrivia_Rounds_By_PkArgs = {
  round_id: Scalars['uuid'];
};


/** query root */
export type Query_RootTrivia_UsersArgs = {
  distinct_on?: InputMaybe<Array<Trivia_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trivia_Users_Order_By>>;
  where?: InputMaybe<Trivia_Users_Bool_Exp>;
};


/** query root */
export type Query_RootTrivia_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trivia_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trivia_Users_Order_By>>;
  where?: InputMaybe<Trivia_Users_Bool_Exp>;
};


/** query root */
export type Query_RootTrivia_Users_By_PkArgs = {
  trivia_user_id: Scalars['uuid'];
};


/** query root */
export type Query_RootUser_TypesArgs = {
  distinct_on?: InputMaybe<Array<User_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Types_Order_By>>;
  where?: InputMaybe<User_Types_Bool_Exp>;
};


/** query root */
export type Query_RootUser_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Types_Order_By>>;
  where?: InputMaybe<User_Types_Bool_Exp>;
};


/** query root */
export type Query_RootUser_Types_By_PkArgs = {
  user_type_id: Scalars['Int'];
};

/** columns and relationships of "question_bonuses" */
export type Question_Bonuses = {
  __typename?: 'question_bonuses';
  question_bonus_id: Scalars['Int'];
  question_bonus_name: Scalars['String'];
};

/** aggregated selection of "question_bonuses" */
export type Question_Bonuses_Aggregate = {
  __typename?: 'question_bonuses_aggregate';
  aggregate?: Maybe<Question_Bonuses_Aggregate_Fields>;
  nodes: Array<Question_Bonuses>;
};

/** aggregate fields of "question_bonuses" */
export type Question_Bonuses_Aggregate_Fields = {
  __typename?: 'question_bonuses_aggregate_fields';
  avg?: Maybe<Question_Bonuses_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Question_Bonuses_Max_Fields>;
  min?: Maybe<Question_Bonuses_Min_Fields>;
  stddev?: Maybe<Question_Bonuses_Stddev_Fields>;
  stddev_pop?: Maybe<Question_Bonuses_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Question_Bonuses_Stddev_Samp_Fields>;
  sum?: Maybe<Question_Bonuses_Sum_Fields>;
  var_pop?: Maybe<Question_Bonuses_Var_Pop_Fields>;
  var_samp?: Maybe<Question_Bonuses_Var_Samp_Fields>;
  variance?: Maybe<Question_Bonuses_Variance_Fields>;
};


/** aggregate fields of "question_bonuses" */
export type Question_Bonuses_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Question_Bonuses_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "question_bonuses" */
export type Question_Bonuses_Aggregate_Order_By = {
  avg?: InputMaybe<Question_Bonuses_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Question_Bonuses_Max_Order_By>;
  min?: InputMaybe<Question_Bonuses_Min_Order_By>;
  stddev?: InputMaybe<Question_Bonuses_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Question_Bonuses_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Question_Bonuses_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Question_Bonuses_Sum_Order_By>;
  var_pop?: InputMaybe<Question_Bonuses_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Question_Bonuses_Var_Samp_Order_By>;
  variance?: InputMaybe<Question_Bonuses_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "question_bonuses" */
export type Question_Bonuses_Arr_Rel_Insert_Input = {
  data: Array<Question_Bonuses_Insert_Input>;
  on_conflict?: InputMaybe<Question_Bonuses_On_Conflict>;
};

/** aggregate avg on columns */
export type Question_Bonuses_Avg_Fields = {
  __typename?: 'question_bonuses_avg_fields';
  question_bonus_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "question_bonuses" */
export type Question_Bonuses_Avg_Order_By = {
  question_bonus_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "question_bonuses". All fields are combined with a logical 'AND'. */
export type Question_Bonuses_Bool_Exp = {
  _and?: InputMaybe<Array<InputMaybe<Question_Bonuses_Bool_Exp>>>;
  _not?: InputMaybe<Question_Bonuses_Bool_Exp>;
  _or?: InputMaybe<Array<InputMaybe<Question_Bonuses_Bool_Exp>>>;
  question_bonus_id?: InputMaybe<Int_Comparison_Exp>;
  question_bonus_name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "question_bonuses" */
export enum Question_Bonuses_Constraint {
  /** unique or primary key constraint */
  QuestionBonusesPkey = 'question_bonuses_pkey',
  /** unique or primary key constraint */
  QuestionBonusesQuestionBonusNameKey = 'question_bonuses_question_bonus_name_key'
}

/** input type for incrementing integer column in table "question_bonuses" */
export type Question_Bonuses_Inc_Input = {
  question_bonus_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "question_bonuses" */
export type Question_Bonuses_Insert_Input = {
  question_bonus_id?: InputMaybe<Scalars['Int']>;
  question_bonus_name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Question_Bonuses_Max_Fields = {
  __typename?: 'question_bonuses_max_fields';
  question_bonus_id?: Maybe<Scalars['Int']>;
  question_bonus_name?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "question_bonuses" */
export type Question_Bonuses_Max_Order_By = {
  question_bonus_id?: InputMaybe<Order_By>;
  question_bonus_name?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Question_Bonuses_Min_Fields = {
  __typename?: 'question_bonuses_min_fields';
  question_bonus_id?: Maybe<Scalars['Int']>;
  question_bonus_name?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "question_bonuses" */
export type Question_Bonuses_Min_Order_By = {
  question_bonus_id?: InputMaybe<Order_By>;
  question_bonus_name?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "question_bonuses" */
export type Question_Bonuses_Mutation_Response = {
  __typename?: 'question_bonuses_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Question_Bonuses>;
};

/** input type for inserting object relation for remote table "question_bonuses" */
export type Question_Bonuses_Obj_Rel_Insert_Input = {
  data: Question_Bonuses_Insert_Input;
  on_conflict?: InputMaybe<Question_Bonuses_On_Conflict>;
};

/** on conflict condition type for table "question_bonuses" */
export type Question_Bonuses_On_Conflict = {
  constraint: Question_Bonuses_Constraint;
  update_columns: Array<Question_Bonuses_Update_Column>;
  where?: InputMaybe<Question_Bonuses_Bool_Exp>;
};

/** ordering options when selecting data from "question_bonuses" */
export type Question_Bonuses_Order_By = {
  question_bonus_id?: InputMaybe<Order_By>;
  question_bonus_name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: "question_bonuses" */
export type Question_Bonuses_Pk_Columns_Input = {
  question_bonus_id: Scalars['Int'];
};

/** select columns of table "question_bonuses" */
export enum Question_Bonuses_Select_Column {
  /** column name */
  QuestionBonusId = 'question_bonus_id',
  /** column name */
  QuestionBonusName = 'question_bonus_name'
}

/** input type for updating data in table "question_bonuses" */
export type Question_Bonuses_Set_Input = {
  question_bonus_id?: InputMaybe<Scalars['Int']>;
  question_bonus_name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Question_Bonuses_Stddev_Fields = {
  __typename?: 'question_bonuses_stddev_fields';
  question_bonus_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "question_bonuses" */
export type Question_Bonuses_Stddev_Order_By = {
  question_bonus_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Question_Bonuses_Stddev_Pop_Fields = {
  __typename?: 'question_bonuses_stddev_pop_fields';
  question_bonus_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "question_bonuses" */
export type Question_Bonuses_Stddev_Pop_Order_By = {
  question_bonus_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Question_Bonuses_Stddev_Samp_Fields = {
  __typename?: 'question_bonuses_stddev_samp_fields';
  question_bonus_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "question_bonuses" */
export type Question_Bonuses_Stddev_Samp_Order_By = {
  question_bonus_id?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Question_Bonuses_Sum_Fields = {
  __typename?: 'question_bonuses_sum_fields';
  question_bonus_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "question_bonuses" */
export type Question_Bonuses_Sum_Order_By = {
  question_bonus_id?: InputMaybe<Order_By>;
};

/** update columns of table "question_bonuses" */
export enum Question_Bonuses_Update_Column {
  /** column name */
  QuestionBonusId = 'question_bonus_id',
  /** column name */
  QuestionBonusName = 'question_bonus_name'
}

/** aggregate var_pop on columns */
export type Question_Bonuses_Var_Pop_Fields = {
  __typename?: 'question_bonuses_var_pop_fields';
  question_bonus_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "question_bonuses" */
export type Question_Bonuses_Var_Pop_Order_By = {
  question_bonus_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Question_Bonuses_Var_Samp_Fields = {
  __typename?: 'question_bonuses_var_samp_fields';
  question_bonus_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "question_bonuses" */
export type Question_Bonuses_Var_Samp_Order_By = {
  question_bonus_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Question_Bonuses_Variance_Fields = {
  __typename?: 'question_bonuses_variance_fields';
  question_bonus_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "question_bonuses" */
export type Question_Bonuses_Variance_Order_By = {
  question_bonus_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "question_difficulties" */
export type Question_Difficulties = {
  __typename?: 'question_difficulties';
  question_difficulty_id: Scalars['Int'];
  question_difficulty_name: Scalars['String'];
};

/** aggregated selection of "question_difficulties" */
export type Question_Difficulties_Aggregate = {
  __typename?: 'question_difficulties_aggregate';
  aggregate?: Maybe<Question_Difficulties_Aggregate_Fields>;
  nodes: Array<Question_Difficulties>;
};

/** aggregate fields of "question_difficulties" */
export type Question_Difficulties_Aggregate_Fields = {
  __typename?: 'question_difficulties_aggregate_fields';
  avg?: Maybe<Question_Difficulties_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Question_Difficulties_Max_Fields>;
  min?: Maybe<Question_Difficulties_Min_Fields>;
  stddev?: Maybe<Question_Difficulties_Stddev_Fields>;
  stddev_pop?: Maybe<Question_Difficulties_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Question_Difficulties_Stddev_Samp_Fields>;
  sum?: Maybe<Question_Difficulties_Sum_Fields>;
  var_pop?: Maybe<Question_Difficulties_Var_Pop_Fields>;
  var_samp?: Maybe<Question_Difficulties_Var_Samp_Fields>;
  variance?: Maybe<Question_Difficulties_Variance_Fields>;
};


/** aggregate fields of "question_difficulties" */
export type Question_Difficulties_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Question_Difficulties_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "question_difficulties" */
export type Question_Difficulties_Aggregate_Order_By = {
  avg?: InputMaybe<Question_Difficulties_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Question_Difficulties_Max_Order_By>;
  min?: InputMaybe<Question_Difficulties_Min_Order_By>;
  stddev?: InputMaybe<Question_Difficulties_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Question_Difficulties_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Question_Difficulties_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Question_Difficulties_Sum_Order_By>;
  var_pop?: InputMaybe<Question_Difficulties_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Question_Difficulties_Var_Samp_Order_By>;
  variance?: InputMaybe<Question_Difficulties_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "question_difficulties" */
export type Question_Difficulties_Arr_Rel_Insert_Input = {
  data: Array<Question_Difficulties_Insert_Input>;
  on_conflict?: InputMaybe<Question_Difficulties_On_Conflict>;
};

/** aggregate avg on columns */
export type Question_Difficulties_Avg_Fields = {
  __typename?: 'question_difficulties_avg_fields';
  question_difficulty_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "question_difficulties" */
export type Question_Difficulties_Avg_Order_By = {
  question_difficulty_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "question_difficulties". All fields are combined with a logical 'AND'. */
export type Question_Difficulties_Bool_Exp = {
  _and?: InputMaybe<Array<InputMaybe<Question_Difficulties_Bool_Exp>>>;
  _not?: InputMaybe<Question_Difficulties_Bool_Exp>;
  _or?: InputMaybe<Array<InputMaybe<Question_Difficulties_Bool_Exp>>>;
  question_difficulty_id?: InputMaybe<Int_Comparison_Exp>;
  question_difficulty_name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "question_difficulties" */
export enum Question_Difficulties_Constraint {
  /** unique or primary key constraint */
  QuestionDifficultiesPkey = 'question_difficulties_pkey',
  /** unique or primary key constraint */
  QuestionDifficultiesQuestionDifficultyNameKey = 'question_difficulties_question_difficulty_name_key'
}

/** input type for incrementing integer column in table "question_difficulties" */
export type Question_Difficulties_Inc_Input = {
  question_difficulty_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "question_difficulties" */
export type Question_Difficulties_Insert_Input = {
  question_difficulty_id?: InputMaybe<Scalars['Int']>;
  question_difficulty_name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Question_Difficulties_Max_Fields = {
  __typename?: 'question_difficulties_max_fields';
  question_difficulty_id?: Maybe<Scalars['Int']>;
  question_difficulty_name?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "question_difficulties" */
export type Question_Difficulties_Max_Order_By = {
  question_difficulty_id?: InputMaybe<Order_By>;
  question_difficulty_name?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Question_Difficulties_Min_Fields = {
  __typename?: 'question_difficulties_min_fields';
  question_difficulty_id?: Maybe<Scalars['Int']>;
  question_difficulty_name?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "question_difficulties" */
export type Question_Difficulties_Min_Order_By = {
  question_difficulty_id?: InputMaybe<Order_By>;
  question_difficulty_name?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "question_difficulties" */
export type Question_Difficulties_Mutation_Response = {
  __typename?: 'question_difficulties_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Question_Difficulties>;
};

/** input type for inserting object relation for remote table "question_difficulties" */
export type Question_Difficulties_Obj_Rel_Insert_Input = {
  data: Question_Difficulties_Insert_Input;
  on_conflict?: InputMaybe<Question_Difficulties_On_Conflict>;
};

/** on conflict condition type for table "question_difficulties" */
export type Question_Difficulties_On_Conflict = {
  constraint: Question_Difficulties_Constraint;
  update_columns: Array<Question_Difficulties_Update_Column>;
  where?: InputMaybe<Question_Difficulties_Bool_Exp>;
};

/** ordering options when selecting data from "question_difficulties" */
export type Question_Difficulties_Order_By = {
  question_difficulty_id?: InputMaybe<Order_By>;
  question_difficulty_name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: "question_difficulties" */
export type Question_Difficulties_Pk_Columns_Input = {
  question_difficulty_id: Scalars['Int'];
};

/** select columns of table "question_difficulties" */
export enum Question_Difficulties_Select_Column {
  /** column name */
  QuestionDifficultyId = 'question_difficulty_id',
  /** column name */
  QuestionDifficultyName = 'question_difficulty_name'
}

/** input type for updating data in table "question_difficulties" */
export type Question_Difficulties_Set_Input = {
  question_difficulty_id?: InputMaybe<Scalars['Int']>;
  question_difficulty_name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Question_Difficulties_Stddev_Fields = {
  __typename?: 'question_difficulties_stddev_fields';
  question_difficulty_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "question_difficulties" */
export type Question_Difficulties_Stddev_Order_By = {
  question_difficulty_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Question_Difficulties_Stddev_Pop_Fields = {
  __typename?: 'question_difficulties_stddev_pop_fields';
  question_difficulty_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "question_difficulties" */
export type Question_Difficulties_Stddev_Pop_Order_By = {
  question_difficulty_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Question_Difficulties_Stddev_Samp_Fields = {
  __typename?: 'question_difficulties_stddev_samp_fields';
  question_difficulty_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "question_difficulties" */
export type Question_Difficulties_Stddev_Samp_Order_By = {
  question_difficulty_id?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Question_Difficulties_Sum_Fields = {
  __typename?: 'question_difficulties_sum_fields';
  question_difficulty_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "question_difficulties" */
export type Question_Difficulties_Sum_Order_By = {
  question_difficulty_id?: InputMaybe<Order_By>;
};

/** update columns of table "question_difficulties" */
export enum Question_Difficulties_Update_Column {
  /** column name */
  QuestionDifficultyId = 'question_difficulty_id',
  /** column name */
  QuestionDifficultyName = 'question_difficulty_name'
}

/** aggregate var_pop on columns */
export type Question_Difficulties_Var_Pop_Fields = {
  __typename?: 'question_difficulties_var_pop_fields';
  question_difficulty_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "question_difficulties" */
export type Question_Difficulties_Var_Pop_Order_By = {
  question_difficulty_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Question_Difficulties_Var_Samp_Fields = {
  __typename?: 'question_difficulties_var_samp_fields';
  question_difficulty_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "question_difficulties" */
export type Question_Difficulties_Var_Samp_Order_By = {
  question_difficulty_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Question_Difficulties_Variance_Fields = {
  __typename?: 'question_difficulties_variance_fields';
  question_difficulty_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "question_difficulties" */
export type Question_Difficulties_Variance_Order_By = {
  question_difficulty_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "question_languages" */
export type Question_Languages = {
  __typename?: 'question_languages';
  market_id: Scalars['String'];
  question_id: Scalars['uuid'];
  question_text: Scalars['String'];
};

/** aggregated selection of "question_languages" */
export type Question_Languages_Aggregate = {
  __typename?: 'question_languages_aggregate';
  aggregate?: Maybe<Question_Languages_Aggregate_Fields>;
  nodes: Array<Question_Languages>;
};

/** aggregate fields of "question_languages" */
export type Question_Languages_Aggregate_Fields = {
  __typename?: 'question_languages_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Question_Languages_Max_Fields>;
  min?: Maybe<Question_Languages_Min_Fields>;
};


/** aggregate fields of "question_languages" */
export type Question_Languages_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Question_Languages_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "question_languages" */
export type Question_Languages_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Question_Languages_Max_Order_By>;
  min?: InputMaybe<Question_Languages_Min_Order_By>;
};

/** input type for inserting array relation for remote table "question_languages" */
export type Question_Languages_Arr_Rel_Insert_Input = {
  data: Array<Question_Languages_Insert_Input>;
  on_conflict?: InputMaybe<Question_Languages_On_Conflict>;
};

/** Boolean expression to filter rows from the table "question_languages". All fields are combined with a logical 'AND'. */
export type Question_Languages_Bool_Exp = {
  _and?: InputMaybe<Array<InputMaybe<Question_Languages_Bool_Exp>>>;
  _not?: InputMaybe<Question_Languages_Bool_Exp>;
  _or?: InputMaybe<Array<InputMaybe<Question_Languages_Bool_Exp>>>;
  market_id?: InputMaybe<String_Comparison_Exp>;
  question_id?: InputMaybe<Uuid_Comparison_Exp>;
  question_text?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "question_languages" */
export enum Question_Languages_Constraint {
  /** unique or primary key constraint */
  QuestionLanguagesPkey = 'question_languages_pkey'
}

/** input type for inserting data into table "question_languages" */
export type Question_Languages_Insert_Input = {
  market_id?: InputMaybe<Scalars['String']>;
  question_id?: InputMaybe<Scalars['uuid']>;
  question_text?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Question_Languages_Max_Fields = {
  __typename?: 'question_languages_max_fields';
  market_id?: Maybe<Scalars['String']>;
  question_id?: Maybe<Scalars['uuid']>;
  question_text?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "question_languages" */
export type Question_Languages_Max_Order_By = {
  market_id?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
  question_text?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Question_Languages_Min_Fields = {
  __typename?: 'question_languages_min_fields';
  market_id?: Maybe<Scalars['String']>;
  question_id?: Maybe<Scalars['uuid']>;
  question_text?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "question_languages" */
export type Question_Languages_Min_Order_By = {
  market_id?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
  question_text?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "question_languages" */
export type Question_Languages_Mutation_Response = {
  __typename?: 'question_languages_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Question_Languages>;
};

/** input type for inserting object relation for remote table "question_languages" */
export type Question_Languages_Obj_Rel_Insert_Input = {
  data: Question_Languages_Insert_Input;
  on_conflict?: InputMaybe<Question_Languages_On_Conflict>;
};

/** on conflict condition type for table "question_languages" */
export type Question_Languages_On_Conflict = {
  constraint: Question_Languages_Constraint;
  update_columns: Array<Question_Languages_Update_Column>;
  where?: InputMaybe<Question_Languages_Bool_Exp>;
};

/** ordering options when selecting data from "question_languages" */
export type Question_Languages_Order_By = {
  market_id?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
  question_text?: InputMaybe<Order_By>;
};

/** primary key columns input for table: "question_languages" */
export type Question_Languages_Pk_Columns_Input = {
  market_id: Scalars['String'];
  question_id: Scalars['uuid'];
};

/** select columns of table "question_languages" */
export enum Question_Languages_Select_Column {
  /** column name */
  MarketId = 'market_id',
  /** column name */
  QuestionId = 'question_id',
  /** column name */
  QuestionText = 'question_text'
}

/** input type for updating data in table "question_languages" */
export type Question_Languages_Set_Input = {
  market_id?: InputMaybe<Scalars['String']>;
  question_id?: InputMaybe<Scalars['uuid']>;
  question_text?: InputMaybe<Scalars['String']>;
};

/** update columns of table "question_languages" */
export enum Question_Languages_Update_Column {
  /** column name */
  MarketId = 'market_id',
  /** column name */
  QuestionId = 'question_id',
  /** column name */
  QuestionText = 'question_text'
}

/** columns and relationships of "question_ratings" */
export type Question_Ratings = {
  __typename?: 'question_ratings';
  id: Scalars['Int'];
  name: Scalars['String'];
};

/** aggregated selection of "question_ratings" */
export type Question_Ratings_Aggregate = {
  __typename?: 'question_ratings_aggregate';
  aggregate?: Maybe<Question_Ratings_Aggregate_Fields>;
  nodes: Array<Question_Ratings>;
};

/** aggregate fields of "question_ratings" */
export type Question_Ratings_Aggregate_Fields = {
  __typename?: 'question_ratings_aggregate_fields';
  avg?: Maybe<Question_Ratings_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Question_Ratings_Max_Fields>;
  min?: Maybe<Question_Ratings_Min_Fields>;
  stddev?: Maybe<Question_Ratings_Stddev_Fields>;
  stddev_pop?: Maybe<Question_Ratings_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Question_Ratings_Stddev_Samp_Fields>;
  sum?: Maybe<Question_Ratings_Sum_Fields>;
  var_pop?: Maybe<Question_Ratings_Var_Pop_Fields>;
  var_samp?: Maybe<Question_Ratings_Var_Samp_Fields>;
  variance?: Maybe<Question_Ratings_Variance_Fields>;
};


/** aggregate fields of "question_ratings" */
export type Question_Ratings_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Question_Ratings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "question_ratings" */
export type Question_Ratings_Aggregate_Order_By = {
  avg?: InputMaybe<Question_Ratings_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Question_Ratings_Max_Order_By>;
  min?: InputMaybe<Question_Ratings_Min_Order_By>;
  stddev?: InputMaybe<Question_Ratings_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Question_Ratings_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Question_Ratings_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Question_Ratings_Sum_Order_By>;
  var_pop?: InputMaybe<Question_Ratings_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Question_Ratings_Var_Samp_Order_By>;
  variance?: InputMaybe<Question_Ratings_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "question_ratings" */
export type Question_Ratings_Arr_Rel_Insert_Input = {
  data: Array<Question_Ratings_Insert_Input>;
  on_conflict?: InputMaybe<Question_Ratings_On_Conflict>;
};

/** aggregate avg on columns */
export type Question_Ratings_Avg_Fields = {
  __typename?: 'question_ratings_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "question_ratings" */
export type Question_Ratings_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "question_ratings". All fields are combined with a logical 'AND'. */
export type Question_Ratings_Bool_Exp = {
  _and?: InputMaybe<Array<InputMaybe<Question_Ratings_Bool_Exp>>>;
  _not?: InputMaybe<Question_Ratings_Bool_Exp>;
  _or?: InputMaybe<Array<InputMaybe<Question_Ratings_Bool_Exp>>>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "question_ratings" */
export enum Question_Ratings_Constraint {
  /** unique or primary key constraint */
  QuestionRatingsIdKey = 'question_ratings_id_key',
  /** unique or primary key constraint */
  QuestionRatingsPkey = 'question_ratings_pkey'
}

/** input type for incrementing integer column in table "question_ratings" */
export type Question_Ratings_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "question_ratings" */
export type Question_Ratings_Insert_Input = {
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Question_Ratings_Max_Fields = {
  __typename?: 'question_ratings_max_fields';
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "question_ratings" */
export type Question_Ratings_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Question_Ratings_Min_Fields = {
  __typename?: 'question_ratings_min_fields';
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "question_ratings" */
export type Question_Ratings_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "question_ratings" */
export type Question_Ratings_Mutation_Response = {
  __typename?: 'question_ratings_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Question_Ratings>;
};

/** input type for inserting object relation for remote table "question_ratings" */
export type Question_Ratings_Obj_Rel_Insert_Input = {
  data: Question_Ratings_Insert_Input;
  on_conflict?: InputMaybe<Question_Ratings_On_Conflict>;
};

/** on conflict condition type for table "question_ratings" */
export type Question_Ratings_On_Conflict = {
  constraint: Question_Ratings_Constraint;
  update_columns: Array<Question_Ratings_Update_Column>;
  where?: InputMaybe<Question_Ratings_Bool_Exp>;
};

/** ordering options when selecting data from "question_ratings" */
export type Question_Ratings_Order_By = {
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: "question_ratings" */
export type Question_Ratings_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "question_ratings" */
export enum Question_Ratings_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "question_ratings" */
export type Question_Ratings_Set_Input = {
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Question_Ratings_Stddev_Fields = {
  __typename?: 'question_ratings_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "question_ratings" */
export type Question_Ratings_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Question_Ratings_Stddev_Pop_Fields = {
  __typename?: 'question_ratings_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "question_ratings" */
export type Question_Ratings_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Question_Ratings_Stddev_Samp_Fields = {
  __typename?: 'question_ratings_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "question_ratings" */
export type Question_Ratings_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Question_Ratings_Sum_Fields = {
  __typename?: 'question_ratings_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "question_ratings" */
export type Question_Ratings_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** update columns of table "question_ratings" */
export enum Question_Ratings_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** aggregate var_pop on columns */
export type Question_Ratings_Var_Pop_Fields = {
  __typename?: 'question_ratings_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "question_ratings" */
export type Question_Ratings_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Question_Ratings_Var_Samp_Fields = {
  __typename?: 'question_ratings_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "question_ratings" */
export type Question_Ratings_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Question_Ratings_Variance_Fields = {
  __typename?: 'question_ratings_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "question_ratings" */
export type Question_Ratings_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "question_status" */
export type Question_Status = {
  __typename?: 'question_status';
  question_status_id: Scalars['Int'];
  question_status_name: Scalars['String'];
};

/** aggregated selection of "question_status" */
export type Question_Status_Aggregate = {
  __typename?: 'question_status_aggregate';
  aggregate?: Maybe<Question_Status_Aggregate_Fields>;
  nodes: Array<Question_Status>;
};

/** aggregate fields of "question_status" */
export type Question_Status_Aggregate_Fields = {
  __typename?: 'question_status_aggregate_fields';
  avg?: Maybe<Question_Status_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Question_Status_Max_Fields>;
  min?: Maybe<Question_Status_Min_Fields>;
  stddev?: Maybe<Question_Status_Stddev_Fields>;
  stddev_pop?: Maybe<Question_Status_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Question_Status_Stddev_Samp_Fields>;
  sum?: Maybe<Question_Status_Sum_Fields>;
  var_pop?: Maybe<Question_Status_Var_Pop_Fields>;
  var_samp?: Maybe<Question_Status_Var_Samp_Fields>;
  variance?: Maybe<Question_Status_Variance_Fields>;
};


/** aggregate fields of "question_status" */
export type Question_Status_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Question_Status_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "question_status" */
export type Question_Status_Aggregate_Order_By = {
  avg?: InputMaybe<Question_Status_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Question_Status_Max_Order_By>;
  min?: InputMaybe<Question_Status_Min_Order_By>;
  stddev?: InputMaybe<Question_Status_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Question_Status_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Question_Status_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Question_Status_Sum_Order_By>;
  var_pop?: InputMaybe<Question_Status_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Question_Status_Var_Samp_Order_By>;
  variance?: InputMaybe<Question_Status_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "question_status" */
export type Question_Status_Arr_Rel_Insert_Input = {
  data: Array<Question_Status_Insert_Input>;
  on_conflict?: InputMaybe<Question_Status_On_Conflict>;
};

/** aggregate avg on columns */
export type Question_Status_Avg_Fields = {
  __typename?: 'question_status_avg_fields';
  question_status_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "question_status" */
export type Question_Status_Avg_Order_By = {
  question_status_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "question_status". All fields are combined with a logical 'AND'. */
export type Question_Status_Bool_Exp = {
  _and?: InputMaybe<Array<InputMaybe<Question_Status_Bool_Exp>>>;
  _not?: InputMaybe<Question_Status_Bool_Exp>;
  _or?: InputMaybe<Array<InputMaybe<Question_Status_Bool_Exp>>>;
  question_status_id?: InputMaybe<Int_Comparison_Exp>;
  question_status_name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "question_status" */
export enum Question_Status_Constraint {
  /** unique or primary key constraint */
  QuestionStatusPkey = 'question_status_pkey'
}

/** input type for incrementing integer column in table "question_status" */
export type Question_Status_Inc_Input = {
  question_status_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "question_status" */
export type Question_Status_Insert_Input = {
  question_status_id?: InputMaybe<Scalars['Int']>;
  question_status_name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Question_Status_Max_Fields = {
  __typename?: 'question_status_max_fields';
  question_status_id?: Maybe<Scalars['Int']>;
  question_status_name?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "question_status" */
export type Question_Status_Max_Order_By = {
  question_status_id?: InputMaybe<Order_By>;
  question_status_name?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Question_Status_Min_Fields = {
  __typename?: 'question_status_min_fields';
  question_status_id?: Maybe<Scalars['Int']>;
  question_status_name?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "question_status" */
export type Question_Status_Min_Order_By = {
  question_status_id?: InputMaybe<Order_By>;
  question_status_name?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "question_status" */
export type Question_Status_Mutation_Response = {
  __typename?: 'question_status_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Question_Status>;
};

/** input type for inserting object relation for remote table "question_status" */
export type Question_Status_Obj_Rel_Insert_Input = {
  data: Question_Status_Insert_Input;
  on_conflict?: InputMaybe<Question_Status_On_Conflict>;
};

/** on conflict condition type for table "question_status" */
export type Question_Status_On_Conflict = {
  constraint: Question_Status_Constraint;
  update_columns: Array<Question_Status_Update_Column>;
  where?: InputMaybe<Question_Status_Bool_Exp>;
};

/** ordering options when selecting data from "question_status" */
export type Question_Status_Order_By = {
  question_status_id?: InputMaybe<Order_By>;
  question_status_name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: "question_status" */
export type Question_Status_Pk_Columns_Input = {
  question_status_id: Scalars['Int'];
};

/** select columns of table "question_status" */
export enum Question_Status_Select_Column {
  /** column name */
  QuestionStatusId = 'question_status_id',
  /** column name */
  QuestionStatusName = 'question_status_name'
}

/** input type for updating data in table "question_status" */
export type Question_Status_Set_Input = {
  question_status_id?: InputMaybe<Scalars['Int']>;
  question_status_name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Question_Status_Stddev_Fields = {
  __typename?: 'question_status_stddev_fields';
  question_status_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "question_status" */
export type Question_Status_Stddev_Order_By = {
  question_status_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Question_Status_Stddev_Pop_Fields = {
  __typename?: 'question_status_stddev_pop_fields';
  question_status_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "question_status" */
export type Question_Status_Stddev_Pop_Order_By = {
  question_status_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Question_Status_Stddev_Samp_Fields = {
  __typename?: 'question_status_stddev_samp_fields';
  question_status_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "question_status" */
export type Question_Status_Stddev_Samp_Order_By = {
  question_status_id?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Question_Status_Sum_Fields = {
  __typename?: 'question_status_sum_fields';
  question_status_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "question_status" */
export type Question_Status_Sum_Order_By = {
  question_status_id?: InputMaybe<Order_By>;
};

/** update columns of table "question_status" */
export enum Question_Status_Update_Column {
  /** column name */
  QuestionStatusId = 'question_status_id',
  /** column name */
  QuestionStatusName = 'question_status_name'
}

/** aggregate var_pop on columns */
export type Question_Status_Var_Pop_Fields = {
  __typename?: 'question_status_var_pop_fields';
  question_status_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "question_status" */
export type Question_Status_Var_Pop_Order_By = {
  question_status_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Question_Status_Var_Samp_Fields = {
  __typename?: 'question_status_var_samp_fields';
  question_status_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "question_status" */
export type Question_Status_Var_Samp_Order_By = {
  question_status_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Question_Status_Variance_Fields = {
  __typename?: 'question_status_variance_fields';
  question_status_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "question_status" */
export type Question_Status_Variance_Order_By = {
  question_status_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "question_tags" */
export type Question_Tags = {
  __typename?: 'question_tags';
  /** An object relationship */
  question: Questions;
  question_id: Scalars['uuid'];
  tag: Scalars['String'];
};

/** aggregated selection of "question_tags" */
export type Question_Tags_Aggregate = {
  __typename?: 'question_tags_aggregate';
  aggregate?: Maybe<Question_Tags_Aggregate_Fields>;
  nodes: Array<Question_Tags>;
};

/** aggregate fields of "question_tags" */
export type Question_Tags_Aggregate_Fields = {
  __typename?: 'question_tags_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Question_Tags_Max_Fields>;
  min?: Maybe<Question_Tags_Min_Fields>;
};


/** aggregate fields of "question_tags" */
export type Question_Tags_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Question_Tags_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "question_tags" */
export type Question_Tags_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Question_Tags_Max_Order_By>;
  min?: InputMaybe<Question_Tags_Min_Order_By>;
};

/** input type for inserting array relation for remote table "question_tags" */
export type Question_Tags_Arr_Rel_Insert_Input = {
  data: Array<Question_Tags_Insert_Input>;
  on_conflict?: InputMaybe<Question_Tags_On_Conflict>;
};

/** Boolean expression to filter rows from the table "question_tags". All fields are combined with a logical 'AND'. */
export type Question_Tags_Bool_Exp = {
  _and?: InputMaybe<Array<InputMaybe<Question_Tags_Bool_Exp>>>;
  _not?: InputMaybe<Question_Tags_Bool_Exp>;
  _or?: InputMaybe<Array<InputMaybe<Question_Tags_Bool_Exp>>>;
  question?: InputMaybe<Questions_Bool_Exp>;
  question_id?: InputMaybe<Uuid_Comparison_Exp>;
  tag?: InputMaybe<String_Comparison_Exp>;
};

/** columns and relationships of "question_tags_by_count" */
export type Question_Tags_By_Count = {
  __typename?: 'question_tags_by_count';
  count?: Maybe<Scalars['bigint']>;
  tag?: Maybe<Scalars['String']>;
};

/** aggregated selection of "question_tags_by_count" */
export type Question_Tags_By_Count_Aggregate = {
  __typename?: 'question_tags_by_count_aggregate';
  aggregate?: Maybe<Question_Tags_By_Count_Aggregate_Fields>;
  nodes: Array<Question_Tags_By_Count>;
};

/** aggregate fields of "question_tags_by_count" */
export type Question_Tags_By_Count_Aggregate_Fields = {
  __typename?: 'question_tags_by_count_aggregate_fields';
  avg?: Maybe<Question_Tags_By_Count_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Question_Tags_By_Count_Max_Fields>;
  min?: Maybe<Question_Tags_By_Count_Min_Fields>;
  stddev?: Maybe<Question_Tags_By_Count_Stddev_Fields>;
  stddev_pop?: Maybe<Question_Tags_By_Count_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Question_Tags_By_Count_Stddev_Samp_Fields>;
  sum?: Maybe<Question_Tags_By_Count_Sum_Fields>;
  var_pop?: Maybe<Question_Tags_By_Count_Var_Pop_Fields>;
  var_samp?: Maybe<Question_Tags_By_Count_Var_Samp_Fields>;
  variance?: Maybe<Question_Tags_By_Count_Variance_Fields>;
};


/** aggregate fields of "question_tags_by_count" */
export type Question_Tags_By_Count_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Question_Tags_By_Count_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "question_tags_by_count" */
export type Question_Tags_By_Count_Aggregate_Order_By = {
  avg?: InputMaybe<Question_Tags_By_Count_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Question_Tags_By_Count_Max_Order_By>;
  min?: InputMaybe<Question_Tags_By_Count_Min_Order_By>;
  stddev?: InputMaybe<Question_Tags_By_Count_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Question_Tags_By_Count_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Question_Tags_By_Count_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Question_Tags_By_Count_Sum_Order_By>;
  var_pop?: InputMaybe<Question_Tags_By_Count_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Question_Tags_By_Count_Var_Samp_Order_By>;
  variance?: InputMaybe<Question_Tags_By_Count_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Question_Tags_By_Count_Avg_Fields = {
  __typename?: 'question_tags_by_count_avg_fields';
  count?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "question_tags_by_count" */
export type Question_Tags_By_Count_Avg_Order_By = {
  count?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "question_tags_by_count". All fields are combined with a logical 'AND'. */
export type Question_Tags_By_Count_Bool_Exp = {
  _and?: InputMaybe<Array<InputMaybe<Question_Tags_By_Count_Bool_Exp>>>;
  _not?: InputMaybe<Question_Tags_By_Count_Bool_Exp>;
  _or?: InputMaybe<Array<InputMaybe<Question_Tags_By_Count_Bool_Exp>>>;
  count?: InputMaybe<Bigint_Comparison_Exp>;
  tag?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Question_Tags_By_Count_Max_Fields = {
  __typename?: 'question_tags_by_count_max_fields';
  count?: Maybe<Scalars['bigint']>;
  tag?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "question_tags_by_count" */
export type Question_Tags_By_Count_Max_Order_By = {
  count?: InputMaybe<Order_By>;
  tag?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Question_Tags_By_Count_Min_Fields = {
  __typename?: 'question_tags_by_count_min_fields';
  count?: Maybe<Scalars['bigint']>;
  tag?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "question_tags_by_count" */
export type Question_Tags_By_Count_Min_Order_By = {
  count?: InputMaybe<Order_By>;
  tag?: InputMaybe<Order_By>;
};

/** ordering options when selecting data from "question_tags_by_count" */
export type Question_Tags_By_Count_Order_By = {
  count?: InputMaybe<Order_By>;
  tag?: InputMaybe<Order_By>;
};

/** select columns of table "question_tags_by_count" */
export enum Question_Tags_By_Count_Select_Column {
  /** column name */
  Count = 'count',
  /** column name */
  Tag = 'tag'
}

/** aggregate stddev on columns */
export type Question_Tags_By_Count_Stddev_Fields = {
  __typename?: 'question_tags_by_count_stddev_fields';
  count?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "question_tags_by_count" */
export type Question_Tags_By_Count_Stddev_Order_By = {
  count?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Question_Tags_By_Count_Stddev_Pop_Fields = {
  __typename?: 'question_tags_by_count_stddev_pop_fields';
  count?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "question_tags_by_count" */
export type Question_Tags_By_Count_Stddev_Pop_Order_By = {
  count?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Question_Tags_By_Count_Stddev_Samp_Fields = {
  __typename?: 'question_tags_by_count_stddev_samp_fields';
  count?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "question_tags_by_count" */
export type Question_Tags_By_Count_Stddev_Samp_Order_By = {
  count?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Question_Tags_By_Count_Sum_Fields = {
  __typename?: 'question_tags_by_count_sum_fields';
  count?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "question_tags_by_count" */
export type Question_Tags_By_Count_Sum_Order_By = {
  count?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Question_Tags_By_Count_Var_Pop_Fields = {
  __typename?: 'question_tags_by_count_var_pop_fields';
  count?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "question_tags_by_count" */
export type Question_Tags_By_Count_Var_Pop_Order_By = {
  count?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Question_Tags_By_Count_Var_Samp_Fields = {
  __typename?: 'question_tags_by_count_var_samp_fields';
  count?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "question_tags_by_count" */
export type Question_Tags_By_Count_Var_Samp_Order_By = {
  count?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Question_Tags_By_Count_Variance_Fields = {
  __typename?: 'question_tags_by_count_variance_fields';
  count?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "question_tags_by_count" */
export type Question_Tags_By_Count_Variance_Order_By = {
  count?: InputMaybe<Order_By>;
};

/** unique or primary key constraints on table "question_tags" */
export enum Question_Tags_Constraint {
  /** unique or primary key constraint */
  QuestionTagsPkey = 'question_tags_pkey'
}

/** input type for inserting data into table "question_tags" */
export type Question_Tags_Insert_Input = {
  question?: InputMaybe<Questions_Obj_Rel_Insert_Input>;
  question_id?: InputMaybe<Scalars['uuid']>;
  tag?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Question_Tags_Max_Fields = {
  __typename?: 'question_tags_max_fields';
  question_id?: Maybe<Scalars['uuid']>;
  tag?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "question_tags" */
export type Question_Tags_Max_Order_By = {
  question_id?: InputMaybe<Order_By>;
  tag?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Question_Tags_Min_Fields = {
  __typename?: 'question_tags_min_fields';
  question_id?: Maybe<Scalars['uuid']>;
  tag?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "question_tags" */
export type Question_Tags_Min_Order_By = {
  question_id?: InputMaybe<Order_By>;
  tag?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "question_tags" */
export type Question_Tags_Mutation_Response = {
  __typename?: 'question_tags_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Question_Tags>;
};

/** input type for inserting object relation for remote table "question_tags" */
export type Question_Tags_Obj_Rel_Insert_Input = {
  data: Question_Tags_Insert_Input;
  on_conflict?: InputMaybe<Question_Tags_On_Conflict>;
};

/** on conflict condition type for table "question_tags" */
export type Question_Tags_On_Conflict = {
  constraint: Question_Tags_Constraint;
  update_columns: Array<Question_Tags_Update_Column>;
  where?: InputMaybe<Question_Tags_Bool_Exp>;
};

/** ordering options when selecting data from "question_tags" */
export type Question_Tags_Order_By = {
  question?: InputMaybe<Questions_Order_By>;
  question_id?: InputMaybe<Order_By>;
  tag?: InputMaybe<Order_By>;
};

/** primary key columns input for table: "question_tags" */
export type Question_Tags_Pk_Columns_Input = {
  question_id: Scalars['uuid'];
  tag: Scalars['String'];
};

/** select columns of table "question_tags" */
export enum Question_Tags_Select_Column {
  /** column name */
  QuestionId = 'question_id',
  /** column name */
  Tag = 'tag'
}

/** input type for updating data in table "question_tags" */
export type Question_Tags_Set_Input = {
  question_id?: InputMaybe<Scalars['uuid']>;
  tag?: InputMaybe<Scalars['String']>;
};

/** update columns of table "question_tags" */
export enum Question_Tags_Update_Column {
  /** column name */
  QuestionId = 'question_id',
  /** column name */
  Tag = 'tag'
}

/** columns and relationships of "question_texts_similarities" */
export type Question_Texts_Similarities = {
  __typename?: 'question_texts_similarities';
  question_text: Scalars['String'];
  question_type_short_name?: Maybe<Scalars['String']>;
  sim: Scalars['Float'];
};

/** aggregated selection of "question_texts_similarities" */
export type Question_Texts_Similarities_Aggregate = {
  __typename?: 'question_texts_similarities_aggregate';
  aggregate?: Maybe<Question_Texts_Similarities_Aggregate_Fields>;
  nodes: Array<Question_Texts_Similarities>;
};

/** aggregate fields of "question_texts_similarities" */
export type Question_Texts_Similarities_Aggregate_Fields = {
  __typename?: 'question_texts_similarities_aggregate_fields';
  avg?: Maybe<Question_Texts_Similarities_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Question_Texts_Similarities_Max_Fields>;
  min?: Maybe<Question_Texts_Similarities_Min_Fields>;
  stddev?: Maybe<Question_Texts_Similarities_Stddev_Fields>;
  stddev_pop?: Maybe<Question_Texts_Similarities_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Question_Texts_Similarities_Stddev_Samp_Fields>;
  sum?: Maybe<Question_Texts_Similarities_Sum_Fields>;
  var_pop?: Maybe<Question_Texts_Similarities_Var_Pop_Fields>;
  var_samp?: Maybe<Question_Texts_Similarities_Var_Samp_Fields>;
  variance?: Maybe<Question_Texts_Similarities_Variance_Fields>;
};


/** aggregate fields of "question_texts_similarities" */
export type Question_Texts_Similarities_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Question_Texts_Similarities_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "question_texts_similarities" */
export type Question_Texts_Similarities_Aggregate_Order_By = {
  avg?: InputMaybe<Question_Texts_Similarities_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Question_Texts_Similarities_Max_Order_By>;
  min?: InputMaybe<Question_Texts_Similarities_Min_Order_By>;
  stddev?: InputMaybe<Question_Texts_Similarities_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Question_Texts_Similarities_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Question_Texts_Similarities_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Question_Texts_Similarities_Sum_Order_By>;
  var_pop?: InputMaybe<Question_Texts_Similarities_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Question_Texts_Similarities_Var_Samp_Order_By>;
  variance?: InputMaybe<Question_Texts_Similarities_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "question_texts_similarities" */
export type Question_Texts_Similarities_Arr_Rel_Insert_Input = {
  data: Array<Question_Texts_Similarities_Insert_Input>;
  on_conflict?: InputMaybe<Question_Texts_Similarities_On_Conflict>;
};

/** aggregate avg on columns */
export type Question_Texts_Similarities_Avg_Fields = {
  __typename?: 'question_texts_similarities_avg_fields';
  sim?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "question_texts_similarities" */
export type Question_Texts_Similarities_Avg_Order_By = {
  sim?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "question_texts_similarities". All fields are combined with a logical 'AND'. */
export type Question_Texts_Similarities_Bool_Exp = {
  _and?: InputMaybe<Array<InputMaybe<Question_Texts_Similarities_Bool_Exp>>>;
  _not?: InputMaybe<Question_Texts_Similarities_Bool_Exp>;
  _or?: InputMaybe<Array<InputMaybe<Question_Texts_Similarities_Bool_Exp>>>;
  question_text?: InputMaybe<String_Comparison_Exp>;
  question_type_short_name?: InputMaybe<String_Comparison_Exp>;
  sim?: InputMaybe<Float_Comparison_Exp>;
};

/** unique or primary key constraints on table "question_texts_similarities" */
export enum Question_Texts_Similarities_Constraint {
  /** unique or primary key constraint */
  SearchQuestionTextPkey = 'search_question_text_pkey'
}

/** input type for incrementing integer column in table "question_texts_similarities" */
export type Question_Texts_Similarities_Inc_Input = {
  sim?: InputMaybe<Scalars['Float']>;
};

/** input type for inserting data into table "question_texts_similarities" */
export type Question_Texts_Similarities_Insert_Input = {
  question_text?: InputMaybe<Scalars['String']>;
  question_type_short_name?: InputMaybe<Scalars['String']>;
  sim?: InputMaybe<Scalars['Float']>;
};

/** aggregate max on columns */
export type Question_Texts_Similarities_Max_Fields = {
  __typename?: 'question_texts_similarities_max_fields';
  question_text?: Maybe<Scalars['String']>;
  question_type_short_name?: Maybe<Scalars['String']>;
  sim?: Maybe<Scalars['Float']>;
};

/** order by max() on columns of table "question_texts_similarities" */
export type Question_Texts_Similarities_Max_Order_By = {
  question_text?: InputMaybe<Order_By>;
  question_type_short_name?: InputMaybe<Order_By>;
  sim?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Question_Texts_Similarities_Min_Fields = {
  __typename?: 'question_texts_similarities_min_fields';
  question_text?: Maybe<Scalars['String']>;
  question_type_short_name?: Maybe<Scalars['String']>;
  sim?: Maybe<Scalars['Float']>;
};

/** order by min() on columns of table "question_texts_similarities" */
export type Question_Texts_Similarities_Min_Order_By = {
  question_text?: InputMaybe<Order_By>;
  question_type_short_name?: InputMaybe<Order_By>;
  sim?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "question_texts_similarities" */
export type Question_Texts_Similarities_Mutation_Response = {
  __typename?: 'question_texts_similarities_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Question_Texts_Similarities>;
};

/** input type for inserting object relation for remote table "question_texts_similarities" */
export type Question_Texts_Similarities_Obj_Rel_Insert_Input = {
  data: Question_Texts_Similarities_Insert_Input;
  on_conflict?: InputMaybe<Question_Texts_Similarities_On_Conflict>;
};

/** on conflict condition type for table "question_texts_similarities" */
export type Question_Texts_Similarities_On_Conflict = {
  constraint: Question_Texts_Similarities_Constraint;
  update_columns: Array<Question_Texts_Similarities_Update_Column>;
  where?: InputMaybe<Question_Texts_Similarities_Bool_Exp>;
};

/** ordering options when selecting data from "question_texts_similarities" */
export type Question_Texts_Similarities_Order_By = {
  question_text?: InputMaybe<Order_By>;
  question_type_short_name?: InputMaybe<Order_By>;
  sim?: InputMaybe<Order_By>;
};

/** primary key columns input for table: "question_texts_similarities" */
export type Question_Texts_Similarities_Pk_Columns_Input = {
  question_text: Scalars['String'];
  sim: Scalars['Float'];
};

/** select columns of table "question_texts_similarities" */
export enum Question_Texts_Similarities_Select_Column {
  /** column name */
  QuestionText = 'question_text',
  /** column name */
  QuestionTypeShortName = 'question_type_short_name',
  /** column name */
  Sim = 'sim'
}

/** input type for updating data in table "question_texts_similarities" */
export type Question_Texts_Similarities_Set_Input = {
  question_text?: InputMaybe<Scalars['String']>;
  question_type_short_name?: InputMaybe<Scalars['String']>;
  sim?: InputMaybe<Scalars['Float']>;
};

/** aggregate stddev on columns */
export type Question_Texts_Similarities_Stddev_Fields = {
  __typename?: 'question_texts_similarities_stddev_fields';
  sim?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "question_texts_similarities" */
export type Question_Texts_Similarities_Stddev_Order_By = {
  sim?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Question_Texts_Similarities_Stddev_Pop_Fields = {
  __typename?: 'question_texts_similarities_stddev_pop_fields';
  sim?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "question_texts_similarities" */
export type Question_Texts_Similarities_Stddev_Pop_Order_By = {
  sim?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Question_Texts_Similarities_Stddev_Samp_Fields = {
  __typename?: 'question_texts_similarities_stddev_samp_fields';
  sim?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "question_texts_similarities" */
export type Question_Texts_Similarities_Stddev_Samp_Order_By = {
  sim?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Question_Texts_Similarities_Sum_Fields = {
  __typename?: 'question_texts_similarities_sum_fields';
  sim?: Maybe<Scalars['Float']>;
};

/** order by sum() on columns of table "question_texts_similarities" */
export type Question_Texts_Similarities_Sum_Order_By = {
  sim?: InputMaybe<Order_By>;
};

/** update columns of table "question_texts_similarities" */
export enum Question_Texts_Similarities_Update_Column {
  /** column name */
  QuestionText = 'question_text',
  /** column name */
  QuestionTypeShortName = 'question_type_short_name',
  /** column name */
  Sim = 'sim'
}

/** aggregate var_pop on columns */
export type Question_Texts_Similarities_Var_Pop_Fields = {
  __typename?: 'question_texts_similarities_var_pop_fields';
  sim?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "question_texts_similarities" */
export type Question_Texts_Similarities_Var_Pop_Order_By = {
  sim?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Question_Texts_Similarities_Var_Samp_Fields = {
  __typename?: 'question_texts_similarities_var_samp_fields';
  sim?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "question_texts_similarities" */
export type Question_Texts_Similarities_Var_Samp_Order_By = {
  sim?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Question_Texts_Similarities_Variance_Fields = {
  __typename?: 'question_texts_similarities_variance_fields';
  sim?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "question_texts_similarities" */
export type Question_Texts_Similarities_Variance_Order_By = {
  sim?: InputMaybe<Order_By>;
};

/** columns and relationships of "question_types" */
export type Question_Types = {
  __typename?: 'question_types';
  question_type_id: Scalars['Int'];
  question_type_name: Scalars['String'];
  question_type_short_name?: Maybe<Scalars['String']>;
};

/** aggregated selection of "question_types" */
export type Question_Types_Aggregate = {
  __typename?: 'question_types_aggregate';
  aggregate?: Maybe<Question_Types_Aggregate_Fields>;
  nodes: Array<Question_Types>;
};

/** aggregate fields of "question_types" */
export type Question_Types_Aggregate_Fields = {
  __typename?: 'question_types_aggregate_fields';
  avg?: Maybe<Question_Types_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Question_Types_Max_Fields>;
  min?: Maybe<Question_Types_Min_Fields>;
  stddev?: Maybe<Question_Types_Stddev_Fields>;
  stddev_pop?: Maybe<Question_Types_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Question_Types_Stddev_Samp_Fields>;
  sum?: Maybe<Question_Types_Sum_Fields>;
  var_pop?: Maybe<Question_Types_Var_Pop_Fields>;
  var_samp?: Maybe<Question_Types_Var_Samp_Fields>;
  variance?: Maybe<Question_Types_Variance_Fields>;
};


/** aggregate fields of "question_types" */
export type Question_Types_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Question_Types_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "question_types" */
export type Question_Types_Aggregate_Order_By = {
  avg?: InputMaybe<Question_Types_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Question_Types_Max_Order_By>;
  min?: InputMaybe<Question_Types_Min_Order_By>;
  stddev?: InputMaybe<Question_Types_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Question_Types_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Question_Types_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Question_Types_Sum_Order_By>;
  var_pop?: InputMaybe<Question_Types_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Question_Types_Var_Samp_Order_By>;
  variance?: InputMaybe<Question_Types_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "question_types" */
export type Question_Types_Arr_Rel_Insert_Input = {
  data: Array<Question_Types_Insert_Input>;
  on_conflict?: InputMaybe<Question_Types_On_Conflict>;
};

/** aggregate avg on columns */
export type Question_Types_Avg_Fields = {
  __typename?: 'question_types_avg_fields';
  question_type_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "question_types" */
export type Question_Types_Avg_Order_By = {
  question_type_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "question_types". All fields are combined with a logical 'AND'. */
export type Question_Types_Bool_Exp = {
  _and?: InputMaybe<Array<InputMaybe<Question_Types_Bool_Exp>>>;
  _not?: InputMaybe<Question_Types_Bool_Exp>;
  _or?: InputMaybe<Array<InputMaybe<Question_Types_Bool_Exp>>>;
  question_type_id?: InputMaybe<Int_Comparison_Exp>;
  question_type_name?: InputMaybe<String_Comparison_Exp>;
  question_type_short_name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "question_types" */
export enum Question_Types_Constraint {
  /** unique or primary key constraint */
  QuestionTypesPkey = 'question_types_pkey'
}

/** input type for incrementing integer column in table "question_types" */
export type Question_Types_Inc_Input = {
  question_type_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "question_types" */
export type Question_Types_Insert_Input = {
  question_type_id?: InputMaybe<Scalars['Int']>;
  question_type_name?: InputMaybe<Scalars['String']>;
  question_type_short_name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Question_Types_Max_Fields = {
  __typename?: 'question_types_max_fields';
  question_type_id?: Maybe<Scalars['Int']>;
  question_type_name?: Maybe<Scalars['String']>;
  question_type_short_name?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "question_types" */
export type Question_Types_Max_Order_By = {
  question_type_id?: InputMaybe<Order_By>;
  question_type_name?: InputMaybe<Order_By>;
  question_type_short_name?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Question_Types_Min_Fields = {
  __typename?: 'question_types_min_fields';
  question_type_id?: Maybe<Scalars['Int']>;
  question_type_name?: Maybe<Scalars['String']>;
  question_type_short_name?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "question_types" */
export type Question_Types_Min_Order_By = {
  question_type_id?: InputMaybe<Order_By>;
  question_type_name?: InputMaybe<Order_By>;
  question_type_short_name?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "question_types" */
export type Question_Types_Mutation_Response = {
  __typename?: 'question_types_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Question_Types>;
};

/** input type for inserting object relation for remote table "question_types" */
export type Question_Types_Obj_Rel_Insert_Input = {
  data: Question_Types_Insert_Input;
  on_conflict?: InputMaybe<Question_Types_On_Conflict>;
};

/** on conflict condition type for table "question_types" */
export type Question_Types_On_Conflict = {
  constraint: Question_Types_Constraint;
  update_columns: Array<Question_Types_Update_Column>;
  where?: InputMaybe<Question_Types_Bool_Exp>;
};

/** ordering options when selecting data from "question_types" */
export type Question_Types_Order_By = {
  question_type_id?: InputMaybe<Order_By>;
  question_type_name?: InputMaybe<Order_By>;
  question_type_short_name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: "question_types" */
export type Question_Types_Pk_Columns_Input = {
  question_type_id: Scalars['Int'];
};

/** select columns of table "question_types" */
export enum Question_Types_Select_Column {
  /** column name */
  QuestionTypeId = 'question_type_id',
  /** column name */
  QuestionTypeName = 'question_type_name',
  /** column name */
  QuestionTypeShortName = 'question_type_short_name'
}

/** input type for updating data in table "question_types" */
export type Question_Types_Set_Input = {
  question_type_id?: InputMaybe<Scalars['Int']>;
  question_type_name?: InputMaybe<Scalars['String']>;
  question_type_short_name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Question_Types_Stddev_Fields = {
  __typename?: 'question_types_stddev_fields';
  question_type_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "question_types" */
export type Question_Types_Stddev_Order_By = {
  question_type_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Question_Types_Stddev_Pop_Fields = {
  __typename?: 'question_types_stddev_pop_fields';
  question_type_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "question_types" */
export type Question_Types_Stddev_Pop_Order_By = {
  question_type_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Question_Types_Stddev_Samp_Fields = {
  __typename?: 'question_types_stddev_samp_fields';
  question_type_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "question_types" */
export type Question_Types_Stddev_Samp_Order_By = {
  question_type_id?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Question_Types_Sum_Fields = {
  __typename?: 'question_types_sum_fields';
  question_type_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "question_types" */
export type Question_Types_Sum_Order_By = {
  question_type_id?: InputMaybe<Order_By>;
};

/** update columns of table "question_types" */
export enum Question_Types_Update_Column {
  /** column name */
  QuestionTypeId = 'question_type_id',
  /** column name */
  QuestionTypeName = 'question_type_name',
  /** column name */
  QuestionTypeShortName = 'question_type_short_name'
}

/** aggregate var_pop on columns */
export type Question_Types_Var_Pop_Fields = {
  __typename?: 'question_types_var_pop_fields';
  question_type_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "question_types" */
export type Question_Types_Var_Pop_Order_By = {
  question_type_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Question_Types_Var_Samp_Fields = {
  __typename?: 'question_types_var_samp_fields';
  question_type_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "question_types" */
export type Question_Types_Var_Samp_Order_By = {
  question_type_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Question_Types_Variance_Fields = {
  __typename?: 'question_types_variance_fields';
  question_type_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "question_types" */
export type Question_Types_Variance_Order_By = {
  question_type_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "questions" */
export type Questions = {
  __typename?: 'questions';
  approved_datetime?: Maybe<Scalars['timestamp']>;
  /** An object relationship */
  approved_user?: Maybe<Trivia_Users>;
  approved_user_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  category?: Maybe<Categories>;
  category_id?: Maybe<Scalars['uuid']>;
  created_datetime: Scalars['timestamp'];
  /** An array relationship */
  edit_logs: Array<Edit_Log>;
  /** An aggregated array relationship */
  edit_logs_aggregate: Edit_Log_Aggregate;
  editor_user_id?: Maybe<Scalars['uuid']>;
  first_used_date?: Maybe<Scalars['date']>;
  for_round_type?: Maybe<Scalars['String']>;
  host_note?: Maybe<Scalars['String']>;
  is_alcohol?: Maybe<Scalars['Boolean']>;
  is_mature: Scalars['Boolean'];
  is_used?: Maybe<Scalars['Boolean']>;
  last_edited_datetime?: Maybe<Scalars['timestamp']>;
  last_used_date?: Maybe<Scalars['date']>;
  /** An object relationship */
  market: Markets;
  market_id: Scalars['String'];
  paid_invoice_id?: Maybe<Scalars['uuid']>;
  point_value?: Maybe<Scalars['Int']>;
  question_bonus_id?: Maybe<Scalars['Int']>;
  question_data?: Maybe<Scalars['jsonb']>;
  /** An object relationship */
  question_difficulty?: Maybe<Question_Difficulties>;
  question_difficulty_id?: Maybe<Scalars['Int']>;
  question_id: Scalars['uuid'];
  question_image?: Maybe<Scalars['String']>;
  question_json?: Maybe<Scalars['jsonb']>;
  question_rating: Scalars['Int'];
  /** An object relationship */
  question_status?: Maybe<Question_Status>;
  question_status_id?: Maybe<Scalars['Int']>;
  /** An array relationship */
  question_tags: Array<Question_Tags>;
  /** An aggregated array relationship */
  question_tags_aggregate: Question_Tags_Aggregate;
  question_text?: Maybe<Scalars['String']>;
  /** An object relationship */
  question_type: Question_Types;
  question_type_id: Scalars['Int'];
  rejection_note?: Maybe<Scalars['String']>;
  /** An object relationship */
  rejection_reason?: Maybe<Rejection_Reasons>;
  rejection_reason_id?: Maybe<Scalars['Int']>;
  rejector_user_id?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  reports: Array<Reports>;
  /** An aggregated array relationship */
  reports_aggregate: Reports_Aggregate;
  source_primary?: Maybe<Scalars['String']>;
  source_secondary?: Maybe<Scalars['String']>;
  source_tertiary?: Maybe<Scalars['String']>;
  source_validation?: Maybe<Scalars['jsonb']>;
  /** An object relationship */
  sub_category?: Maybe<Categories>;
  sub_category_id?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  trivia_round_questions: Array<Trivia_Round_Questions>;
  /** An aggregated array relationship */
  trivia_round_questions_aggregate: Trivia_Round_Questions_Aggregate;
  use_end_date?: Maybe<Scalars['date']>;
  use_start_date?: Maybe<Scalars['date']>;
  /** An object relationship */
  writer_user?: Maybe<Trivia_Users>;
  writer_user_id?: Maybe<Scalars['uuid']>;
};


/** columns and relationships of "questions" */
export type QuestionsEdit_LogsArgs = {
  distinct_on?: InputMaybe<Array<Edit_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Edit_Log_Order_By>>;
  where?: InputMaybe<Edit_Log_Bool_Exp>;
};


/** columns and relationships of "questions" */
export type QuestionsEdit_Logs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Edit_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Edit_Log_Order_By>>;
  where?: InputMaybe<Edit_Log_Bool_Exp>;
};


/** columns and relationships of "questions" */
export type QuestionsQuestion_DataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "questions" */
export type QuestionsQuestion_JsonArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "questions" */
export type QuestionsQuestion_TagsArgs = {
  distinct_on?: InputMaybe<Array<Question_Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Question_Tags_Order_By>>;
  where?: InputMaybe<Question_Tags_Bool_Exp>;
};


/** columns and relationships of "questions" */
export type QuestionsQuestion_Tags_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Question_Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Question_Tags_Order_By>>;
  where?: InputMaybe<Question_Tags_Bool_Exp>;
};


/** columns and relationships of "questions" */
export type QuestionsReportsArgs = {
  distinct_on?: InputMaybe<Array<Reports_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Reports_Order_By>>;
  where?: InputMaybe<Reports_Bool_Exp>;
};


/** columns and relationships of "questions" */
export type QuestionsReports_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Reports_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Reports_Order_By>>;
  where?: InputMaybe<Reports_Bool_Exp>;
};


/** columns and relationships of "questions" */
export type QuestionsSource_ValidationArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "questions" */
export type QuestionsTrivia_Round_QuestionsArgs = {
  distinct_on?: InputMaybe<Array<Trivia_Round_Questions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trivia_Round_Questions_Order_By>>;
  where?: InputMaybe<Trivia_Round_Questions_Bool_Exp>;
};


/** columns and relationships of "questions" */
export type QuestionsTrivia_Round_Questions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trivia_Round_Questions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trivia_Round_Questions_Order_By>>;
  where?: InputMaybe<Trivia_Round_Questions_Bool_Exp>;
};

/** aggregated selection of "questions" */
export type Questions_Aggregate = {
  __typename?: 'questions_aggregate';
  aggregate?: Maybe<Questions_Aggregate_Fields>;
  nodes: Array<Questions>;
};

/** aggregate fields of "questions" */
export type Questions_Aggregate_Fields = {
  __typename?: 'questions_aggregate_fields';
  avg?: Maybe<Questions_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Questions_Max_Fields>;
  min?: Maybe<Questions_Min_Fields>;
  stddev?: Maybe<Questions_Stddev_Fields>;
  stddev_pop?: Maybe<Questions_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Questions_Stddev_Samp_Fields>;
  sum?: Maybe<Questions_Sum_Fields>;
  var_pop?: Maybe<Questions_Var_Pop_Fields>;
  var_samp?: Maybe<Questions_Var_Samp_Fields>;
  variance?: Maybe<Questions_Variance_Fields>;
};


/** aggregate fields of "questions" */
export type Questions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Questions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "questions" */
export type Questions_Aggregate_Order_By = {
  avg?: InputMaybe<Questions_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Questions_Max_Order_By>;
  min?: InputMaybe<Questions_Min_Order_By>;
  stddev?: InputMaybe<Questions_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Questions_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Questions_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Questions_Sum_Order_By>;
  var_pop?: InputMaybe<Questions_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Questions_Var_Samp_Order_By>;
  variance?: InputMaybe<Questions_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Questions_Append_Input = {
  question_data?: InputMaybe<Scalars['jsonb']>;
  question_json?: InputMaybe<Scalars['jsonb']>;
  source_validation?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "questions" */
export type Questions_Arr_Rel_Insert_Input = {
  data: Array<Questions_Insert_Input>;
  on_conflict?: InputMaybe<Questions_On_Conflict>;
};

/** aggregate avg on columns */
export type Questions_Avg_Fields = {
  __typename?: 'questions_avg_fields';
  point_value?: Maybe<Scalars['Float']>;
  question_bonus_id?: Maybe<Scalars['Float']>;
  question_difficulty_id?: Maybe<Scalars['Float']>;
  question_rating?: Maybe<Scalars['Float']>;
  question_status_id?: Maybe<Scalars['Float']>;
  question_type_id?: Maybe<Scalars['Float']>;
  rejection_reason_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "questions" */
export type Questions_Avg_Order_By = {
  point_value?: InputMaybe<Order_By>;
  question_bonus_id?: InputMaybe<Order_By>;
  question_difficulty_id?: InputMaybe<Order_By>;
  question_rating?: InputMaybe<Order_By>;
  question_status_id?: InputMaybe<Order_By>;
  question_type_id?: InputMaybe<Order_By>;
  rejection_reason_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "questions". All fields are combined with a logical 'AND'. */
export type Questions_Bool_Exp = {
  _and?: InputMaybe<Array<InputMaybe<Questions_Bool_Exp>>>;
  _not?: InputMaybe<Questions_Bool_Exp>;
  _or?: InputMaybe<Array<InputMaybe<Questions_Bool_Exp>>>;
  approved_datetime?: InputMaybe<Timestamp_Comparison_Exp>;
  approved_user?: InputMaybe<Trivia_Users_Bool_Exp>;
  approved_user_id?: InputMaybe<Uuid_Comparison_Exp>;
  category?: InputMaybe<Categories_Bool_Exp>;
  category_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_datetime?: InputMaybe<Timestamp_Comparison_Exp>;
  edit_logs?: InputMaybe<Edit_Log_Bool_Exp>;
  editor_user_id?: InputMaybe<Uuid_Comparison_Exp>;
  first_used_date?: InputMaybe<Date_Comparison_Exp>;
  for_round_type?: InputMaybe<String_Comparison_Exp>;
  host_note?: InputMaybe<String_Comparison_Exp>;
  is_alcohol?: InputMaybe<Boolean_Comparison_Exp>;
  is_mature?: InputMaybe<Boolean_Comparison_Exp>;
  is_used?: InputMaybe<Boolean_Comparison_Exp>;
  last_edited_datetime?: InputMaybe<Timestamp_Comparison_Exp>;
  last_used_date?: InputMaybe<Date_Comparison_Exp>;
  market?: InputMaybe<Markets_Bool_Exp>;
  market_id?: InputMaybe<String_Comparison_Exp>;
  paid_invoice_id?: InputMaybe<Uuid_Comparison_Exp>;
  point_value?: InputMaybe<Int_Comparison_Exp>;
  question_bonus_id?: InputMaybe<Int_Comparison_Exp>;
  question_data?: InputMaybe<Jsonb_Comparison_Exp>;
  question_difficulty?: InputMaybe<Question_Difficulties_Bool_Exp>;
  question_difficulty_id?: InputMaybe<Int_Comparison_Exp>;
  question_id?: InputMaybe<Uuid_Comparison_Exp>;
  question_image?: InputMaybe<String_Comparison_Exp>;
  question_json?: InputMaybe<Jsonb_Comparison_Exp>;
  question_rating?: InputMaybe<Int_Comparison_Exp>;
  question_status?: InputMaybe<Question_Status_Bool_Exp>;
  question_status_id?: InputMaybe<Int_Comparison_Exp>;
  question_tags?: InputMaybe<Question_Tags_Bool_Exp>;
  question_text?: InputMaybe<String_Comparison_Exp>;
  question_type?: InputMaybe<Question_Types_Bool_Exp>;
  question_type_id?: InputMaybe<Int_Comparison_Exp>;
  rejection_note?: InputMaybe<String_Comparison_Exp>;
  rejection_reason?: InputMaybe<Rejection_Reasons_Bool_Exp>;
  rejection_reason_id?: InputMaybe<Int_Comparison_Exp>;
  rejector_user_id?: InputMaybe<Uuid_Comparison_Exp>;
  reports?: InputMaybe<Reports_Bool_Exp>;
  source_primary?: InputMaybe<String_Comparison_Exp>;
  source_secondary?: InputMaybe<String_Comparison_Exp>;
  source_tertiary?: InputMaybe<String_Comparison_Exp>;
  source_validation?: InputMaybe<Jsonb_Comparison_Exp>;
  sub_category?: InputMaybe<Categories_Bool_Exp>;
  sub_category_id?: InputMaybe<Uuid_Comparison_Exp>;
  trivia_round_questions?: InputMaybe<Trivia_Round_Questions_Bool_Exp>;
  use_end_date?: InputMaybe<Date_Comparison_Exp>;
  use_start_date?: InputMaybe<Date_Comparison_Exp>;
  writer_user?: InputMaybe<Trivia_Users_Bool_Exp>;
  writer_user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "questions" */
export enum Questions_Constraint {
  /** unique or primary key constraint */
  TriviaQuestionPkey = 'trivia_question_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Questions_Delete_At_Path_Input = {
  question_data?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  question_json?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  source_validation?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Questions_Delete_Elem_Input = {
  question_data?: InputMaybe<Scalars['Int']>;
  question_json?: InputMaybe<Scalars['Int']>;
  source_validation?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Questions_Delete_Key_Input = {
  question_data?: InputMaybe<Scalars['String']>;
  question_json?: InputMaybe<Scalars['String']>;
  source_validation?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing integer column in table "questions" */
export type Questions_Inc_Input = {
  point_value?: InputMaybe<Scalars['Int']>;
  question_bonus_id?: InputMaybe<Scalars['Int']>;
  question_difficulty_id?: InputMaybe<Scalars['Int']>;
  question_rating?: InputMaybe<Scalars['Int']>;
  question_status_id?: InputMaybe<Scalars['Int']>;
  question_type_id?: InputMaybe<Scalars['Int']>;
  rejection_reason_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "questions" */
export type Questions_Insert_Input = {
  approved_datetime?: InputMaybe<Scalars['timestamp']>;
  approved_user?: InputMaybe<Trivia_Users_Obj_Rel_Insert_Input>;
  approved_user_id?: InputMaybe<Scalars['uuid']>;
  category?: InputMaybe<Categories_Obj_Rel_Insert_Input>;
  category_id?: InputMaybe<Scalars['uuid']>;
  created_datetime?: InputMaybe<Scalars['timestamp']>;
  edit_logs?: InputMaybe<Edit_Log_Arr_Rel_Insert_Input>;
  editor_user_id?: InputMaybe<Scalars['uuid']>;
  first_used_date?: InputMaybe<Scalars['date']>;
  for_round_type?: InputMaybe<Scalars['String']>;
  host_note?: InputMaybe<Scalars['String']>;
  is_alcohol?: InputMaybe<Scalars['Boolean']>;
  is_mature?: InputMaybe<Scalars['Boolean']>;
  is_used?: InputMaybe<Scalars['Boolean']>;
  last_edited_datetime?: InputMaybe<Scalars['timestamp']>;
  last_used_date?: InputMaybe<Scalars['date']>;
  market?: InputMaybe<Markets_Obj_Rel_Insert_Input>;
  market_id?: InputMaybe<Scalars['String']>;
  paid_invoice_id?: InputMaybe<Scalars['uuid']>;
  point_value?: InputMaybe<Scalars['Int']>;
  question_bonus_id?: InputMaybe<Scalars['Int']>;
  question_data?: InputMaybe<Scalars['jsonb']>;
  question_difficulty?: InputMaybe<Question_Difficulties_Obj_Rel_Insert_Input>;
  question_difficulty_id?: InputMaybe<Scalars['Int']>;
  question_id?: InputMaybe<Scalars['uuid']>;
  question_image?: InputMaybe<Scalars['String']>;
  question_json?: InputMaybe<Scalars['jsonb']>;
  question_rating?: InputMaybe<Scalars['Int']>;
  question_status?: InputMaybe<Question_Status_Obj_Rel_Insert_Input>;
  question_status_id?: InputMaybe<Scalars['Int']>;
  question_tags?: InputMaybe<Question_Tags_Arr_Rel_Insert_Input>;
  question_text?: InputMaybe<Scalars['String']>;
  question_type?: InputMaybe<Question_Types_Obj_Rel_Insert_Input>;
  question_type_id?: InputMaybe<Scalars['Int']>;
  rejection_note?: InputMaybe<Scalars['String']>;
  rejection_reason?: InputMaybe<Rejection_Reasons_Obj_Rel_Insert_Input>;
  rejection_reason_id?: InputMaybe<Scalars['Int']>;
  rejector_user_id?: InputMaybe<Scalars['uuid']>;
  reports?: InputMaybe<Reports_Arr_Rel_Insert_Input>;
  source_primary?: InputMaybe<Scalars['String']>;
  source_secondary?: InputMaybe<Scalars['String']>;
  source_tertiary?: InputMaybe<Scalars['String']>;
  source_validation?: InputMaybe<Scalars['jsonb']>;
  sub_category?: InputMaybe<Categories_Obj_Rel_Insert_Input>;
  sub_category_id?: InputMaybe<Scalars['uuid']>;
  trivia_round_questions?: InputMaybe<Trivia_Round_Questions_Arr_Rel_Insert_Input>;
  use_end_date?: InputMaybe<Scalars['date']>;
  use_start_date?: InputMaybe<Scalars['date']>;
  writer_user?: InputMaybe<Trivia_Users_Obj_Rel_Insert_Input>;
  writer_user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Questions_Max_Fields = {
  __typename?: 'questions_max_fields';
  approved_datetime?: Maybe<Scalars['timestamp']>;
  approved_user_id?: Maybe<Scalars['uuid']>;
  category_id?: Maybe<Scalars['uuid']>;
  created_datetime?: Maybe<Scalars['timestamp']>;
  editor_user_id?: Maybe<Scalars['uuid']>;
  first_used_date?: Maybe<Scalars['date']>;
  for_round_type?: Maybe<Scalars['String']>;
  host_note?: Maybe<Scalars['String']>;
  last_edited_datetime?: Maybe<Scalars['timestamp']>;
  last_used_date?: Maybe<Scalars['date']>;
  market_id?: Maybe<Scalars['String']>;
  paid_invoice_id?: Maybe<Scalars['uuid']>;
  point_value?: Maybe<Scalars['Int']>;
  question_bonus_id?: Maybe<Scalars['Int']>;
  question_difficulty_id?: Maybe<Scalars['Int']>;
  question_id?: Maybe<Scalars['uuid']>;
  question_image?: Maybe<Scalars['String']>;
  question_rating?: Maybe<Scalars['Int']>;
  question_status_id?: Maybe<Scalars['Int']>;
  question_text?: Maybe<Scalars['String']>;
  question_type_id?: Maybe<Scalars['Int']>;
  rejection_note?: Maybe<Scalars['String']>;
  rejection_reason_id?: Maybe<Scalars['Int']>;
  rejector_user_id?: Maybe<Scalars['uuid']>;
  source_primary?: Maybe<Scalars['String']>;
  source_secondary?: Maybe<Scalars['String']>;
  source_tertiary?: Maybe<Scalars['String']>;
  sub_category_id?: Maybe<Scalars['uuid']>;
  use_end_date?: Maybe<Scalars['date']>;
  use_start_date?: Maybe<Scalars['date']>;
  writer_user_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "questions" */
export type Questions_Max_Order_By = {
  approved_datetime?: InputMaybe<Order_By>;
  approved_user_id?: InputMaybe<Order_By>;
  category_id?: InputMaybe<Order_By>;
  created_datetime?: InputMaybe<Order_By>;
  editor_user_id?: InputMaybe<Order_By>;
  first_used_date?: InputMaybe<Order_By>;
  for_round_type?: InputMaybe<Order_By>;
  host_note?: InputMaybe<Order_By>;
  last_edited_datetime?: InputMaybe<Order_By>;
  last_used_date?: InputMaybe<Order_By>;
  market_id?: InputMaybe<Order_By>;
  paid_invoice_id?: InputMaybe<Order_By>;
  point_value?: InputMaybe<Order_By>;
  question_bonus_id?: InputMaybe<Order_By>;
  question_difficulty_id?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
  question_image?: InputMaybe<Order_By>;
  question_rating?: InputMaybe<Order_By>;
  question_status_id?: InputMaybe<Order_By>;
  question_text?: InputMaybe<Order_By>;
  question_type_id?: InputMaybe<Order_By>;
  rejection_note?: InputMaybe<Order_By>;
  rejection_reason_id?: InputMaybe<Order_By>;
  rejector_user_id?: InputMaybe<Order_By>;
  source_primary?: InputMaybe<Order_By>;
  source_secondary?: InputMaybe<Order_By>;
  source_tertiary?: InputMaybe<Order_By>;
  sub_category_id?: InputMaybe<Order_By>;
  use_end_date?: InputMaybe<Order_By>;
  use_start_date?: InputMaybe<Order_By>;
  writer_user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Questions_Min_Fields = {
  __typename?: 'questions_min_fields';
  approved_datetime?: Maybe<Scalars['timestamp']>;
  approved_user_id?: Maybe<Scalars['uuid']>;
  category_id?: Maybe<Scalars['uuid']>;
  created_datetime?: Maybe<Scalars['timestamp']>;
  editor_user_id?: Maybe<Scalars['uuid']>;
  first_used_date?: Maybe<Scalars['date']>;
  for_round_type?: Maybe<Scalars['String']>;
  host_note?: Maybe<Scalars['String']>;
  last_edited_datetime?: Maybe<Scalars['timestamp']>;
  last_used_date?: Maybe<Scalars['date']>;
  market_id?: Maybe<Scalars['String']>;
  paid_invoice_id?: Maybe<Scalars['uuid']>;
  point_value?: Maybe<Scalars['Int']>;
  question_bonus_id?: Maybe<Scalars['Int']>;
  question_difficulty_id?: Maybe<Scalars['Int']>;
  question_id?: Maybe<Scalars['uuid']>;
  question_image?: Maybe<Scalars['String']>;
  question_rating?: Maybe<Scalars['Int']>;
  question_status_id?: Maybe<Scalars['Int']>;
  question_text?: Maybe<Scalars['String']>;
  question_type_id?: Maybe<Scalars['Int']>;
  rejection_note?: Maybe<Scalars['String']>;
  rejection_reason_id?: Maybe<Scalars['Int']>;
  rejector_user_id?: Maybe<Scalars['uuid']>;
  source_primary?: Maybe<Scalars['String']>;
  source_secondary?: Maybe<Scalars['String']>;
  source_tertiary?: Maybe<Scalars['String']>;
  sub_category_id?: Maybe<Scalars['uuid']>;
  use_end_date?: Maybe<Scalars['date']>;
  use_start_date?: Maybe<Scalars['date']>;
  writer_user_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "questions" */
export type Questions_Min_Order_By = {
  approved_datetime?: InputMaybe<Order_By>;
  approved_user_id?: InputMaybe<Order_By>;
  category_id?: InputMaybe<Order_By>;
  created_datetime?: InputMaybe<Order_By>;
  editor_user_id?: InputMaybe<Order_By>;
  first_used_date?: InputMaybe<Order_By>;
  for_round_type?: InputMaybe<Order_By>;
  host_note?: InputMaybe<Order_By>;
  last_edited_datetime?: InputMaybe<Order_By>;
  last_used_date?: InputMaybe<Order_By>;
  market_id?: InputMaybe<Order_By>;
  paid_invoice_id?: InputMaybe<Order_By>;
  point_value?: InputMaybe<Order_By>;
  question_bonus_id?: InputMaybe<Order_By>;
  question_difficulty_id?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
  question_image?: InputMaybe<Order_By>;
  question_rating?: InputMaybe<Order_By>;
  question_status_id?: InputMaybe<Order_By>;
  question_text?: InputMaybe<Order_By>;
  question_type_id?: InputMaybe<Order_By>;
  rejection_note?: InputMaybe<Order_By>;
  rejection_reason_id?: InputMaybe<Order_By>;
  rejector_user_id?: InputMaybe<Order_By>;
  source_primary?: InputMaybe<Order_By>;
  source_secondary?: InputMaybe<Order_By>;
  source_tertiary?: InputMaybe<Order_By>;
  sub_category_id?: InputMaybe<Order_By>;
  use_end_date?: InputMaybe<Order_By>;
  use_start_date?: InputMaybe<Order_By>;
  writer_user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "questions" */
export type Questions_Mutation_Response = {
  __typename?: 'questions_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Questions>;
};

/** input type for inserting object relation for remote table "questions" */
export type Questions_Obj_Rel_Insert_Input = {
  data: Questions_Insert_Input;
  on_conflict?: InputMaybe<Questions_On_Conflict>;
};

/** on conflict condition type for table "questions" */
export type Questions_On_Conflict = {
  constraint: Questions_Constraint;
  update_columns: Array<Questions_Update_Column>;
  where?: InputMaybe<Questions_Bool_Exp>;
};

/** ordering options when selecting data from "questions" */
export type Questions_Order_By = {
  approved_datetime?: InputMaybe<Order_By>;
  approved_user?: InputMaybe<Trivia_Users_Order_By>;
  approved_user_id?: InputMaybe<Order_By>;
  category?: InputMaybe<Categories_Order_By>;
  category_id?: InputMaybe<Order_By>;
  created_datetime?: InputMaybe<Order_By>;
  edit_logs_aggregate?: InputMaybe<Edit_Log_Aggregate_Order_By>;
  editor_user_id?: InputMaybe<Order_By>;
  first_used_date?: InputMaybe<Order_By>;
  for_round_type?: InputMaybe<Order_By>;
  host_note?: InputMaybe<Order_By>;
  is_alcohol?: InputMaybe<Order_By>;
  is_mature?: InputMaybe<Order_By>;
  is_used?: InputMaybe<Order_By>;
  last_edited_datetime?: InputMaybe<Order_By>;
  last_used_date?: InputMaybe<Order_By>;
  market?: InputMaybe<Markets_Order_By>;
  market_id?: InputMaybe<Order_By>;
  paid_invoice_id?: InputMaybe<Order_By>;
  point_value?: InputMaybe<Order_By>;
  question_bonus_id?: InputMaybe<Order_By>;
  question_data?: InputMaybe<Order_By>;
  question_difficulty?: InputMaybe<Question_Difficulties_Order_By>;
  question_difficulty_id?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
  question_image?: InputMaybe<Order_By>;
  question_json?: InputMaybe<Order_By>;
  question_rating?: InputMaybe<Order_By>;
  question_status?: InputMaybe<Question_Status_Order_By>;
  question_status_id?: InputMaybe<Order_By>;
  question_tags_aggregate?: InputMaybe<Question_Tags_Aggregate_Order_By>;
  question_text?: InputMaybe<Order_By>;
  question_type?: InputMaybe<Question_Types_Order_By>;
  question_type_id?: InputMaybe<Order_By>;
  rejection_note?: InputMaybe<Order_By>;
  rejection_reason?: InputMaybe<Rejection_Reasons_Order_By>;
  rejection_reason_id?: InputMaybe<Order_By>;
  rejector_user_id?: InputMaybe<Order_By>;
  reports_aggregate?: InputMaybe<Reports_Aggregate_Order_By>;
  source_primary?: InputMaybe<Order_By>;
  source_secondary?: InputMaybe<Order_By>;
  source_tertiary?: InputMaybe<Order_By>;
  source_validation?: InputMaybe<Order_By>;
  sub_category?: InputMaybe<Categories_Order_By>;
  sub_category_id?: InputMaybe<Order_By>;
  trivia_round_questions_aggregate?: InputMaybe<Trivia_Round_Questions_Aggregate_Order_By>;
  use_end_date?: InputMaybe<Order_By>;
  use_start_date?: InputMaybe<Order_By>;
  writer_user?: InputMaybe<Trivia_Users_Order_By>;
  writer_user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: "questions" */
export type Questions_Pk_Columns_Input = {
  question_id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Questions_Prepend_Input = {
  question_data?: InputMaybe<Scalars['jsonb']>;
  question_json?: InputMaybe<Scalars['jsonb']>;
  source_validation?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "questions" */
export enum Questions_Select_Column {
  /** column name */
  ApprovedDatetime = 'approved_datetime',
  /** column name */
  ApprovedUserId = 'approved_user_id',
  /** column name */
  CategoryId = 'category_id',
  /** column name */
  CreatedDatetime = 'created_datetime',
  /** column name */
  EditorUserId = 'editor_user_id',
  /** column name */
  FirstUsedDate = 'first_used_date',
  /** column name */
  ForRoundType = 'for_round_type',
  /** column name */
  HostNote = 'host_note',
  /** column name */
  IsAlcohol = 'is_alcohol',
  /** column name */
  IsMature = 'is_mature',
  /** column name */
  IsUsed = 'is_used',
  /** column name */
  LastEditedDatetime = 'last_edited_datetime',
  /** column name */
  LastUsedDate = 'last_used_date',
  /** column name */
  MarketId = 'market_id',
  /** column name */
  PaidInvoiceId = 'paid_invoice_id',
  /** column name */
  PointValue = 'point_value',
  /** column name */
  QuestionBonusId = 'question_bonus_id',
  /** column name */
  QuestionData = 'question_data',
  /** column name */
  QuestionDifficultyId = 'question_difficulty_id',
  /** column name */
  QuestionId = 'question_id',
  /** column name */
  QuestionImage = 'question_image',
  /** column name */
  QuestionJson = 'question_json',
  /** column name */
  QuestionRating = 'question_rating',
  /** column name */
  QuestionStatusId = 'question_status_id',
  /** column name */
  QuestionText = 'question_text',
  /** column name */
  QuestionTypeId = 'question_type_id',
  /** column name */
  RejectionNote = 'rejection_note',
  /** column name */
  RejectionReasonId = 'rejection_reason_id',
  /** column name */
  RejectorUserId = 'rejector_user_id',
  /** column name */
  SourcePrimary = 'source_primary',
  /** column name */
  SourceSecondary = 'source_secondary',
  /** column name */
  SourceTertiary = 'source_tertiary',
  /** column name */
  SourceValidation = 'source_validation',
  /** column name */
  SubCategoryId = 'sub_category_id',
  /** column name */
  UseEndDate = 'use_end_date',
  /** column name */
  UseStartDate = 'use_start_date',
  /** column name */
  WriterUserId = 'writer_user_id'
}

/** input type for updating data in table "questions" */
export type Questions_Set_Input = {
  approved_datetime?: InputMaybe<Scalars['timestamp']>;
  approved_user_id?: InputMaybe<Scalars['uuid']>;
  category_id?: InputMaybe<Scalars['uuid']>;
  created_datetime?: InputMaybe<Scalars['timestamp']>;
  editor_user_id?: InputMaybe<Scalars['uuid']>;
  first_used_date?: InputMaybe<Scalars['date']>;
  for_round_type?: InputMaybe<Scalars['String']>;
  host_note?: InputMaybe<Scalars['String']>;
  is_alcohol?: InputMaybe<Scalars['Boolean']>;
  is_mature?: InputMaybe<Scalars['Boolean']>;
  is_used?: InputMaybe<Scalars['Boolean']>;
  last_edited_datetime?: InputMaybe<Scalars['timestamp']>;
  last_used_date?: InputMaybe<Scalars['date']>;
  market_id?: InputMaybe<Scalars['String']>;
  paid_invoice_id?: InputMaybe<Scalars['uuid']>;
  point_value?: InputMaybe<Scalars['Int']>;
  question_bonus_id?: InputMaybe<Scalars['Int']>;
  question_data?: InputMaybe<Scalars['jsonb']>;
  question_difficulty_id?: InputMaybe<Scalars['Int']>;
  question_id?: InputMaybe<Scalars['uuid']>;
  question_image?: InputMaybe<Scalars['String']>;
  question_json?: InputMaybe<Scalars['jsonb']>;
  question_rating?: InputMaybe<Scalars['Int']>;
  question_status_id?: InputMaybe<Scalars['Int']>;
  question_text?: InputMaybe<Scalars['String']>;
  question_type_id?: InputMaybe<Scalars['Int']>;
  rejection_note?: InputMaybe<Scalars['String']>;
  rejection_reason_id?: InputMaybe<Scalars['Int']>;
  rejector_user_id?: InputMaybe<Scalars['uuid']>;
  source_primary?: InputMaybe<Scalars['String']>;
  source_secondary?: InputMaybe<Scalars['String']>;
  source_tertiary?: InputMaybe<Scalars['String']>;
  source_validation?: InputMaybe<Scalars['jsonb']>;
  sub_category_id?: InputMaybe<Scalars['uuid']>;
  use_end_date?: InputMaybe<Scalars['date']>;
  use_start_date?: InputMaybe<Scalars['date']>;
  writer_user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Questions_Stddev_Fields = {
  __typename?: 'questions_stddev_fields';
  point_value?: Maybe<Scalars['Float']>;
  question_bonus_id?: Maybe<Scalars['Float']>;
  question_difficulty_id?: Maybe<Scalars['Float']>;
  question_rating?: Maybe<Scalars['Float']>;
  question_status_id?: Maybe<Scalars['Float']>;
  question_type_id?: Maybe<Scalars['Float']>;
  rejection_reason_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "questions" */
export type Questions_Stddev_Order_By = {
  point_value?: InputMaybe<Order_By>;
  question_bonus_id?: InputMaybe<Order_By>;
  question_difficulty_id?: InputMaybe<Order_By>;
  question_rating?: InputMaybe<Order_By>;
  question_status_id?: InputMaybe<Order_By>;
  question_type_id?: InputMaybe<Order_By>;
  rejection_reason_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Questions_Stddev_Pop_Fields = {
  __typename?: 'questions_stddev_pop_fields';
  point_value?: Maybe<Scalars['Float']>;
  question_bonus_id?: Maybe<Scalars['Float']>;
  question_difficulty_id?: Maybe<Scalars['Float']>;
  question_rating?: Maybe<Scalars['Float']>;
  question_status_id?: Maybe<Scalars['Float']>;
  question_type_id?: Maybe<Scalars['Float']>;
  rejection_reason_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "questions" */
export type Questions_Stddev_Pop_Order_By = {
  point_value?: InputMaybe<Order_By>;
  question_bonus_id?: InputMaybe<Order_By>;
  question_difficulty_id?: InputMaybe<Order_By>;
  question_rating?: InputMaybe<Order_By>;
  question_status_id?: InputMaybe<Order_By>;
  question_type_id?: InputMaybe<Order_By>;
  rejection_reason_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Questions_Stddev_Samp_Fields = {
  __typename?: 'questions_stddev_samp_fields';
  point_value?: Maybe<Scalars['Float']>;
  question_bonus_id?: Maybe<Scalars['Float']>;
  question_difficulty_id?: Maybe<Scalars['Float']>;
  question_rating?: Maybe<Scalars['Float']>;
  question_status_id?: Maybe<Scalars['Float']>;
  question_type_id?: Maybe<Scalars['Float']>;
  rejection_reason_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "questions" */
export type Questions_Stddev_Samp_Order_By = {
  point_value?: InputMaybe<Order_By>;
  question_bonus_id?: InputMaybe<Order_By>;
  question_difficulty_id?: InputMaybe<Order_By>;
  question_rating?: InputMaybe<Order_By>;
  question_status_id?: InputMaybe<Order_By>;
  question_type_id?: InputMaybe<Order_By>;
  rejection_reason_id?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Questions_Sum_Fields = {
  __typename?: 'questions_sum_fields';
  point_value?: Maybe<Scalars['Int']>;
  question_bonus_id?: Maybe<Scalars['Int']>;
  question_difficulty_id?: Maybe<Scalars['Int']>;
  question_rating?: Maybe<Scalars['Int']>;
  question_status_id?: Maybe<Scalars['Int']>;
  question_type_id?: Maybe<Scalars['Int']>;
  rejection_reason_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "questions" */
export type Questions_Sum_Order_By = {
  point_value?: InputMaybe<Order_By>;
  question_bonus_id?: InputMaybe<Order_By>;
  question_difficulty_id?: InputMaybe<Order_By>;
  question_rating?: InputMaybe<Order_By>;
  question_status_id?: InputMaybe<Order_By>;
  question_type_id?: InputMaybe<Order_By>;
  rejection_reason_id?: InputMaybe<Order_By>;
};

/** update columns of table "questions" */
export enum Questions_Update_Column {
  /** column name */
  ApprovedDatetime = 'approved_datetime',
  /** column name */
  ApprovedUserId = 'approved_user_id',
  /** column name */
  CategoryId = 'category_id',
  /** column name */
  CreatedDatetime = 'created_datetime',
  /** column name */
  EditorUserId = 'editor_user_id',
  /** column name */
  FirstUsedDate = 'first_used_date',
  /** column name */
  ForRoundType = 'for_round_type',
  /** column name */
  HostNote = 'host_note',
  /** column name */
  IsAlcohol = 'is_alcohol',
  /** column name */
  IsMature = 'is_mature',
  /** column name */
  IsUsed = 'is_used',
  /** column name */
  LastEditedDatetime = 'last_edited_datetime',
  /** column name */
  LastUsedDate = 'last_used_date',
  /** column name */
  MarketId = 'market_id',
  /** column name */
  PaidInvoiceId = 'paid_invoice_id',
  /** column name */
  PointValue = 'point_value',
  /** column name */
  QuestionBonusId = 'question_bonus_id',
  /** column name */
  QuestionData = 'question_data',
  /** column name */
  QuestionDifficultyId = 'question_difficulty_id',
  /** column name */
  QuestionId = 'question_id',
  /** column name */
  QuestionImage = 'question_image',
  /** column name */
  QuestionJson = 'question_json',
  /** column name */
  QuestionRating = 'question_rating',
  /** column name */
  QuestionStatusId = 'question_status_id',
  /** column name */
  QuestionText = 'question_text',
  /** column name */
  QuestionTypeId = 'question_type_id',
  /** column name */
  RejectionNote = 'rejection_note',
  /** column name */
  RejectionReasonId = 'rejection_reason_id',
  /** column name */
  RejectorUserId = 'rejector_user_id',
  /** column name */
  SourcePrimary = 'source_primary',
  /** column name */
  SourceSecondary = 'source_secondary',
  /** column name */
  SourceTertiary = 'source_tertiary',
  /** column name */
  SourceValidation = 'source_validation',
  /** column name */
  SubCategoryId = 'sub_category_id',
  /** column name */
  UseEndDate = 'use_end_date',
  /** column name */
  UseStartDate = 'use_start_date',
  /** column name */
  WriterUserId = 'writer_user_id'
}

/** aggregate var_pop on columns */
export type Questions_Var_Pop_Fields = {
  __typename?: 'questions_var_pop_fields';
  point_value?: Maybe<Scalars['Float']>;
  question_bonus_id?: Maybe<Scalars['Float']>;
  question_difficulty_id?: Maybe<Scalars['Float']>;
  question_rating?: Maybe<Scalars['Float']>;
  question_status_id?: Maybe<Scalars['Float']>;
  question_type_id?: Maybe<Scalars['Float']>;
  rejection_reason_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "questions" */
export type Questions_Var_Pop_Order_By = {
  point_value?: InputMaybe<Order_By>;
  question_bonus_id?: InputMaybe<Order_By>;
  question_difficulty_id?: InputMaybe<Order_By>;
  question_rating?: InputMaybe<Order_By>;
  question_status_id?: InputMaybe<Order_By>;
  question_type_id?: InputMaybe<Order_By>;
  rejection_reason_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Questions_Var_Samp_Fields = {
  __typename?: 'questions_var_samp_fields';
  point_value?: Maybe<Scalars['Float']>;
  question_bonus_id?: Maybe<Scalars['Float']>;
  question_difficulty_id?: Maybe<Scalars['Float']>;
  question_rating?: Maybe<Scalars['Float']>;
  question_status_id?: Maybe<Scalars['Float']>;
  question_type_id?: Maybe<Scalars['Float']>;
  rejection_reason_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "questions" */
export type Questions_Var_Samp_Order_By = {
  point_value?: InputMaybe<Order_By>;
  question_bonus_id?: InputMaybe<Order_By>;
  question_difficulty_id?: InputMaybe<Order_By>;
  question_rating?: InputMaybe<Order_By>;
  question_status_id?: InputMaybe<Order_By>;
  question_type_id?: InputMaybe<Order_By>;
  rejection_reason_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Questions_Variance_Fields = {
  __typename?: 'questions_variance_fields';
  point_value?: Maybe<Scalars['Float']>;
  question_bonus_id?: Maybe<Scalars['Float']>;
  question_difficulty_id?: Maybe<Scalars['Float']>;
  question_rating?: Maybe<Scalars['Float']>;
  question_status_id?: Maybe<Scalars['Float']>;
  question_type_id?: Maybe<Scalars['Float']>;
  rejection_reason_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "questions" */
export type Questions_Variance_Order_By = {
  point_value?: InputMaybe<Order_By>;
  question_bonus_id?: InputMaybe<Order_By>;
  question_difficulty_id?: InputMaybe<Order_By>;
  question_rating?: InputMaybe<Order_By>;
  question_status_id?: InputMaybe<Order_By>;
  question_type_id?: InputMaybe<Order_By>;
  rejection_reason_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "rejection_reasons" */
export type Rejection_Reasons = {
  __typename?: 'rejection_reasons';
  rejection_reason_id: Scalars['Int'];
  rejection_reason_name: Scalars['String'];
};

/** aggregated selection of "rejection_reasons" */
export type Rejection_Reasons_Aggregate = {
  __typename?: 'rejection_reasons_aggregate';
  aggregate?: Maybe<Rejection_Reasons_Aggregate_Fields>;
  nodes: Array<Rejection_Reasons>;
};

/** aggregate fields of "rejection_reasons" */
export type Rejection_Reasons_Aggregate_Fields = {
  __typename?: 'rejection_reasons_aggregate_fields';
  avg?: Maybe<Rejection_Reasons_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Rejection_Reasons_Max_Fields>;
  min?: Maybe<Rejection_Reasons_Min_Fields>;
  stddev?: Maybe<Rejection_Reasons_Stddev_Fields>;
  stddev_pop?: Maybe<Rejection_Reasons_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Rejection_Reasons_Stddev_Samp_Fields>;
  sum?: Maybe<Rejection_Reasons_Sum_Fields>;
  var_pop?: Maybe<Rejection_Reasons_Var_Pop_Fields>;
  var_samp?: Maybe<Rejection_Reasons_Var_Samp_Fields>;
  variance?: Maybe<Rejection_Reasons_Variance_Fields>;
};


/** aggregate fields of "rejection_reasons" */
export type Rejection_Reasons_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Rejection_Reasons_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "rejection_reasons" */
export type Rejection_Reasons_Aggregate_Order_By = {
  avg?: InputMaybe<Rejection_Reasons_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Rejection_Reasons_Max_Order_By>;
  min?: InputMaybe<Rejection_Reasons_Min_Order_By>;
  stddev?: InputMaybe<Rejection_Reasons_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Rejection_Reasons_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Rejection_Reasons_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Rejection_Reasons_Sum_Order_By>;
  var_pop?: InputMaybe<Rejection_Reasons_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Rejection_Reasons_Var_Samp_Order_By>;
  variance?: InputMaybe<Rejection_Reasons_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "rejection_reasons" */
export type Rejection_Reasons_Arr_Rel_Insert_Input = {
  data: Array<Rejection_Reasons_Insert_Input>;
  on_conflict?: InputMaybe<Rejection_Reasons_On_Conflict>;
};

/** aggregate avg on columns */
export type Rejection_Reasons_Avg_Fields = {
  __typename?: 'rejection_reasons_avg_fields';
  rejection_reason_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "rejection_reasons" */
export type Rejection_Reasons_Avg_Order_By = {
  rejection_reason_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "rejection_reasons". All fields are combined with a logical 'AND'. */
export type Rejection_Reasons_Bool_Exp = {
  _and?: InputMaybe<Array<InputMaybe<Rejection_Reasons_Bool_Exp>>>;
  _not?: InputMaybe<Rejection_Reasons_Bool_Exp>;
  _or?: InputMaybe<Array<InputMaybe<Rejection_Reasons_Bool_Exp>>>;
  rejection_reason_id?: InputMaybe<Int_Comparison_Exp>;
  rejection_reason_name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "rejection_reasons" */
export enum Rejection_Reasons_Constraint {
  /** unique or primary key constraint */
  RejectionReasonPkey = 'rejection_reason_pkey',
  /** unique or primary key constraint */
  RejectionReasonRejectionReasonNameKey = 'rejection_reason_rejection_reason_name_key'
}

/** input type for incrementing integer column in table "rejection_reasons" */
export type Rejection_Reasons_Inc_Input = {
  rejection_reason_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "rejection_reasons" */
export type Rejection_Reasons_Insert_Input = {
  rejection_reason_id?: InputMaybe<Scalars['Int']>;
  rejection_reason_name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Rejection_Reasons_Max_Fields = {
  __typename?: 'rejection_reasons_max_fields';
  rejection_reason_id?: Maybe<Scalars['Int']>;
  rejection_reason_name?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "rejection_reasons" */
export type Rejection_Reasons_Max_Order_By = {
  rejection_reason_id?: InputMaybe<Order_By>;
  rejection_reason_name?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Rejection_Reasons_Min_Fields = {
  __typename?: 'rejection_reasons_min_fields';
  rejection_reason_id?: Maybe<Scalars['Int']>;
  rejection_reason_name?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "rejection_reasons" */
export type Rejection_Reasons_Min_Order_By = {
  rejection_reason_id?: InputMaybe<Order_By>;
  rejection_reason_name?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "rejection_reasons" */
export type Rejection_Reasons_Mutation_Response = {
  __typename?: 'rejection_reasons_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Rejection_Reasons>;
};

/** input type for inserting object relation for remote table "rejection_reasons" */
export type Rejection_Reasons_Obj_Rel_Insert_Input = {
  data: Rejection_Reasons_Insert_Input;
  on_conflict?: InputMaybe<Rejection_Reasons_On_Conflict>;
};

/** on conflict condition type for table "rejection_reasons" */
export type Rejection_Reasons_On_Conflict = {
  constraint: Rejection_Reasons_Constraint;
  update_columns: Array<Rejection_Reasons_Update_Column>;
  where?: InputMaybe<Rejection_Reasons_Bool_Exp>;
};

/** ordering options when selecting data from "rejection_reasons" */
export type Rejection_Reasons_Order_By = {
  rejection_reason_id?: InputMaybe<Order_By>;
  rejection_reason_name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: "rejection_reasons" */
export type Rejection_Reasons_Pk_Columns_Input = {
  rejection_reason_id: Scalars['Int'];
};

/** select columns of table "rejection_reasons" */
export enum Rejection_Reasons_Select_Column {
  /** column name */
  RejectionReasonId = 'rejection_reason_id',
  /** column name */
  RejectionReasonName = 'rejection_reason_name'
}

/** input type for updating data in table "rejection_reasons" */
export type Rejection_Reasons_Set_Input = {
  rejection_reason_id?: InputMaybe<Scalars['Int']>;
  rejection_reason_name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Rejection_Reasons_Stddev_Fields = {
  __typename?: 'rejection_reasons_stddev_fields';
  rejection_reason_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "rejection_reasons" */
export type Rejection_Reasons_Stddev_Order_By = {
  rejection_reason_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Rejection_Reasons_Stddev_Pop_Fields = {
  __typename?: 'rejection_reasons_stddev_pop_fields';
  rejection_reason_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "rejection_reasons" */
export type Rejection_Reasons_Stddev_Pop_Order_By = {
  rejection_reason_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Rejection_Reasons_Stddev_Samp_Fields = {
  __typename?: 'rejection_reasons_stddev_samp_fields';
  rejection_reason_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "rejection_reasons" */
export type Rejection_Reasons_Stddev_Samp_Order_By = {
  rejection_reason_id?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Rejection_Reasons_Sum_Fields = {
  __typename?: 'rejection_reasons_sum_fields';
  rejection_reason_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "rejection_reasons" */
export type Rejection_Reasons_Sum_Order_By = {
  rejection_reason_id?: InputMaybe<Order_By>;
};

/** update columns of table "rejection_reasons" */
export enum Rejection_Reasons_Update_Column {
  /** column name */
  RejectionReasonId = 'rejection_reason_id',
  /** column name */
  RejectionReasonName = 'rejection_reason_name'
}

/** aggregate var_pop on columns */
export type Rejection_Reasons_Var_Pop_Fields = {
  __typename?: 'rejection_reasons_var_pop_fields';
  rejection_reason_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "rejection_reasons" */
export type Rejection_Reasons_Var_Pop_Order_By = {
  rejection_reason_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Rejection_Reasons_Var_Samp_Fields = {
  __typename?: 'rejection_reasons_var_samp_fields';
  rejection_reason_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "rejection_reasons" */
export type Rejection_Reasons_Var_Samp_Order_By = {
  rejection_reason_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Rejection_Reasons_Variance_Fields = {
  __typename?: 'rejection_reasons_variance_fields';
  rejection_reason_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "rejection_reasons" */
export type Rejection_Reasons_Variance_Order_By = {
  rejection_reason_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "report_reasons" */
export type Report_Reasons = {
  __typename?: 'report_reasons';
  report_reason_id: Scalars['Int'];
  report_reason_name: Scalars['String'];
};

/** aggregated selection of "report_reasons" */
export type Report_Reasons_Aggregate = {
  __typename?: 'report_reasons_aggregate';
  aggregate?: Maybe<Report_Reasons_Aggregate_Fields>;
  nodes: Array<Report_Reasons>;
};

/** aggregate fields of "report_reasons" */
export type Report_Reasons_Aggregate_Fields = {
  __typename?: 'report_reasons_aggregate_fields';
  avg?: Maybe<Report_Reasons_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Report_Reasons_Max_Fields>;
  min?: Maybe<Report_Reasons_Min_Fields>;
  stddev?: Maybe<Report_Reasons_Stddev_Fields>;
  stddev_pop?: Maybe<Report_Reasons_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Report_Reasons_Stddev_Samp_Fields>;
  sum?: Maybe<Report_Reasons_Sum_Fields>;
  var_pop?: Maybe<Report_Reasons_Var_Pop_Fields>;
  var_samp?: Maybe<Report_Reasons_Var_Samp_Fields>;
  variance?: Maybe<Report_Reasons_Variance_Fields>;
};


/** aggregate fields of "report_reasons" */
export type Report_Reasons_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Report_Reasons_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "report_reasons" */
export type Report_Reasons_Aggregate_Order_By = {
  avg?: InputMaybe<Report_Reasons_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Report_Reasons_Max_Order_By>;
  min?: InputMaybe<Report_Reasons_Min_Order_By>;
  stddev?: InputMaybe<Report_Reasons_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Report_Reasons_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Report_Reasons_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Report_Reasons_Sum_Order_By>;
  var_pop?: InputMaybe<Report_Reasons_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Report_Reasons_Var_Samp_Order_By>;
  variance?: InputMaybe<Report_Reasons_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "report_reasons" */
export type Report_Reasons_Arr_Rel_Insert_Input = {
  data: Array<Report_Reasons_Insert_Input>;
  on_conflict?: InputMaybe<Report_Reasons_On_Conflict>;
};

/** aggregate avg on columns */
export type Report_Reasons_Avg_Fields = {
  __typename?: 'report_reasons_avg_fields';
  report_reason_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "report_reasons" */
export type Report_Reasons_Avg_Order_By = {
  report_reason_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "report_reasons". All fields are combined with a logical 'AND'. */
export type Report_Reasons_Bool_Exp = {
  _and?: InputMaybe<Array<InputMaybe<Report_Reasons_Bool_Exp>>>;
  _not?: InputMaybe<Report_Reasons_Bool_Exp>;
  _or?: InputMaybe<Array<InputMaybe<Report_Reasons_Bool_Exp>>>;
  report_reason_id?: InputMaybe<Int_Comparison_Exp>;
  report_reason_name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "report_reasons" */
export enum Report_Reasons_Constraint {
  /** unique or primary key constraint */
  ReportReasonsPkey = 'report_reasons_pkey'
}

/** input type for incrementing integer column in table "report_reasons" */
export type Report_Reasons_Inc_Input = {
  report_reason_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "report_reasons" */
export type Report_Reasons_Insert_Input = {
  report_reason_id?: InputMaybe<Scalars['Int']>;
  report_reason_name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Report_Reasons_Max_Fields = {
  __typename?: 'report_reasons_max_fields';
  report_reason_id?: Maybe<Scalars['Int']>;
  report_reason_name?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "report_reasons" */
export type Report_Reasons_Max_Order_By = {
  report_reason_id?: InputMaybe<Order_By>;
  report_reason_name?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Report_Reasons_Min_Fields = {
  __typename?: 'report_reasons_min_fields';
  report_reason_id?: Maybe<Scalars['Int']>;
  report_reason_name?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "report_reasons" */
export type Report_Reasons_Min_Order_By = {
  report_reason_id?: InputMaybe<Order_By>;
  report_reason_name?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "report_reasons" */
export type Report_Reasons_Mutation_Response = {
  __typename?: 'report_reasons_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Report_Reasons>;
};

/** input type for inserting object relation for remote table "report_reasons" */
export type Report_Reasons_Obj_Rel_Insert_Input = {
  data: Report_Reasons_Insert_Input;
  on_conflict?: InputMaybe<Report_Reasons_On_Conflict>;
};

/** on conflict condition type for table "report_reasons" */
export type Report_Reasons_On_Conflict = {
  constraint: Report_Reasons_Constraint;
  update_columns: Array<Report_Reasons_Update_Column>;
  where?: InputMaybe<Report_Reasons_Bool_Exp>;
};

/** ordering options when selecting data from "report_reasons" */
export type Report_Reasons_Order_By = {
  report_reason_id?: InputMaybe<Order_By>;
  report_reason_name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: "report_reasons" */
export type Report_Reasons_Pk_Columns_Input = {
  report_reason_id: Scalars['Int'];
};

/** select columns of table "report_reasons" */
export enum Report_Reasons_Select_Column {
  /** column name */
  ReportReasonId = 'report_reason_id',
  /** column name */
  ReportReasonName = 'report_reason_name'
}

/** input type for updating data in table "report_reasons" */
export type Report_Reasons_Set_Input = {
  report_reason_id?: InputMaybe<Scalars['Int']>;
  report_reason_name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Report_Reasons_Stddev_Fields = {
  __typename?: 'report_reasons_stddev_fields';
  report_reason_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "report_reasons" */
export type Report_Reasons_Stddev_Order_By = {
  report_reason_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Report_Reasons_Stddev_Pop_Fields = {
  __typename?: 'report_reasons_stddev_pop_fields';
  report_reason_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "report_reasons" */
export type Report_Reasons_Stddev_Pop_Order_By = {
  report_reason_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Report_Reasons_Stddev_Samp_Fields = {
  __typename?: 'report_reasons_stddev_samp_fields';
  report_reason_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "report_reasons" */
export type Report_Reasons_Stddev_Samp_Order_By = {
  report_reason_id?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Report_Reasons_Sum_Fields = {
  __typename?: 'report_reasons_sum_fields';
  report_reason_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "report_reasons" */
export type Report_Reasons_Sum_Order_By = {
  report_reason_id?: InputMaybe<Order_By>;
};

/** update columns of table "report_reasons" */
export enum Report_Reasons_Update_Column {
  /** column name */
  ReportReasonId = 'report_reason_id',
  /** column name */
  ReportReasonName = 'report_reason_name'
}

/** aggregate var_pop on columns */
export type Report_Reasons_Var_Pop_Fields = {
  __typename?: 'report_reasons_var_pop_fields';
  report_reason_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "report_reasons" */
export type Report_Reasons_Var_Pop_Order_By = {
  report_reason_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Report_Reasons_Var_Samp_Fields = {
  __typename?: 'report_reasons_var_samp_fields';
  report_reason_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "report_reasons" */
export type Report_Reasons_Var_Samp_Order_By = {
  report_reason_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Report_Reasons_Variance_Fields = {
  __typename?: 'report_reasons_variance_fields';
  report_reason_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "report_reasons" */
export type Report_Reasons_Variance_Order_By = {
  report_reason_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "reports" */
export type Reports = {
  __typename?: 'reports';
  app_name?: Maybe<Scalars['String']>;
  comment: Scalars['String'];
  created_at?: Maybe<Scalars['timestamptz']>;
  is_checked: Scalars['Int'];
  /** An object relationship */
  question: Questions;
  question_id: Scalars['uuid'];
  report_id: Scalars['uuid'];
  /** An object relationship */
  report_reason: Report_Reasons;
  report_reason_id: Scalars['Int'];
  user_id: Scalars['uuid'];
};

/** aggregated selection of "reports" */
export type Reports_Aggregate = {
  __typename?: 'reports_aggregate';
  aggregate?: Maybe<Reports_Aggregate_Fields>;
  nodes: Array<Reports>;
};

/** aggregate fields of "reports" */
export type Reports_Aggregate_Fields = {
  __typename?: 'reports_aggregate_fields';
  avg?: Maybe<Reports_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Reports_Max_Fields>;
  min?: Maybe<Reports_Min_Fields>;
  stddev?: Maybe<Reports_Stddev_Fields>;
  stddev_pop?: Maybe<Reports_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Reports_Stddev_Samp_Fields>;
  sum?: Maybe<Reports_Sum_Fields>;
  var_pop?: Maybe<Reports_Var_Pop_Fields>;
  var_samp?: Maybe<Reports_Var_Samp_Fields>;
  variance?: Maybe<Reports_Variance_Fields>;
};


/** aggregate fields of "reports" */
export type Reports_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Reports_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "reports" */
export type Reports_Aggregate_Order_By = {
  avg?: InputMaybe<Reports_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Reports_Max_Order_By>;
  min?: InputMaybe<Reports_Min_Order_By>;
  stddev?: InputMaybe<Reports_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Reports_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Reports_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Reports_Sum_Order_By>;
  var_pop?: InputMaybe<Reports_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Reports_Var_Samp_Order_By>;
  variance?: InputMaybe<Reports_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "reports" */
export type Reports_Arr_Rel_Insert_Input = {
  data: Array<Reports_Insert_Input>;
  on_conflict?: InputMaybe<Reports_On_Conflict>;
};

/** aggregate avg on columns */
export type Reports_Avg_Fields = {
  __typename?: 'reports_avg_fields';
  is_checked?: Maybe<Scalars['Float']>;
  report_reason_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "reports" */
export type Reports_Avg_Order_By = {
  is_checked?: InputMaybe<Order_By>;
  report_reason_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "reports". All fields are combined with a logical 'AND'. */
export type Reports_Bool_Exp = {
  _and?: InputMaybe<Array<InputMaybe<Reports_Bool_Exp>>>;
  _not?: InputMaybe<Reports_Bool_Exp>;
  _or?: InputMaybe<Array<InputMaybe<Reports_Bool_Exp>>>;
  app_name?: InputMaybe<String_Comparison_Exp>;
  comment?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  is_checked?: InputMaybe<Int_Comparison_Exp>;
  question?: InputMaybe<Questions_Bool_Exp>;
  question_id?: InputMaybe<Uuid_Comparison_Exp>;
  report_id?: InputMaybe<Uuid_Comparison_Exp>;
  report_reason?: InputMaybe<Report_Reasons_Bool_Exp>;
  report_reason_id?: InputMaybe<Int_Comparison_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "reports" */
export enum Reports_Constraint {
  /** unique or primary key constraint */
  ReportsPkey = 'reports_pkey'
}

/** input type for incrementing integer column in table "reports" */
export type Reports_Inc_Input = {
  is_checked?: InputMaybe<Scalars['Int']>;
  report_reason_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "reports" */
export type Reports_Insert_Input = {
  app_name?: InputMaybe<Scalars['String']>;
  comment?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  is_checked?: InputMaybe<Scalars['Int']>;
  question?: InputMaybe<Questions_Obj_Rel_Insert_Input>;
  question_id?: InputMaybe<Scalars['uuid']>;
  report_id?: InputMaybe<Scalars['uuid']>;
  report_reason?: InputMaybe<Report_Reasons_Obj_Rel_Insert_Input>;
  report_reason_id?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Reports_Max_Fields = {
  __typename?: 'reports_max_fields';
  app_name?: Maybe<Scalars['String']>;
  comment?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  is_checked?: Maybe<Scalars['Int']>;
  question_id?: Maybe<Scalars['uuid']>;
  report_id?: Maybe<Scalars['uuid']>;
  report_reason_id?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "reports" */
export type Reports_Max_Order_By = {
  app_name?: InputMaybe<Order_By>;
  comment?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  is_checked?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
  report_id?: InputMaybe<Order_By>;
  report_reason_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Reports_Min_Fields = {
  __typename?: 'reports_min_fields';
  app_name?: Maybe<Scalars['String']>;
  comment?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  is_checked?: Maybe<Scalars['Int']>;
  question_id?: Maybe<Scalars['uuid']>;
  report_id?: Maybe<Scalars['uuid']>;
  report_reason_id?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "reports" */
export type Reports_Min_Order_By = {
  app_name?: InputMaybe<Order_By>;
  comment?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  is_checked?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
  report_id?: InputMaybe<Order_By>;
  report_reason_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "reports" */
export type Reports_Mutation_Response = {
  __typename?: 'reports_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Reports>;
};

/** input type for inserting object relation for remote table "reports" */
export type Reports_Obj_Rel_Insert_Input = {
  data: Reports_Insert_Input;
  on_conflict?: InputMaybe<Reports_On_Conflict>;
};

/** on conflict condition type for table "reports" */
export type Reports_On_Conflict = {
  constraint: Reports_Constraint;
  update_columns: Array<Reports_Update_Column>;
  where?: InputMaybe<Reports_Bool_Exp>;
};

/** ordering options when selecting data from "reports" */
export type Reports_Order_By = {
  app_name?: InputMaybe<Order_By>;
  comment?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  is_checked?: InputMaybe<Order_By>;
  question?: InputMaybe<Questions_Order_By>;
  question_id?: InputMaybe<Order_By>;
  report_id?: InputMaybe<Order_By>;
  report_reason?: InputMaybe<Report_Reasons_Order_By>;
  report_reason_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: "reports" */
export type Reports_Pk_Columns_Input = {
  report_id: Scalars['uuid'];
};

/** select columns of table "reports" */
export enum Reports_Select_Column {
  /** column name */
  AppName = 'app_name',
  /** column name */
  Comment = 'comment',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  IsChecked = 'is_checked',
  /** column name */
  QuestionId = 'question_id',
  /** column name */
  ReportId = 'report_id',
  /** column name */
  ReportReasonId = 'report_reason_id',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "reports" */
export type Reports_Set_Input = {
  app_name?: InputMaybe<Scalars['String']>;
  comment?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  is_checked?: InputMaybe<Scalars['Int']>;
  question_id?: InputMaybe<Scalars['uuid']>;
  report_id?: InputMaybe<Scalars['uuid']>;
  report_reason_id?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Reports_Stddev_Fields = {
  __typename?: 'reports_stddev_fields';
  is_checked?: Maybe<Scalars['Float']>;
  report_reason_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "reports" */
export type Reports_Stddev_Order_By = {
  is_checked?: InputMaybe<Order_By>;
  report_reason_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Reports_Stddev_Pop_Fields = {
  __typename?: 'reports_stddev_pop_fields';
  is_checked?: Maybe<Scalars['Float']>;
  report_reason_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "reports" */
export type Reports_Stddev_Pop_Order_By = {
  is_checked?: InputMaybe<Order_By>;
  report_reason_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Reports_Stddev_Samp_Fields = {
  __typename?: 'reports_stddev_samp_fields';
  is_checked?: Maybe<Scalars['Float']>;
  report_reason_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "reports" */
export type Reports_Stddev_Samp_Order_By = {
  is_checked?: InputMaybe<Order_By>;
  report_reason_id?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Reports_Sum_Fields = {
  __typename?: 'reports_sum_fields';
  is_checked?: Maybe<Scalars['Int']>;
  report_reason_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "reports" */
export type Reports_Sum_Order_By = {
  is_checked?: InputMaybe<Order_By>;
  report_reason_id?: InputMaybe<Order_By>;
};

/** update columns of table "reports" */
export enum Reports_Update_Column {
  /** column name */
  AppName = 'app_name',
  /** column name */
  Comment = 'comment',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  IsChecked = 'is_checked',
  /** column name */
  QuestionId = 'question_id',
  /** column name */
  ReportId = 'report_id',
  /** column name */
  ReportReasonId = 'report_reason_id',
  /** column name */
  UserId = 'user_id'
}

/** aggregate var_pop on columns */
export type Reports_Var_Pop_Fields = {
  __typename?: 'reports_var_pop_fields';
  is_checked?: Maybe<Scalars['Float']>;
  report_reason_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "reports" */
export type Reports_Var_Pop_Order_By = {
  is_checked?: InputMaybe<Order_By>;
  report_reason_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Reports_Var_Samp_Fields = {
  __typename?: 'reports_var_samp_fields';
  is_checked?: Maybe<Scalars['Float']>;
  report_reason_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "reports" */
export type Reports_Var_Samp_Order_By = {
  is_checked?: InputMaybe<Order_By>;
  report_reason_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Reports_Variance_Fields = {
  __typename?: 'reports_variance_fields';
  is_checked?: Maybe<Scalars['Float']>;
  report_reason_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "reports" */
export type Reports_Variance_Order_By = {
  is_checked?: InputMaybe<Order_By>;
  report_reason_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "rounds" */
export type Rounds = {
  __typename?: 'rounds';
  market_id?: Maybe<Scalars['String']>;
  owner_id?: Maybe<Scalars['uuid']>;
  question_type_id?: Maybe<Scalars['Int']>;
  round_desc?: Maybe<Scalars['String']>;
  round_id: Scalars['uuid'];
  round_json?: Maybe<Scalars['jsonb']>;
  round_name: Scalars['String'];
};


/** columns and relationships of "rounds" */
export type RoundsRound_JsonArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "rounds" */
export type Rounds_Aggregate = {
  __typename?: 'rounds_aggregate';
  aggregate?: Maybe<Rounds_Aggregate_Fields>;
  nodes: Array<Rounds>;
};

/** aggregate fields of "rounds" */
export type Rounds_Aggregate_Fields = {
  __typename?: 'rounds_aggregate_fields';
  avg?: Maybe<Rounds_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Rounds_Max_Fields>;
  min?: Maybe<Rounds_Min_Fields>;
  stddev?: Maybe<Rounds_Stddev_Fields>;
  stddev_pop?: Maybe<Rounds_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Rounds_Stddev_Samp_Fields>;
  sum?: Maybe<Rounds_Sum_Fields>;
  var_pop?: Maybe<Rounds_Var_Pop_Fields>;
  var_samp?: Maybe<Rounds_Var_Samp_Fields>;
  variance?: Maybe<Rounds_Variance_Fields>;
};


/** aggregate fields of "rounds" */
export type Rounds_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Rounds_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "rounds" */
export type Rounds_Aggregate_Order_By = {
  avg?: InputMaybe<Rounds_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Rounds_Max_Order_By>;
  min?: InputMaybe<Rounds_Min_Order_By>;
  stddev?: InputMaybe<Rounds_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Rounds_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Rounds_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Rounds_Sum_Order_By>;
  var_pop?: InputMaybe<Rounds_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Rounds_Var_Samp_Order_By>;
  variance?: InputMaybe<Rounds_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Rounds_Append_Input = {
  round_json?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "rounds" */
export type Rounds_Arr_Rel_Insert_Input = {
  data: Array<Rounds_Insert_Input>;
  on_conflict?: InputMaybe<Rounds_On_Conflict>;
};

/** aggregate avg on columns */
export type Rounds_Avg_Fields = {
  __typename?: 'rounds_avg_fields';
  question_type_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "rounds" */
export type Rounds_Avg_Order_By = {
  question_type_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "rounds". All fields are combined with a logical 'AND'. */
export type Rounds_Bool_Exp = {
  _and?: InputMaybe<Array<InputMaybe<Rounds_Bool_Exp>>>;
  _not?: InputMaybe<Rounds_Bool_Exp>;
  _or?: InputMaybe<Array<InputMaybe<Rounds_Bool_Exp>>>;
  market_id?: InputMaybe<String_Comparison_Exp>;
  owner_id?: InputMaybe<Uuid_Comparison_Exp>;
  question_type_id?: InputMaybe<Int_Comparison_Exp>;
  round_desc?: InputMaybe<String_Comparison_Exp>;
  round_id?: InputMaybe<Uuid_Comparison_Exp>;
  round_json?: InputMaybe<Jsonb_Comparison_Exp>;
  round_name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "rounds" */
export enum Rounds_Constraint {
  /** unique or primary key constraint */
  RoundsPkey = 'rounds_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Rounds_Delete_At_Path_Input = {
  round_json?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Rounds_Delete_Elem_Input = {
  round_json?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Rounds_Delete_Key_Input = {
  round_json?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing integer column in table "rounds" */
export type Rounds_Inc_Input = {
  question_type_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "rounds" */
export type Rounds_Insert_Input = {
  market_id?: InputMaybe<Scalars['String']>;
  owner_id?: InputMaybe<Scalars['uuid']>;
  question_type_id?: InputMaybe<Scalars['Int']>;
  round_desc?: InputMaybe<Scalars['String']>;
  round_id?: InputMaybe<Scalars['uuid']>;
  round_json?: InputMaybe<Scalars['jsonb']>;
  round_name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Rounds_Max_Fields = {
  __typename?: 'rounds_max_fields';
  market_id?: Maybe<Scalars['String']>;
  owner_id?: Maybe<Scalars['uuid']>;
  question_type_id?: Maybe<Scalars['Int']>;
  round_desc?: Maybe<Scalars['String']>;
  round_id?: Maybe<Scalars['uuid']>;
  round_name?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "rounds" */
export type Rounds_Max_Order_By = {
  market_id?: InputMaybe<Order_By>;
  owner_id?: InputMaybe<Order_By>;
  question_type_id?: InputMaybe<Order_By>;
  round_desc?: InputMaybe<Order_By>;
  round_id?: InputMaybe<Order_By>;
  round_name?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Rounds_Min_Fields = {
  __typename?: 'rounds_min_fields';
  market_id?: Maybe<Scalars['String']>;
  owner_id?: Maybe<Scalars['uuid']>;
  question_type_id?: Maybe<Scalars['Int']>;
  round_desc?: Maybe<Scalars['String']>;
  round_id?: Maybe<Scalars['uuid']>;
  round_name?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "rounds" */
export type Rounds_Min_Order_By = {
  market_id?: InputMaybe<Order_By>;
  owner_id?: InputMaybe<Order_By>;
  question_type_id?: InputMaybe<Order_By>;
  round_desc?: InputMaybe<Order_By>;
  round_id?: InputMaybe<Order_By>;
  round_name?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "rounds" */
export type Rounds_Mutation_Response = {
  __typename?: 'rounds_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Rounds>;
};

/** input type for inserting object relation for remote table "rounds" */
export type Rounds_Obj_Rel_Insert_Input = {
  data: Rounds_Insert_Input;
  on_conflict?: InputMaybe<Rounds_On_Conflict>;
};

/** on conflict condition type for table "rounds" */
export type Rounds_On_Conflict = {
  constraint: Rounds_Constraint;
  update_columns: Array<Rounds_Update_Column>;
  where?: InputMaybe<Rounds_Bool_Exp>;
};

/** ordering options when selecting data from "rounds" */
export type Rounds_Order_By = {
  market_id?: InputMaybe<Order_By>;
  owner_id?: InputMaybe<Order_By>;
  question_type_id?: InputMaybe<Order_By>;
  round_desc?: InputMaybe<Order_By>;
  round_id?: InputMaybe<Order_By>;
  round_json?: InputMaybe<Order_By>;
  round_name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: "rounds" */
export type Rounds_Pk_Columns_Input = {
  round_id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Rounds_Prepend_Input = {
  round_json?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "rounds" */
export enum Rounds_Select_Column {
  /** column name */
  MarketId = 'market_id',
  /** column name */
  OwnerId = 'owner_id',
  /** column name */
  QuestionTypeId = 'question_type_id',
  /** column name */
  RoundDesc = 'round_desc',
  /** column name */
  RoundId = 'round_id',
  /** column name */
  RoundJson = 'round_json',
  /** column name */
  RoundName = 'round_name'
}

/** input type for updating data in table "rounds" */
export type Rounds_Set_Input = {
  market_id?: InputMaybe<Scalars['String']>;
  owner_id?: InputMaybe<Scalars['uuid']>;
  question_type_id?: InputMaybe<Scalars['Int']>;
  round_desc?: InputMaybe<Scalars['String']>;
  round_id?: InputMaybe<Scalars['uuid']>;
  round_json?: InputMaybe<Scalars['jsonb']>;
  round_name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Rounds_Stddev_Fields = {
  __typename?: 'rounds_stddev_fields';
  question_type_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "rounds" */
export type Rounds_Stddev_Order_By = {
  question_type_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Rounds_Stddev_Pop_Fields = {
  __typename?: 'rounds_stddev_pop_fields';
  question_type_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "rounds" */
export type Rounds_Stddev_Pop_Order_By = {
  question_type_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Rounds_Stddev_Samp_Fields = {
  __typename?: 'rounds_stddev_samp_fields';
  question_type_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "rounds" */
export type Rounds_Stddev_Samp_Order_By = {
  question_type_id?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Rounds_Sum_Fields = {
  __typename?: 'rounds_sum_fields';
  question_type_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "rounds" */
export type Rounds_Sum_Order_By = {
  question_type_id?: InputMaybe<Order_By>;
};

/** update columns of table "rounds" */
export enum Rounds_Update_Column {
  /** column name */
  MarketId = 'market_id',
  /** column name */
  OwnerId = 'owner_id',
  /** column name */
  QuestionTypeId = 'question_type_id',
  /** column name */
  RoundDesc = 'round_desc',
  /** column name */
  RoundId = 'round_id',
  /** column name */
  RoundJson = 'round_json',
  /** column name */
  RoundName = 'round_name'
}

/** aggregate var_pop on columns */
export type Rounds_Var_Pop_Fields = {
  __typename?: 'rounds_var_pop_fields';
  question_type_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "rounds" */
export type Rounds_Var_Pop_Order_By = {
  question_type_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Rounds_Var_Samp_Fields = {
  __typename?: 'rounds_var_samp_fields';
  question_type_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "rounds" */
export type Rounds_Var_Samp_Order_By = {
  question_type_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Rounds_Variance_Fields = {
  __typename?: 'rounds_variance_fields';
  question_type_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "rounds" */
export type Rounds_Variance_Order_By = {
  question_type_id?: InputMaybe<Order_By>;
};

export type Search_Question_Text_Args = {
  search?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "settings" */
export type Settings = {
  __typename?: 'settings';
  setting_name: Scalars['String'];
  setting_value: Scalars['String'];
};

/** aggregated selection of "settings" */
export type Settings_Aggregate = {
  __typename?: 'settings_aggregate';
  aggregate?: Maybe<Settings_Aggregate_Fields>;
  nodes: Array<Settings>;
};

/** aggregate fields of "settings" */
export type Settings_Aggregate_Fields = {
  __typename?: 'settings_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Settings_Max_Fields>;
  min?: Maybe<Settings_Min_Fields>;
};


/** aggregate fields of "settings" */
export type Settings_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Settings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "settings" */
export type Settings_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Settings_Max_Order_By>;
  min?: InputMaybe<Settings_Min_Order_By>;
};

/** input type for inserting array relation for remote table "settings" */
export type Settings_Arr_Rel_Insert_Input = {
  data: Array<Settings_Insert_Input>;
  on_conflict?: InputMaybe<Settings_On_Conflict>;
};

/** Boolean expression to filter rows from the table "settings". All fields are combined with a logical 'AND'. */
export type Settings_Bool_Exp = {
  _and?: InputMaybe<Array<InputMaybe<Settings_Bool_Exp>>>;
  _not?: InputMaybe<Settings_Bool_Exp>;
  _or?: InputMaybe<Array<InputMaybe<Settings_Bool_Exp>>>;
  setting_name?: InputMaybe<String_Comparison_Exp>;
  setting_value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "settings" */
export enum Settings_Constraint {
  /** unique or primary key constraint */
  SettingsPkey = 'settings_pkey'
}

/** input type for inserting data into table "settings" */
export type Settings_Insert_Input = {
  setting_name?: InputMaybe<Scalars['String']>;
  setting_value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Settings_Max_Fields = {
  __typename?: 'settings_max_fields';
  setting_name?: Maybe<Scalars['String']>;
  setting_value?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "settings" */
export type Settings_Max_Order_By = {
  setting_name?: InputMaybe<Order_By>;
  setting_value?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Settings_Min_Fields = {
  __typename?: 'settings_min_fields';
  setting_name?: Maybe<Scalars['String']>;
  setting_value?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "settings" */
export type Settings_Min_Order_By = {
  setting_name?: InputMaybe<Order_By>;
  setting_value?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "settings" */
export type Settings_Mutation_Response = {
  __typename?: 'settings_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Settings>;
};

/** input type for inserting object relation for remote table "settings" */
export type Settings_Obj_Rel_Insert_Input = {
  data: Settings_Insert_Input;
  on_conflict?: InputMaybe<Settings_On_Conflict>;
};

/** on conflict condition type for table "settings" */
export type Settings_On_Conflict = {
  constraint: Settings_Constraint;
  update_columns: Array<Settings_Update_Column>;
  where?: InputMaybe<Settings_Bool_Exp>;
};

/** ordering options when selecting data from "settings" */
export type Settings_Order_By = {
  setting_name?: InputMaybe<Order_By>;
  setting_value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: "settings" */
export type Settings_Pk_Columns_Input = {
  setting_name: Scalars['String'];
};

/** select columns of table "settings" */
export enum Settings_Select_Column {
  /** column name */
  SettingName = 'setting_name',
  /** column name */
  SettingValue = 'setting_value'
}

/** input type for updating data in table "settings" */
export type Settings_Set_Input = {
  setting_name?: InputMaybe<Scalars['String']>;
  setting_value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "settings" */
export enum Settings_Update_Column {
  /** column name */
  SettingName = 'setting_name',
  /** column name */
  SettingValue = 'setting_value'
}

/** expression to compare columns of type smallint. All fields are combined with logical 'AND'. */
export type Smallint_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['smallint']>;
  _gt?: InputMaybe<Scalars['smallint']>;
  _gte?: InputMaybe<Scalars['smallint']>;
  _in?: InputMaybe<Array<Scalars['smallint']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['smallint']>;
  _lte?: InputMaybe<Scalars['smallint']>;
  _neq?: InputMaybe<Scalars['smallint']>;
  _nin?: InputMaybe<Array<Scalars['smallint']>>;
};

/** columns and relationships of "sponsor_questions" */
export type Sponsor_Questions = {
  __typename?: 'sponsor_questions';
  question_id: Scalars['uuid'];
  sponsor_id: Scalars['uuid'];
};

/** aggregated selection of "sponsor_questions" */
export type Sponsor_Questions_Aggregate = {
  __typename?: 'sponsor_questions_aggregate';
  aggregate?: Maybe<Sponsor_Questions_Aggregate_Fields>;
  nodes: Array<Sponsor_Questions>;
};

/** aggregate fields of "sponsor_questions" */
export type Sponsor_Questions_Aggregate_Fields = {
  __typename?: 'sponsor_questions_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Sponsor_Questions_Max_Fields>;
  min?: Maybe<Sponsor_Questions_Min_Fields>;
};


/** aggregate fields of "sponsor_questions" */
export type Sponsor_Questions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Sponsor_Questions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "sponsor_questions" */
export type Sponsor_Questions_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Sponsor_Questions_Max_Order_By>;
  min?: InputMaybe<Sponsor_Questions_Min_Order_By>;
};

/** input type for inserting array relation for remote table "sponsor_questions" */
export type Sponsor_Questions_Arr_Rel_Insert_Input = {
  data: Array<Sponsor_Questions_Insert_Input>;
  on_conflict?: InputMaybe<Sponsor_Questions_On_Conflict>;
};

/** Boolean expression to filter rows from the table "sponsor_questions". All fields are combined with a logical 'AND'. */
export type Sponsor_Questions_Bool_Exp = {
  _and?: InputMaybe<Array<InputMaybe<Sponsor_Questions_Bool_Exp>>>;
  _not?: InputMaybe<Sponsor_Questions_Bool_Exp>;
  _or?: InputMaybe<Array<InputMaybe<Sponsor_Questions_Bool_Exp>>>;
  question_id?: InputMaybe<Uuid_Comparison_Exp>;
  sponsor_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "sponsor_questions" */
export enum Sponsor_Questions_Constraint {
  /** unique or primary key constraint */
  SponsorQuestionsPkey = 'sponsor_questions_pkey'
}

/** input type for inserting data into table "sponsor_questions" */
export type Sponsor_Questions_Insert_Input = {
  question_id?: InputMaybe<Scalars['uuid']>;
  sponsor_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Sponsor_Questions_Max_Fields = {
  __typename?: 'sponsor_questions_max_fields';
  question_id?: Maybe<Scalars['uuid']>;
  sponsor_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "sponsor_questions" */
export type Sponsor_Questions_Max_Order_By = {
  question_id?: InputMaybe<Order_By>;
  sponsor_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Sponsor_Questions_Min_Fields = {
  __typename?: 'sponsor_questions_min_fields';
  question_id?: Maybe<Scalars['uuid']>;
  sponsor_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "sponsor_questions" */
export type Sponsor_Questions_Min_Order_By = {
  question_id?: InputMaybe<Order_By>;
  sponsor_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "sponsor_questions" */
export type Sponsor_Questions_Mutation_Response = {
  __typename?: 'sponsor_questions_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Sponsor_Questions>;
};

/** input type for inserting object relation for remote table "sponsor_questions" */
export type Sponsor_Questions_Obj_Rel_Insert_Input = {
  data: Sponsor_Questions_Insert_Input;
  on_conflict?: InputMaybe<Sponsor_Questions_On_Conflict>;
};

/** on conflict condition type for table "sponsor_questions" */
export type Sponsor_Questions_On_Conflict = {
  constraint: Sponsor_Questions_Constraint;
  update_columns: Array<Sponsor_Questions_Update_Column>;
  where?: InputMaybe<Sponsor_Questions_Bool_Exp>;
};

/** ordering options when selecting data from "sponsor_questions" */
export type Sponsor_Questions_Order_By = {
  question_id?: InputMaybe<Order_By>;
  sponsor_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: "sponsor_questions" */
export type Sponsor_Questions_Pk_Columns_Input = {
  question_id: Scalars['uuid'];
  sponsor_id: Scalars['uuid'];
};

/** select columns of table "sponsor_questions" */
export enum Sponsor_Questions_Select_Column {
  /** column name */
  QuestionId = 'question_id',
  /** column name */
  SponsorId = 'sponsor_id'
}

/** input type for updating data in table "sponsor_questions" */
export type Sponsor_Questions_Set_Input = {
  question_id?: InputMaybe<Scalars['uuid']>;
  sponsor_id?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "sponsor_questions" */
export enum Sponsor_Questions_Update_Column {
  /** column name */
  QuestionId = 'question_id',
  /** column name */
  SponsorId = 'sponsor_id'
}

/** columns and relationships of "sponsors" */
export type Sponsors = {
  __typename?: 'sponsors';
  sponsor_id: Scalars['uuid'];
  sponsor_name: Scalars['String'];
  sponsor_restricted: Scalars['Boolean'];
};

/** aggregated selection of "sponsors" */
export type Sponsors_Aggregate = {
  __typename?: 'sponsors_aggregate';
  aggregate?: Maybe<Sponsors_Aggregate_Fields>;
  nodes: Array<Sponsors>;
};

/** aggregate fields of "sponsors" */
export type Sponsors_Aggregate_Fields = {
  __typename?: 'sponsors_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Sponsors_Max_Fields>;
  min?: Maybe<Sponsors_Min_Fields>;
};


/** aggregate fields of "sponsors" */
export type Sponsors_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Sponsors_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "sponsors" */
export type Sponsors_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Sponsors_Max_Order_By>;
  min?: InputMaybe<Sponsors_Min_Order_By>;
};

/** input type for inserting array relation for remote table "sponsors" */
export type Sponsors_Arr_Rel_Insert_Input = {
  data: Array<Sponsors_Insert_Input>;
  on_conflict?: InputMaybe<Sponsors_On_Conflict>;
};

/** Boolean expression to filter rows from the table "sponsors". All fields are combined with a logical 'AND'. */
export type Sponsors_Bool_Exp = {
  _and?: InputMaybe<Array<InputMaybe<Sponsors_Bool_Exp>>>;
  _not?: InputMaybe<Sponsors_Bool_Exp>;
  _or?: InputMaybe<Array<InputMaybe<Sponsors_Bool_Exp>>>;
  sponsor_id?: InputMaybe<Uuid_Comparison_Exp>;
  sponsor_name?: InputMaybe<String_Comparison_Exp>;
  sponsor_restricted?: InputMaybe<Boolean_Comparison_Exp>;
};

/** unique or primary key constraints on table "sponsors" */
export enum Sponsors_Constraint {
  /** unique or primary key constraint */
  SponsorsPkey = 'sponsors_pkey'
}

/** input type for inserting data into table "sponsors" */
export type Sponsors_Insert_Input = {
  sponsor_id?: InputMaybe<Scalars['uuid']>;
  sponsor_name?: InputMaybe<Scalars['String']>;
  sponsor_restricted?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate max on columns */
export type Sponsors_Max_Fields = {
  __typename?: 'sponsors_max_fields';
  sponsor_id?: Maybe<Scalars['uuid']>;
  sponsor_name?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "sponsors" */
export type Sponsors_Max_Order_By = {
  sponsor_id?: InputMaybe<Order_By>;
  sponsor_name?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Sponsors_Min_Fields = {
  __typename?: 'sponsors_min_fields';
  sponsor_id?: Maybe<Scalars['uuid']>;
  sponsor_name?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "sponsors" */
export type Sponsors_Min_Order_By = {
  sponsor_id?: InputMaybe<Order_By>;
  sponsor_name?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "sponsors" */
export type Sponsors_Mutation_Response = {
  __typename?: 'sponsors_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Sponsors>;
};

/** input type for inserting object relation for remote table "sponsors" */
export type Sponsors_Obj_Rel_Insert_Input = {
  data: Sponsors_Insert_Input;
  on_conflict?: InputMaybe<Sponsors_On_Conflict>;
};

/** on conflict condition type for table "sponsors" */
export type Sponsors_On_Conflict = {
  constraint: Sponsors_Constraint;
  update_columns: Array<Sponsors_Update_Column>;
  where?: InputMaybe<Sponsors_Bool_Exp>;
};

/** ordering options when selecting data from "sponsors" */
export type Sponsors_Order_By = {
  sponsor_id?: InputMaybe<Order_By>;
  sponsor_name?: InputMaybe<Order_By>;
  sponsor_restricted?: InputMaybe<Order_By>;
};

/** primary key columns input for table: "sponsors" */
export type Sponsors_Pk_Columns_Input = {
  sponsor_id: Scalars['uuid'];
};

/** select columns of table "sponsors" */
export enum Sponsors_Select_Column {
  /** column name */
  SponsorId = 'sponsor_id',
  /** column name */
  SponsorName = 'sponsor_name',
  /** column name */
  SponsorRestricted = 'sponsor_restricted'
}

/** input type for updating data in table "sponsors" */
export type Sponsors_Set_Input = {
  sponsor_id?: InputMaybe<Scalars['uuid']>;
  sponsor_name?: InputMaybe<Scalars['String']>;
  sponsor_restricted?: InputMaybe<Scalars['Boolean']>;
};

/** update columns of table "sponsors" */
export enum Sponsors_Update_Column {
  /** column name */
  SponsorId = 'sponsor_id',
  /** column name */
  SponsorName = 'sponsor_name',
  /** column name */
  SponsorRestricted = 'sponsor_restricted'
}

/** subscription root */
export type Subscription_Root = {
  __typename?: 'subscription_root';
  /** execute function "_generate_bonus_round" which returns "gen_round" */
  _generate_bonus_round: Array<Gen_Round>;
  /** execute function "_generate_bonus_round" and query aggregates on result of table type "gen_round" */
  _generate_bonus_round_aggregate: Gen_Round_Aggregate;
  /** execute function "_generate_ctm_round" which returns "gen_round" */
  _generate_ctm_round: Array<Gen_Round>;
  /** execute function "_generate_ctm_round" and query aggregates on result of table type "gen_round" */
  _generate_ctm_round_aggregate: Gen_Round_Aggregate;
  /** execute function "_generate_default_final_round" which returns "gen_round" */
  _generate_default_final_round: Array<Gen_Round>;
  /** execute function "_generate_default_final_round" and query aggregates on result of table type "gen_round" */
  _generate_default_final_round_aggregate: Gen_Round_Aggregate;
  /** execute function "_generate_default_round" which returns "gen_round" */
  _generate_default_round: Array<Gen_Round>;
  /** execute function "_generate_default_round" and query aggregates on result of table type "gen_round" */
  _generate_default_round_aggregate: Gen_Round_Aggregate;
  /** execute function "_get_random_question_for_round" which returns "questions" */
  _get_random_question_for_round: Array<Questions>;
  /** execute function "_get_random_question_for_round" and query aggregates on result of table type "questions" */
  _get_random_question_for_round_aggregate: Questions_Aggregate;
  /** fetch data from the table: "answer_types" */
  answer_types: Array<Answer_Types>;
  /** fetch aggregated fields from the table: "answer_types" */
  answer_types_aggregate: Answer_Types_Aggregate;
  /** fetch data from the table: "answer_types" using primary key columns */
  answer_types_by_pk?: Maybe<Answer_Types>;
  /** fetch data from the table: "categories" */
  categories: Array<Categories>;
  /** fetch aggregated fields from the table: "categories" */
  categories_aggregate: Categories_Aggregate;
  /** fetch data from the table: "categories" using primary key columns */
  categories_by_pk?: Maybe<Categories>;
  /** fetch data from the table: "city_edit_log" */
  city_edit_log: Array<City_Edit_Log>;
  /** fetch aggregated fields from the table: "city_edit_log" */
  city_edit_log_aggregate: City_Edit_Log_Aggregate;
  /** fetch data from the table: "city_tqs" */
  city_tqs: Array<City_Tqs>;
  /** fetch aggregated fields from the table: "city_tqs" */
  city_tqs_aggregate: City_Tqs_Aggregate;
  /** fetch data from the table: "city_trivia_category" */
  city_trivia_category: Array<City_Trivia_Category>;
  /** fetch aggregated fields from the table: "city_trivia_category" */
  city_trivia_category_aggregate: City_Trivia_Category_Aggregate;
  /** fetch data from the table: "city_trivia_question" */
  city_trivia_question: Array<City_Trivia_Question>;
  /** fetch aggregated fields from the table: "city_trivia_question" */
  city_trivia_question_aggregate: City_Trivia_Question_Aggregate;
  /** fetch data from the table: "city_trivia_round" */
  city_trivia_round: Array<City_Trivia_Round>;
  /** fetch aggregated fields from the table: "city_trivia_round" */
  city_trivia_round_aggregate: City_Trivia_Round_Aggregate;
  /** fetch data from the table: "dayle_sessions" */
  dayle_sessions: Array<Dayle_Sessions>;
  /** fetch aggregated fields from the table: "dayle_sessions" */
  dayle_sessions_aggregate: Dayle_Sessions_Aggregate;
  /** fetch data from the table: "dayle_sessions" using primary key columns */
  dayle_sessions_by_pk?: Maybe<Dayle_Sessions>;
  /** fetch data from the table: "edit_log" */
  edit_log: Array<Edit_Log>;
  /** fetch aggregated fields from the table: "edit_log" */
  edit_log_aggregate: Edit_Log_Aggregate;
  /** fetch data from the table: "edit_log" using primary key columns */
  edit_log_by_pk?: Maybe<Edit_Log>;
  /** fetch data from the table: "edit_log_types" */
  edit_log_types: Array<Edit_Log_Types>;
  /** fetch aggregated fields from the table: "edit_log_types" */
  edit_log_types_aggregate: Edit_Log_Types_Aggregate;
  /** fetch data from the table: "edit_log_types" using primary key columns */
  edit_log_types_by_pk?: Maybe<Edit_Log_Types>;
  /** perform the action: "fillCtmRoundQuestions" */
  fillCtmRoundQuestions?: Maybe<Array<Maybe<FillCtmRoundQuestionsOutput>>>;
  /** perform the action: "fillFinalRoundQuestions" */
  fillFinalRoundQuestions?: Maybe<Array<Maybe<FillFinalRoundQuestionsOutput>>>;
  /** perform the action: "fillRoundQuestions" */
  fillRoundQuestions?: Maybe<Array<Maybe<FillRoundQuestionsOutput>>>;
  /** fetch data from the table: "forgot_password" */
  forgot_password: Array<Forgot_Password>;
  /** fetch aggregated fields from the table: "forgot_password" */
  forgot_password_aggregate: Forgot_Password_Aggregate;
  /** fetch data from the table: "forgot_password" using primary key columns */
  forgot_password_by_pk?: Maybe<Forgot_Password>;
  /** fetch data from the table: "game_difficulties" */
  game_difficulties: Array<Game_Difficulties>;
  /** fetch aggregated fields from the table: "game_difficulties" */
  game_difficulties_aggregate: Game_Difficulties_Aggregate;
  /** fetch data from the table: "game_difficulties" using primary key columns */
  game_difficulties_by_pk?: Maybe<Game_Difficulties>;
  /** fetch data from the table: "game_formats" */
  game_formats: Array<Game_Formats>;
  /** fetch aggregated fields from the table: "game_formats" */
  game_formats_aggregate: Game_Formats_Aggregate;
  /** fetch data from the table: "game_formats" using primary key columns */
  game_formats_by_pk?: Maybe<Game_Formats>;
  /** fetch data from the table: "game_ratings" */
  game_ratings: Array<Game_Ratings>;
  /** fetch aggregated fields from the table: "game_ratings" */
  game_ratings_aggregate: Game_Ratings_Aggregate;
  /** fetch data from the table: "game_ratings" using primary key columns */
  game_ratings_by_pk?: Maybe<Game_Ratings>;
  /** fetch data from the table: "game_status" */
  game_status: Array<Game_Status>;
  /** fetch aggregated fields from the table: "game_status" */
  game_status_aggregate: Game_Status_Aggregate;
  /** fetch data from the table: "game_status" using primary key columns */
  game_status_by_pk?: Maybe<Game_Status>;
  /** fetch data from the table: "game_themes" */
  game_themes: Array<Game_Themes>;
  /** fetch aggregated fields from the table: "game_themes" */
  game_themes_aggregate: Game_Themes_Aggregate;
  /** fetch data from the table: "game_themes" using primary key columns */
  game_themes_by_pk?: Maybe<Game_Themes>;
  /** fetch data from the table: "gen_round" */
  gen_round: Array<Gen_Round>;
  /** fetch aggregated fields from the table: "gen_round" */
  gen_round_aggregate: Gen_Round_Aggregate;
  /** fetch data from the table: "gen_round" using primary key columns */
  gen_round_by_pk?: Maybe<Gen_Round>;
  /** fetch data from the table: "gen_uuid" */
  gen_uuid: Array<Gen_Uuid>;
  /** fetch aggregated fields from the table: "gen_uuid" */
  gen_uuid_aggregate: Gen_Uuid_Aggregate;
  /** fetch data from the table: "gen_uuid" using primary key columns */
  gen_uuid_by_pk?: Maybe<Gen_Uuid>;
  /** perform the action: "generateBonusRoundQuestions" */
  generateBonusRoundQuestions?: Maybe<GenRound>;
  /** perform the action: "generateCtmRoundQuestions" */
  generateCtmRoundQuestions?: Maybe<GenRound>;
  /** perform the action: "generateCtmRoundQuestionsById" */
  generateCtmRoundQuestionsById?: Maybe<GenRound>;
  /** perform the action: "generateRound" */
  generateRound?: Maybe<GenRound>;
  /** perform the action: "generateRoundQuestions" */
  generateRoundQuestions?: Maybe<Response>;
  /** perform the action: "generateStandardRoundQuestions" */
  generateStandardRoundQuestions?: Maybe<GenRound>;
  /** perform the action: "generateTwoColumnRoundQuestions" */
  generateTwoColumnRoundQuestions?: Maybe<GenRound>;
  /** perform the action: "generateWarfareRoundQuestions" */
  generateWarfareRoundQuestions?: Maybe<GenRound>;
  /** fetch data from the table: "markets" */
  markets: Array<Markets>;
  /** fetch aggregated fields from the table: "markets" */
  markets_aggregate: Markets_Aggregate;
  /** fetch data from the table: "markets" using primary key columns */
  markets_by_pk?: Maybe<Markets>;
  /** fetch data from the table: "question_bonuses" */
  question_bonuses: Array<Question_Bonuses>;
  /** fetch aggregated fields from the table: "question_bonuses" */
  question_bonuses_aggregate: Question_Bonuses_Aggregate;
  /** fetch data from the table: "question_bonuses" using primary key columns */
  question_bonuses_by_pk?: Maybe<Question_Bonuses>;
  /** fetch data from the table: "question_difficulties" */
  question_difficulties: Array<Question_Difficulties>;
  /** fetch aggregated fields from the table: "question_difficulties" */
  question_difficulties_aggregate: Question_Difficulties_Aggregate;
  /** fetch data from the table: "question_difficulties" using primary key columns */
  question_difficulties_by_pk?: Maybe<Question_Difficulties>;
  /** fetch data from the table: "question_languages" */
  question_languages: Array<Question_Languages>;
  /** fetch aggregated fields from the table: "question_languages" */
  question_languages_aggregate: Question_Languages_Aggregate;
  /** fetch data from the table: "question_languages" using primary key columns */
  question_languages_by_pk?: Maybe<Question_Languages>;
  /** fetch data from the table: "question_ratings" */
  question_ratings: Array<Question_Ratings>;
  /** fetch aggregated fields from the table: "question_ratings" */
  question_ratings_aggregate: Question_Ratings_Aggregate;
  /** fetch data from the table: "question_ratings" using primary key columns */
  question_ratings_by_pk?: Maybe<Question_Ratings>;
  /** fetch data from the table: "question_status" */
  question_status: Array<Question_Status>;
  /** fetch aggregated fields from the table: "question_status" */
  question_status_aggregate: Question_Status_Aggregate;
  /** fetch data from the table: "question_status" using primary key columns */
  question_status_by_pk?: Maybe<Question_Status>;
  /** fetch data from the table: "question_tags" */
  question_tags: Array<Question_Tags>;
  /** fetch aggregated fields from the table: "question_tags" */
  question_tags_aggregate: Question_Tags_Aggregate;
  /** fetch data from the table: "question_tags_by_count" */
  question_tags_by_count: Array<Question_Tags_By_Count>;
  /** fetch aggregated fields from the table: "question_tags_by_count" */
  question_tags_by_count_aggregate: Question_Tags_By_Count_Aggregate;
  /** fetch data from the table: "question_tags" using primary key columns */
  question_tags_by_pk?: Maybe<Question_Tags>;
  /** fetch data from the table: "question_texts_similarities" */
  question_texts_similarities: Array<Question_Texts_Similarities>;
  /** fetch aggregated fields from the table: "question_texts_similarities" */
  question_texts_similarities_aggregate: Question_Texts_Similarities_Aggregate;
  /** fetch data from the table: "question_texts_similarities" using primary key columns */
  question_texts_similarities_by_pk?: Maybe<Question_Texts_Similarities>;
  /** fetch data from the table: "question_types" */
  question_types: Array<Question_Types>;
  /** fetch aggregated fields from the table: "question_types" */
  question_types_aggregate: Question_Types_Aggregate;
  /** fetch data from the table: "question_types" using primary key columns */
  question_types_by_pk?: Maybe<Question_Types>;
  /** fetch data from the table: "questions" */
  questions: Array<Questions>;
  /** fetch aggregated fields from the table: "questions" */
  questions_aggregate: Questions_Aggregate;
  /** fetch data from the table: "questions" using primary key columns */
  questions_by_pk?: Maybe<Questions>;
  /** fetch data from the table: "rejection_reasons" */
  rejection_reasons: Array<Rejection_Reasons>;
  /** fetch aggregated fields from the table: "rejection_reasons" */
  rejection_reasons_aggregate: Rejection_Reasons_Aggregate;
  /** fetch data from the table: "rejection_reasons" using primary key columns */
  rejection_reasons_by_pk?: Maybe<Rejection_Reasons>;
  /** fetch data from the table: "report_reasons" */
  report_reasons: Array<Report_Reasons>;
  /** fetch aggregated fields from the table: "report_reasons" */
  report_reasons_aggregate: Report_Reasons_Aggregate;
  /** fetch data from the table: "report_reasons" using primary key columns */
  report_reasons_by_pk?: Maybe<Report_Reasons>;
  /** fetch data from the table: "reports" */
  reports: Array<Reports>;
  /** fetch aggregated fields from the table: "reports" */
  reports_aggregate: Reports_Aggregate;
  /** fetch data from the table: "reports" using primary key columns */
  reports_by_pk?: Maybe<Reports>;
  /** fetch data from the table: "rounds" */
  rounds: Array<Rounds>;
  /** fetch aggregated fields from the table: "rounds" */
  rounds_aggregate: Rounds_Aggregate;
  /** fetch data from the table: "rounds" using primary key columns */
  rounds_by_pk?: Maybe<Rounds>;
  /** execute function "search_question_text" which returns "question_texts_similarities" */
  search_question_text: Array<Question_Texts_Similarities>;
  /** execute function "search_question_text" and query aggregates on result of table type "question_texts_similarities" */
  search_question_text_aggregate: Question_Texts_Similarities_Aggregate;
  /** fetch data from the table: "settings" */
  settings: Array<Settings>;
  /** fetch aggregated fields from the table: "settings" */
  settings_aggregate: Settings_Aggregate;
  /** fetch data from the table: "settings" using primary key columns */
  settings_by_pk?: Maybe<Settings>;
  /** fetch data from the table: "sponsor_questions" */
  sponsor_questions: Array<Sponsor_Questions>;
  /** fetch aggregated fields from the table: "sponsor_questions" */
  sponsor_questions_aggregate: Sponsor_Questions_Aggregate;
  /** fetch data from the table: "sponsor_questions" using primary key columns */
  sponsor_questions_by_pk?: Maybe<Sponsor_Questions>;
  /** fetch data from the table: "sponsors" */
  sponsors: Array<Sponsors>;
  /** fetch aggregated fields from the table: "sponsors" */
  sponsors_aggregate: Sponsors_Aggregate;
  /** fetch data from the table: "sponsors" using primary key columns */
  sponsors_by_pk?: Maybe<Sponsors>;
  /** fetch data from the table: "test_sm" */
  test_sm: Array<Test_Sm>;
  /** fetch aggregated fields from the table: "test_sm" */
  test_sm_aggregate: Test_Sm_Aggregate;
  /** perform the action: "triviaGameRoundDelete" */
  triviaGameRoundDelete?: Maybe<Response>;
  /** fetch data from the table: "trivia_event_types" */
  trivia_event_types: Array<Trivia_Event_Types>;
  /** fetch aggregated fields from the table: "trivia_event_types" */
  trivia_event_types_aggregate: Trivia_Event_Types_Aggregate;
  /** fetch data from the table: "trivia_event_types" using primary key columns */
  trivia_event_types_by_pk?: Maybe<Trivia_Event_Types>;
  /** fetch data from the table: "trivia_events" */
  trivia_events: Array<Trivia_Events>;
  /** fetch aggregated fields from the table: "trivia_events" */
  trivia_events_aggregate: Trivia_Events_Aggregate;
  /** fetch data from the table: "trivia_events" using primary key columns */
  trivia_events_by_pk?: Maybe<Trivia_Events>;
  /** fetch data from the table: "trivia_game_category" */
  trivia_game_category: Array<Trivia_Game_Category>;
  /** fetch aggregated fields from the table: "trivia_game_category" */
  trivia_game_category_aggregate: Trivia_Game_Category_Aggregate;
  /** fetch data from the table: "trivia_game_category" using primary key columns */
  trivia_game_category_by_pk?: Maybe<Trivia_Game_Category>;
  /** fetch data from the table: "trivia_game_rounds" */
  trivia_game_rounds: Array<Trivia_Game_Rounds>;
  /** fetch aggregated fields from the table: "trivia_game_rounds" */
  trivia_game_rounds_aggregate: Trivia_Game_Rounds_Aggregate;
  /** fetch data from the table: "trivia_game_rounds" using primary key columns */
  trivia_game_rounds_by_pk?: Maybe<Trivia_Game_Rounds>;
  /** fetch data from the table: "trivia_game_templates" */
  trivia_game_templates: Array<Trivia_Game_Templates>;
  /** fetch aggregated fields from the table: "trivia_game_templates" */
  trivia_game_templates_aggregate: Trivia_Game_Templates_Aggregate;
  /** fetch data from the table: "trivia_game_templates" using primary key columns */
  trivia_game_templates_by_pk?: Maybe<Trivia_Game_Templates>;
  /** fetch data from the table: "trivia_game_themes" */
  trivia_game_themes: Array<Trivia_Game_Themes>;
  /** fetch aggregated fields from the table: "trivia_game_themes" */
  trivia_game_themes_aggregate: Trivia_Game_Themes_Aggregate;
  /** fetch data from the table: "trivia_game_themes" using primary key columns */
  trivia_game_themes_by_pk?: Maybe<Trivia_Game_Themes>;
  /** fetch data from the table: "trivia_games" */
  trivia_games: Array<Trivia_Games>;
  /** fetch aggregated fields from the table: "trivia_games" */
  trivia_games_aggregate: Trivia_Games_Aggregate;
  /** fetch data from the table: "trivia_games" using primary key columns */
  trivia_games_by_pk?: Maybe<Trivia_Games>;
  /** fetch data from the table: "trivia_question" */
  trivia_question: Array<Trivia_Question>;
  /** fetch aggregated fields from the table: "trivia_question" */
  trivia_question_aggregate: Trivia_Question_Aggregate;
  /** fetch data from the table: "trivia_round_questions" */
  trivia_round_questions: Array<Trivia_Round_Questions>;
  /** fetch aggregated fields from the table: "trivia_round_questions" */
  trivia_round_questions_aggregate: Trivia_Round_Questions_Aggregate;
  /** fetch data from the table: "trivia_round_questions" using primary key columns */
  trivia_round_questions_by_pk?: Maybe<Trivia_Round_Questions>;
  /** fetch data from the table: "trivia_round_templates" */
  trivia_round_templates: Array<Trivia_Round_Templates>;
  /** fetch aggregated fields from the table: "trivia_round_templates" */
  trivia_round_templates_aggregate: Trivia_Round_Templates_Aggregate;
  /** fetch data from the table: "trivia_round_templates" using primary key columns */
  trivia_round_templates_by_pk?: Maybe<Trivia_Round_Templates>;
  /** fetch data from the table: "trivia_round_themes" */
  trivia_round_themes: Array<Trivia_Round_Themes>;
  /** fetch aggregated fields from the table: "trivia_round_themes" */
  trivia_round_themes_aggregate: Trivia_Round_Themes_Aggregate;
  /** fetch data from the table: "trivia_round_themes" using primary key columns */
  trivia_round_themes_by_pk?: Maybe<Trivia_Round_Themes>;
  /** fetch data from the table: "trivia_round_types" */
  trivia_round_types: Array<Trivia_Round_Types>;
  /** fetch aggregated fields from the table: "trivia_round_types" */
  trivia_round_types_aggregate: Trivia_Round_Types_Aggregate;
  /** fetch data from the table: "trivia_round_types" using primary key columns */
  trivia_round_types_by_pk?: Maybe<Trivia_Round_Types>;
  /** fetch data from the table: "trivia_rounds" */
  trivia_rounds: Array<Trivia_Rounds>;
  /** fetch aggregated fields from the table: "trivia_rounds" */
  trivia_rounds_aggregate: Trivia_Rounds_Aggregate;
  /** fetch data from the table: "trivia_rounds" using primary key columns */
  trivia_rounds_by_pk?: Maybe<Trivia_Rounds>;
  /** fetch data from the table: "trivia_users" */
  trivia_users: Array<Trivia_Users>;
  /** fetch aggregated fields from the table: "trivia_users" */
  trivia_users_aggregate: Trivia_Users_Aggregate;
  /** fetch data from the table: "trivia_users" using primary key columns */
  trivia_users_by_pk?: Maybe<Trivia_Users>;
  /** fetch data from the table: "user_types" */
  user_types: Array<User_Types>;
  /** fetch aggregated fields from the table: "user_types" */
  user_types_aggregate: User_Types_Aggregate;
  /** fetch data from the table: "user_types" using primary key columns */
  user_types_by_pk?: Maybe<User_Types>;
};


/** subscription root */
export type Subscription_Root_Generate_Bonus_RoundArgs = {
  args: _Generate_Bonus_Round_Args;
  distinct_on?: InputMaybe<Array<Gen_Round_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Gen_Round_Order_By>>;
  where?: InputMaybe<Gen_Round_Bool_Exp>;
};


/** subscription root */
export type Subscription_Root_Generate_Bonus_Round_AggregateArgs = {
  args: _Generate_Bonus_Round_Args;
  distinct_on?: InputMaybe<Array<Gen_Round_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Gen_Round_Order_By>>;
  where?: InputMaybe<Gen_Round_Bool_Exp>;
};


/** subscription root */
export type Subscription_Root_Generate_Ctm_RoundArgs = {
  args: _Generate_Ctm_Round_Args;
  distinct_on?: InputMaybe<Array<Gen_Round_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Gen_Round_Order_By>>;
  where?: InputMaybe<Gen_Round_Bool_Exp>;
};


/** subscription root */
export type Subscription_Root_Generate_Ctm_Round_AggregateArgs = {
  args: _Generate_Ctm_Round_Args;
  distinct_on?: InputMaybe<Array<Gen_Round_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Gen_Round_Order_By>>;
  where?: InputMaybe<Gen_Round_Bool_Exp>;
};


/** subscription root */
export type Subscription_Root_Generate_Default_Final_RoundArgs = {
  args: _Generate_Default_Final_Round_Args;
  distinct_on?: InputMaybe<Array<Gen_Round_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Gen_Round_Order_By>>;
  where?: InputMaybe<Gen_Round_Bool_Exp>;
};


/** subscription root */
export type Subscription_Root_Generate_Default_Final_Round_AggregateArgs = {
  args: _Generate_Default_Final_Round_Args;
  distinct_on?: InputMaybe<Array<Gen_Round_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Gen_Round_Order_By>>;
  where?: InputMaybe<Gen_Round_Bool_Exp>;
};


/** subscription root */
export type Subscription_Root_Generate_Default_RoundArgs = {
  args: _Generate_Default_Round_Args;
  distinct_on?: InputMaybe<Array<Gen_Round_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Gen_Round_Order_By>>;
  where?: InputMaybe<Gen_Round_Bool_Exp>;
};


/** subscription root */
export type Subscription_Root_Generate_Default_Round_AggregateArgs = {
  args: _Generate_Default_Round_Args;
  distinct_on?: InputMaybe<Array<Gen_Round_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Gen_Round_Order_By>>;
  where?: InputMaybe<Gen_Round_Bool_Exp>;
};


/** subscription root */
export type Subscription_Root_Get_Random_Question_For_RoundArgs = {
  args: _Get_Random_Question_For_Round_Args;
  distinct_on?: InputMaybe<Array<Questions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Questions_Order_By>>;
  where?: InputMaybe<Questions_Bool_Exp>;
};


/** subscription root */
export type Subscription_Root_Get_Random_Question_For_Round_AggregateArgs = {
  args: _Get_Random_Question_For_Round_Args;
  distinct_on?: InputMaybe<Array<Questions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Questions_Order_By>>;
  where?: InputMaybe<Questions_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootAnswer_TypesArgs = {
  distinct_on?: InputMaybe<Array<Answer_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Answer_Types_Order_By>>;
  where?: InputMaybe<Answer_Types_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootAnswer_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Answer_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Answer_Types_Order_By>>;
  where?: InputMaybe<Answer_Types_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootAnswer_Types_By_PkArgs = {
  answer_type_id: Scalars['Int'];
};


/** subscription root */
export type Subscription_RootCategoriesArgs = {
  distinct_on?: InputMaybe<Array<Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Categories_Order_By>>;
  where?: InputMaybe<Categories_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootCategories_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Categories_Order_By>>;
  where?: InputMaybe<Categories_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootCategories_By_PkArgs = {
  category_id: Scalars['uuid'];
};


/** subscription root */
export type Subscription_RootCity_Edit_LogArgs = {
  distinct_on?: InputMaybe<Array<City_Edit_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<City_Edit_Log_Order_By>>;
  where?: InputMaybe<City_Edit_Log_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootCity_Edit_Log_AggregateArgs = {
  distinct_on?: InputMaybe<Array<City_Edit_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<City_Edit_Log_Order_By>>;
  where?: InputMaybe<City_Edit_Log_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootCity_TqsArgs = {
  distinct_on?: InputMaybe<Array<City_Tqs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<City_Tqs_Order_By>>;
  where?: InputMaybe<City_Tqs_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootCity_Tqs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<City_Tqs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<City_Tqs_Order_By>>;
  where?: InputMaybe<City_Tqs_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootCity_Trivia_CategoryArgs = {
  distinct_on?: InputMaybe<Array<City_Trivia_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<City_Trivia_Category_Order_By>>;
  where?: InputMaybe<City_Trivia_Category_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootCity_Trivia_Category_AggregateArgs = {
  distinct_on?: InputMaybe<Array<City_Trivia_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<City_Trivia_Category_Order_By>>;
  where?: InputMaybe<City_Trivia_Category_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootCity_Trivia_QuestionArgs = {
  distinct_on?: InputMaybe<Array<City_Trivia_Question_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<City_Trivia_Question_Order_By>>;
  where?: InputMaybe<City_Trivia_Question_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootCity_Trivia_Question_AggregateArgs = {
  distinct_on?: InputMaybe<Array<City_Trivia_Question_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<City_Trivia_Question_Order_By>>;
  where?: InputMaybe<City_Trivia_Question_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootCity_Trivia_RoundArgs = {
  distinct_on?: InputMaybe<Array<City_Trivia_Round_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<City_Trivia_Round_Order_By>>;
  where?: InputMaybe<City_Trivia_Round_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootCity_Trivia_Round_AggregateArgs = {
  distinct_on?: InputMaybe<Array<City_Trivia_Round_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<City_Trivia_Round_Order_By>>;
  where?: InputMaybe<City_Trivia_Round_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootDayle_SessionsArgs = {
  distinct_on?: InputMaybe<Array<Dayle_Sessions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Dayle_Sessions_Order_By>>;
  where?: InputMaybe<Dayle_Sessions_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootDayle_Sessions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Dayle_Sessions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Dayle_Sessions_Order_By>>;
  where?: InputMaybe<Dayle_Sessions_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootDayle_Sessions_By_PkArgs = {
  dayle_session_id: Scalars['Int'];
};


/** subscription root */
export type Subscription_RootEdit_LogArgs = {
  distinct_on?: InputMaybe<Array<Edit_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Edit_Log_Order_By>>;
  where?: InputMaybe<Edit_Log_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootEdit_Log_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Edit_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Edit_Log_Order_By>>;
  where?: InputMaybe<Edit_Log_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootEdit_Log_By_PkArgs = {
  edit_log_id: Scalars['uuid'];
};


/** subscription root */
export type Subscription_RootEdit_Log_TypesArgs = {
  distinct_on?: InputMaybe<Array<Edit_Log_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Edit_Log_Types_Order_By>>;
  where?: InputMaybe<Edit_Log_Types_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootEdit_Log_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Edit_Log_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Edit_Log_Types_Order_By>>;
  where?: InputMaybe<Edit_Log_Types_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootEdit_Log_Types_By_PkArgs = {
  edit_log_type_id: Scalars['Int'];
};


/** subscription root */
export type Subscription_RootFillCtmRoundQuestionsArgs = {
  args: FillCtmRoundQuestionsInput;
};


/** subscription root */
export type Subscription_RootFillFinalRoundQuestionsArgs = {
  args: FillRoundQuestionsInput;
};


/** subscription root */
export type Subscription_RootFillRoundQuestionsArgs = {
  args: FillRoundQuestionsByTypeInput;
};


/** subscription root */
export type Subscription_RootForgot_PasswordArgs = {
  distinct_on?: InputMaybe<Array<Forgot_Password_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Forgot_Password_Order_By>>;
  where?: InputMaybe<Forgot_Password_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootForgot_Password_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Forgot_Password_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Forgot_Password_Order_By>>;
  where?: InputMaybe<Forgot_Password_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootForgot_Password_By_PkArgs = {
  forgot_password_id: Scalars['uuid'];
};


/** subscription root */
export type Subscription_RootGame_DifficultiesArgs = {
  distinct_on?: InputMaybe<Array<Game_Difficulties_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Game_Difficulties_Order_By>>;
  where?: InputMaybe<Game_Difficulties_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootGame_Difficulties_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Game_Difficulties_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Game_Difficulties_Order_By>>;
  where?: InputMaybe<Game_Difficulties_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootGame_Difficulties_By_PkArgs = {
  game_difficult_id: Scalars['Int'];
};


/** subscription root */
export type Subscription_RootGame_FormatsArgs = {
  distinct_on?: InputMaybe<Array<Game_Formats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Game_Formats_Order_By>>;
  where?: InputMaybe<Game_Formats_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootGame_Formats_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Game_Formats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Game_Formats_Order_By>>;
  where?: InputMaybe<Game_Formats_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootGame_Formats_By_PkArgs = {
  game_format_id: Scalars['Int'];
};


/** subscription root */
export type Subscription_RootGame_RatingsArgs = {
  distinct_on?: InputMaybe<Array<Game_Ratings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Game_Ratings_Order_By>>;
  where?: InputMaybe<Game_Ratings_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootGame_Ratings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Game_Ratings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Game_Ratings_Order_By>>;
  where?: InputMaybe<Game_Ratings_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootGame_Ratings_By_PkArgs = {
  id: Scalars['String'];
};


/** subscription root */
export type Subscription_RootGame_StatusArgs = {
  distinct_on?: InputMaybe<Array<Game_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Game_Status_Order_By>>;
  where?: InputMaybe<Game_Status_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootGame_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Game_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Game_Status_Order_By>>;
  where?: InputMaybe<Game_Status_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootGame_Status_By_PkArgs = {
  id: Scalars['Int'];
};


/** subscription root */
export type Subscription_RootGame_ThemesArgs = {
  distinct_on?: InputMaybe<Array<Game_Themes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Game_Themes_Order_By>>;
  where?: InputMaybe<Game_Themes_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootGame_Themes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Game_Themes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Game_Themes_Order_By>>;
  where?: InputMaybe<Game_Themes_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootGame_Themes_By_PkArgs = {
  id: Scalars['uuid'];
};


/** subscription root */
export type Subscription_RootGen_RoundArgs = {
  distinct_on?: InputMaybe<Array<Gen_Round_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Gen_Round_Order_By>>;
  where?: InputMaybe<Gen_Round_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootGen_Round_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Gen_Round_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Gen_Round_Order_By>>;
  where?: InputMaybe<Gen_Round_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootGen_Round_By_PkArgs = {
  id: Scalars['uuid'];
};


/** subscription root */
export type Subscription_RootGen_UuidArgs = {
  distinct_on?: InputMaybe<Array<Gen_Uuid_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Gen_Uuid_Order_By>>;
  where?: InputMaybe<Gen_Uuid_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootGen_Uuid_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Gen_Uuid_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Gen_Uuid_Order_By>>;
  where?: InputMaybe<Gen_Uuid_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootGen_Uuid_By_PkArgs = {
  id: Scalars['uuid'];
};


/** subscription root */
export type Subscription_RootGenerateBonusRoundQuestionsArgs = {
  args?: InputMaybe<GenRoundId>;
};


/** subscription root */
export type Subscription_RootGenerateCtmRoundQuestionsArgs = {
  args?: InputMaybe<GenRoundId>;
};


/** subscription root */
export type Subscription_RootGenerateCtmRoundQuestionsByIdArgs = {
  args?: InputMaybe<GenRoundId>;
};


/** subscription root */
export type Subscription_RootGenerateRoundArgs = {
  args?: InputMaybe<GenRound_>;
};


/** subscription root */
export type Subscription_RootGenerateRoundQuestionsArgs = {
  args?: InputMaybe<GenRoundQuestions>;
};


/** subscription root */
export type Subscription_RootGenerateStandardRoundQuestionsArgs = {
  args?: InputMaybe<GenRoundId>;
};


/** subscription root */
export type Subscription_RootGenerateTwoColumnRoundQuestionsArgs = {
  args?: InputMaybe<GenRoundId>;
};


/** subscription root */
export type Subscription_RootGenerateWarfareRoundQuestionsArgs = {
  args?: InputMaybe<GenWarfareRoundId>;
};


/** subscription root */
export type Subscription_RootMarketsArgs = {
  distinct_on?: InputMaybe<Array<Markets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Markets_Order_By>>;
  where?: InputMaybe<Markets_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootMarkets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Markets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Markets_Order_By>>;
  where?: InputMaybe<Markets_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootMarkets_By_PkArgs = {
  market_id: Scalars['String'];
};


/** subscription root */
export type Subscription_RootQuestion_BonusesArgs = {
  distinct_on?: InputMaybe<Array<Question_Bonuses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Question_Bonuses_Order_By>>;
  where?: InputMaybe<Question_Bonuses_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootQuestion_Bonuses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Question_Bonuses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Question_Bonuses_Order_By>>;
  where?: InputMaybe<Question_Bonuses_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootQuestion_Bonuses_By_PkArgs = {
  question_bonus_id: Scalars['Int'];
};


/** subscription root */
export type Subscription_RootQuestion_DifficultiesArgs = {
  distinct_on?: InputMaybe<Array<Question_Difficulties_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Question_Difficulties_Order_By>>;
  where?: InputMaybe<Question_Difficulties_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootQuestion_Difficulties_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Question_Difficulties_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Question_Difficulties_Order_By>>;
  where?: InputMaybe<Question_Difficulties_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootQuestion_Difficulties_By_PkArgs = {
  question_difficulty_id: Scalars['Int'];
};


/** subscription root */
export type Subscription_RootQuestion_LanguagesArgs = {
  distinct_on?: InputMaybe<Array<Question_Languages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Question_Languages_Order_By>>;
  where?: InputMaybe<Question_Languages_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootQuestion_Languages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Question_Languages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Question_Languages_Order_By>>;
  where?: InputMaybe<Question_Languages_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootQuestion_Languages_By_PkArgs = {
  market_id: Scalars['String'];
  question_id: Scalars['uuid'];
};


/** subscription root */
export type Subscription_RootQuestion_RatingsArgs = {
  distinct_on?: InputMaybe<Array<Question_Ratings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Question_Ratings_Order_By>>;
  where?: InputMaybe<Question_Ratings_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootQuestion_Ratings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Question_Ratings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Question_Ratings_Order_By>>;
  where?: InputMaybe<Question_Ratings_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootQuestion_Ratings_By_PkArgs = {
  id: Scalars['Int'];
};


/** subscription root */
export type Subscription_RootQuestion_StatusArgs = {
  distinct_on?: InputMaybe<Array<Question_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Question_Status_Order_By>>;
  where?: InputMaybe<Question_Status_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootQuestion_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Question_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Question_Status_Order_By>>;
  where?: InputMaybe<Question_Status_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootQuestion_Status_By_PkArgs = {
  question_status_id: Scalars['Int'];
};


/** subscription root */
export type Subscription_RootQuestion_TagsArgs = {
  distinct_on?: InputMaybe<Array<Question_Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Question_Tags_Order_By>>;
  where?: InputMaybe<Question_Tags_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootQuestion_Tags_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Question_Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Question_Tags_Order_By>>;
  where?: InputMaybe<Question_Tags_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootQuestion_Tags_By_CountArgs = {
  distinct_on?: InputMaybe<Array<Question_Tags_By_Count_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Question_Tags_By_Count_Order_By>>;
  where?: InputMaybe<Question_Tags_By_Count_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootQuestion_Tags_By_Count_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Question_Tags_By_Count_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Question_Tags_By_Count_Order_By>>;
  where?: InputMaybe<Question_Tags_By_Count_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootQuestion_Tags_By_PkArgs = {
  question_id: Scalars['uuid'];
  tag: Scalars['String'];
};


/** subscription root */
export type Subscription_RootQuestion_Texts_SimilaritiesArgs = {
  distinct_on?: InputMaybe<Array<Question_Texts_Similarities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Question_Texts_Similarities_Order_By>>;
  where?: InputMaybe<Question_Texts_Similarities_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootQuestion_Texts_Similarities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Question_Texts_Similarities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Question_Texts_Similarities_Order_By>>;
  where?: InputMaybe<Question_Texts_Similarities_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootQuestion_Texts_Similarities_By_PkArgs = {
  question_text: Scalars['String'];
  sim: Scalars['Float'];
};


/** subscription root */
export type Subscription_RootQuestion_TypesArgs = {
  distinct_on?: InputMaybe<Array<Question_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Question_Types_Order_By>>;
  where?: InputMaybe<Question_Types_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootQuestion_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Question_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Question_Types_Order_By>>;
  where?: InputMaybe<Question_Types_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootQuestion_Types_By_PkArgs = {
  question_type_id: Scalars['Int'];
};


/** subscription root */
export type Subscription_RootQuestionsArgs = {
  distinct_on?: InputMaybe<Array<Questions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Questions_Order_By>>;
  where?: InputMaybe<Questions_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootQuestions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Questions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Questions_Order_By>>;
  where?: InputMaybe<Questions_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootQuestions_By_PkArgs = {
  question_id: Scalars['uuid'];
};


/** subscription root */
export type Subscription_RootRejection_ReasonsArgs = {
  distinct_on?: InputMaybe<Array<Rejection_Reasons_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Rejection_Reasons_Order_By>>;
  where?: InputMaybe<Rejection_Reasons_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootRejection_Reasons_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Rejection_Reasons_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Rejection_Reasons_Order_By>>;
  where?: InputMaybe<Rejection_Reasons_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootRejection_Reasons_By_PkArgs = {
  rejection_reason_id: Scalars['Int'];
};


/** subscription root */
export type Subscription_RootReport_ReasonsArgs = {
  distinct_on?: InputMaybe<Array<Report_Reasons_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Report_Reasons_Order_By>>;
  where?: InputMaybe<Report_Reasons_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootReport_Reasons_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Report_Reasons_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Report_Reasons_Order_By>>;
  where?: InputMaybe<Report_Reasons_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootReport_Reasons_By_PkArgs = {
  report_reason_id: Scalars['Int'];
};


/** subscription root */
export type Subscription_RootReportsArgs = {
  distinct_on?: InputMaybe<Array<Reports_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Reports_Order_By>>;
  where?: InputMaybe<Reports_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootReports_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Reports_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Reports_Order_By>>;
  where?: InputMaybe<Reports_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootReports_By_PkArgs = {
  report_id: Scalars['uuid'];
};


/** subscription root */
export type Subscription_RootRoundsArgs = {
  distinct_on?: InputMaybe<Array<Rounds_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Rounds_Order_By>>;
  where?: InputMaybe<Rounds_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootRounds_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Rounds_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Rounds_Order_By>>;
  where?: InputMaybe<Rounds_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootRounds_By_PkArgs = {
  round_id: Scalars['uuid'];
};


/** subscription root */
export type Subscription_RootSearch_Question_TextArgs = {
  args: Search_Question_Text_Args;
  distinct_on?: InputMaybe<Array<Question_Texts_Similarities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Question_Texts_Similarities_Order_By>>;
  where?: InputMaybe<Question_Texts_Similarities_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootSearch_Question_Text_AggregateArgs = {
  args: Search_Question_Text_Args;
  distinct_on?: InputMaybe<Array<Question_Texts_Similarities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Question_Texts_Similarities_Order_By>>;
  where?: InputMaybe<Question_Texts_Similarities_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootSettingsArgs = {
  distinct_on?: InputMaybe<Array<Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Settings_Order_By>>;
  where?: InputMaybe<Settings_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootSettings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Settings_Order_By>>;
  where?: InputMaybe<Settings_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootSettings_By_PkArgs = {
  setting_name: Scalars['String'];
};


/** subscription root */
export type Subscription_RootSponsor_QuestionsArgs = {
  distinct_on?: InputMaybe<Array<Sponsor_Questions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sponsor_Questions_Order_By>>;
  where?: InputMaybe<Sponsor_Questions_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootSponsor_Questions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sponsor_Questions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sponsor_Questions_Order_By>>;
  where?: InputMaybe<Sponsor_Questions_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootSponsor_Questions_By_PkArgs = {
  question_id: Scalars['uuid'];
  sponsor_id: Scalars['uuid'];
};


/** subscription root */
export type Subscription_RootSponsorsArgs = {
  distinct_on?: InputMaybe<Array<Sponsors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sponsors_Order_By>>;
  where?: InputMaybe<Sponsors_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootSponsors_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sponsors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sponsors_Order_By>>;
  where?: InputMaybe<Sponsors_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootSponsors_By_PkArgs = {
  sponsor_id: Scalars['uuid'];
};


/** subscription root */
export type Subscription_RootTest_SmArgs = {
  distinct_on?: InputMaybe<Array<Test_Sm_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Test_Sm_Order_By>>;
  where?: InputMaybe<Test_Sm_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootTest_Sm_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Test_Sm_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Test_Sm_Order_By>>;
  where?: InputMaybe<Test_Sm_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootTriviaGameRoundDeleteArgs = {
  args?: InputMaybe<GenRoundId>;
};


/** subscription root */
export type Subscription_RootTrivia_Event_TypesArgs = {
  distinct_on?: InputMaybe<Array<Trivia_Event_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trivia_Event_Types_Order_By>>;
  where?: InputMaybe<Trivia_Event_Types_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootTrivia_Event_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trivia_Event_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trivia_Event_Types_Order_By>>;
  where?: InputMaybe<Trivia_Event_Types_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootTrivia_Event_Types_By_PkArgs = {
  event_type_id: Scalars['Int'];
};


/** subscription root */
export type Subscription_RootTrivia_EventsArgs = {
  distinct_on?: InputMaybe<Array<Trivia_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trivia_Events_Order_By>>;
  where?: InputMaybe<Trivia_Events_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootTrivia_Events_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trivia_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trivia_Events_Order_By>>;
  where?: InputMaybe<Trivia_Events_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootTrivia_Events_By_PkArgs = {
  event_id: Scalars['uuid'];
};


/** subscription root */
export type Subscription_RootTrivia_Game_CategoryArgs = {
  distinct_on?: InputMaybe<Array<Trivia_Game_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trivia_Game_Category_Order_By>>;
  where?: InputMaybe<Trivia_Game_Category_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootTrivia_Game_Category_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trivia_Game_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trivia_Game_Category_Order_By>>;
  where?: InputMaybe<Trivia_Game_Category_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootTrivia_Game_Category_By_PkArgs = {
  id: Scalars['Int'];
};


/** subscription root */
export type Subscription_RootTrivia_Game_RoundsArgs = {
  distinct_on?: InputMaybe<Array<Trivia_Game_Rounds_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trivia_Game_Rounds_Order_By>>;
  where?: InputMaybe<Trivia_Game_Rounds_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootTrivia_Game_Rounds_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trivia_Game_Rounds_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trivia_Game_Rounds_Order_By>>;
  where?: InputMaybe<Trivia_Game_Rounds_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootTrivia_Game_Rounds_By_PkArgs = {
  id: Scalars['uuid'];
};


/** subscription root */
export type Subscription_RootTrivia_Game_TemplatesArgs = {
  distinct_on?: InputMaybe<Array<Trivia_Game_Templates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trivia_Game_Templates_Order_By>>;
  where?: InputMaybe<Trivia_Game_Templates_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootTrivia_Game_Templates_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trivia_Game_Templates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trivia_Game_Templates_Order_By>>;
  where?: InputMaybe<Trivia_Game_Templates_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootTrivia_Game_Templates_By_PkArgs = {
  template_id: Scalars['String'];
};


/** subscription root */
export type Subscription_RootTrivia_Game_ThemesArgs = {
  distinct_on?: InputMaybe<Array<Trivia_Game_Themes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trivia_Game_Themes_Order_By>>;
  where?: InputMaybe<Trivia_Game_Themes_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootTrivia_Game_Themes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trivia_Game_Themes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trivia_Game_Themes_Order_By>>;
  where?: InputMaybe<Trivia_Game_Themes_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootTrivia_Game_Themes_By_PkArgs = {
  game_theme_id: Scalars['uuid'];
};


/** subscription root */
export type Subscription_RootTrivia_GamesArgs = {
  distinct_on?: InputMaybe<Array<Trivia_Games_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trivia_Games_Order_By>>;
  where?: InputMaybe<Trivia_Games_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootTrivia_Games_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trivia_Games_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trivia_Games_Order_By>>;
  where?: InputMaybe<Trivia_Games_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootTrivia_Games_By_PkArgs = {
  game_id: Scalars['uuid'];
};


/** subscription root */
export type Subscription_RootTrivia_QuestionArgs = {
  distinct_on?: InputMaybe<Array<Trivia_Question_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trivia_Question_Order_By>>;
  where?: InputMaybe<Trivia_Question_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootTrivia_Question_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trivia_Question_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trivia_Question_Order_By>>;
  where?: InputMaybe<Trivia_Question_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootTrivia_Round_QuestionsArgs = {
  distinct_on?: InputMaybe<Array<Trivia_Round_Questions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trivia_Round_Questions_Order_By>>;
  where?: InputMaybe<Trivia_Round_Questions_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootTrivia_Round_Questions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trivia_Round_Questions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trivia_Round_Questions_Order_By>>;
  where?: InputMaybe<Trivia_Round_Questions_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootTrivia_Round_Questions_By_PkArgs = {
  id: Scalars['uuid'];
};


/** subscription root */
export type Subscription_RootTrivia_Round_TemplatesArgs = {
  distinct_on?: InputMaybe<Array<Trivia_Round_Templates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trivia_Round_Templates_Order_By>>;
  where?: InputMaybe<Trivia_Round_Templates_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootTrivia_Round_Templates_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trivia_Round_Templates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trivia_Round_Templates_Order_By>>;
  where?: InputMaybe<Trivia_Round_Templates_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootTrivia_Round_Templates_By_PkArgs = {
  template_id: Scalars['String'];
};


/** subscription root */
export type Subscription_RootTrivia_Round_ThemesArgs = {
  distinct_on?: InputMaybe<Array<Trivia_Round_Themes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trivia_Round_Themes_Order_By>>;
  where?: InputMaybe<Trivia_Round_Themes_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootTrivia_Round_Themes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trivia_Round_Themes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trivia_Round_Themes_Order_By>>;
  where?: InputMaybe<Trivia_Round_Themes_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootTrivia_Round_Themes_By_PkArgs = {
  round_theme_id: Scalars['uuid'];
};


/** subscription root */
export type Subscription_RootTrivia_Round_TypesArgs = {
  distinct_on?: InputMaybe<Array<Trivia_Round_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trivia_Round_Types_Order_By>>;
  where?: InputMaybe<Trivia_Round_Types_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootTrivia_Round_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trivia_Round_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trivia_Round_Types_Order_By>>;
  where?: InputMaybe<Trivia_Round_Types_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootTrivia_Round_Types_By_PkArgs = {
  id: Scalars['String'];
};


/** subscription root */
export type Subscription_RootTrivia_RoundsArgs = {
  distinct_on?: InputMaybe<Array<Trivia_Rounds_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trivia_Rounds_Order_By>>;
  where?: InputMaybe<Trivia_Rounds_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootTrivia_Rounds_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trivia_Rounds_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trivia_Rounds_Order_By>>;
  where?: InputMaybe<Trivia_Rounds_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootTrivia_Rounds_By_PkArgs = {
  round_id: Scalars['uuid'];
};


/** subscription root */
export type Subscription_RootTrivia_UsersArgs = {
  distinct_on?: InputMaybe<Array<Trivia_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trivia_Users_Order_By>>;
  where?: InputMaybe<Trivia_Users_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootTrivia_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trivia_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trivia_Users_Order_By>>;
  where?: InputMaybe<Trivia_Users_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootTrivia_Users_By_PkArgs = {
  trivia_user_id: Scalars['uuid'];
};


/** subscription root */
export type Subscription_RootUser_TypesArgs = {
  distinct_on?: InputMaybe<Array<User_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Types_Order_By>>;
  where?: InputMaybe<User_Types_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootUser_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Types_Order_By>>;
  where?: InputMaybe<User_Types_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootUser_Types_By_PkArgs = {
  user_type_id: Scalars['Int'];
};

/** columns and relationships of "test_sm" */
export type Test_Sm = {
  __typename?: 'test_sm';
  firstname?: Maybe<Scalars['String']>;
  question_text?: Maybe<Scalars['String']>;
  sim?: Maybe<Scalars['Float']>;
};

/** aggregated selection of "test_sm" */
export type Test_Sm_Aggregate = {
  __typename?: 'test_sm_aggregate';
  aggregate?: Maybe<Test_Sm_Aggregate_Fields>;
  nodes: Array<Test_Sm>;
};

/** aggregate fields of "test_sm" */
export type Test_Sm_Aggregate_Fields = {
  __typename?: 'test_sm_aggregate_fields';
  avg?: Maybe<Test_Sm_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Test_Sm_Max_Fields>;
  min?: Maybe<Test_Sm_Min_Fields>;
  stddev?: Maybe<Test_Sm_Stddev_Fields>;
  stddev_pop?: Maybe<Test_Sm_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Test_Sm_Stddev_Samp_Fields>;
  sum?: Maybe<Test_Sm_Sum_Fields>;
  var_pop?: Maybe<Test_Sm_Var_Pop_Fields>;
  var_samp?: Maybe<Test_Sm_Var_Samp_Fields>;
  variance?: Maybe<Test_Sm_Variance_Fields>;
};


/** aggregate fields of "test_sm" */
export type Test_Sm_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Test_Sm_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "test_sm" */
export type Test_Sm_Aggregate_Order_By = {
  avg?: InputMaybe<Test_Sm_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Test_Sm_Max_Order_By>;
  min?: InputMaybe<Test_Sm_Min_Order_By>;
  stddev?: InputMaybe<Test_Sm_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Test_Sm_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Test_Sm_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Test_Sm_Sum_Order_By>;
  var_pop?: InputMaybe<Test_Sm_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Test_Sm_Var_Samp_Order_By>;
  variance?: InputMaybe<Test_Sm_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Test_Sm_Avg_Fields = {
  __typename?: 'test_sm_avg_fields';
  sim?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "test_sm" */
export type Test_Sm_Avg_Order_By = {
  sim?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "test_sm". All fields are combined with a logical 'AND'. */
export type Test_Sm_Bool_Exp = {
  _and?: InputMaybe<Array<InputMaybe<Test_Sm_Bool_Exp>>>;
  _not?: InputMaybe<Test_Sm_Bool_Exp>;
  _or?: InputMaybe<Array<InputMaybe<Test_Sm_Bool_Exp>>>;
  firstname?: InputMaybe<String_Comparison_Exp>;
  question_text?: InputMaybe<String_Comparison_Exp>;
  sim?: InputMaybe<Float_Comparison_Exp>;
};

/** aggregate max on columns */
export type Test_Sm_Max_Fields = {
  __typename?: 'test_sm_max_fields';
  firstname?: Maybe<Scalars['String']>;
  question_text?: Maybe<Scalars['String']>;
  sim?: Maybe<Scalars['Float']>;
};

/** order by max() on columns of table "test_sm" */
export type Test_Sm_Max_Order_By = {
  firstname?: InputMaybe<Order_By>;
  question_text?: InputMaybe<Order_By>;
  sim?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Test_Sm_Min_Fields = {
  __typename?: 'test_sm_min_fields';
  firstname?: Maybe<Scalars['String']>;
  question_text?: Maybe<Scalars['String']>;
  sim?: Maybe<Scalars['Float']>;
};

/** order by min() on columns of table "test_sm" */
export type Test_Sm_Min_Order_By = {
  firstname?: InputMaybe<Order_By>;
  question_text?: InputMaybe<Order_By>;
  sim?: InputMaybe<Order_By>;
};

/** ordering options when selecting data from "test_sm" */
export type Test_Sm_Order_By = {
  firstname?: InputMaybe<Order_By>;
  question_text?: InputMaybe<Order_By>;
  sim?: InputMaybe<Order_By>;
};

/** select columns of table "test_sm" */
export enum Test_Sm_Select_Column {
  /** column name */
  Firstname = 'firstname',
  /** column name */
  QuestionText = 'question_text',
  /** column name */
  Sim = 'sim'
}

/** aggregate stddev on columns */
export type Test_Sm_Stddev_Fields = {
  __typename?: 'test_sm_stddev_fields';
  sim?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "test_sm" */
export type Test_Sm_Stddev_Order_By = {
  sim?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Test_Sm_Stddev_Pop_Fields = {
  __typename?: 'test_sm_stddev_pop_fields';
  sim?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "test_sm" */
export type Test_Sm_Stddev_Pop_Order_By = {
  sim?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Test_Sm_Stddev_Samp_Fields = {
  __typename?: 'test_sm_stddev_samp_fields';
  sim?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "test_sm" */
export type Test_Sm_Stddev_Samp_Order_By = {
  sim?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Test_Sm_Sum_Fields = {
  __typename?: 'test_sm_sum_fields';
  sim?: Maybe<Scalars['Float']>;
};

/** order by sum() on columns of table "test_sm" */
export type Test_Sm_Sum_Order_By = {
  sim?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Test_Sm_Var_Pop_Fields = {
  __typename?: 'test_sm_var_pop_fields';
  sim?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "test_sm" */
export type Test_Sm_Var_Pop_Order_By = {
  sim?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Test_Sm_Var_Samp_Fields = {
  __typename?: 'test_sm_var_samp_fields';
  sim?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "test_sm" */
export type Test_Sm_Var_Samp_Order_By = {
  sim?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Test_Sm_Variance_Fields = {
  __typename?: 'test_sm_variance_fields';
  sim?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "test_sm" */
export type Test_Sm_Variance_Order_By = {
  sim?: InputMaybe<Order_By>;
};

/** expression to compare columns of type timestamp. All fields are combined with logical 'AND'. */
export type Timestamp_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamp']>;
  _gt?: InputMaybe<Scalars['timestamp']>;
  _gte?: InputMaybe<Scalars['timestamp']>;
  _in?: InputMaybe<Array<Scalars['timestamp']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['timestamp']>;
  _lte?: InputMaybe<Scalars['timestamp']>;
  _neq?: InputMaybe<Scalars['timestamp']>;
  _nin?: InputMaybe<Array<Scalars['timestamp']>>;
};

/** expression to compare columns of type timestamptz. All fields are combined with logical 'AND'. */
export type Timestamptz_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamptz']>;
  _gt?: InputMaybe<Scalars['timestamptz']>;
  _gte?: InputMaybe<Scalars['timestamptz']>;
  _in?: InputMaybe<Array<Scalars['timestamptz']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['timestamptz']>;
  _lte?: InputMaybe<Scalars['timestamptz']>;
  _neq?: InputMaybe<Scalars['timestamptz']>;
  _nin?: InputMaybe<Array<Scalars['timestamptz']>>;
};

/** expression to compare columns of type timetz. All fields are combined with logical 'AND'. */
export type Timetz_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timetz']>;
  _gt?: InputMaybe<Scalars['timetz']>;
  _gte?: InputMaybe<Scalars['timetz']>;
  _in?: InputMaybe<Array<Scalars['timetz']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['timetz']>;
  _lte?: InputMaybe<Scalars['timetz']>;
  _neq?: InputMaybe<Scalars['timetz']>;
  _nin?: InputMaybe<Array<Scalars['timetz']>>;
};

/** columns and relationships of "trivia_event_types" */
export type Trivia_Event_Types = {
  __typename?: 'trivia_event_types';
  event_type_id: Scalars['Int'];
  event_type_name: Scalars['String'];
};

/** aggregated selection of "trivia_event_types" */
export type Trivia_Event_Types_Aggregate = {
  __typename?: 'trivia_event_types_aggregate';
  aggregate?: Maybe<Trivia_Event_Types_Aggregate_Fields>;
  nodes: Array<Trivia_Event_Types>;
};

/** aggregate fields of "trivia_event_types" */
export type Trivia_Event_Types_Aggregate_Fields = {
  __typename?: 'trivia_event_types_aggregate_fields';
  avg?: Maybe<Trivia_Event_Types_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Trivia_Event_Types_Max_Fields>;
  min?: Maybe<Trivia_Event_Types_Min_Fields>;
  stddev?: Maybe<Trivia_Event_Types_Stddev_Fields>;
  stddev_pop?: Maybe<Trivia_Event_Types_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Trivia_Event_Types_Stddev_Samp_Fields>;
  sum?: Maybe<Trivia_Event_Types_Sum_Fields>;
  var_pop?: Maybe<Trivia_Event_Types_Var_Pop_Fields>;
  var_samp?: Maybe<Trivia_Event_Types_Var_Samp_Fields>;
  variance?: Maybe<Trivia_Event_Types_Variance_Fields>;
};


/** aggregate fields of "trivia_event_types" */
export type Trivia_Event_Types_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Trivia_Event_Types_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "trivia_event_types" */
export type Trivia_Event_Types_Aggregate_Order_By = {
  avg?: InputMaybe<Trivia_Event_Types_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Trivia_Event_Types_Max_Order_By>;
  min?: InputMaybe<Trivia_Event_Types_Min_Order_By>;
  stddev?: InputMaybe<Trivia_Event_Types_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Trivia_Event_Types_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Trivia_Event_Types_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Trivia_Event_Types_Sum_Order_By>;
  var_pop?: InputMaybe<Trivia_Event_Types_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Trivia_Event_Types_Var_Samp_Order_By>;
  variance?: InputMaybe<Trivia_Event_Types_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "trivia_event_types" */
export type Trivia_Event_Types_Arr_Rel_Insert_Input = {
  data: Array<Trivia_Event_Types_Insert_Input>;
  on_conflict?: InputMaybe<Trivia_Event_Types_On_Conflict>;
};

/** aggregate avg on columns */
export type Trivia_Event_Types_Avg_Fields = {
  __typename?: 'trivia_event_types_avg_fields';
  event_type_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "trivia_event_types" */
export type Trivia_Event_Types_Avg_Order_By = {
  event_type_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "trivia_event_types". All fields are combined with a logical 'AND'. */
export type Trivia_Event_Types_Bool_Exp = {
  _and?: InputMaybe<Array<InputMaybe<Trivia_Event_Types_Bool_Exp>>>;
  _not?: InputMaybe<Trivia_Event_Types_Bool_Exp>;
  _or?: InputMaybe<Array<InputMaybe<Trivia_Event_Types_Bool_Exp>>>;
  event_type_id?: InputMaybe<Int_Comparison_Exp>;
  event_type_name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "trivia_event_types" */
export enum Trivia_Event_Types_Constraint {
  /** unique or primary key constraint */
  TriviaEventTypesPkey = 'trivia_event_types_pkey'
}

/** input type for incrementing integer column in table "trivia_event_types" */
export type Trivia_Event_Types_Inc_Input = {
  event_type_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "trivia_event_types" */
export type Trivia_Event_Types_Insert_Input = {
  event_type_id?: InputMaybe<Scalars['Int']>;
  event_type_name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Trivia_Event_Types_Max_Fields = {
  __typename?: 'trivia_event_types_max_fields';
  event_type_id?: Maybe<Scalars['Int']>;
  event_type_name?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "trivia_event_types" */
export type Trivia_Event_Types_Max_Order_By = {
  event_type_id?: InputMaybe<Order_By>;
  event_type_name?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Trivia_Event_Types_Min_Fields = {
  __typename?: 'trivia_event_types_min_fields';
  event_type_id?: Maybe<Scalars['Int']>;
  event_type_name?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "trivia_event_types" */
export type Trivia_Event_Types_Min_Order_By = {
  event_type_id?: InputMaybe<Order_By>;
  event_type_name?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "trivia_event_types" */
export type Trivia_Event_Types_Mutation_Response = {
  __typename?: 'trivia_event_types_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Trivia_Event_Types>;
};

/** input type for inserting object relation for remote table "trivia_event_types" */
export type Trivia_Event_Types_Obj_Rel_Insert_Input = {
  data: Trivia_Event_Types_Insert_Input;
  on_conflict?: InputMaybe<Trivia_Event_Types_On_Conflict>;
};

/** on conflict condition type for table "trivia_event_types" */
export type Trivia_Event_Types_On_Conflict = {
  constraint: Trivia_Event_Types_Constraint;
  update_columns: Array<Trivia_Event_Types_Update_Column>;
  where?: InputMaybe<Trivia_Event_Types_Bool_Exp>;
};

/** ordering options when selecting data from "trivia_event_types" */
export type Trivia_Event_Types_Order_By = {
  event_type_id?: InputMaybe<Order_By>;
  event_type_name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: "trivia_event_types" */
export type Trivia_Event_Types_Pk_Columns_Input = {
  event_type_id: Scalars['Int'];
};

/** select columns of table "trivia_event_types" */
export enum Trivia_Event_Types_Select_Column {
  /** column name */
  EventTypeId = 'event_type_id',
  /** column name */
  EventTypeName = 'event_type_name'
}

/** input type for updating data in table "trivia_event_types" */
export type Trivia_Event_Types_Set_Input = {
  event_type_id?: InputMaybe<Scalars['Int']>;
  event_type_name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Trivia_Event_Types_Stddev_Fields = {
  __typename?: 'trivia_event_types_stddev_fields';
  event_type_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "trivia_event_types" */
export type Trivia_Event_Types_Stddev_Order_By = {
  event_type_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Trivia_Event_Types_Stddev_Pop_Fields = {
  __typename?: 'trivia_event_types_stddev_pop_fields';
  event_type_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "trivia_event_types" */
export type Trivia_Event_Types_Stddev_Pop_Order_By = {
  event_type_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Trivia_Event_Types_Stddev_Samp_Fields = {
  __typename?: 'trivia_event_types_stddev_samp_fields';
  event_type_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "trivia_event_types" */
export type Trivia_Event_Types_Stddev_Samp_Order_By = {
  event_type_id?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Trivia_Event_Types_Sum_Fields = {
  __typename?: 'trivia_event_types_sum_fields';
  event_type_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "trivia_event_types" */
export type Trivia_Event_Types_Sum_Order_By = {
  event_type_id?: InputMaybe<Order_By>;
};

/** update columns of table "trivia_event_types" */
export enum Trivia_Event_Types_Update_Column {
  /** column name */
  EventTypeId = 'event_type_id',
  /** column name */
  EventTypeName = 'event_type_name'
}

/** aggregate var_pop on columns */
export type Trivia_Event_Types_Var_Pop_Fields = {
  __typename?: 'trivia_event_types_var_pop_fields';
  event_type_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "trivia_event_types" */
export type Trivia_Event_Types_Var_Pop_Order_By = {
  event_type_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Trivia_Event_Types_Var_Samp_Fields = {
  __typename?: 'trivia_event_types_var_samp_fields';
  event_type_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "trivia_event_types" */
export type Trivia_Event_Types_Var_Samp_Order_By = {
  event_type_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Trivia_Event_Types_Variance_Fields = {
  __typename?: 'trivia_event_types_variance_fields';
  event_type_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "trivia_event_types" */
export type Trivia_Event_Types_Variance_Order_By = {
  event_type_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "trivia_events" */
export type Trivia_Events = {
  __typename?: 'trivia_events';
  date?: Maybe<Scalars['date']>;
  event_id: Scalars['uuid'];
  event_type_id: Scalars['Int'];
  game_format_id: Scalars['Int'];
  game_id: Scalars['uuid'];
  /** An object relationship */
  trivia_event_type: Trivia_Event_Types;
  /** An object relationship */
  trivia_game: Trivia_Games;
  trivia_user_id?: Maybe<Scalars['uuid']>;
};

/** aggregated selection of "trivia_events" */
export type Trivia_Events_Aggregate = {
  __typename?: 'trivia_events_aggregate';
  aggregate?: Maybe<Trivia_Events_Aggregate_Fields>;
  nodes: Array<Trivia_Events>;
};

/** aggregate fields of "trivia_events" */
export type Trivia_Events_Aggregate_Fields = {
  __typename?: 'trivia_events_aggregate_fields';
  avg?: Maybe<Trivia_Events_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Trivia_Events_Max_Fields>;
  min?: Maybe<Trivia_Events_Min_Fields>;
  stddev?: Maybe<Trivia_Events_Stddev_Fields>;
  stddev_pop?: Maybe<Trivia_Events_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Trivia_Events_Stddev_Samp_Fields>;
  sum?: Maybe<Trivia_Events_Sum_Fields>;
  var_pop?: Maybe<Trivia_Events_Var_Pop_Fields>;
  var_samp?: Maybe<Trivia_Events_Var_Samp_Fields>;
  variance?: Maybe<Trivia_Events_Variance_Fields>;
};


/** aggregate fields of "trivia_events" */
export type Trivia_Events_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Trivia_Events_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "trivia_events" */
export type Trivia_Events_Aggregate_Order_By = {
  avg?: InputMaybe<Trivia_Events_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Trivia_Events_Max_Order_By>;
  min?: InputMaybe<Trivia_Events_Min_Order_By>;
  stddev?: InputMaybe<Trivia_Events_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Trivia_Events_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Trivia_Events_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Trivia_Events_Sum_Order_By>;
  var_pop?: InputMaybe<Trivia_Events_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Trivia_Events_Var_Samp_Order_By>;
  variance?: InputMaybe<Trivia_Events_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "trivia_events" */
export type Trivia_Events_Arr_Rel_Insert_Input = {
  data: Array<Trivia_Events_Insert_Input>;
  on_conflict?: InputMaybe<Trivia_Events_On_Conflict>;
};

/** aggregate avg on columns */
export type Trivia_Events_Avg_Fields = {
  __typename?: 'trivia_events_avg_fields';
  event_type_id?: Maybe<Scalars['Float']>;
  game_format_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "trivia_events" */
export type Trivia_Events_Avg_Order_By = {
  event_type_id?: InputMaybe<Order_By>;
  game_format_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "trivia_events". All fields are combined with a logical 'AND'. */
export type Trivia_Events_Bool_Exp = {
  _and?: InputMaybe<Array<InputMaybe<Trivia_Events_Bool_Exp>>>;
  _not?: InputMaybe<Trivia_Events_Bool_Exp>;
  _or?: InputMaybe<Array<InputMaybe<Trivia_Events_Bool_Exp>>>;
  date?: InputMaybe<Date_Comparison_Exp>;
  event_id?: InputMaybe<Uuid_Comparison_Exp>;
  event_type_id?: InputMaybe<Int_Comparison_Exp>;
  game_format_id?: InputMaybe<Int_Comparison_Exp>;
  game_id?: InputMaybe<Uuid_Comparison_Exp>;
  trivia_event_type?: InputMaybe<Trivia_Event_Types_Bool_Exp>;
  trivia_game?: InputMaybe<Trivia_Games_Bool_Exp>;
  trivia_user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "trivia_events" */
export enum Trivia_Events_Constraint {
  /** unique or primary key constraint */
  TriviaEventsPkey = 'trivia_events_pkey'
}

/** input type for incrementing integer column in table "trivia_events" */
export type Trivia_Events_Inc_Input = {
  event_type_id?: InputMaybe<Scalars['Int']>;
  game_format_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "trivia_events" */
export type Trivia_Events_Insert_Input = {
  date?: InputMaybe<Scalars['date']>;
  event_id?: InputMaybe<Scalars['uuid']>;
  event_type_id?: InputMaybe<Scalars['Int']>;
  game_format_id?: InputMaybe<Scalars['Int']>;
  game_id?: InputMaybe<Scalars['uuid']>;
  trivia_event_type?: InputMaybe<Trivia_Event_Types_Obj_Rel_Insert_Input>;
  trivia_game?: InputMaybe<Trivia_Games_Obj_Rel_Insert_Input>;
  trivia_user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Trivia_Events_Max_Fields = {
  __typename?: 'trivia_events_max_fields';
  date?: Maybe<Scalars['date']>;
  event_id?: Maybe<Scalars['uuid']>;
  event_type_id?: Maybe<Scalars['Int']>;
  game_format_id?: Maybe<Scalars['Int']>;
  game_id?: Maybe<Scalars['uuid']>;
  trivia_user_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "trivia_events" */
export type Trivia_Events_Max_Order_By = {
  date?: InputMaybe<Order_By>;
  event_id?: InputMaybe<Order_By>;
  event_type_id?: InputMaybe<Order_By>;
  game_format_id?: InputMaybe<Order_By>;
  game_id?: InputMaybe<Order_By>;
  trivia_user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Trivia_Events_Min_Fields = {
  __typename?: 'trivia_events_min_fields';
  date?: Maybe<Scalars['date']>;
  event_id?: Maybe<Scalars['uuid']>;
  event_type_id?: Maybe<Scalars['Int']>;
  game_format_id?: Maybe<Scalars['Int']>;
  game_id?: Maybe<Scalars['uuid']>;
  trivia_user_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "trivia_events" */
export type Trivia_Events_Min_Order_By = {
  date?: InputMaybe<Order_By>;
  event_id?: InputMaybe<Order_By>;
  event_type_id?: InputMaybe<Order_By>;
  game_format_id?: InputMaybe<Order_By>;
  game_id?: InputMaybe<Order_By>;
  trivia_user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "trivia_events" */
export type Trivia_Events_Mutation_Response = {
  __typename?: 'trivia_events_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Trivia_Events>;
};

/** input type for inserting object relation for remote table "trivia_events" */
export type Trivia_Events_Obj_Rel_Insert_Input = {
  data: Trivia_Events_Insert_Input;
  on_conflict?: InputMaybe<Trivia_Events_On_Conflict>;
};

/** on conflict condition type for table "trivia_events" */
export type Trivia_Events_On_Conflict = {
  constraint: Trivia_Events_Constraint;
  update_columns: Array<Trivia_Events_Update_Column>;
  where?: InputMaybe<Trivia_Events_Bool_Exp>;
};

/** ordering options when selecting data from "trivia_events" */
export type Trivia_Events_Order_By = {
  date?: InputMaybe<Order_By>;
  event_id?: InputMaybe<Order_By>;
  event_type_id?: InputMaybe<Order_By>;
  game_format_id?: InputMaybe<Order_By>;
  game_id?: InputMaybe<Order_By>;
  trivia_event_type?: InputMaybe<Trivia_Event_Types_Order_By>;
  trivia_game?: InputMaybe<Trivia_Games_Order_By>;
  trivia_user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: "trivia_events" */
export type Trivia_Events_Pk_Columns_Input = {
  event_id: Scalars['uuid'];
};

/** select columns of table "trivia_events" */
export enum Trivia_Events_Select_Column {
  /** column name */
  Date = 'date',
  /** column name */
  EventId = 'event_id',
  /** column name */
  EventTypeId = 'event_type_id',
  /** column name */
  GameFormatId = 'game_format_id',
  /** column name */
  GameId = 'game_id',
  /** column name */
  TriviaUserId = 'trivia_user_id'
}

/** input type for updating data in table "trivia_events" */
export type Trivia_Events_Set_Input = {
  date?: InputMaybe<Scalars['date']>;
  event_id?: InputMaybe<Scalars['uuid']>;
  event_type_id?: InputMaybe<Scalars['Int']>;
  game_format_id?: InputMaybe<Scalars['Int']>;
  game_id?: InputMaybe<Scalars['uuid']>;
  trivia_user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Trivia_Events_Stddev_Fields = {
  __typename?: 'trivia_events_stddev_fields';
  event_type_id?: Maybe<Scalars['Float']>;
  game_format_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "trivia_events" */
export type Trivia_Events_Stddev_Order_By = {
  event_type_id?: InputMaybe<Order_By>;
  game_format_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Trivia_Events_Stddev_Pop_Fields = {
  __typename?: 'trivia_events_stddev_pop_fields';
  event_type_id?: Maybe<Scalars['Float']>;
  game_format_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "trivia_events" */
export type Trivia_Events_Stddev_Pop_Order_By = {
  event_type_id?: InputMaybe<Order_By>;
  game_format_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Trivia_Events_Stddev_Samp_Fields = {
  __typename?: 'trivia_events_stddev_samp_fields';
  event_type_id?: Maybe<Scalars['Float']>;
  game_format_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "trivia_events" */
export type Trivia_Events_Stddev_Samp_Order_By = {
  event_type_id?: InputMaybe<Order_By>;
  game_format_id?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Trivia_Events_Sum_Fields = {
  __typename?: 'trivia_events_sum_fields';
  event_type_id?: Maybe<Scalars['Int']>;
  game_format_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "trivia_events" */
export type Trivia_Events_Sum_Order_By = {
  event_type_id?: InputMaybe<Order_By>;
  game_format_id?: InputMaybe<Order_By>;
};

/** update columns of table "trivia_events" */
export enum Trivia_Events_Update_Column {
  /** column name */
  Date = 'date',
  /** column name */
  EventId = 'event_id',
  /** column name */
  EventTypeId = 'event_type_id',
  /** column name */
  GameFormatId = 'game_format_id',
  /** column name */
  GameId = 'game_id',
  /** column name */
  TriviaUserId = 'trivia_user_id'
}

/** aggregate var_pop on columns */
export type Trivia_Events_Var_Pop_Fields = {
  __typename?: 'trivia_events_var_pop_fields';
  event_type_id?: Maybe<Scalars['Float']>;
  game_format_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "trivia_events" */
export type Trivia_Events_Var_Pop_Order_By = {
  event_type_id?: InputMaybe<Order_By>;
  game_format_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Trivia_Events_Var_Samp_Fields = {
  __typename?: 'trivia_events_var_samp_fields';
  event_type_id?: Maybe<Scalars['Float']>;
  game_format_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "trivia_events" */
export type Trivia_Events_Var_Samp_Order_By = {
  event_type_id?: InputMaybe<Order_By>;
  game_format_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Trivia_Events_Variance_Fields = {
  __typename?: 'trivia_events_variance_fields';
  event_type_id?: Maybe<Scalars['Float']>;
  game_format_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "trivia_events" */
export type Trivia_Events_Variance_Order_By = {
  event_type_id?: InputMaybe<Order_By>;
  game_format_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "trivia_game_category" */
export type Trivia_Game_Category = {
  __typename?: 'trivia_game_category';
  id: Scalars['Int'];
  name: Scalars['String'];
};

/** aggregated selection of "trivia_game_category" */
export type Trivia_Game_Category_Aggregate = {
  __typename?: 'trivia_game_category_aggregate';
  aggregate?: Maybe<Trivia_Game_Category_Aggregate_Fields>;
  nodes: Array<Trivia_Game_Category>;
};

/** aggregate fields of "trivia_game_category" */
export type Trivia_Game_Category_Aggregate_Fields = {
  __typename?: 'trivia_game_category_aggregate_fields';
  avg?: Maybe<Trivia_Game_Category_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Trivia_Game_Category_Max_Fields>;
  min?: Maybe<Trivia_Game_Category_Min_Fields>;
  stddev?: Maybe<Trivia_Game_Category_Stddev_Fields>;
  stddev_pop?: Maybe<Trivia_Game_Category_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Trivia_Game_Category_Stddev_Samp_Fields>;
  sum?: Maybe<Trivia_Game_Category_Sum_Fields>;
  var_pop?: Maybe<Trivia_Game_Category_Var_Pop_Fields>;
  var_samp?: Maybe<Trivia_Game_Category_Var_Samp_Fields>;
  variance?: Maybe<Trivia_Game_Category_Variance_Fields>;
};


/** aggregate fields of "trivia_game_category" */
export type Trivia_Game_Category_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Trivia_Game_Category_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "trivia_game_category" */
export type Trivia_Game_Category_Aggregate_Order_By = {
  avg?: InputMaybe<Trivia_Game_Category_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Trivia_Game_Category_Max_Order_By>;
  min?: InputMaybe<Trivia_Game_Category_Min_Order_By>;
  stddev?: InputMaybe<Trivia_Game_Category_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Trivia_Game_Category_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Trivia_Game_Category_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Trivia_Game_Category_Sum_Order_By>;
  var_pop?: InputMaybe<Trivia_Game_Category_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Trivia_Game_Category_Var_Samp_Order_By>;
  variance?: InputMaybe<Trivia_Game_Category_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "trivia_game_category" */
export type Trivia_Game_Category_Arr_Rel_Insert_Input = {
  data: Array<Trivia_Game_Category_Insert_Input>;
  on_conflict?: InputMaybe<Trivia_Game_Category_On_Conflict>;
};

/** aggregate avg on columns */
export type Trivia_Game_Category_Avg_Fields = {
  __typename?: 'trivia_game_category_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "trivia_game_category" */
export type Trivia_Game_Category_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "trivia_game_category". All fields are combined with a logical 'AND'. */
export type Trivia_Game_Category_Bool_Exp = {
  _and?: InputMaybe<Array<InputMaybe<Trivia_Game_Category_Bool_Exp>>>;
  _not?: InputMaybe<Trivia_Game_Category_Bool_Exp>;
  _or?: InputMaybe<Array<InputMaybe<Trivia_Game_Category_Bool_Exp>>>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "trivia_game_category" */
export enum Trivia_Game_Category_Constraint {
  /** unique or primary key constraint */
  TriviaGameCategoryPkey = 'trivia_game_category_pkey'
}

/** input type for incrementing integer column in table "trivia_game_category" */
export type Trivia_Game_Category_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "trivia_game_category" */
export type Trivia_Game_Category_Insert_Input = {
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Trivia_Game_Category_Max_Fields = {
  __typename?: 'trivia_game_category_max_fields';
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "trivia_game_category" */
export type Trivia_Game_Category_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Trivia_Game_Category_Min_Fields = {
  __typename?: 'trivia_game_category_min_fields';
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "trivia_game_category" */
export type Trivia_Game_Category_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "trivia_game_category" */
export type Trivia_Game_Category_Mutation_Response = {
  __typename?: 'trivia_game_category_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Trivia_Game_Category>;
};

/** input type for inserting object relation for remote table "trivia_game_category" */
export type Trivia_Game_Category_Obj_Rel_Insert_Input = {
  data: Trivia_Game_Category_Insert_Input;
  on_conflict?: InputMaybe<Trivia_Game_Category_On_Conflict>;
};

/** on conflict condition type for table "trivia_game_category" */
export type Trivia_Game_Category_On_Conflict = {
  constraint: Trivia_Game_Category_Constraint;
  update_columns: Array<Trivia_Game_Category_Update_Column>;
  where?: InputMaybe<Trivia_Game_Category_Bool_Exp>;
};

/** ordering options when selecting data from "trivia_game_category" */
export type Trivia_Game_Category_Order_By = {
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: "trivia_game_category" */
export type Trivia_Game_Category_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "trivia_game_category" */
export enum Trivia_Game_Category_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "trivia_game_category" */
export type Trivia_Game_Category_Set_Input = {
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Trivia_Game_Category_Stddev_Fields = {
  __typename?: 'trivia_game_category_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "trivia_game_category" */
export type Trivia_Game_Category_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Trivia_Game_Category_Stddev_Pop_Fields = {
  __typename?: 'trivia_game_category_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "trivia_game_category" */
export type Trivia_Game_Category_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Trivia_Game_Category_Stddev_Samp_Fields = {
  __typename?: 'trivia_game_category_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "trivia_game_category" */
export type Trivia_Game_Category_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Trivia_Game_Category_Sum_Fields = {
  __typename?: 'trivia_game_category_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "trivia_game_category" */
export type Trivia_Game_Category_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** update columns of table "trivia_game_category" */
export enum Trivia_Game_Category_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** aggregate var_pop on columns */
export type Trivia_Game_Category_Var_Pop_Fields = {
  __typename?: 'trivia_game_category_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "trivia_game_category" */
export type Trivia_Game_Category_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Trivia_Game_Category_Var_Samp_Fields = {
  __typename?: 'trivia_game_category_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "trivia_game_category" */
export type Trivia_Game_Category_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Trivia_Game_Category_Variance_Fields = {
  __typename?: 'trivia_game_category_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "trivia_game_category" */
export type Trivia_Game_Category_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "trivia_game_rounds" */
export type Trivia_Game_Rounds = {
  __typename?: 'trivia_game_rounds';
  created_at: Scalars['timestamptz'];
  game_id: Scalars['uuid'];
  id: Scalars['uuid'];
  round_id: Scalars['uuid'];
  round_order: Scalars['Int'];
  /** An object relationship */
  trivia_game: Trivia_Games;
  /** An object relationship */
  trivia_round: Trivia_Rounds;
};

/** aggregated selection of "trivia_game_rounds" */
export type Trivia_Game_Rounds_Aggregate = {
  __typename?: 'trivia_game_rounds_aggregate';
  aggregate?: Maybe<Trivia_Game_Rounds_Aggregate_Fields>;
  nodes: Array<Trivia_Game_Rounds>;
};

/** aggregate fields of "trivia_game_rounds" */
export type Trivia_Game_Rounds_Aggregate_Fields = {
  __typename?: 'trivia_game_rounds_aggregate_fields';
  avg?: Maybe<Trivia_Game_Rounds_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Trivia_Game_Rounds_Max_Fields>;
  min?: Maybe<Trivia_Game_Rounds_Min_Fields>;
  stddev?: Maybe<Trivia_Game_Rounds_Stddev_Fields>;
  stddev_pop?: Maybe<Trivia_Game_Rounds_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Trivia_Game_Rounds_Stddev_Samp_Fields>;
  sum?: Maybe<Trivia_Game_Rounds_Sum_Fields>;
  var_pop?: Maybe<Trivia_Game_Rounds_Var_Pop_Fields>;
  var_samp?: Maybe<Trivia_Game_Rounds_Var_Samp_Fields>;
  variance?: Maybe<Trivia_Game_Rounds_Variance_Fields>;
};


/** aggregate fields of "trivia_game_rounds" */
export type Trivia_Game_Rounds_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Trivia_Game_Rounds_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "trivia_game_rounds" */
export type Trivia_Game_Rounds_Aggregate_Order_By = {
  avg?: InputMaybe<Trivia_Game_Rounds_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Trivia_Game_Rounds_Max_Order_By>;
  min?: InputMaybe<Trivia_Game_Rounds_Min_Order_By>;
  stddev?: InputMaybe<Trivia_Game_Rounds_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Trivia_Game_Rounds_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Trivia_Game_Rounds_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Trivia_Game_Rounds_Sum_Order_By>;
  var_pop?: InputMaybe<Trivia_Game_Rounds_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Trivia_Game_Rounds_Var_Samp_Order_By>;
  variance?: InputMaybe<Trivia_Game_Rounds_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "trivia_game_rounds" */
export type Trivia_Game_Rounds_Arr_Rel_Insert_Input = {
  data: Array<Trivia_Game_Rounds_Insert_Input>;
  on_conflict?: InputMaybe<Trivia_Game_Rounds_On_Conflict>;
};

/** aggregate avg on columns */
export type Trivia_Game_Rounds_Avg_Fields = {
  __typename?: 'trivia_game_rounds_avg_fields';
  round_order?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "trivia_game_rounds" */
export type Trivia_Game_Rounds_Avg_Order_By = {
  round_order?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "trivia_game_rounds". All fields are combined with a logical 'AND'. */
export type Trivia_Game_Rounds_Bool_Exp = {
  _and?: InputMaybe<Array<InputMaybe<Trivia_Game_Rounds_Bool_Exp>>>;
  _not?: InputMaybe<Trivia_Game_Rounds_Bool_Exp>;
  _or?: InputMaybe<Array<InputMaybe<Trivia_Game_Rounds_Bool_Exp>>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  game_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  round_id?: InputMaybe<Uuid_Comparison_Exp>;
  round_order?: InputMaybe<Int_Comparison_Exp>;
  trivia_game?: InputMaybe<Trivia_Games_Bool_Exp>;
  trivia_round?: InputMaybe<Trivia_Rounds_Bool_Exp>;
};

/** unique or primary key constraints on table "trivia_game_rounds" */
export enum Trivia_Game_Rounds_Constraint {
  /** unique or primary key constraint */
  TriviaGameRoundsPkey = 'trivia_game_rounds_pkey'
}

/** input type for incrementing integer column in table "trivia_game_rounds" */
export type Trivia_Game_Rounds_Inc_Input = {
  round_order?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "trivia_game_rounds" */
export type Trivia_Game_Rounds_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  game_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  round_id?: InputMaybe<Scalars['uuid']>;
  round_order?: InputMaybe<Scalars['Int']>;
  trivia_game?: InputMaybe<Trivia_Games_Obj_Rel_Insert_Input>;
  trivia_round?: InputMaybe<Trivia_Rounds_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Trivia_Game_Rounds_Max_Fields = {
  __typename?: 'trivia_game_rounds_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  game_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  round_id?: Maybe<Scalars['uuid']>;
  round_order?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "trivia_game_rounds" */
export type Trivia_Game_Rounds_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  game_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  round_id?: InputMaybe<Order_By>;
  round_order?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Trivia_Game_Rounds_Min_Fields = {
  __typename?: 'trivia_game_rounds_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  game_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  round_id?: Maybe<Scalars['uuid']>;
  round_order?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "trivia_game_rounds" */
export type Trivia_Game_Rounds_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  game_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  round_id?: InputMaybe<Order_By>;
  round_order?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "trivia_game_rounds" */
export type Trivia_Game_Rounds_Mutation_Response = {
  __typename?: 'trivia_game_rounds_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Trivia_Game_Rounds>;
};

/** input type for inserting object relation for remote table "trivia_game_rounds" */
export type Trivia_Game_Rounds_Obj_Rel_Insert_Input = {
  data: Trivia_Game_Rounds_Insert_Input;
  on_conflict?: InputMaybe<Trivia_Game_Rounds_On_Conflict>;
};

/** on conflict condition type for table "trivia_game_rounds" */
export type Trivia_Game_Rounds_On_Conflict = {
  constraint: Trivia_Game_Rounds_Constraint;
  update_columns: Array<Trivia_Game_Rounds_Update_Column>;
  where?: InputMaybe<Trivia_Game_Rounds_Bool_Exp>;
};

/** ordering options when selecting data from "trivia_game_rounds" */
export type Trivia_Game_Rounds_Order_By = {
  created_at?: InputMaybe<Order_By>;
  game_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  round_id?: InputMaybe<Order_By>;
  round_order?: InputMaybe<Order_By>;
  trivia_game?: InputMaybe<Trivia_Games_Order_By>;
  trivia_round?: InputMaybe<Trivia_Rounds_Order_By>;
};

/** primary key columns input for table: "trivia_game_rounds" */
export type Trivia_Game_Rounds_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "trivia_game_rounds" */
export enum Trivia_Game_Rounds_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  GameId = 'game_id',
  /** column name */
  Id = 'id',
  /** column name */
  RoundId = 'round_id',
  /** column name */
  RoundOrder = 'round_order'
}

/** input type for updating data in table "trivia_game_rounds" */
export type Trivia_Game_Rounds_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  game_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  round_id?: InputMaybe<Scalars['uuid']>;
  round_order?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Trivia_Game_Rounds_Stddev_Fields = {
  __typename?: 'trivia_game_rounds_stddev_fields';
  round_order?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "trivia_game_rounds" */
export type Trivia_Game_Rounds_Stddev_Order_By = {
  round_order?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Trivia_Game_Rounds_Stddev_Pop_Fields = {
  __typename?: 'trivia_game_rounds_stddev_pop_fields';
  round_order?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "trivia_game_rounds" */
export type Trivia_Game_Rounds_Stddev_Pop_Order_By = {
  round_order?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Trivia_Game_Rounds_Stddev_Samp_Fields = {
  __typename?: 'trivia_game_rounds_stddev_samp_fields';
  round_order?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "trivia_game_rounds" */
export type Trivia_Game_Rounds_Stddev_Samp_Order_By = {
  round_order?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Trivia_Game_Rounds_Sum_Fields = {
  __typename?: 'trivia_game_rounds_sum_fields';
  round_order?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "trivia_game_rounds" */
export type Trivia_Game_Rounds_Sum_Order_By = {
  round_order?: InputMaybe<Order_By>;
};

/** update columns of table "trivia_game_rounds" */
export enum Trivia_Game_Rounds_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  GameId = 'game_id',
  /** column name */
  Id = 'id',
  /** column name */
  RoundId = 'round_id',
  /** column name */
  RoundOrder = 'round_order'
}

/** aggregate var_pop on columns */
export type Trivia_Game_Rounds_Var_Pop_Fields = {
  __typename?: 'trivia_game_rounds_var_pop_fields';
  round_order?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "trivia_game_rounds" */
export type Trivia_Game_Rounds_Var_Pop_Order_By = {
  round_order?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Trivia_Game_Rounds_Var_Samp_Fields = {
  __typename?: 'trivia_game_rounds_var_samp_fields';
  round_order?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "trivia_game_rounds" */
export type Trivia_Game_Rounds_Var_Samp_Order_By = {
  round_order?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Trivia_Game_Rounds_Variance_Fields = {
  __typename?: 'trivia_game_rounds_variance_fields';
  round_order?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "trivia_game_rounds" */
export type Trivia_Game_Rounds_Variance_Order_By = {
  round_order?: InputMaybe<Order_By>;
};

/** columns and relationships of "trivia_game_templates" */
export type Trivia_Game_Templates = {
  __typename?: 'trivia_game_templates';
  order?: Maybe<Scalars['Int']>;
  template_id: Scalars['String'];
  template_name: Scalars['String'];
};

/** aggregated selection of "trivia_game_templates" */
export type Trivia_Game_Templates_Aggregate = {
  __typename?: 'trivia_game_templates_aggregate';
  aggregate?: Maybe<Trivia_Game_Templates_Aggregate_Fields>;
  nodes: Array<Trivia_Game_Templates>;
};

/** aggregate fields of "trivia_game_templates" */
export type Trivia_Game_Templates_Aggregate_Fields = {
  __typename?: 'trivia_game_templates_aggregate_fields';
  avg?: Maybe<Trivia_Game_Templates_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Trivia_Game_Templates_Max_Fields>;
  min?: Maybe<Trivia_Game_Templates_Min_Fields>;
  stddev?: Maybe<Trivia_Game_Templates_Stddev_Fields>;
  stddev_pop?: Maybe<Trivia_Game_Templates_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Trivia_Game_Templates_Stddev_Samp_Fields>;
  sum?: Maybe<Trivia_Game_Templates_Sum_Fields>;
  var_pop?: Maybe<Trivia_Game_Templates_Var_Pop_Fields>;
  var_samp?: Maybe<Trivia_Game_Templates_Var_Samp_Fields>;
  variance?: Maybe<Trivia_Game_Templates_Variance_Fields>;
};


/** aggregate fields of "trivia_game_templates" */
export type Trivia_Game_Templates_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Trivia_Game_Templates_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "trivia_game_templates" */
export type Trivia_Game_Templates_Aggregate_Order_By = {
  avg?: InputMaybe<Trivia_Game_Templates_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Trivia_Game_Templates_Max_Order_By>;
  min?: InputMaybe<Trivia_Game_Templates_Min_Order_By>;
  stddev?: InputMaybe<Trivia_Game_Templates_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Trivia_Game_Templates_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Trivia_Game_Templates_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Trivia_Game_Templates_Sum_Order_By>;
  var_pop?: InputMaybe<Trivia_Game_Templates_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Trivia_Game_Templates_Var_Samp_Order_By>;
  variance?: InputMaybe<Trivia_Game_Templates_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "trivia_game_templates" */
export type Trivia_Game_Templates_Arr_Rel_Insert_Input = {
  data: Array<Trivia_Game_Templates_Insert_Input>;
  on_conflict?: InputMaybe<Trivia_Game_Templates_On_Conflict>;
};

/** aggregate avg on columns */
export type Trivia_Game_Templates_Avg_Fields = {
  __typename?: 'trivia_game_templates_avg_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "trivia_game_templates" */
export type Trivia_Game_Templates_Avg_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "trivia_game_templates". All fields are combined with a logical 'AND'. */
export type Trivia_Game_Templates_Bool_Exp = {
  _and?: InputMaybe<Array<InputMaybe<Trivia_Game_Templates_Bool_Exp>>>;
  _not?: InputMaybe<Trivia_Game_Templates_Bool_Exp>;
  _or?: InputMaybe<Array<InputMaybe<Trivia_Game_Templates_Bool_Exp>>>;
  order?: InputMaybe<Int_Comparison_Exp>;
  template_id?: InputMaybe<String_Comparison_Exp>;
  template_name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "trivia_game_templates" */
export enum Trivia_Game_Templates_Constraint {
  /** unique or primary key constraint */
  TriviaGameTemplatesOrderKey = 'trivia_game_templates_order_key',
  /** unique or primary key constraint */
  TriviaGameTemplatesPkey = 'trivia_game_templates_pkey'
}

/** input type for incrementing integer column in table "trivia_game_templates" */
export type Trivia_Game_Templates_Inc_Input = {
  order?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "trivia_game_templates" */
export type Trivia_Game_Templates_Insert_Input = {
  order?: InputMaybe<Scalars['Int']>;
  template_id?: InputMaybe<Scalars['String']>;
  template_name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Trivia_Game_Templates_Max_Fields = {
  __typename?: 'trivia_game_templates_max_fields';
  order?: Maybe<Scalars['Int']>;
  template_id?: Maybe<Scalars['String']>;
  template_name?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "trivia_game_templates" */
export type Trivia_Game_Templates_Max_Order_By = {
  order?: InputMaybe<Order_By>;
  template_id?: InputMaybe<Order_By>;
  template_name?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Trivia_Game_Templates_Min_Fields = {
  __typename?: 'trivia_game_templates_min_fields';
  order?: Maybe<Scalars['Int']>;
  template_id?: Maybe<Scalars['String']>;
  template_name?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "trivia_game_templates" */
export type Trivia_Game_Templates_Min_Order_By = {
  order?: InputMaybe<Order_By>;
  template_id?: InputMaybe<Order_By>;
  template_name?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "trivia_game_templates" */
export type Trivia_Game_Templates_Mutation_Response = {
  __typename?: 'trivia_game_templates_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Trivia_Game_Templates>;
};

/** input type for inserting object relation for remote table "trivia_game_templates" */
export type Trivia_Game_Templates_Obj_Rel_Insert_Input = {
  data: Trivia_Game_Templates_Insert_Input;
  on_conflict?: InputMaybe<Trivia_Game_Templates_On_Conflict>;
};

/** on conflict condition type for table "trivia_game_templates" */
export type Trivia_Game_Templates_On_Conflict = {
  constraint: Trivia_Game_Templates_Constraint;
  update_columns: Array<Trivia_Game_Templates_Update_Column>;
  where?: InputMaybe<Trivia_Game_Templates_Bool_Exp>;
};

/** ordering options when selecting data from "trivia_game_templates" */
export type Trivia_Game_Templates_Order_By = {
  order?: InputMaybe<Order_By>;
  template_id?: InputMaybe<Order_By>;
  template_name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: "trivia_game_templates" */
export type Trivia_Game_Templates_Pk_Columns_Input = {
  template_id: Scalars['String'];
};

/** select columns of table "trivia_game_templates" */
export enum Trivia_Game_Templates_Select_Column {
  /** column name */
  Order = 'order',
  /** column name */
  TemplateId = 'template_id',
  /** column name */
  TemplateName = 'template_name'
}

/** input type for updating data in table "trivia_game_templates" */
export type Trivia_Game_Templates_Set_Input = {
  order?: InputMaybe<Scalars['Int']>;
  template_id?: InputMaybe<Scalars['String']>;
  template_name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Trivia_Game_Templates_Stddev_Fields = {
  __typename?: 'trivia_game_templates_stddev_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "trivia_game_templates" */
export type Trivia_Game_Templates_Stddev_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Trivia_Game_Templates_Stddev_Pop_Fields = {
  __typename?: 'trivia_game_templates_stddev_pop_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "trivia_game_templates" */
export type Trivia_Game_Templates_Stddev_Pop_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Trivia_Game_Templates_Stddev_Samp_Fields = {
  __typename?: 'trivia_game_templates_stddev_samp_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "trivia_game_templates" */
export type Trivia_Game_Templates_Stddev_Samp_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Trivia_Game_Templates_Sum_Fields = {
  __typename?: 'trivia_game_templates_sum_fields';
  order?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "trivia_game_templates" */
export type Trivia_Game_Templates_Sum_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** update columns of table "trivia_game_templates" */
export enum Trivia_Game_Templates_Update_Column {
  /** column name */
  Order = 'order',
  /** column name */
  TemplateId = 'template_id',
  /** column name */
  TemplateName = 'template_name'
}

/** aggregate var_pop on columns */
export type Trivia_Game_Templates_Var_Pop_Fields = {
  __typename?: 'trivia_game_templates_var_pop_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "trivia_game_templates" */
export type Trivia_Game_Templates_Var_Pop_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Trivia_Game_Templates_Var_Samp_Fields = {
  __typename?: 'trivia_game_templates_var_samp_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "trivia_game_templates" */
export type Trivia_Game_Templates_Var_Samp_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Trivia_Game_Templates_Variance_Fields = {
  __typename?: 'trivia_game_templates_variance_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "trivia_game_templates" */
export type Trivia_Game_Templates_Variance_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** columns and relationships of "trivia_game_themes" */
export type Trivia_Game_Themes = {
  __typename?: 'trivia_game_themes';
  game_id: Scalars['uuid'];
  /** An object relationship */
  game_theme: Game_Themes;
  game_theme_id: Scalars['uuid'];
  theme_id: Scalars['uuid'];
  /** An object relationship */
  trivia_game: Trivia_Games;
};

/** aggregated selection of "trivia_game_themes" */
export type Trivia_Game_Themes_Aggregate = {
  __typename?: 'trivia_game_themes_aggregate';
  aggregate?: Maybe<Trivia_Game_Themes_Aggregate_Fields>;
  nodes: Array<Trivia_Game_Themes>;
};

/** aggregate fields of "trivia_game_themes" */
export type Trivia_Game_Themes_Aggregate_Fields = {
  __typename?: 'trivia_game_themes_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Trivia_Game_Themes_Max_Fields>;
  min?: Maybe<Trivia_Game_Themes_Min_Fields>;
};


/** aggregate fields of "trivia_game_themes" */
export type Trivia_Game_Themes_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Trivia_Game_Themes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "trivia_game_themes" */
export type Trivia_Game_Themes_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Trivia_Game_Themes_Max_Order_By>;
  min?: InputMaybe<Trivia_Game_Themes_Min_Order_By>;
};

/** input type for inserting array relation for remote table "trivia_game_themes" */
export type Trivia_Game_Themes_Arr_Rel_Insert_Input = {
  data: Array<Trivia_Game_Themes_Insert_Input>;
  on_conflict?: InputMaybe<Trivia_Game_Themes_On_Conflict>;
};

/** Boolean expression to filter rows from the table "trivia_game_themes". All fields are combined with a logical 'AND'. */
export type Trivia_Game_Themes_Bool_Exp = {
  _and?: InputMaybe<Array<InputMaybe<Trivia_Game_Themes_Bool_Exp>>>;
  _not?: InputMaybe<Trivia_Game_Themes_Bool_Exp>;
  _or?: InputMaybe<Array<InputMaybe<Trivia_Game_Themes_Bool_Exp>>>;
  game_id?: InputMaybe<Uuid_Comparison_Exp>;
  game_theme?: InputMaybe<Game_Themes_Bool_Exp>;
  game_theme_id?: InputMaybe<Uuid_Comparison_Exp>;
  theme_id?: InputMaybe<Uuid_Comparison_Exp>;
  trivia_game?: InputMaybe<Trivia_Games_Bool_Exp>;
};

/** unique or primary key constraints on table "trivia_game_themes" */
export enum Trivia_Game_Themes_Constraint {
  /** unique or primary key constraint */
  TriviaGameThemesPkey = 'trivia_game_themes_pkey'
}

/** input type for inserting data into table "trivia_game_themes" */
export type Trivia_Game_Themes_Insert_Input = {
  game_id?: InputMaybe<Scalars['uuid']>;
  game_theme?: InputMaybe<Game_Themes_Obj_Rel_Insert_Input>;
  game_theme_id?: InputMaybe<Scalars['uuid']>;
  theme_id?: InputMaybe<Scalars['uuid']>;
  trivia_game?: InputMaybe<Trivia_Games_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Trivia_Game_Themes_Max_Fields = {
  __typename?: 'trivia_game_themes_max_fields';
  game_id?: Maybe<Scalars['uuid']>;
  game_theme_id?: Maybe<Scalars['uuid']>;
  theme_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "trivia_game_themes" */
export type Trivia_Game_Themes_Max_Order_By = {
  game_id?: InputMaybe<Order_By>;
  game_theme_id?: InputMaybe<Order_By>;
  theme_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Trivia_Game_Themes_Min_Fields = {
  __typename?: 'trivia_game_themes_min_fields';
  game_id?: Maybe<Scalars['uuid']>;
  game_theme_id?: Maybe<Scalars['uuid']>;
  theme_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "trivia_game_themes" */
export type Trivia_Game_Themes_Min_Order_By = {
  game_id?: InputMaybe<Order_By>;
  game_theme_id?: InputMaybe<Order_By>;
  theme_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "trivia_game_themes" */
export type Trivia_Game_Themes_Mutation_Response = {
  __typename?: 'trivia_game_themes_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Trivia_Game_Themes>;
};

/** input type for inserting object relation for remote table "trivia_game_themes" */
export type Trivia_Game_Themes_Obj_Rel_Insert_Input = {
  data: Trivia_Game_Themes_Insert_Input;
  on_conflict?: InputMaybe<Trivia_Game_Themes_On_Conflict>;
};

/** on conflict condition type for table "trivia_game_themes" */
export type Trivia_Game_Themes_On_Conflict = {
  constraint: Trivia_Game_Themes_Constraint;
  update_columns: Array<Trivia_Game_Themes_Update_Column>;
  where?: InputMaybe<Trivia_Game_Themes_Bool_Exp>;
};

/** ordering options when selecting data from "trivia_game_themes" */
export type Trivia_Game_Themes_Order_By = {
  game_id?: InputMaybe<Order_By>;
  game_theme?: InputMaybe<Game_Themes_Order_By>;
  game_theme_id?: InputMaybe<Order_By>;
  theme_id?: InputMaybe<Order_By>;
  trivia_game?: InputMaybe<Trivia_Games_Order_By>;
};

/** primary key columns input for table: "trivia_game_themes" */
export type Trivia_Game_Themes_Pk_Columns_Input = {
  game_theme_id: Scalars['uuid'];
};

/** select columns of table "trivia_game_themes" */
export enum Trivia_Game_Themes_Select_Column {
  /** column name */
  GameId = 'game_id',
  /** column name */
  GameThemeId = 'game_theme_id',
  /** column name */
  ThemeId = 'theme_id'
}

/** input type for updating data in table "trivia_game_themes" */
export type Trivia_Game_Themes_Set_Input = {
  game_id?: InputMaybe<Scalars['uuid']>;
  game_theme_id?: InputMaybe<Scalars['uuid']>;
  theme_id?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "trivia_game_themes" */
export enum Trivia_Game_Themes_Update_Column {
  /** column name */
  GameId = 'game_id',
  /** column name */
  GameThemeId = 'game_theme_id',
  /** column name */
  ThemeId = 'theme_id'
}

/** columns and relationships of "trivia_games" */
export type Trivia_Games = {
  __typename?: 'trivia_games';
  category?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  creator_id?: Maybe<Scalars['uuid']>;
  description?: Maybe<Scalars['String']>;
  format_graphic_url?: Maybe<Scalars['String']>;
  /** An object relationship */
  gameStatusByGameStatus: Game_Status;
  game_date?: Maybe<Scalars['date']>;
  game_difficult_id?: Maybe<Scalars['Int']>;
  game_id: Scalars['uuid'];
  game_status: Scalars['Int'];
  game_template_id: Scalars['String'];
  is_demo: Scalars['Boolean'];
  keywords?: Maybe<Scalars['String']>;
  market?: Maybe<Scalars['String']>;
  /** An object relationship */
  marketByMarket?: Maybe<Markets>;
  promo_image_url?: Maybe<Scalars['String']>;
  rating?: Maybe<Scalars['String']>;
  theme_image_url?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  /** An object relationship */
  trivia_game_category?: Maybe<Trivia_Game_Category>;
  /** An array relationship */
  trivia_game_rounds: Array<Trivia_Game_Rounds>;
  /** An aggregated array relationship */
  trivia_game_rounds_aggregate: Trivia_Game_Rounds_Aggregate;
  /** An object relationship */
  trivia_game_template: Trivia_Game_Templates;
  /** An array relationship */
  trivia_game_themes: Array<Trivia_Game_Themes>;
  /** An aggregated array relationship */
  trivia_game_themes_aggregate: Trivia_Game_Themes_Aggregate;
  /** An object relationship */
  trivia_user?: Maybe<Trivia_Users>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};


/** columns and relationships of "trivia_games" */
export type Trivia_GamesTrivia_Game_RoundsArgs = {
  distinct_on?: InputMaybe<Array<Trivia_Game_Rounds_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trivia_Game_Rounds_Order_By>>;
  where?: InputMaybe<Trivia_Game_Rounds_Bool_Exp>;
};


/** columns and relationships of "trivia_games" */
export type Trivia_GamesTrivia_Game_Rounds_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trivia_Game_Rounds_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trivia_Game_Rounds_Order_By>>;
  where?: InputMaybe<Trivia_Game_Rounds_Bool_Exp>;
};


/** columns and relationships of "trivia_games" */
export type Trivia_GamesTrivia_Game_ThemesArgs = {
  distinct_on?: InputMaybe<Array<Trivia_Game_Themes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trivia_Game_Themes_Order_By>>;
  where?: InputMaybe<Trivia_Game_Themes_Bool_Exp>;
};


/** columns and relationships of "trivia_games" */
export type Trivia_GamesTrivia_Game_Themes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trivia_Game_Themes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trivia_Game_Themes_Order_By>>;
  where?: InputMaybe<Trivia_Game_Themes_Bool_Exp>;
};

/** aggregated selection of "trivia_games" */
export type Trivia_Games_Aggregate = {
  __typename?: 'trivia_games_aggregate';
  aggregate?: Maybe<Trivia_Games_Aggregate_Fields>;
  nodes: Array<Trivia_Games>;
};

/** aggregate fields of "trivia_games" */
export type Trivia_Games_Aggregate_Fields = {
  __typename?: 'trivia_games_aggregate_fields';
  avg?: Maybe<Trivia_Games_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Trivia_Games_Max_Fields>;
  min?: Maybe<Trivia_Games_Min_Fields>;
  stddev?: Maybe<Trivia_Games_Stddev_Fields>;
  stddev_pop?: Maybe<Trivia_Games_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Trivia_Games_Stddev_Samp_Fields>;
  sum?: Maybe<Trivia_Games_Sum_Fields>;
  var_pop?: Maybe<Trivia_Games_Var_Pop_Fields>;
  var_samp?: Maybe<Trivia_Games_Var_Samp_Fields>;
  variance?: Maybe<Trivia_Games_Variance_Fields>;
};


/** aggregate fields of "trivia_games" */
export type Trivia_Games_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Trivia_Games_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "trivia_games" */
export type Trivia_Games_Aggregate_Order_By = {
  avg?: InputMaybe<Trivia_Games_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Trivia_Games_Max_Order_By>;
  min?: InputMaybe<Trivia_Games_Min_Order_By>;
  stddev?: InputMaybe<Trivia_Games_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Trivia_Games_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Trivia_Games_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Trivia_Games_Sum_Order_By>;
  var_pop?: InputMaybe<Trivia_Games_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Trivia_Games_Var_Samp_Order_By>;
  variance?: InputMaybe<Trivia_Games_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "trivia_games" */
export type Trivia_Games_Arr_Rel_Insert_Input = {
  data: Array<Trivia_Games_Insert_Input>;
  on_conflict?: InputMaybe<Trivia_Games_On_Conflict>;
};

/** aggregate avg on columns */
export type Trivia_Games_Avg_Fields = {
  __typename?: 'trivia_games_avg_fields';
  category?: Maybe<Scalars['Float']>;
  game_difficult_id?: Maybe<Scalars['Float']>;
  game_status?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "trivia_games" */
export type Trivia_Games_Avg_Order_By = {
  category?: InputMaybe<Order_By>;
  game_difficult_id?: InputMaybe<Order_By>;
  game_status?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "trivia_games". All fields are combined with a logical 'AND'. */
export type Trivia_Games_Bool_Exp = {
  _and?: InputMaybe<Array<InputMaybe<Trivia_Games_Bool_Exp>>>;
  _not?: InputMaybe<Trivia_Games_Bool_Exp>;
  _or?: InputMaybe<Array<InputMaybe<Trivia_Games_Bool_Exp>>>;
  category?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  creator_id?: InputMaybe<Uuid_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  format_graphic_url?: InputMaybe<String_Comparison_Exp>;
  gameStatusByGameStatus?: InputMaybe<Game_Status_Bool_Exp>;
  game_date?: InputMaybe<Date_Comparison_Exp>;
  game_difficult_id?: InputMaybe<Int_Comparison_Exp>;
  game_id?: InputMaybe<Uuid_Comparison_Exp>;
  game_status?: InputMaybe<Int_Comparison_Exp>;
  game_template_id?: InputMaybe<String_Comparison_Exp>;
  is_demo?: InputMaybe<Boolean_Comparison_Exp>;
  keywords?: InputMaybe<String_Comparison_Exp>;
  market?: InputMaybe<String_Comparison_Exp>;
  marketByMarket?: InputMaybe<Markets_Bool_Exp>;
  promo_image_url?: InputMaybe<String_Comparison_Exp>;
  rating?: InputMaybe<String_Comparison_Exp>;
  theme_image_url?: InputMaybe<String_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  trivia_game_category?: InputMaybe<Trivia_Game_Category_Bool_Exp>;
  trivia_game_rounds?: InputMaybe<Trivia_Game_Rounds_Bool_Exp>;
  trivia_game_template?: InputMaybe<Trivia_Game_Templates_Bool_Exp>;
  trivia_game_themes?: InputMaybe<Trivia_Game_Themes_Bool_Exp>;
  trivia_user?: InputMaybe<Trivia_Users_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "trivia_games" */
export enum Trivia_Games_Constraint {
  /** unique or primary key constraint */
  TriviaGamesPkey = 'trivia_games_pkey'
}

/** input type for incrementing integer column in table "trivia_games" */
export type Trivia_Games_Inc_Input = {
  category?: InputMaybe<Scalars['Int']>;
  game_difficult_id?: InputMaybe<Scalars['Int']>;
  game_status?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "trivia_games" */
export type Trivia_Games_Insert_Input = {
  category?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  creator_id?: InputMaybe<Scalars['uuid']>;
  description?: InputMaybe<Scalars['String']>;
  format_graphic_url?: InputMaybe<Scalars['String']>;
  gameStatusByGameStatus?: InputMaybe<Game_Status_Obj_Rel_Insert_Input>;
  game_date?: InputMaybe<Scalars['date']>;
  game_difficult_id?: InputMaybe<Scalars['Int']>;
  game_id?: InputMaybe<Scalars['uuid']>;
  game_status?: InputMaybe<Scalars['Int']>;
  game_template_id?: InputMaybe<Scalars['String']>;
  is_demo?: InputMaybe<Scalars['Boolean']>;
  keywords?: InputMaybe<Scalars['String']>;
  market?: InputMaybe<Scalars['String']>;
  marketByMarket?: InputMaybe<Markets_Obj_Rel_Insert_Input>;
  promo_image_url?: InputMaybe<Scalars['String']>;
  rating?: InputMaybe<Scalars['String']>;
  theme_image_url?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  trivia_game_category?: InputMaybe<Trivia_Game_Category_Obj_Rel_Insert_Input>;
  trivia_game_rounds?: InputMaybe<Trivia_Game_Rounds_Arr_Rel_Insert_Input>;
  trivia_game_template?: InputMaybe<Trivia_Game_Templates_Obj_Rel_Insert_Input>;
  trivia_game_themes?: InputMaybe<Trivia_Game_Themes_Arr_Rel_Insert_Input>;
  trivia_user?: InputMaybe<Trivia_Users_Obj_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Trivia_Games_Max_Fields = {
  __typename?: 'trivia_games_max_fields';
  category?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  creator_id?: Maybe<Scalars['uuid']>;
  description?: Maybe<Scalars['String']>;
  format_graphic_url?: Maybe<Scalars['String']>;
  game_date?: Maybe<Scalars['date']>;
  game_difficult_id?: Maybe<Scalars['Int']>;
  game_id?: Maybe<Scalars['uuid']>;
  game_status?: Maybe<Scalars['Int']>;
  game_template_id?: Maybe<Scalars['String']>;
  keywords?: Maybe<Scalars['String']>;
  market?: Maybe<Scalars['String']>;
  promo_image_url?: Maybe<Scalars['String']>;
  rating?: Maybe<Scalars['String']>;
  theme_image_url?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "trivia_games" */
export type Trivia_Games_Max_Order_By = {
  category?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  creator_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  format_graphic_url?: InputMaybe<Order_By>;
  game_date?: InputMaybe<Order_By>;
  game_difficult_id?: InputMaybe<Order_By>;
  game_id?: InputMaybe<Order_By>;
  game_status?: InputMaybe<Order_By>;
  game_template_id?: InputMaybe<Order_By>;
  keywords?: InputMaybe<Order_By>;
  market?: InputMaybe<Order_By>;
  promo_image_url?: InputMaybe<Order_By>;
  rating?: InputMaybe<Order_By>;
  theme_image_url?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Trivia_Games_Min_Fields = {
  __typename?: 'trivia_games_min_fields';
  category?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  creator_id?: Maybe<Scalars['uuid']>;
  description?: Maybe<Scalars['String']>;
  format_graphic_url?: Maybe<Scalars['String']>;
  game_date?: Maybe<Scalars['date']>;
  game_difficult_id?: Maybe<Scalars['Int']>;
  game_id?: Maybe<Scalars['uuid']>;
  game_status?: Maybe<Scalars['Int']>;
  game_template_id?: Maybe<Scalars['String']>;
  keywords?: Maybe<Scalars['String']>;
  market?: Maybe<Scalars['String']>;
  promo_image_url?: Maybe<Scalars['String']>;
  rating?: Maybe<Scalars['String']>;
  theme_image_url?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "trivia_games" */
export type Trivia_Games_Min_Order_By = {
  category?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  creator_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  format_graphic_url?: InputMaybe<Order_By>;
  game_date?: InputMaybe<Order_By>;
  game_difficult_id?: InputMaybe<Order_By>;
  game_id?: InputMaybe<Order_By>;
  game_status?: InputMaybe<Order_By>;
  game_template_id?: InputMaybe<Order_By>;
  keywords?: InputMaybe<Order_By>;
  market?: InputMaybe<Order_By>;
  promo_image_url?: InputMaybe<Order_By>;
  rating?: InputMaybe<Order_By>;
  theme_image_url?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "trivia_games" */
export type Trivia_Games_Mutation_Response = {
  __typename?: 'trivia_games_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Trivia_Games>;
};

/** input type for inserting object relation for remote table "trivia_games" */
export type Trivia_Games_Obj_Rel_Insert_Input = {
  data: Trivia_Games_Insert_Input;
  on_conflict?: InputMaybe<Trivia_Games_On_Conflict>;
};

/** on conflict condition type for table "trivia_games" */
export type Trivia_Games_On_Conflict = {
  constraint: Trivia_Games_Constraint;
  update_columns: Array<Trivia_Games_Update_Column>;
  where?: InputMaybe<Trivia_Games_Bool_Exp>;
};

/** ordering options when selecting data from "trivia_games" */
export type Trivia_Games_Order_By = {
  category?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  creator_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  format_graphic_url?: InputMaybe<Order_By>;
  gameStatusByGameStatus?: InputMaybe<Game_Status_Order_By>;
  game_date?: InputMaybe<Order_By>;
  game_difficult_id?: InputMaybe<Order_By>;
  game_id?: InputMaybe<Order_By>;
  game_status?: InputMaybe<Order_By>;
  game_template_id?: InputMaybe<Order_By>;
  is_demo?: InputMaybe<Order_By>;
  keywords?: InputMaybe<Order_By>;
  market?: InputMaybe<Order_By>;
  marketByMarket?: InputMaybe<Markets_Order_By>;
  promo_image_url?: InputMaybe<Order_By>;
  rating?: InputMaybe<Order_By>;
  theme_image_url?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  trivia_game_category?: InputMaybe<Trivia_Game_Category_Order_By>;
  trivia_game_rounds_aggregate?: InputMaybe<Trivia_Game_Rounds_Aggregate_Order_By>;
  trivia_game_template?: InputMaybe<Trivia_Game_Templates_Order_By>;
  trivia_game_themes_aggregate?: InputMaybe<Trivia_Game_Themes_Aggregate_Order_By>;
  trivia_user?: InputMaybe<Trivia_Users_Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: "trivia_games" */
export type Trivia_Games_Pk_Columns_Input = {
  game_id: Scalars['uuid'];
};

/** select columns of table "trivia_games" */
export enum Trivia_Games_Select_Column {
  /** column name */
  Category = 'category',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatorId = 'creator_id',
  /** column name */
  Description = 'description',
  /** column name */
  FormatGraphicUrl = 'format_graphic_url',
  /** column name */
  GameDate = 'game_date',
  /** column name */
  GameDifficultId = 'game_difficult_id',
  /** column name */
  GameId = 'game_id',
  /** column name */
  GameStatus = 'game_status',
  /** column name */
  GameTemplateId = 'game_template_id',
  /** column name */
  IsDemo = 'is_demo',
  /** column name */
  Keywords = 'keywords',
  /** column name */
  Market = 'market',
  /** column name */
  PromoImageUrl = 'promo_image_url',
  /** column name */
  Rating = 'rating',
  /** column name */
  ThemeImageUrl = 'theme_image_url',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "trivia_games" */
export type Trivia_Games_Set_Input = {
  category?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  creator_id?: InputMaybe<Scalars['uuid']>;
  description?: InputMaybe<Scalars['String']>;
  format_graphic_url?: InputMaybe<Scalars['String']>;
  game_date?: InputMaybe<Scalars['date']>;
  game_difficult_id?: InputMaybe<Scalars['Int']>;
  game_id?: InputMaybe<Scalars['uuid']>;
  game_status?: InputMaybe<Scalars['Int']>;
  game_template_id?: InputMaybe<Scalars['String']>;
  is_demo?: InputMaybe<Scalars['Boolean']>;
  keywords?: InputMaybe<Scalars['String']>;
  market?: InputMaybe<Scalars['String']>;
  promo_image_url?: InputMaybe<Scalars['String']>;
  rating?: InputMaybe<Scalars['String']>;
  theme_image_url?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Trivia_Games_Stddev_Fields = {
  __typename?: 'trivia_games_stddev_fields';
  category?: Maybe<Scalars['Float']>;
  game_difficult_id?: Maybe<Scalars['Float']>;
  game_status?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "trivia_games" */
export type Trivia_Games_Stddev_Order_By = {
  category?: InputMaybe<Order_By>;
  game_difficult_id?: InputMaybe<Order_By>;
  game_status?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Trivia_Games_Stddev_Pop_Fields = {
  __typename?: 'trivia_games_stddev_pop_fields';
  category?: Maybe<Scalars['Float']>;
  game_difficult_id?: Maybe<Scalars['Float']>;
  game_status?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "trivia_games" */
export type Trivia_Games_Stddev_Pop_Order_By = {
  category?: InputMaybe<Order_By>;
  game_difficult_id?: InputMaybe<Order_By>;
  game_status?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Trivia_Games_Stddev_Samp_Fields = {
  __typename?: 'trivia_games_stddev_samp_fields';
  category?: Maybe<Scalars['Float']>;
  game_difficult_id?: Maybe<Scalars['Float']>;
  game_status?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "trivia_games" */
export type Trivia_Games_Stddev_Samp_Order_By = {
  category?: InputMaybe<Order_By>;
  game_difficult_id?: InputMaybe<Order_By>;
  game_status?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Trivia_Games_Sum_Fields = {
  __typename?: 'trivia_games_sum_fields';
  category?: Maybe<Scalars['Int']>;
  game_difficult_id?: Maybe<Scalars['Int']>;
  game_status?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "trivia_games" */
export type Trivia_Games_Sum_Order_By = {
  category?: InputMaybe<Order_By>;
  game_difficult_id?: InputMaybe<Order_By>;
  game_status?: InputMaybe<Order_By>;
};

/** update columns of table "trivia_games" */
export enum Trivia_Games_Update_Column {
  /** column name */
  Category = 'category',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatorId = 'creator_id',
  /** column name */
  Description = 'description',
  /** column name */
  FormatGraphicUrl = 'format_graphic_url',
  /** column name */
  GameDate = 'game_date',
  /** column name */
  GameDifficultId = 'game_difficult_id',
  /** column name */
  GameId = 'game_id',
  /** column name */
  GameStatus = 'game_status',
  /** column name */
  GameTemplateId = 'game_template_id',
  /** column name */
  IsDemo = 'is_demo',
  /** column name */
  Keywords = 'keywords',
  /** column name */
  Market = 'market',
  /** column name */
  PromoImageUrl = 'promo_image_url',
  /** column name */
  Rating = 'rating',
  /** column name */
  ThemeImageUrl = 'theme_image_url',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** aggregate var_pop on columns */
export type Trivia_Games_Var_Pop_Fields = {
  __typename?: 'trivia_games_var_pop_fields';
  category?: Maybe<Scalars['Float']>;
  game_difficult_id?: Maybe<Scalars['Float']>;
  game_status?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "trivia_games" */
export type Trivia_Games_Var_Pop_Order_By = {
  category?: InputMaybe<Order_By>;
  game_difficult_id?: InputMaybe<Order_By>;
  game_status?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Trivia_Games_Var_Samp_Fields = {
  __typename?: 'trivia_games_var_samp_fields';
  category?: Maybe<Scalars['Float']>;
  game_difficult_id?: Maybe<Scalars['Float']>;
  game_status?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "trivia_games" */
export type Trivia_Games_Var_Samp_Order_By = {
  category?: InputMaybe<Order_By>;
  game_difficult_id?: InputMaybe<Order_By>;
  game_status?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Trivia_Games_Variance_Fields = {
  __typename?: 'trivia_games_variance_fields';
  category?: Maybe<Scalars['Float']>;
  game_difficult_id?: Maybe<Scalars['Float']>;
  game_status?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "trivia_games" */
export type Trivia_Games_Variance_Order_By = {
  category?: InputMaybe<Order_By>;
  game_difficult_id?: InputMaybe<Order_By>;
  game_status?: InputMaybe<Order_By>;
};

/** columns and relationships of "trivia_question" */
export type Trivia_Question = {
  __typename?: 'trivia_question';
  answer?: Maybe<Scalars['String']>;
  category_id?: Maybe<Scalars['String']>;
  host_note?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  market_id?: Maybe<Scalars['String']>;
  point_value?: Maybe<Scalars['String']>;
  question?: Maybe<Scalars['String']>;
  question_id?: Maybe<Scalars['String']>;
  source_primary?: Maybe<Scalars['String']>;
  source_secondary?: Maybe<Scalars['String']>;
  sub_category_id?: Maybe<Scalars['String']>;
  trivia_category_fk?: Maybe<Scalars['String']>;
  trivia_category_name?: Maybe<Scalars['String']>;
  wrong_answers?: Maybe<Scalars['String']>;
};

/** aggregated selection of "trivia_question" */
export type Trivia_Question_Aggregate = {
  __typename?: 'trivia_question_aggregate';
  aggregate?: Maybe<Trivia_Question_Aggregate_Fields>;
  nodes: Array<Trivia_Question>;
};

/** aggregate fields of "trivia_question" */
export type Trivia_Question_Aggregate_Fields = {
  __typename?: 'trivia_question_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Trivia_Question_Max_Fields>;
  min?: Maybe<Trivia_Question_Min_Fields>;
};


/** aggregate fields of "trivia_question" */
export type Trivia_Question_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Trivia_Question_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "trivia_question" */
export type Trivia_Question_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Trivia_Question_Max_Order_By>;
  min?: InputMaybe<Trivia_Question_Min_Order_By>;
};

/** input type for inserting array relation for remote table "trivia_question" */
export type Trivia_Question_Arr_Rel_Insert_Input = {
  data: Array<Trivia_Question_Insert_Input>;
};

/** Boolean expression to filter rows from the table "trivia_question". All fields are combined with a logical 'AND'. */
export type Trivia_Question_Bool_Exp = {
  _and?: InputMaybe<Array<InputMaybe<Trivia_Question_Bool_Exp>>>;
  _not?: InputMaybe<Trivia_Question_Bool_Exp>;
  _or?: InputMaybe<Array<InputMaybe<Trivia_Question_Bool_Exp>>>;
  answer?: InputMaybe<String_Comparison_Exp>;
  category_id?: InputMaybe<String_Comparison_Exp>;
  host_note?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  market_id?: InputMaybe<String_Comparison_Exp>;
  point_value?: InputMaybe<String_Comparison_Exp>;
  question?: InputMaybe<String_Comparison_Exp>;
  question_id?: InputMaybe<String_Comparison_Exp>;
  source_primary?: InputMaybe<String_Comparison_Exp>;
  source_secondary?: InputMaybe<String_Comparison_Exp>;
  sub_category_id?: InputMaybe<String_Comparison_Exp>;
  trivia_category_fk?: InputMaybe<String_Comparison_Exp>;
  trivia_category_name?: InputMaybe<String_Comparison_Exp>;
  wrong_answers?: InputMaybe<String_Comparison_Exp>;
};

/** input type for inserting data into table "trivia_question" */
export type Trivia_Question_Insert_Input = {
  answer?: InputMaybe<Scalars['String']>;
  category_id?: InputMaybe<Scalars['String']>;
  host_note?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  market_id?: InputMaybe<Scalars['String']>;
  point_value?: InputMaybe<Scalars['String']>;
  question?: InputMaybe<Scalars['String']>;
  question_id?: InputMaybe<Scalars['String']>;
  source_primary?: InputMaybe<Scalars['String']>;
  source_secondary?: InputMaybe<Scalars['String']>;
  sub_category_id?: InputMaybe<Scalars['String']>;
  trivia_category_fk?: InputMaybe<Scalars['String']>;
  trivia_category_name?: InputMaybe<Scalars['String']>;
  wrong_answers?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Trivia_Question_Max_Fields = {
  __typename?: 'trivia_question_max_fields';
  answer?: Maybe<Scalars['String']>;
  category_id?: Maybe<Scalars['String']>;
  host_note?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  market_id?: Maybe<Scalars['String']>;
  point_value?: Maybe<Scalars['String']>;
  question?: Maybe<Scalars['String']>;
  question_id?: Maybe<Scalars['String']>;
  source_primary?: Maybe<Scalars['String']>;
  source_secondary?: Maybe<Scalars['String']>;
  sub_category_id?: Maybe<Scalars['String']>;
  trivia_category_fk?: Maybe<Scalars['String']>;
  trivia_category_name?: Maybe<Scalars['String']>;
  wrong_answers?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "trivia_question" */
export type Trivia_Question_Max_Order_By = {
  answer?: InputMaybe<Order_By>;
  category_id?: InputMaybe<Order_By>;
  host_note?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  market_id?: InputMaybe<Order_By>;
  point_value?: InputMaybe<Order_By>;
  question?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
  source_primary?: InputMaybe<Order_By>;
  source_secondary?: InputMaybe<Order_By>;
  sub_category_id?: InputMaybe<Order_By>;
  trivia_category_fk?: InputMaybe<Order_By>;
  trivia_category_name?: InputMaybe<Order_By>;
  wrong_answers?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Trivia_Question_Min_Fields = {
  __typename?: 'trivia_question_min_fields';
  answer?: Maybe<Scalars['String']>;
  category_id?: Maybe<Scalars['String']>;
  host_note?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  market_id?: Maybe<Scalars['String']>;
  point_value?: Maybe<Scalars['String']>;
  question?: Maybe<Scalars['String']>;
  question_id?: Maybe<Scalars['String']>;
  source_primary?: Maybe<Scalars['String']>;
  source_secondary?: Maybe<Scalars['String']>;
  sub_category_id?: Maybe<Scalars['String']>;
  trivia_category_fk?: Maybe<Scalars['String']>;
  trivia_category_name?: Maybe<Scalars['String']>;
  wrong_answers?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "trivia_question" */
export type Trivia_Question_Min_Order_By = {
  answer?: InputMaybe<Order_By>;
  category_id?: InputMaybe<Order_By>;
  host_note?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  market_id?: InputMaybe<Order_By>;
  point_value?: InputMaybe<Order_By>;
  question?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
  source_primary?: InputMaybe<Order_By>;
  source_secondary?: InputMaybe<Order_By>;
  sub_category_id?: InputMaybe<Order_By>;
  trivia_category_fk?: InputMaybe<Order_By>;
  trivia_category_name?: InputMaybe<Order_By>;
  wrong_answers?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "trivia_question" */
export type Trivia_Question_Mutation_Response = {
  __typename?: 'trivia_question_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Trivia_Question>;
};

/** input type for inserting object relation for remote table "trivia_question" */
export type Trivia_Question_Obj_Rel_Insert_Input = {
  data: Trivia_Question_Insert_Input;
};

/** ordering options when selecting data from "trivia_question" */
export type Trivia_Question_Order_By = {
  answer?: InputMaybe<Order_By>;
  category_id?: InputMaybe<Order_By>;
  host_note?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  market_id?: InputMaybe<Order_By>;
  point_value?: InputMaybe<Order_By>;
  question?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
  source_primary?: InputMaybe<Order_By>;
  source_secondary?: InputMaybe<Order_By>;
  sub_category_id?: InputMaybe<Order_By>;
  trivia_category_fk?: InputMaybe<Order_By>;
  trivia_category_name?: InputMaybe<Order_By>;
  wrong_answers?: InputMaybe<Order_By>;
};

/** select columns of table "trivia_question" */
export enum Trivia_Question_Select_Column {
  /** column name */
  Answer = 'answer',
  /** column name */
  CategoryId = 'category_id',
  /** column name */
  HostNote = 'host_note',
  /** column name */
  Id = 'id',
  /** column name */
  MarketId = 'market_id',
  /** column name */
  PointValue = 'point_value',
  /** column name */
  Question = 'question',
  /** column name */
  QuestionId = 'question_id',
  /** column name */
  SourcePrimary = 'source_primary',
  /** column name */
  SourceSecondary = 'source_secondary',
  /** column name */
  SubCategoryId = 'sub_category_id',
  /** column name */
  TriviaCategoryFk = 'trivia_category_fk',
  /** column name */
  TriviaCategoryName = 'trivia_category_name',
  /** column name */
  WrongAnswers = 'wrong_answers'
}

/** input type for updating data in table "trivia_question" */
export type Trivia_Question_Set_Input = {
  answer?: InputMaybe<Scalars['String']>;
  category_id?: InputMaybe<Scalars['String']>;
  host_note?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  market_id?: InputMaybe<Scalars['String']>;
  point_value?: InputMaybe<Scalars['String']>;
  question?: InputMaybe<Scalars['String']>;
  question_id?: InputMaybe<Scalars['String']>;
  source_primary?: InputMaybe<Scalars['String']>;
  source_secondary?: InputMaybe<Scalars['String']>;
  sub_category_id?: InputMaybe<Scalars['String']>;
  trivia_category_fk?: InputMaybe<Scalars['String']>;
  trivia_category_name?: InputMaybe<Scalars['String']>;
  wrong_answers?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "trivia_round_questions" */
export type Trivia_Round_Questions = {
  __typename?: 'trivia_round_questions';
  /** An object relationship */
  answer_type: Answer_Types;
  answer_type_id: Scalars['Int'];
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  /** An object relationship */
  question: Questions;
  question_id: Scalars['uuid'];
  question_order: Scalars['Int'];
  round_id: Scalars['uuid'];
  trivia_manager_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  trivia_round: Trivia_Rounds;
  updated_at?: Maybe<Scalars['timestamptz']>;
  wager: Scalars['Boolean'];
  wager_range_value?: Maybe<Scalars['String']>;
};

/** aggregated selection of "trivia_round_questions" */
export type Trivia_Round_Questions_Aggregate = {
  __typename?: 'trivia_round_questions_aggregate';
  aggregate?: Maybe<Trivia_Round_Questions_Aggregate_Fields>;
  nodes: Array<Trivia_Round_Questions>;
};

/** aggregate fields of "trivia_round_questions" */
export type Trivia_Round_Questions_Aggregate_Fields = {
  __typename?: 'trivia_round_questions_aggregate_fields';
  avg?: Maybe<Trivia_Round_Questions_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Trivia_Round_Questions_Max_Fields>;
  min?: Maybe<Trivia_Round_Questions_Min_Fields>;
  stddev?: Maybe<Trivia_Round_Questions_Stddev_Fields>;
  stddev_pop?: Maybe<Trivia_Round_Questions_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Trivia_Round_Questions_Stddev_Samp_Fields>;
  sum?: Maybe<Trivia_Round_Questions_Sum_Fields>;
  var_pop?: Maybe<Trivia_Round_Questions_Var_Pop_Fields>;
  var_samp?: Maybe<Trivia_Round_Questions_Var_Samp_Fields>;
  variance?: Maybe<Trivia_Round_Questions_Variance_Fields>;
};


/** aggregate fields of "trivia_round_questions" */
export type Trivia_Round_Questions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Trivia_Round_Questions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "trivia_round_questions" */
export type Trivia_Round_Questions_Aggregate_Order_By = {
  avg?: InputMaybe<Trivia_Round_Questions_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Trivia_Round_Questions_Max_Order_By>;
  min?: InputMaybe<Trivia_Round_Questions_Min_Order_By>;
  stddev?: InputMaybe<Trivia_Round_Questions_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Trivia_Round_Questions_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Trivia_Round_Questions_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Trivia_Round_Questions_Sum_Order_By>;
  var_pop?: InputMaybe<Trivia_Round_Questions_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Trivia_Round_Questions_Var_Samp_Order_By>;
  variance?: InputMaybe<Trivia_Round_Questions_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "trivia_round_questions" */
export type Trivia_Round_Questions_Arr_Rel_Insert_Input = {
  data: Array<Trivia_Round_Questions_Insert_Input>;
  on_conflict?: InputMaybe<Trivia_Round_Questions_On_Conflict>;
};

/** aggregate avg on columns */
export type Trivia_Round_Questions_Avg_Fields = {
  __typename?: 'trivia_round_questions_avg_fields';
  answer_type_id?: Maybe<Scalars['Float']>;
  question_order?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "trivia_round_questions" */
export type Trivia_Round_Questions_Avg_Order_By = {
  answer_type_id?: InputMaybe<Order_By>;
  question_order?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "trivia_round_questions". All fields are combined with a logical 'AND'. */
export type Trivia_Round_Questions_Bool_Exp = {
  _and?: InputMaybe<Array<InputMaybe<Trivia_Round_Questions_Bool_Exp>>>;
  _not?: InputMaybe<Trivia_Round_Questions_Bool_Exp>;
  _or?: InputMaybe<Array<InputMaybe<Trivia_Round_Questions_Bool_Exp>>>;
  answer_type?: InputMaybe<Answer_Types_Bool_Exp>;
  answer_type_id?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  question?: InputMaybe<Questions_Bool_Exp>;
  question_id?: InputMaybe<Uuid_Comparison_Exp>;
  question_order?: InputMaybe<Int_Comparison_Exp>;
  round_id?: InputMaybe<Uuid_Comparison_Exp>;
  trivia_manager_id?: InputMaybe<Uuid_Comparison_Exp>;
  trivia_round?: InputMaybe<Trivia_Rounds_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  wager?: InputMaybe<Boolean_Comparison_Exp>;
  wager_range_value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "trivia_round_questions" */
export enum Trivia_Round_Questions_Constraint {
  /** unique or primary key constraint */
  TriviaRoundQuestionsPkey = 'trivia_round_questions_pkey',
  /** unique or primary key constraint */
  UniqueQuestionRound = 'unique_question_round'
}

/** input type for incrementing integer column in table "trivia_round_questions" */
export type Trivia_Round_Questions_Inc_Input = {
  answer_type_id?: InputMaybe<Scalars['Int']>;
  question_order?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "trivia_round_questions" */
export type Trivia_Round_Questions_Insert_Input = {
  answer_type?: InputMaybe<Answer_Types_Obj_Rel_Insert_Input>;
  answer_type_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  question?: InputMaybe<Questions_Obj_Rel_Insert_Input>;
  question_id?: InputMaybe<Scalars['uuid']>;
  question_order?: InputMaybe<Scalars['Int']>;
  round_id?: InputMaybe<Scalars['uuid']>;
  trivia_manager_id?: InputMaybe<Scalars['uuid']>;
  trivia_round?: InputMaybe<Trivia_Rounds_Obj_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  wager?: InputMaybe<Scalars['Boolean']>;
  wager_range_value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Trivia_Round_Questions_Max_Fields = {
  __typename?: 'trivia_round_questions_max_fields';
  answer_type_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  question_id?: Maybe<Scalars['uuid']>;
  question_order?: Maybe<Scalars['Int']>;
  round_id?: Maybe<Scalars['uuid']>;
  trivia_manager_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  wager_range_value?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "trivia_round_questions" */
export type Trivia_Round_Questions_Max_Order_By = {
  answer_type_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
  question_order?: InputMaybe<Order_By>;
  round_id?: InputMaybe<Order_By>;
  trivia_manager_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  wager_range_value?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Trivia_Round_Questions_Min_Fields = {
  __typename?: 'trivia_round_questions_min_fields';
  answer_type_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  question_id?: Maybe<Scalars['uuid']>;
  question_order?: Maybe<Scalars['Int']>;
  round_id?: Maybe<Scalars['uuid']>;
  trivia_manager_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  wager_range_value?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "trivia_round_questions" */
export type Trivia_Round_Questions_Min_Order_By = {
  answer_type_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
  question_order?: InputMaybe<Order_By>;
  round_id?: InputMaybe<Order_By>;
  trivia_manager_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  wager_range_value?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "trivia_round_questions" */
export type Trivia_Round_Questions_Mutation_Response = {
  __typename?: 'trivia_round_questions_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Trivia_Round_Questions>;
};

/** input type for inserting object relation for remote table "trivia_round_questions" */
export type Trivia_Round_Questions_Obj_Rel_Insert_Input = {
  data: Trivia_Round_Questions_Insert_Input;
  on_conflict?: InputMaybe<Trivia_Round_Questions_On_Conflict>;
};

/** on conflict condition type for table "trivia_round_questions" */
export type Trivia_Round_Questions_On_Conflict = {
  constraint: Trivia_Round_Questions_Constraint;
  update_columns: Array<Trivia_Round_Questions_Update_Column>;
  where?: InputMaybe<Trivia_Round_Questions_Bool_Exp>;
};

/** ordering options when selecting data from "trivia_round_questions" */
export type Trivia_Round_Questions_Order_By = {
  answer_type?: InputMaybe<Answer_Types_Order_By>;
  answer_type_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  question?: InputMaybe<Questions_Order_By>;
  question_id?: InputMaybe<Order_By>;
  question_order?: InputMaybe<Order_By>;
  round_id?: InputMaybe<Order_By>;
  trivia_manager_id?: InputMaybe<Order_By>;
  trivia_round?: InputMaybe<Trivia_Rounds_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  wager?: InputMaybe<Order_By>;
  wager_range_value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: "trivia_round_questions" */
export type Trivia_Round_Questions_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "trivia_round_questions" */
export enum Trivia_Round_Questions_Select_Column {
  /** column name */
  AnswerTypeId = 'answer_type_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  QuestionId = 'question_id',
  /** column name */
  QuestionOrder = 'question_order',
  /** column name */
  RoundId = 'round_id',
  /** column name */
  TriviaManagerId = 'trivia_manager_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Wager = 'wager',
  /** column name */
  WagerRangeValue = 'wager_range_value'
}

/** input type for updating data in table "trivia_round_questions" */
export type Trivia_Round_Questions_Set_Input = {
  answer_type_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  question_id?: InputMaybe<Scalars['uuid']>;
  question_order?: InputMaybe<Scalars['Int']>;
  round_id?: InputMaybe<Scalars['uuid']>;
  trivia_manager_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  wager?: InputMaybe<Scalars['Boolean']>;
  wager_range_value?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Trivia_Round_Questions_Stddev_Fields = {
  __typename?: 'trivia_round_questions_stddev_fields';
  answer_type_id?: Maybe<Scalars['Float']>;
  question_order?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "trivia_round_questions" */
export type Trivia_Round_Questions_Stddev_Order_By = {
  answer_type_id?: InputMaybe<Order_By>;
  question_order?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Trivia_Round_Questions_Stddev_Pop_Fields = {
  __typename?: 'trivia_round_questions_stddev_pop_fields';
  answer_type_id?: Maybe<Scalars['Float']>;
  question_order?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "trivia_round_questions" */
export type Trivia_Round_Questions_Stddev_Pop_Order_By = {
  answer_type_id?: InputMaybe<Order_By>;
  question_order?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Trivia_Round_Questions_Stddev_Samp_Fields = {
  __typename?: 'trivia_round_questions_stddev_samp_fields';
  answer_type_id?: Maybe<Scalars['Float']>;
  question_order?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "trivia_round_questions" */
export type Trivia_Round_Questions_Stddev_Samp_Order_By = {
  answer_type_id?: InputMaybe<Order_By>;
  question_order?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Trivia_Round_Questions_Sum_Fields = {
  __typename?: 'trivia_round_questions_sum_fields';
  answer_type_id?: Maybe<Scalars['Int']>;
  question_order?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "trivia_round_questions" */
export type Trivia_Round_Questions_Sum_Order_By = {
  answer_type_id?: InputMaybe<Order_By>;
  question_order?: InputMaybe<Order_By>;
};

/** update columns of table "trivia_round_questions" */
export enum Trivia_Round_Questions_Update_Column {
  /** column name */
  AnswerTypeId = 'answer_type_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  QuestionId = 'question_id',
  /** column name */
  QuestionOrder = 'question_order',
  /** column name */
  RoundId = 'round_id',
  /** column name */
  TriviaManagerId = 'trivia_manager_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Wager = 'wager',
  /** column name */
  WagerRangeValue = 'wager_range_value'
}

/** aggregate var_pop on columns */
export type Trivia_Round_Questions_Var_Pop_Fields = {
  __typename?: 'trivia_round_questions_var_pop_fields';
  answer_type_id?: Maybe<Scalars['Float']>;
  question_order?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "trivia_round_questions" */
export type Trivia_Round_Questions_Var_Pop_Order_By = {
  answer_type_id?: InputMaybe<Order_By>;
  question_order?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Trivia_Round_Questions_Var_Samp_Fields = {
  __typename?: 'trivia_round_questions_var_samp_fields';
  answer_type_id?: Maybe<Scalars['Float']>;
  question_order?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "trivia_round_questions" */
export type Trivia_Round_Questions_Var_Samp_Order_By = {
  answer_type_id?: InputMaybe<Order_By>;
  question_order?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Trivia_Round_Questions_Variance_Fields = {
  __typename?: 'trivia_round_questions_variance_fields';
  answer_type_id?: Maybe<Scalars['Float']>;
  question_order?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "trivia_round_questions" */
export type Trivia_Round_Questions_Variance_Order_By = {
  answer_type_id?: InputMaybe<Order_By>;
  question_order?: InputMaybe<Order_By>;
};

/** columns and relationships of "trivia_round_templates" */
export type Trivia_Round_Templates = {
  __typename?: 'trivia_round_templates';
  template_id: Scalars['String'];
  template_name: Scalars['String'];
};

/** aggregated selection of "trivia_round_templates" */
export type Trivia_Round_Templates_Aggregate = {
  __typename?: 'trivia_round_templates_aggregate';
  aggregate?: Maybe<Trivia_Round_Templates_Aggregate_Fields>;
  nodes: Array<Trivia_Round_Templates>;
};

/** aggregate fields of "trivia_round_templates" */
export type Trivia_Round_Templates_Aggregate_Fields = {
  __typename?: 'trivia_round_templates_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Trivia_Round_Templates_Max_Fields>;
  min?: Maybe<Trivia_Round_Templates_Min_Fields>;
};


/** aggregate fields of "trivia_round_templates" */
export type Trivia_Round_Templates_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Trivia_Round_Templates_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "trivia_round_templates" */
export type Trivia_Round_Templates_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Trivia_Round_Templates_Max_Order_By>;
  min?: InputMaybe<Trivia_Round_Templates_Min_Order_By>;
};

/** input type for inserting array relation for remote table "trivia_round_templates" */
export type Trivia_Round_Templates_Arr_Rel_Insert_Input = {
  data: Array<Trivia_Round_Templates_Insert_Input>;
  on_conflict?: InputMaybe<Trivia_Round_Templates_On_Conflict>;
};

/** Boolean expression to filter rows from the table "trivia_round_templates". All fields are combined with a logical 'AND'. */
export type Trivia_Round_Templates_Bool_Exp = {
  _and?: InputMaybe<Array<InputMaybe<Trivia_Round_Templates_Bool_Exp>>>;
  _not?: InputMaybe<Trivia_Round_Templates_Bool_Exp>;
  _or?: InputMaybe<Array<InputMaybe<Trivia_Round_Templates_Bool_Exp>>>;
  template_id?: InputMaybe<String_Comparison_Exp>;
  template_name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "trivia_round_templates" */
export enum Trivia_Round_Templates_Constraint {
  /** unique or primary key constraint */
  TriviaRoundTemplatesPkey = 'trivia_round_templates_pkey'
}

/** input type for inserting data into table "trivia_round_templates" */
export type Trivia_Round_Templates_Insert_Input = {
  template_id?: InputMaybe<Scalars['String']>;
  template_name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Trivia_Round_Templates_Max_Fields = {
  __typename?: 'trivia_round_templates_max_fields';
  template_id?: Maybe<Scalars['String']>;
  template_name?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "trivia_round_templates" */
export type Trivia_Round_Templates_Max_Order_By = {
  template_id?: InputMaybe<Order_By>;
  template_name?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Trivia_Round_Templates_Min_Fields = {
  __typename?: 'trivia_round_templates_min_fields';
  template_id?: Maybe<Scalars['String']>;
  template_name?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "trivia_round_templates" */
export type Trivia_Round_Templates_Min_Order_By = {
  template_id?: InputMaybe<Order_By>;
  template_name?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "trivia_round_templates" */
export type Trivia_Round_Templates_Mutation_Response = {
  __typename?: 'trivia_round_templates_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Trivia_Round_Templates>;
};

/** input type for inserting object relation for remote table "trivia_round_templates" */
export type Trivia_Round_Templates_Obj_Rel_Insert_Input = {
  data: Trivia_Round_Templates_Insert_Input;
  on_conflict?: InputMaybe<Trivia_Round_Templates_On_Conflict>;
};

/** on conflict condition type for table "trivia_round_templates" */
export type Trivia_Round_Templates_On_Conflict = {
  constraint: Trivia_Round_Templates_Constraint;
  update_columns: Array<Trivia_Round_Templates_Update_Column>;
  where?: InputMaybe<Trivia_Round_Templates_Bool_Exp>;
};

/** ordering options when selecting data from "trivia_round_templates" */
export type Trivia_Round_Templates_Order_By = {
  template_id?: InputMaybe<Order_By>;
  template_name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: "trivia_round_templates" */
export type Trivia_Round_Templates_Pk_Columns_Input = {
  template_id: Scalars['String'];
};

/** select columns of table "trivia_round_templates" */
export enum Trivia_Round_Templates_Select_Column {
  /** column name */
  TemplateId = 'template_id',
  /** column name */
  TemplateName = 'template_name'
}

/** input type for updating data in table "trivia_round_templates" */
export type Trivia_Round_Templates_Set_Input = {
  template_id?: InputMaybe<Scalars['String']>;
  template_name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "trivia_round_templates" */
export enum Trivia_Round_Templates_Update_Column {
  /** column name */
  TemplateId = 'template_id',
  /** column name */
  TemplateName = 'template_name'
}

/** columns and relationships of "trivia_round_themes" */
export type Trivia_Round_Themes = {
  __typename?: 'trivia_round_themes';
  /** An object relationship */
  game_theme: Game_Themes;
  round_id: Scalars['uuid'];
  round_theme_id: Scalars['uuid'];
  theme_id: Scalars['uuid'];
  /** An object relationship */
  trivia_round: Trivia_Rounds;
};

/** aggregated selection of "trivia_round_themes" */
export type Trivia_Round_Themes_Aggregate = {
  __typename?: 'trivia_round_themes_aggregate';
  aggregate?: Maybe<Trivia_Round_Themes_Aggregate_Fields>;
  nodes: Array<Trivia_Round_Themes>;
};

/** aggregate fields of "trivia_round_themes" */
export type Trivia_Round_Themes_Aggregate_Fields = {
  __typename?: 'trivia_round_themes_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Trivia_Round_Themes_Max_Fields>;
  min?: Maybe<Trivia_Round_Themes_Min_Fields>;
};


/** aggregate fields of "trivia_round_themes" */
export type Trivia_Round_Themes_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Trivia_Round_Themes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "trivia_round_themes" */
export type Trivia_Round_Themes_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Trivia_Round_Themes_Max_Order_By>;
  min?: InputMaybe<Trivia_Round_Themes_Min_Order_By>;
};

/** input type for inserting array relation for remote table "trivia_round_themes" */
export type Trivia_Round_Themes_Arr_Rel_Insert_Input = {
  data: Array<Trivia_Round_Themes_Insert_Input>;
  on_conflict?: InputMaybe<Trivia_Round_Themes_On_Conflict>;
};

/** Boolean expression to filter rows from the table "trivia_round_themes". All fields are combined with a logical 'AND'. */
export type Trivia_Round_Themes_Bool_Exp = {
  _and?: InputMaybe<Array<InputMaybe<Trivia_Round_Themes_Bool_Exp>>>;
  _not?: InputMaybe<Trivia_Round_Themes_Bool_Exp>;
  _or?: InputMaybe<Array<InputMaybe<Trivia_Round_Themes_Bool_Exp>>>;
  game_theme?: InputMaybe<Game_Themes_Bool_Exp>;
  round_id?: InputMaybe<Uuid_Comparison_Exp>;
  round_theme_id?: InputMaybe<Uuid_Comparison_Exp>;
  theme_id?: InputMaybe<Uuid_Comparison_Exp>;
  trivia_round?: InputMaybe<Trivia_Rounds_Bool_Exp>;
};

/** unique or primary key constraints on table "trivia_round_themes" */
export enum Trivia_Round_Themes_Constraint {
  /** unique or primary key constraint */
  TriviaRoundThemesPkey = 'trivia_round_themes_pkey'
}

/** input type for inserting data into table "trivia_round_themes" */
export type Trivia_Round_Themes_Insert_Input = {
  game_theme?: InputMaybe<Game_Themes_Obj_Rel_Insert_Input>;
  round_id?: InputMaybe<Scalars['uuid']>;
  round_theme_id?: InputMaybe<Scalars['uuid']>;
  theme_id?: InputMaybe<Scalars['uuid']>;
  trivia_round?: InputMaybe<Trivia_Rounds_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Trivia_Round_Themes_Max_Fields = {
  __typename?: 'trivia_round_themes_max_fields';
  round_id?: Maybe<Scalars['uuid']>;
  round_theme_id?: Maybe<Scalars['uuid']>;
  theme_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "trivia_round_themes" */
export type Trivia_Round_Themes_Max_Order_By = {
  round_id?: InputMaybe<Order_By>;
  round_theme_id?: InputMaybe<Order_By>;
  theme_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Trivia_Round_Themes_Min_Fields = {
  __typename?: 'trivia_round_themes_min_fields';
  round_id?: Maybe<Scalars['uuid']>;
  round_theme_id?: Maybe<Scalars['uuid']>;
  theme_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "trivia_round_themes" */
export type Trivia_Round_Themes_Min_Order_By = {
  round_id?: InputMaybe<Order_By>;
  round_theme_id?: InputMaybe<Order_By>;
  theme_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "trivia_round_themes" */
export type Trivia_Round_Themes_Mutation_Response = {
  __typename?: 'trivia_round_themes_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Trivia_Round_Themes>;
};

/** input type for inserting object relation for remote table "trivia_round_themes" */
export type Trivia_Round_Themes_Obj_Rel_Insert_Input = {
  data: Trivia_Round_Themes_Insert_Input;
  on_conflict?: InputMaybe<Trivia_Round_Themes_On_Conflict>;
};

/** on conflict condition type for table "trivia_round_themes" */
export type Trivia_Round_Themes_On_Conflict = {
  constraint: Trivia_Round_Themes_Constraint;
  update_columns: Array<Trivia_Round_Themes_Update_Column>;
  where?: InputMaybe<Trivia_Round_Themes_Bool_Exp>;
};

/** ordering options when selecting data from "trivia_round_themes" */
export type Trivia_Round_Themes_Order_By = {
  game_theme?: InputMaybe<Game_Themes_Order_By>;
  round_id?: InputMaybe<Order_By>;
  round_theme_id?: InputMaybe<Order_By>;
  theme_id?: InputMaybe<Order_By>;
  trivia_round?: InputMaybe<Trivia_Rounds_Order_By>;
};

/** primary key columns input for table: "trivia_round_themes" */
export type Trivia_Round_Themes_Pk_Columns_Input = {
  round_theme_id: Scalars['uuid'];
};

/** select columns of table "trivia_round_themes" */
export enum Trivia_Round_Themes_Select_Column {
  /** column name */
  RoundId = 'round_id',
  /** column name */
  RoundThemeId = 'round_theme_id',
  /** column name */
  ThemeId = 'theme_id'
}

/** input type for updating data in table "trivia_round_themes" */
export type Trivia_Round_Themes_Set_Input = {
  round_id?: InputMaybe<Scalars['uuid']>;
  round_theme_id?: InputMaybe<Scalars['uuid']>;
  theme_id?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "trivia_round_themes" */
export enum Trivia_Round_Themes_Update_Column {
  /** column name */
  RoundId = 'round_id',
  /** column name */
  RoundThemeId = 'round_theme_id',
  /** column name */
  ThemeId = 'theme_id'
}

/** columns and relationships of "trivia_round_types" */
export type Trivia_Round_Types = {
  __typename?: 'trivia_round_types';
  id: Scalars['String'];
  name: Scalars['String'];
};

/** aggregated selection of "trivia_round_types" */
export type Trivia_Round_Types_Aggregate = {
  __typename?: 'trivia_round_types_aggregate';
  aggregate?: Maybe<Trivia_Round_Types_Aggregate_Fields>;
  nodes: Array<Trivia_Round_Types>;
};

/** aggregate fields of "trivia_round_types" */
export type Trivia_Round_Types_Aggregate_Fields = {
  __typename?: 'trivia_round_types_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Trivia_Round_Types_Max_Fields>;
  min?: Maybe<Trivia_Round_Types_Min_Fields>;
};


/** aggregate fields of "trivia_round_types" */
export type Trivia_Round_Types_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Trivia_Round_Types_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "trivia_round_types" */
export type Trivia_Round_Types_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Trivia_Round_Types_Max_Order_By>;
  min?: InputMaybe<Trivia_Round_Types_Min_Order_By>;
};

/** input type for inserting array relation for remote table "trivia_round_types" */
export type Trivia_Round_Types_Arr_Rel_Insert_Input = {
  data: Array<Trivia_Round_Types_Insert_Input>;
  on_conflict?: InputMaybe<Trivia_Round_Types_On_Conflict>;
};

/** Boolean expression to filter rows from the table "trivia_round_types". All fields are combined with a logical 'AND'. */
export type Trivia_Round_Types_Bool_Exp = {
  _and?: InputMaybe<Array<InputMaybe<Trivia_Round_Types_Bool_Exp>>>;
  _not?: InputMaybe<Trivia_Round_Types_Bool_Exp>;
  _or?: InputMaybe<Array<InputMaybe<Trivia_Round_Types_Bool_Exp>>>;
  id?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "trivia_round_types" */
export enum Trivia_Round_Types_Constraint {
  /** unique or primary key constraint */
  TriviaRoundTypesPkey = 'trivia_round_types_pkey'
}

/** input type for inserting data into table "trivia_round_types" */
export type Trivia_Round_Types_Insert_Input = {
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Trivia_Round_Types_Max_Fields = {
  __typename?: 'trivia_round_types_max_fields';
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "trivia_round_types" */
export type Trivia_Round_Types_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Trivia_Round_Types_Min_Fields = {
  __typename?: 'trivia_round_types_min_fields';
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "trivia_round_types" */
export type Trivia_Round_Types_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "trivia_round_types" */
export type Trivia_Round_Types_Mutation_Response = {
  __typename?: 'trivia_round_types_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Trivia_Round_Types>;
};

/** input type for inserting object relation for remote table "trivia_round_types" */
export type Trivia_Round_Types_Obj_Rel_Insert_Input = {
  data: Trivia_Round_Types_Insert_Input;
  on_conflict?: InputMaybe<Trivia_Round_Types_On_Conflict>;
};

/** on conflict condition type for table "trivia_round_types" */
export type Trivia_Round_Types_On_Conflict = {
  constraint: Trivia_Round_Types_Constraint;
  update_columns: Array<Trivia_Round_Types_Update_Column>;
  where?: InputMaybe<Trivia_Round_Types_Bool_Exp>;
};

/** ordering options when selecting data from "trivia_round_types" */
export type Trivia_Round_Types_Order_By = {
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: "trivia_round_types" */
export type Trivia_Round_Types_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** select columns of table "trivia_round_types" */
export enum Trivia_Round_Types_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "trivia_round_types" */
export type Trivia_Round_Types_Set_Input = {
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "trivia_round_types" */
export enum Trivia_Round_Types_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** columns and relationships of "trivia_rounds" */
export type Trivia_Rounds = {
  __typename?: 'trivia_rounds';
  created_at: Scalars['timestamptz'];
  name?: Maybe<Scalars['String']>;
  round_id: Scalars['uuid'];
  round_keywords?: Maybe<Scalars['String']>;
  round_template_id: Scalars['String'];
  round_type: Scalars['String'];
  /** An array relationship */
  trivia_game_rounds: Array<Trivia_Game_Rounds>;
  /** An aggregated array relationship */
  trivia_game_rounds_aggregate: Trivia_Game_Rounds_Aggregate;
  /** An array relationship */
  trivia_round_questions: Array<Trivia_Round_Questions>;
  /** An aggregated array relationship */
  trivia_round_questions_aggregate: Trivia_Round_Questions_Aggregate;
  /** An object relationship */
  trivia_round_template: Trivia_Round_Templates;
  /** An array relationship */
  trivia_round_themes: Array<Trivia_Round_Themes>;
  /** An aggregated array relationship */
  trivia_round_themes_aggregate: Trivia_Round_Themes_Aggregate;
  /** An object relationship */
  trivia_round_type: Trivia_Round_Types;
  updated_at?: Maybe<Scalars['timestamptz']>;
};


/** columns and relationships of "trivia_rounds" */
export type Trivia_RoundsTrivia_Game_RoundsArgs = {
  distinct_on?: InputMaybe<Array<Trivia_Game_Rounds_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trivia_Game_Rounds_Order_By>>;
  where?: InputMaybe<Trivia_Game_Rounds_Bool_Exp>;
};


/** columns and relationships of "trivia_rounds" */
export type Trivia_RoundsTrivia_Game_Rounds_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trivia_Game_Rounds_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trivia_Game_Rounds_Order_By>>;
  where?: InputMaybe<Trivia_Game_Rounds_Bool_Exp>;
};


/** columns and relationships of "trivia_rounds" */
export type Trivia_RoundsTrivia_Round_QuestionsArgs = {
  distinct_on?: InputMaybe<Array<Trivia_Round_Questions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trivia_Round_Questions_Order_By>>;
  where?: InputMaybe<Trivia_Round_Questions_Bool_Exp>;
};


/** columns and relationships of "trivia_rounds" */
export type Trivia_RoundsTrivia_Round_Questions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trivia_Round_Questions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trivia_Round_Questions_Order_By>>;
  where?: InputMaybe<Trivia_Round_Questions_Bool_Exp>;
};


/** columns and relationships of "trivia_rounds" */
export type Trivia_RoundsTrivia_Round_ThemesArgs = {
  distinct_on?: InputMaybe<Array<Trivia_Round_Themes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trivia_Round_Themes_Order_By>>;
  where?: InputMaybe<Trivia_Round_Themes_Bool_Exp>;
};


/** columns and relationships of "trivia_rounds" */
export type Trivia_RoundsTrivia_Round_Themes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trivia_Round_Themes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trivia_Round_Themes_Order_By>>;
  where?: InputMaybe<Trivia_Round_Themes_Bool_Exp>;
};

/** aggregated selection of "trivia_rounds" */
export type Trivia_Rounds_Aggregate = {
  __typename?: 'trivia_rounds_aggregate';
  aggregate?: Maybe<Trivia_Rounds_Aggregate_Fields>;
  nodes: Array<Trivia_Rounds>;
};

/** aggregate fields of "trivia_rounds" */
export type Trivia_Rounds_Aggregate_Fields = {
  __typename?: 'trivia_rounds_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Trivia_Rounds_Max_Fields>;
  min?: Maybe<Trivia_Rounds_Min_Fields>;
};


/** aggregate fields of "trivia_rounds" */
export type Trivia_Rounds_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Trivia_Rounds_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "trivia_rounds" */
export type Trivia_Rounds_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Trivia_Rounds_Max_Order_By>;
  min?: InputMaybe<Trivia_Rounds_Min_Order_By>;
};

/** input type for inserting array relation for remote table "trivia_rounds" */
export type Trivia_Rounds_Arr_Rel_Insert_Input = {
  data: Array<Trivia_Rounds_Insert_Input>;
  on_conflict?: InputMaybe<Trivia_Rounds_On_Conflict>;
};

/** Boolean expression to filter rows from the table "trivia_rounds". All fields are combined with a logical 'AND'. */
export type Trivia_Rounds_Bool_Exp = {
  _and?: InputMaybe<Array<InputMaybe<Trivia_Rounds_Bool_Exp>>>;
  _not?: InputMaybe<Trivia_Rounds_Bool_Exp>;
  _or?: InputMaybe<Array<InputMaybe<Trivia_Rounds_Bool_Exp>>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  round_id?: InputMaybe<Uuid_Comparison_Exp>;
  round_keywords?: InputMaybe<String_Comparison_Exp>;
  round_template_id?: InputMaybe<String_Comparison_Exp>;
  round_type?: InputMaybe<String_Comparison_Exp>;
  trivia_game_rounds?: InputMaybe<Trivia_Game_Rounds_Bool_Exp>;
  trivia_round_questions?: InputMaybe<Trivia_Round_Questions_Bool_Exp>;
  trivia_round_template?: InputMaybe<Trivia_Round_Templates_Bool_Exp>;
  trivia_round_themes?: InputMaybe<Trivia_Round_Themes_Bool_Exp>;
  trivia_round_type?: InputMaybe<Trivia_Round_Types_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "trivia_rounds" */
export enum Trivia_Rounds_Constraint {
  /** unique or primary key constraint */
  TriviaRoundsPkey = 'trivia_rounds_pkey'
}

/** input type for inserting data into table "trivia_rounds" */
export type Trivia_Rounds_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  name?: InputMaybe<Scalars['String']>;
  round_id?: InputMaybe<Scalars['uuid']>;
  round_keywords?: InputMaybe<Scalars['String']>;
  round_template_id?: InputMaybe<Scalars['String']>;
  round_type?: InputMaybe<Scalars['String']>;
  trivia_game_rounds?: InputMaybe<Trivia_Game_Rounds_Arr_Rel_Insert_Input>;
  trivia_round_questions?: InputMaybe<Trivia_Round_Questions_Arr_Rel_Insert_Input>;
  trivia_round_template?: InputMaybe<Trivia_Round_Templates_Obj_Rel_Insert_Input>;
  trivia_round_themes?: InputMaybe<Trivia_Round_Themes_Arr_Rel_Insert_Input>;
  trivia_round_type?: InputMaybe<Trivia_Round_Types_Obj_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Trivia_Rounds_Max_Fields = {
  __typename?: 'trivia_rounds_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  name?: Maybe<Scalars['String']>;
  round_id?: Maybe<Scalars['uuid']>;
  round_keywords?: Maybe<Scalars['String']>;
  round_template_id?: Maybe<Scalars['String']>;
  round_type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "trivia_rounds" */
export type Trivia_Rounds_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  round_id?: InputMaybe<Order_By>;
  round_keywords?: InputMaybe<Order_By>;
  round_template_id?: InputMaybe<Order_By>;
  round_type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Trivia_Rounds_Min_Fields = {
  __typename?: 'trivia_rounds_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  name?: Maybe<Scalars['String']>;
  round_id?: Maybe<Scalars['uuid']>;
  round_keywords?: Maybe<Scalars['String']>;
  round_template_id?: Maybe<Scalars['String']>;
  round_type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "trivia_rounds" */
export type Trivia_Rounds_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  round_id?: InputMaybe<Order_By>;
  round_keywords?: InputMaybe<Order_By>;
  round_template_id?: InputMaybe<Order_By>;
  round_type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "trivia_rounds" */
export type Trivia_Rounds_Mutation_Response = {
  __typename?: 'trivia_rounds_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Trivia_Rounds>;
};

/** input type for inserting object relation for remote table "trivia_rounds" */
export type Trivia_Rounds_Obj_Rel_Insert_Input = {
  data: Trivia_Rounds_Insert_Input;
  on_conflict?: InputMaybe<Trivia_Rounds_On_Conflict>;
};

/** on conflict condition type for table "trivia_rounds" */
export type Trivia_Rounds_On_Conflict = {
  constraint: Trivia_Rounds_Constraint;
  update_columns: Array<Trivia_Rounds_Update_Column>;
  where?: InputMaybe<Trivia_Rounds_Bool_Exp>;
};

/** ordering options when selecting data from "trivia_rounds" */
export type Trivia_Rounds_Order_By = {
  created_at?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  round_id?: InputMaybe<Order_By>;
  round_keywords?: InputMaybe<Order_By>;
  round_template_id?: InputMaybe<Order_By>;
  round_type?: InputMaybe<Order_By>;
  trivia_game_rounds_aggregate?: InputMaybe<Trivia_Game_Rounds_Aggregate_Order_By>;
  trivia_round_questions_aggregate?: InputMaybe<Trivia_Round_Questions_Aggregate_Order_By>;
  trivia_round_template?: InputMaybe<Trivia_Round_Templates_Order_By>;
  trivia_round_themes_aggregate?: InputMaybe<Trivia_Round_Themes_Aggregate_Order_By>;
  trivia_round_type?: InputMaybe<Trivia_Round_Types_Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: "trivia_rounds" */
export type Trivia_Rounds_Pk_Columns_Input = {
  round_id: Scalars['uuid'];
};

/** select columns of table "trivia_rounds" */
export enum Trivia_Rounds_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Name = 'name',
  /** column name */
  RoundId = 'round_id',
  /** column name */
  RoundKeywords = 'round_keywords',
  /** column name */
  RoundTemplateId = 'round_template_id',
  /** column name */
  RoundType = 'round_type',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "trivia_rounds" */
export type Trivia_Rounds_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  name?: InputMaybe<Scalars['String']>;
  round_id?: InputMaybe<Scalars['uuid']>;
  round_keywords?: InputMaybe<Scalars['String']>;
  round_template_id?: InputMaybe<Scalars['String']>;
  round_type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "trivia_rounds" */
export enum Trivia_Rounds_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Name = 'name',
  /** column name */
  RoundId = 'round_id',
  /** column name */
  RoundKeywords = 'round_keywords',
  /** column name */
  RoundTemplateId = 'round_template_id',
  /** column name */
  RoundType = 'round_type',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** columns and relationships of "trivia_users" */
export type Trivia_Users = {
  __typename?: 'trivia_users';
  active_status?: Maybe<Scalars['Int']>;
  /** An array relationship */
  approved_questions: Array<Questions>;
  /** An aggregated array relationship */
  approved_questions_aggregate: Questions_Aggregate;
  created_at?: Maybe<Scalars['timestamptz']>;
  email: Scalars['String'];
  firstname?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
  info_json?: Maybe<Scalars['jsonb']>;
  lastname?: Maybe<Scalars['String']>;
  password: Scalars['String'];
  phone_number?: Maybe<Scalars['String']>;
  specialties?: Maybe<Scalars['String']>;
  status_id: Scalars['Int'];
  timezone?: Maybe<Scalars['Int']>;
  topics?: Maybe<Scalars['String']>;
  trivia_user_id: Scalars['uuid'];
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  user_type: User_Types;
  user_type_id: Scalars['Int'];
  /** An array relationship */
  written_questions: Array<Questions>;
  /** An aggregated array relationship */
  written_questions_aggregate: Questions_Aggregate;
};


/** columns and relationships of "trivia_users" */
export type Trivia_UsersApproved_QuestionsArgs = {
  distinct_on?: InputMaybe<Array<Questions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Questions_Order_By>>;
  where?: InputMaybe<Questions_Bool_Exp>;
};


/** columns and relationships of "trivia_users" */
export type Trivia_UsersApproved_Questions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Questions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Questions_Order_By>>;
  where?: InputMaybe<Questions_Bool_Exp>;
};


/** columns and relationships of "trivia_users" */
export type Trivia_UsersInfo_JsonArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "trivia_users" */
export type Trivia_UsersWritten_QuestionsArgs = {
  distinct_on?: InputMaybe<Array<Questions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Questions_Order_By>>;
  where?: InputMaybe<Questions_Bool_Exp>;
};


/** columns and relationships of "trivia_users" */
export type Trivia_UsersWritten_Questions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Questions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Questions_Order_By>>;
  where?: InputMaybe<Questions_Bool_Exp>;
};

/** aggregated selection of "trivia_users" */
export type Trivia_Users_Aggregate = {
  __typename?: 'trivia_users_aggregate';
  aggregate?: Maybe<Trivia_Users_Aggregate_Fields>;
  nodes: Array<Trivia_Users>;
};

/** aggregate fields of "trivia_users" */
export type Trivia_Users_Aggregate_Fields = {
  __typename?: 'trivia_users_aggregate_fields';
  avg?: Maybe<Trivia_Users_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Trivia_Users_Max_Fields>;
  min?: Maybe<Trivia_Users_Min_Fields>;
  stddev?: Maybe<Trivia_Users_Stddev_Fields>;
  stddev_pop?: Maybe<Trivia_Users_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Trivia_Users_Stddev_Samp_Fields>;
  sum?: Maybe<Trivia_Users_Sum_Fields>;
  var_pop?: Maybe<Trivia_Users_Var_Pop_Fields>;
  var_samp?: Maybe<Trivia_Users_Var_Samp_Fields>;
  variance?: Maybe<Trivia_Users_Variance_Fields>;
};


/** aggregate fields of "trivia_users" */
export type Trivia_Users_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Trivia_Users_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "trivia_users" */
export type Trivia_Users_Aggregate_Order_By = {
  avg?: InputMaybe<Trivia_Users_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Trivia_Users_Max_Order_By>;
  min?: InputMaybe<Trivia_Users_Min_Order_By>;
  stddev?: InputMaybe<Trivia_Users_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Trivia_Users_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Trivia_Users_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Trivia_Users_Sum_Order_By>;
  var_pop?: InputMaybe<Trivia_Users_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Trivia_Users_Var_Samp_Order_By>;
  variance?: InputMaybe<Trivia_Users_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Trivia_Users_Append_Input = {
  info_json?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "trivia_users" */
export type Trivia_Users_Arr_Rel_Insert_Input = {
  data: Array<Trivia_Users_Insert_Input>;
  on_conflict?: InputMaybe<Trivia_Users_On_Conflict>;
};

/** aggregate avg on columns */
export type Trivia_Users_Avg_Fields = {
  __typename?: 'trivia_users_avg_fields';
  active_status?: Maybe<Scalars['Float']>;
  status_id?: Maybe<Scalars['Float']>;
  timezone?: Maybe<Scalars['Float']>;
  user_type_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "trivia_users" */
export type Trivia_Users_Avg_Order_By = {
  active_status?: InputMaybe<Order_By>;
  status_id?: InputMaybe<Order_By>;
  timezone?: InputMaybe<Order_By>;
  user_type_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "trivia_users". All fields are combined with a logical 'AND'. */
export type Trivia_Users_Bool_Exp = {
  _and?: InputMaybe<Array<InputMaybe<Trivia_Users_Bool_Exp>>>;
  _not?: InputMaybe<Trivia_Users_Bool_Exp>;
  _or?: InputMaybe<Array<InputMaybe<Trivia_Users_Bool_Exp>>>;
  active_status?: InputMaybe<Int_Comparison_Exp>;
  approved_questions?: InputMaybe<Questions_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  firstname?: InputMaybe<String_Comparison_Exp>;
  image?: InputMaybe<String_Comparison_Exp>;
  info_json?: InputMaybe<Jsonb_Comparison_Exp>;
  lastname?: InputMaybe<String_Comparison_Exp>;
  password?: InputMaybe<String_Comparison_Exp>;
  phone_number?: InputMaybe<String_Comparison_Exp>;
  specialties?: InputMaybe<String_Comparison_Exp>;
  status_id?: InputMaybe<Int_Comparison_Exp>;
  timezone?: InputMaybe<Int_Comparison_Exp>;
  topics?: InputMaybe<String_Comparison_Exp>;
  trivia_user_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_type?: InputMaybe<User_Types_Bool_Exp>;
  user_type_id?: InputMaybe<Int_Comparison_Exp>;
  written_questions?: InputMaybe<Questions_Bool_Exp>;
};

/** unique or primary key constraints on table "trivia_users" */
export enum Trivia_Users_Constraint {
  /** unique or primary key constraint */
  TriviaUsersPkey = 'trivia_users_pkey',
  /** unique or primary key constraint */
  TriviaUsersUserTypeIdEmailActiveStatusKey = 'trivia_users_user_type_id_email_active_status_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Trivia_Users_Delete_At_Path_Input = {
  info_json?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Trivia_Users_Delete_Elem_Input = {
  info_json?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Trivia_Users_Delete_Key_Input = {
  info_json?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing integer column in table "trivia_users" */
export type Trivia_Users_Inc_Input = {
  active_status?: InputMaybe<Scalars['Int']>;
  status_id?: InputMaybe<Scalars['Int']>;
  timezone?: InputMaybe<Scalars['Int']>;
  user_type_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "trivia_users" */
export type Trivia_Users_Insert_Input = {
  active_status?: InputMaybe<Scalars['Int']>;
  approved_questions?: InputMaybe<Questions_Arr_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  firstname?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<Scalars['String']>;
  info_json?: InputMaybe<Scalars['jsonb']>;
  lastname?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  phone_number?: InputMaybe<Scalars['String']>;
  specialties?: InputMaybe<Scalars['String']>;
  status_id?: InputMaybe<Scalars['Int']>;
  timezone?: InputMaybe<Scalars['Int']>;
  topics?: InputMaybe<Scalars['String']>;
  trivia_user_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_type?: InputMaybe<User_Types_Obj_Rel_Insert_Input>;
  user_type_id?: InputMaybe<Scalars['Int']>;
  written_questions?: InputMaybe<Questions_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Trivia_Users_Max_Fields = {
  __typename?: 'trivia_users_max_fields';
  active_status?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  firstname?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
  lastname?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  phone_number?: Maybe<Scalars['String']>;
  specialties?: Maybe<Scalars['String']>;
  status_id?: Maybe<Scalars['Int']>;
  timezone?: Maybe<Scalars['Int']>;
  topics?: Maybe<Scalars['String']>;
  trivia_user_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_type_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "trivia_users" */
export type Trivia_Users_Max_Order_By = {
  active_status?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  firstname?: InputMaybe<Order_By>;
  image?: InputMaybe<Order_By>;
  lastname?: InputMaybe<Order_By>;
  password?: InputMaybe<Order_By>;
  phone_number?: InputMaybe<Order_By>;
  specialties?: InputMaybe<Order_By>;
  status_id?: InputMaybe<Order_By>;
  timezone?: InputMaybe<Order_By>;
  topics?: InputMaybe<Order_By>;
  trivia_user_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_type_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Trivia_Users_Min_Fields = {
  __typename?: 'trivia_users_min_fields';
  active_status?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  firstname?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
  lastname?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  phone_number?: Maybe<Scalars['String']>;
  specialties?: Maybe<Scalars['String']>;
  status_id?: Maybe<Scalars['Int']>;
  timezone?: Maybe<Scalars['Int']>;
  topics?: Maybe<Scalars['String']>;
  trivia_user_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_type_id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "trivia_users" */
export type Trivia_Users_Min_Order_By = {
  active_status?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  firstname?: InputMaybe<Order_By>;
  image?: InputMaybe<Order_By>;
  lastname?: InputMaybe<Order_By>;
  password?: InputMaybe<Order_By>;
  phone_number?: InputMaybe<Order_By>;
  specialties?: InputMaybe<Order_By>;
  status_id?: InputMaybe<Order_By>;
  timezone?: InputMaybe<Order_By>;
  topics?: InputMaybe<Order_By>;
  trivia_user_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_type_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "trivia_users" */
export type Trivia_Users_Mutation_Response = {
  __typename?: 'trivia_users_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Trivia_Users>;
};

/** input type for inserting object relation for remote table "trivia_users" */
export type Trivia_Users_Obj_Rel_Insert_Input = {
  data: Trivia_Users_Insert_Input;
  on_conflict?: InputMaybe<Trivia_Users_On_Conflict>;
};

/** on conflict condition type for table "trivia_users" */
export type Trivia_Users_On_Conflict = {
  constraint: Trivia_Users_Constraint;
  update_columns: Array<Trivia_Users_Update_Column>;
  where?: InputMaybe<Trivia_Users_Bool_Exp>;
};

/** ordering options when selecting data from "trivia_users" */
export type Trivia_Users_Order_By = {
  active_status?: InputMaybe<Order_By>;
  approved_questions_aggregate?: InputMaybe<Questions_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  firstname?: InputMaybe<Order_By>;
  image?: InputMaybe<Order_By>;
  info_json?: InputMaybe<Order_By>;
  lastname?: InputMaybe<Order_By>;
  password?: InputMaybe<Order_By>;
  phone_number?: InputMaybe<Order_By>;
  specialties?: InputMaybe<Order_By>;
  status_id?: InputMaybe<Order_By>;
  timezone?: InputMaybe<Order_By>;
  topics?: InputMaybe<Order_By>;
  trivia_user_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_type?: InputMaybe<User_Types_Order_By>;
  user_type_id?: InputMaybe<Order_By>;
  written_questions_aggregate?: InputMaybe<Questions_Aggregate_Order_By>;
};

/** primary key columns input for table: "trivia_users" */
export type Trivia_Users_Pk_Columns_Input = {
  trivia_user_id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Trivia_Users_Prepend_Input = {
  info_json?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "trivia_users" */
export enum Trivia_Users_Select_Column {
  /** column name */
  ActiveStatus = 'active_status',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Email = 'email',
  /** column name */
  Firstname = 'firstname',
  /** column name */
  Image = 'image',
  /** column name */
  InfoJson = 'info_json',
  /** column name */
  Lastname = 'lastname',
  /** column name */
  Password = 'password',
  /** column name */
  PhoneNumber = 'phone_number',
  /** column name */
  Specialties = 'specialties',
  /** column name */
  StatusId = 'status_id',
  /** column name */
  Timezone = 'timezone',
  /** column name */
  Topics = 'topics',
  /** column name */
  TriviaUserId = 'trivia_user_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserTypeId = 'user_type_id'
}

/** input type for updating data in table "trivia_users" */
export type Trivia_Users_Set_Input = {
  active_status?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  firstname?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<Scalars['String']>;
  info_json?: InputMaybe<Scalars['jsonb']>;
  lastname?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  phone_number?: InputMaybe<Scalars['String']>;
  specialties?: InputMaybe<Scalars['String']>;
  status_id?: InputMaybe<Scalars['Int']>;
  timezone?: InputMaybe<Scalars['Int']>;
  topics?: InputMaybe<Scalars['String']>;
  trivia_user_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_type_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Trivia_Users_Stddev_Fields = {
  __typename?: 'trivia_users_stddev_fields';
  active_status?: Maybe<Scalars['Float']>;
  status_id?: Maybe<Scalars['Float']>;
  timezone?: Maybe<Scalars['Float']>;
  user_type_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "trivia_users" */
export type Trivia_Users_Stddev_Order_By = {
  active_status?: InputMaybe<Order_By>;
  status_id?: InputMaybe<Order_By>;
  timezone?: InputMaybe<Order_By>;
  user_type_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Trivia_Users_Stddev_Pop_Fields = {
  __typename?: 'trivia_users_stddev_pop_fields';
  active_status?: Maybe<Scalars['Float']>;
  status_id?: Maybe<Scalars['Float']>;
  timezone?: Maybe<Scalars['Float']>;
  user_type_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "trivia_users" */
export type Trivia_Users_Stddev_Pop_Order_By = {
  active_status?: InputMaybe<Order_By>;
  status_id?: InputMaybe<Order_By>;
  timezone?: InputMaybe<Order_By>;
  user_type_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Trivia_Users_Stddev_Samp_Fields = {
  __typename?: 'trivia_users_stddev_samp_fields';
  active_status?: Maybe<Scalars['Float']>;
  status_id?: Maybe<Scalars['Float']>;
  timezone?: Maybe<Scalars['Float']>;
  user_type_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "trivia_users" */
export type Trivia_Users_Stddev_Samp_Order_By = {
  active_status?: InputMaybe<Order_By>;
  status_id?: InputMaybe<Order_By>;
  timezone?: InputMaybe<Order_By>;
  user_type_id?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Trivia_Users_Sum_Fields = {
  __typename?: 'trivia_users_sum_fields';
  active_status?: Maybe<Scalars['Int']>;
  status_id?: Maybe<Scalars['Int']>;
  timezone?: Maybe<Scalars['Int']>;
  user_type_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "trivia_users" */
export type Trivia_Users_Sum_Order_By = {
  active_status?: InputMaybe<Order_By>;
  status_id?: InputMaybe<Order_By>;
  timezone?: InputMaybe<Order_By>;
  user_type_id?: InputMaybe<Order_By>;
};

/** update columns of table "trivia_users" */
export enum Trivia_Users_Update_Column {
  /** column name */
  ActiveStatus = 'active_status',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Email = 'email',
  /** column name */
  Firstname = 'firstname',
  /** column name */
  Image = 'image',
  /** column name */
  InfoJson = 'info_json',
  /** column name */
  Lastname = 'lastname',
  /** column name */
  Password = 'password',
  /** column name */
  PhoneNumber = 'phone_number',
  /** column name */
  Specialties = 'specialties',
  /** column name */
  StatusId = 'status_id',
  /** column name */
  Timezone = 'timezone',
  /** column name */
  Topics = 'topics',
  /** column name */
  TriviaUserId = 'trivia_user_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserTypeId = 'user_type_id'
}

/** aggregate var_pop on columns */
export type Trivia_Users_Var_Pop_Fields = {
  __typename?: 'trivia_users_var_pop_fields';
  active_status?: Maybe<Scalars['Float']>;
  status_id?: Maybe<Scalars['Float']>;
  timezone?: Maybe<Scalars['Float']>;
  user_type_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "trivia_users" */
export type Trivia_Users_Var_Pop_Order_By = {
  active_status?: InputMaybe<Order_By>;
  status_id?: InputMaybe<Order_By>;
  timezone?: InputMaybe<Order_By>;
  user_type_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Trivia_Users_Var_Samp_Fields = {
  __typename?: 'trivia_users_var_samp_fields';
  active_status?: Maybe<Scalars['Float']>;
  status_id?: Maybe<Scalars['Float']>;
  timezone?: Maybe<Scalars['Float']>;
  user_type_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "trivia_users" */
export type Trivia_Users_Var_Samp_Order_By = {
  active_status?: InputMaybe<Order_By>;
  status_id?: InputMaybe<Order_By>;
  timezone?: InputMaybe<Order_By>;
  user_type_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Trivia_Users_Variance_Fields = {
  __typename?: 'trivia_users_variance_fields';
  active_status?: Maybe<Scalars['Float']>;
  status_id?: Maybe<Scalars['Float']>;
  timezone?: Maybe<Scalars['Float']>;
  user_type_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "trivia_users" */
export type Trivia_Users_Variance_Order_By = {
  active_status?: InputMaybe<Order_By>;
  status_id?: InputMaybe<Order_By>;
  timezone?: InputMaybe<Order_By>;
  user_type_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "user_types" */
export type User_Types = {
  __typename?: 'user_types';
  is_default?: Maybe<Scalars['Boolean']>;
  order_number?: Maybe<Scalars['Int']>;
  user_type_id: Scalars['Int'];
  user_type_name: Scalars['String'];
};

/** aggregated selection of "user_types" */
export type User_Types_Aggregate = {
  __typename?: 'user_types_aggregate';
  aggregate?: Maybe<User_Types_Aggregate_Fields>;
  nodes: Array<User_Types>;
};

/** aggregate fields of "user_types" */
export type User_Types_Aggregate_Fields = {
  __typename?: 'user_types_aggregate_fields';
  avg?: Maybe<User_Types_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<User_Types_Max_Fields>;
  min?: Maybe<User_Types_Min_Fields>;
  stddev?: Maybe<User_Types_Stddev_Fields>;
  stddev_pop?: Maybe<User_Types_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<User_Types_Stddev_Samp_Fields>;
  sum?: Maybe<User_Types_Sum_Fields>;
  var_pop?: Maybe<User_Types_Var_Pop_Fields>;
  var_samp?: Maybe<User_Types_Var_Samp_Fields>;
  variance?: Maybe<User_Types_Variance_Fields>;
};


/** aggregate fields of "user_types" */
export type User_Types_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Types_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "user_types" */
export type User_Types_Aggregate_Order_By = {
  avg?: InputMaybe<User_Types_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<User_Types_Max_Order_By>;
  min?: InputMaybe<User_Types_Min_Order_By>;
  stddev?: InputMaybe<User_Types_Stddev_Order_By>;
  stddev_pop?: InputMaybe<User_Types_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<User_Types_Stddev_Samp_Order_By>;
  sum?: InputMaybe<User_Types_Sum_Order_By>;
  var_pop?: InputMaybe<User_Types_Var_Pop_Order_By>;
  var_samp?: InputMaybe<User_Types_Var_Samp_Order_By>;
  variance?: InputMaybe<User_Types_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "user_types" */
export type User_Types_Arr_Rel_Insert_Input = {
  data: Array<User_Types_Insert_Input>;
  on_conflict?: InputMaybe<User_Types_On_Conflict>;
};

/** aggregate avg on columns */
export type User_Types_Avg_Fields = {
  __typename?: 'user_types_avg_fields';
  order_number?: Maybe<Scalars['Float']>;
  user_type_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "user_types" */
export type User_Types_Avg_Order_By = {
  order_number?: InputMaybe<Order_By>;
  user_type_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "user_types". All fields are combined with a logical 'AND'. */
export type User_Types_Bool_Exp = {
  _and?: InputMaybe<Array<InputMaybe<User_Types_Bool_Exp>>>;
  _not?: InputMaybe<User_Types_Bool_Exp>;
  _or?: InputMaybe<Array<InputMaybe<User_Types_Bool_Exp>>>;
  is_default?: InputMaybe<Boolean_Comparison_Exp>;
  order_number?: InputMaybe<Int_Comparison_Exp>;
  user_type_id?: InputMaybe<Int_Comparison_Exp>;
  user_type_name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_types" */
export enum User_Types_Constraint {
  /** unique or primary key constraint */
  UserTypesPkey = 'user_types_pkey',
  /** unique or primary key constraint */
  UserTypesUserTypeNameKey = 'user_types_user_type_name_key'
}

/** input type for incrementing integer column in table "user_types" */
export type User_Types_Inc_Input = {
  order_number?: InputMaybe<Scalars['Int']>;
  user_type_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "user_types" */
export type User_Types_Insert_Input = {
  is_default?: InputMaybe<Scalars['Boolean']>;
  order_number?: InputMaybe<Scalars['Int']>;
  user_type_id?: InputMaybe<Scalars['Int']>;
  user_type_name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type User_Types_Max_Fields = {
  __typename?: 'user_types_max_fields';
  order_number?: Maybe<Scalars['Int']>;
  user_type_id?: Maybe<Scalars['Int']>;
  user_type_name?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "user_types" */
export type User_Types_Max_Order_By = {
  order_number?: InputMaybe<Order_By>;
  user_type_id?: InputMaybe<Order_By>;
  user_type_name?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type User_Types_Min_Fields = {
  __typename?: 'user_types_min_fields';
  order_number?: Maybe<Scalars['Int']>;
  user_type_id?: Maybe<Scalars['Int']>;
  user_type_name?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "user_types" */
export type User_Types_Min_Order_By = {
  order_number?: InputMaybe<Order_By>;
  user_type_id?: InputMaybe<Order_By>;
  user_type_name?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "user_types" */
export type User_Types_Mutation_Response = {
  __typename?: 'user_types_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<User_Types>;
};

/** input type for inserting object relation for remote table "user_types" */
export type User_Types_Obj_Rel_Insert_Input = {
  data: User_Types_Insert_Input;
  on_conflict?: InputMaybe<User_Types_On_Conflict>;
};

/** on conflict condition type for table "user_types" */
export type User_Types_On_Conflict = {
  constraint: User_Types_Constraint;
  update_columns: Array<User_Types_Update_Column>;
  where?: InputMaybe<User_Types_Bool_Exp>;
};

/** ordering options when selecting data from "user_types" */
export type User_Types_Order_By = {
  is_default?: InputMaybe<Order_By>;
  order_number?: InputMaybe<Order_By>;
  user_type_id?: InputMaybe<Order_By>;
  user_type_name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: "user_types" */
export type User_Types_Pk_Columns_Input = {
  user_type_id: Scalars['Int'];
};

/** select columns of table "user_types" */
export enum User_Types_Select_Column {
  /** column name */
  IsDefault = 'is_default',
  /** column name */
  OrderNumber = 'order_number',
  /** column name */
  UserTypeId = 'user_type_id',
  /** column name */
  UserTypeName = 'user_type_name'
}

/** input type for updating data in table "user_types" */
export type User_Types_Set_Input = {
  is_default?: InputMaybe<Scalars['Boolean']>;
  order_number?: InputMaybe<Scalars['Int']>;
  user_type_id?: InputMaybe<Scalars['Int']>;
  user_type_name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type User_Types_Stddev_Fields = {
  __typename?: 'user_types_stddev_fields';
  order_number?: Maybe<Scalars['Float']>;
  user_type_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "user_types" */
export type User_Types_Stddev_Order_By = {
  order_number?: InputMaybe<Order_By>;
  user_type_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type User_Types_Stddev_Pop_Fields = {
  __typename?: 'user_types_stddev_pop_fields';
  order_number?: Maybe<Scalars['Float']>;
  user_type_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "user_types" */
export type User_Types_Stddev_Pop_Order_By = {
  order_number?: InputMaybe<Order_By>;
  user_type_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type User_Types_Stddev_Samp_Fields = {
  __typename?: 'user_types_stddev_samp_fields';
  order_number?: Maybe<Scalars['Float']>;
  user_type_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "user_types" */
export type User_Types_Stddev_Samp_Order_By = {
  order_number?: InputMaybe<Order_By>;
  user_type_id?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type User_Types_Sum_Fields = {
  __typename?: 'user_types_sum_fields';
  order_number?: Maybe<Scalars['Int']>;
  user_type_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "user_types" */
export type User_Types_Sum_Order_By = {
  order_number?: InputMaybe<Order_By>;
  user_type_id?: InputMaybe<Order_By>;
};

/** update columns of table "user_types" */
export enum User_Types_Update_Column {
  /** column name */
  IsDefault = 'is_default',
  /** column name */
  OrderNumber = 'order_number',
  /** column name */
  UserTypeId = 'user_type_id',
  /** column name */
  UserTypeName = 'user_type_name'
}

/** aggregate var_pop on columns */
export type User_Types_Var_Pop_Fields = {
  __typename?: 'user_types_var_pop_fields';
  order_number?: Maybe<Scalars['Float']>;
  user_type_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "user_types" */
export type User_Types_Var_Pop_Order_By = {
  order_number?: InputMaybe<Order_By>;
  user_type_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type User_Types_Var_Samp_Fields = {
  __typename?: 'user_types_var_samp_fields';
  order_number?: Maybe<Scalars['Float']>;
  user_type_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "user_types" */
export type User_Types_Var_Samp_Order_By = {
  order_number?: InputMaybe<Order_By>;
  user_type_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type User_Types_Variance_Fields = {
  __typename?: 'user_types_variance_fields';
  order_number?: Maybe<Scalars['Float']>;
  user_type_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "user_types" */
export type User_Types_Variance_Order_By = {
  order_number?: InputMaybe<Order_By>;
  user_type_id?: InputMaybe<Order_By>;
};

/** expression to compare columns of type uuid. All fields are combined with logical 'AND'. */
export type Uuid_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['uuid']>;
  _gt?: InputMaybe<Scalars['uuid']>;
  _gte?: InputMaybe<Scalars['uuid']>;
  _in?: InputMaybe<Array<Scalars['uuid']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['uuid']>;
  _lte?: InputMaybe<Scalars['uuid']>;
  _neq?: InputMaybe<Scalars['uuid']>;
  _nin?: InputMaybe<Array<Scalars['uuid']>>;
};

export type AddProfileMutationVariables = Exact<{
  email?: InputMaybe<Scalars['String']>;
  user_type_id?: InputMaybe<Scalars['Int']>;
  password?: InputMaybe<Scalars['String']>;
  lastname?: InputMaybe<Scalars['String']>;
  firstname?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<Scalars['String']>;
}>;


export type AddProfileMutation = { __typename?: 'mutation_root', insert_trivia_users?: { __typename?: 'trivia_users_mutation_response', affected_rows: number } | null };

export type ChangeUserStatusMutationVariables = Exact<{
  userId?: InputMaybe<Scalars['uuid']>;
  statusId?: InputMaybe<Scalars['Int']>;
}>;


export type ChangeUserStatusMutation = { __typename?: 'mutation_root', update_trivia_users?: { __typename?: 'trivia_users_mutation_response', returning: Array<{ __typename?: 'trivia_users', status_id: number }> } | null };

export type DeleteEventByIdMutationVariables = Exact<{
  _eq?: InputMaybe<Scalars['uuid']>;
}>;


export type DeleteEventByIdMutation = { __typename?: 'mutation_root', delete_trivia_events?: { __typename?: 'trivia_events_mutation_response', returning: Array<{ __typename?: 'trivia_events', game_id: any, trivia_game: { __typename?: 'trivia_games', game_status: number } }> } | null };

export type AddRoundsToGameMutationVariables = Exact<{
  gameRounds: Array<Trivia_Game_Rounds_Insert_Input> | Trivia_Game_Rounds_Insert_Input;
}>;


export type AddRoundsToGameMutation = { __typename?: 'mutation_root', insert_trivia_game_rounds?: { __typename?: 'trivia_game_rounds_mutation_response', affected_rows: number } | null };

export type ChangeAnswerTypeMutationVariables = Exact<{
  questionId?: InputMaybe<Scalars['uuid']>;
  answer_type_id?: InputMaybe<Scalars['Int']>;
}>;


export type ChangeAnswerTypeMutation = { __typename?: 'mutation_root', update_trivia_round_questions?: { __typename?: 'trivia_round_questions_mutation_response', returning: Array<{ __typename?: 'trivia_round_questions', question_id: any, round_id: any, answer_type_id: number }> } | null };

export type CreateGameMutationVariables = Exact<{
  game_id?: InputMaybe<Scalars['uuid']>;
  game_status?: InputMaybe<Scalars['Int']>;
  game_template_id: Scalars['String'];
  market?: InputMaybe<Scalars['String']>;
  rating?: InputMaybe<Scalars['String']>;
  theme?: InputMaybe<Trivia_Game_Themes_Arr_Rel_Insert_Input>;
  creator_id?: InputMaybe<Scalars['uuid']>;
}>;


export type CreateGameMutation = { __typename?: 'mutation_root', insert_trivia_games?: { __typename?: 'trivia_games_mutation_response', returning: Array<{ __typename?: 'trivia_games', game_id: any }> } | null };

export type DeleteGameByIdMutationVariables = Exact<{
  gameId?: InputMaybe<Scalars['uuid']>;
}>;


export type DeleteGameByIdMutation = { __typename?: 'mutation_root', delete_trivia_games?: { __typename?: 'trivia_games_mutation_response', affected_rows: number } | null };

export type EventGameMutationMutationVariables = Exact<{
  event_id?: InputMaybe<Scalars['uuid']>;
  new_game_id?: InputMaybe<Scalars['uuid']>;
  event_type_id?: InputMaybe<Scalars['Int']>;
  _trivia_user_id?: InputMaybe<Scalars['uuid']>;
}>;


export type EventGameMutationMutation = { __typename?: 'mutation_root', update_trivia_events?: { __typename?: 'trivia_events_mutation_response', returning: Array<{ __typename?: 'trivia_events', game_id: any, event_type_id: number, event_id: any, date?: any | null, trivia_game: { __typename?: 'trivia_games', title?: string | null, game_id: any, created_at?: any | null, game_date?: any | null, game_template_id: string, trivia_game_themes: Array<{ __typename?: 'trivia_game_themes', game_theme: { __typename?: 'game_themes', name: string, id: any } }>, trivia_game_template: { __typename?: 'trivia_game_templates', template_id: string, template_name: string } } }> } | null };

export type GenerateCtRoundMutationVariables = Exact<{ [key: string]: never; }>;


export type GenerateCtRoundMutation = { __typename?: 'mutation_root', generate_bonus_round?: { __typename?: 'GenRound', id: any, title?: string | null, type_name: string } | null };

export type GenerateCtmRoundMutationVariables = Exact<{ [key: string]: never; }>;


export type GenerateCtmRoundMutation = { __typename?: 'mutation_root', generate_ctm_round?: { __typename?: 'GenRound', id: any, title?: string | null, type_name: string } | null };

export type GenerateFinalRoundMutationVariables = Exact<{ [key: string]: never; }>;


export type GenerateFinalRoundMutation = { __typename?: 'mutation_root', generate_final_round?: { __typename?: 'GenRound', id: any, title?: string | null, type_name: string } | null };

export type GenerateStandardRoundMutationVariables = Exact<{ [key: string]: never; }>;


export type GenerateStandardRoundMutation = { __typename?: 'mutation_root', generate_standard_round?: { __typename?: 'GenRound', id: any, title?: string | null, type_name: string } | null };

export type GenerateWarfareRoundQuestionsQueryVariables = Exact<{
  roundId?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  questionTypeId?: InputMaybe<Scalars['Int']>;
  questionOrder?: InputMaybe<Scalars['Int']>;
  isWarfare?: InputMaybe<Scalars['Boolean']>;
  gameId?: InputMaybe<Scalars['String']>;
}>;


export type GenerateWarfareRoundQuestionsQuery = { __typename?: 'query_root', generateWarfareRoundQuestions?: { __typename?: 'GenRound', id: any, title?: string | null, type_name: string } | null };

export type GenerateWarfareRoundMutationVariables = Exact<{ [key: string]: never; }>;


export type GenerateWarfareRoundMutation = { __typename?: 'mutation_root', generate_warfare_round?: { __typename?: 'GenRound', id: any, title?: string | null, type_name: string } | null };

export type RemoveGameRoundByPkMutationVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type RemoveGameRoundByPkMutation = { __typename?: 'mutation_root', delete_trivia_game_rounds_by_pk?: { __typename?: 'trivia_game_rounds', id: any } | null };

export type RemoveRoundQueryVariables = Exact<{
  roundId?: InputMaybe<Scalars['String']>;
}>;


export type RemoveRoundQuery = { __typename?: 'query_root', triviaGameRoundDelete?: { __typename?: 'Response', response?: boolean | null } | null };

export type ReplaceGameThemesMutationVariables = Exact<{
  gameId: Scalars['uuid'];
  themes: Array<Trivia_Game_Themes_Insert_Input> | Trivia_Game_Themes_Insert_Input;
}>;


export type ReplaceGameThemesMutation = { __typename?: 'mutation_root', delete_trivia_game_themes?: { __typename?: 'trivia_game_themes_mutation_response', affected_rows: number } | null, insert_trivia_game_themes?: { __typename?: 'trivia_game_themes_mutation_response', affected_rows: number } | null };

export type ReplaceRoundThemesMutationVariables = Exact<{
  roundId: Scalars['uuid'];
  themes: Array<Trivia_Round_Themes_Insert_Input> | Trivia_Round_Themes_Insert_Input;
}>;


export type ReplaceRoundThemesMutation = { __typename?: 'mutation_root', delete_trivia_round_themes?: { __typename?: 'trivia_round_themes_mutation_response', affected_rows: number } | null, insert_trivia_round_themes?: { __typename?: 'trivia_round_themes_mutation_response', affected_rows: number } | null };

export type UpdateAnswerTypesMutationVariables = Exact<{
  id: Scalars['uuid'];
  question_id?: InputMaybe<Scalars['uuid']>;
  answer_type_id?: InputMaybe<Scalars['Int']>;
}>;


export type UpdateAnswerTypesMutation = { __typename?: 'mutation_root', update_trivia_round_questions?: { __typename?: 'trivia_round_questions_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'trivia_round_questions', id: any, question_id: any }> } | null };

export type UpdateCtmLastRoundWagerMutationVariables = Exact<{
  game_id: Scalars['uuid'];
  round_order?: InputMaybe<Scalars['Int']>;
}>;


export type UpdateCtmLastRoundWagerMutation = { __typename?: 'mutation_root', update_trivia_round_questions?: { __typename?: 'trivia_round_questions_mutation_response', affected_rows: number } | null };

export type UpdateCtmWagerMutationVariables = Exact<{
  id: Scalars['uuid'];
  wager: Scalars['String'];
  is_wager?: InputMaybe<Scalars['Boolean']>;
}>;


export type UpdateCtmWagerMutation = { __typename?: 'mutation_root', update_trivia_round_questions_by_pk?: { __typename?: 'trivia_round_questions', id: any } | null };

export type UpdateGameStatusMutationVariables = Exact<{
  change_object?: InputMaybe<Trivia_Games_Set_Input>;
  _eq?: InputMaybe<Scalars['uuid']>;
}>;


export type UpdateGameStatusMutation = { __typename?: 'mutation_root', update_trivia_games?: { __typename?: 'trivia_games_mutation_response', returning: Array<{ __typename?: 'trivia_games', game_id: any, game_status: number }> } | null };

export type UpdateGameMutationVariables = Exact<{
  game_data?: InputMaybe<Trivia_Games_Set_Input>;
  id: Scalars['uuid'];
}>;


export type UpdateGameMutation = { __typename?: 'mutation_root', update_trivia_games_by_pk?: { __typename?: 'trivia_games', category?: number | null, created_at?: any | null, description?: string | null, format_graphic_url?: string | null, keywords?: string | null, market?: string | null, promo_image_url?: string | null, rating?: string | null, theme_image_url?: string | null, title?: string | null, trivia_game_themes: Array<{ __typename?: 'trivia_game_themes', game_theme: { __typename?: 'game_themes', id: any, name: string } }> } | null };

export type UpdateRoundQuestionMutationVariables = Exact<{
  question_id: Scalars['uuid'];
  id: Scalars['uuid'];
}>;


export type UpdateRoundQuestionMutation = { __typename?: 'mutation_root', update_trivia_round_questions_by_pk?: { __typename?: 'trivia_round_questions', id: any } | null };

export type UpdateRoundMutationVariables = Exact<{
  round_data?: InputMaybe<Trivia_Rounds_Set_Input>;
  id: Scalars['uuid'];
}>;


export type UpdateRoundMutation = { __typename?: 'mutation_root', update_trivia_rounds_by_pk?: { __typename?: 'trivia_rounds', round_id: any, name?: string | null, created_at: any, updated_at?: any | null, round_type: string, trivia_round_themes: Array<{ __typename?: 'trivia_round_themes', game_theme: { __typename?: 'game_themes', id: any, name: string } }> } | null };

export type InsertTriviaEventOneMutationVariables = Exact<{
  triviaUserId?: InputMaybe<Scalars['uuid']>;
  eventTypeId?: InputMaybe<Scalars['Int']>;
  gameId?: InputMaybe<Scalars['uuid']>;
  date?: InputMaybe<Scalars['date']>;
  isDemo?: Scalars['Boolean'];
}>;


export type InsertTriviaEventOneMutation = { __typename?: 'mutation_root', insert_trivia_events?: { __typename?: 'trivia_events_mutation_response', returning: Array<{ __typename?: 'trivia_events', event_id: any, event_type_id: number, game_id: any, trivia_user_id?: any | null, date?: any | null, trivia_game: { __typename?: 'trivia_games', game_date?: any | null, created_at?: any | null, game_status: number, title?: string | null, is_demo?: boolean, game_template_id: string, trivia_game_template: { __typename?: 'trivia_game_templates', template_name: string, template_id: string }, trivia_game_themes: Array<{ __typename?: 'trivia_game_themes', game_theme: { __typename?: 'game_themes', id: any, name: string } }> } }> } | null };

export type ChangeQuestionTagsMutationVariables = Exact<{
  objects: Array<Question_Tags_Insert_Input> | Question_Tags_Insert_Input;
  question_id: Scalars['uuid'];
}>;


export type ChangeQuestionTagsMutation = { __typename?: 'mutation_root', delete_question_tags?: { __typename?: 'question_tags_mutation_response', affected_rows: number } | null, insert_question_tags?: { __typename?: 'question_tags_mutation_response', affected_rows: number } | null };

export type InsertQuestionMutationVariables = Exact<{
  source_primary?: InputMaybe<Scalars['String']>;
  source_secondary?: InputMaybe<Scalars['String']>;
  category_id?: InputMaybe<Scalars['uuid']>;
  point_value?: InputMaybe<Scalars['Int']>;
  created_datetime?: InputMaybe<Scalars['timestamp']>;
  market_id?: InputMaybe<Scalars['String']>;
  question_id?: InputMaybe<Scalars['uuid']>;
  question_json?: InputMaybe<Scalars['jsonb']>;
  question_text?: InputMaybe<Scalars['String']>;
  question_type_id?: InputMaybe<Scalars['Int']>;
  sub_category_id?: InputMaybe<Scalars['uuid']>;
  question_bonus_id?: InputMaybe<Scalars['Int']>;
  use_end_date?: InputMaybe<Scalars['date']>;
  use_start_date?: InputMaybe<Scalars['date']>;
  writer_user_id?: InputMaybe<Scalars['uuid']>;
  question_rating?: InputMaybe<Scalars['Int']>;
  question_image?: InputMaybe<Scalars['String']>;
  question_status_id?: InputMaybe<Scalars['Int']>;
  question_difficulty_id?: InputMaybe<Scalars['Int']>;
  for_round_type?: InputMaybe<Scalars['String']>;
}>;


export type InsertQuestionMutation = { __typename?: 'mutation_root', insert_questions_one?: { __typename?: 'questions', writer_user_id?: any | null, question_id: any, for_round_type?: string | null } | null };

export type MarkQuestionForReviewMutationVariables = Exact<{
  questionId: Scalars['uuid'];
}>;


export type MarkQuestionForReviewMutation = { __typename?: 'mutation_root', update_questions_by_pk?: { __typename?: 'questions', question_id: any } | null };

export type ReportQuestionMutationVariables = Exact<{
  message?: InputMaybe<Scalars['String']>;
  questionId: Scalars['uuid'];
  reasonId?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['uuid']>;
}>;


export type ReportQuestionMutation = { __typename?: 'mutation_root', insert_reports_one?: { __typename?: 'reports', report_reason_id: number } | null, update_questions_by_pk?: { __typename?: 'questions', question_id: any } | null };

export type UpdateQuestionApprovedUserIdMutationVariables = Exact<{
  question_id?: InputMaybe<Scalars['uuid']>;
  approved_user_id?: InputMaybe<Scalars['uuid']>;
}>;


export type UpdateQuestionApprovedUserIdMutation = { __typename?: 'mutation_root', update_questions?: { __typename?: 'questions_mutation_response', returning: Array<{ __typename?: 'questions', question_id: any }> } | null };

export type UpdateQuestionDataMutationVariables = Exact<{
  data?: InputMaybe<Questions_Set_Input>;
  question_id?: InputMaybe<Scalars['uuid']>;
}>;


export type UpdateQuestionDataMutation = { __typename?: 'mutation_root', update_questions?: { __typename?: 'questions_mutation_response', returning: Array<{ __typename?: 'questions', approved_datetime?: any | null }> } | null };

export type AddRoundQuestionsMutationVariables = Exact<{
  objects: Array<Trivia_Round_Questions_Insert_Input> | Trivia_Round_Questions_Insert_Input;
}>;


export type AddRoundQuestionsMutation = { __typename?: 'mutation_root', insert_trivia_round_questions?: { __typename?: 'trivia_round_questions_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'trivia_round_questions', id: any, question_order: number, question: { __typename?: 'questions', question_type_id: number, question_id: any } }> } | null };

export type DeleteRoundQuestionMutationVariables = Exact<{
  questionId: Scalars['uuid'];
  roundId?: InputMaybe<Scalars['uuid']>;
}>;


export type DeleteRoundQuestionMutation = { __typename?: 'mutation_root', delete_trivia_round_questions?: { __typename?: 'trivia_round_questions_mutation_response', returning: Array<{ __typename?: 'trivia_round_questions', question_id: any }> } | null };

export type UpdateTriviaRoundQuestionsMutationVariables = Exact<{
  questionData?: InputMaybe<Trivia_Round_Questions_Set_Input>;
  roundColumnId?: InputMaybe<Uuid_Comparison_Exp>;
}>;


export type UpdateTriviaRoundQuestionsMutation = { __typename?: 'mutation_root', update_trivia_round_questions?: { __typename?: 'trivia_round_questions_mutation_response', affected_rows: number } | null };

export type UpdateTriviaUserMutationVariables = Exact<{
  userId?: InputMaybe<Scalars['uuid']>;
  userData?: InputMaybe<Trivia_Users_Set_Input>;
}>;


export type UpdateTriviaUserMutation = { __typename?: 'mutation_root', update_trivia_users?: { __typename?: 'trivia_users_mutation_response', returning: Array<{ __typename?: 'trivia_users', email: string, firstname?: string | null, image?: string | null, lastname?: string | null, specialties?: string | null, topics?: string | null, phone_number?: string | null, user_type: { __typename?: 'user_types', user_type_name: string } }> } | null };

export type UpdateUserImageMutationVariables = Exact<{
  userId?: InputMaybe<Scalars['uuid']>;
  image?: InputMaybe<Scalars['String']>;
}>;


export type UpdateUserImageMutation = { __typename?: 'mutation_root', update_trivia_users?: { __typename?: 'trivia_users_mutation_response', returning: Array<{ __typename?: 'trivia_users', image?: string | null }> } | null };

export type UpdateUserPasswordMutationVariables = Exact<{
  user_id?: InputMaybe<Scalars['uuid']>;
  currentPassword?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
}>;


export type UpdateUserPasswordMutation = { __typename?: 'mutation_root', update_trivia_users?: { __typename?: 'trivia_users_mutation_response', returning: Array<{ __typename?: 'trivia_users', password: string }> } | null };

export type UpdateIsDemoValueMutationVariables = Exact<{
  isDemo?: InputMaybe<Scalars['Boolean']>;
  gameId?: InputMaybe<Scalars['uuid']>;
}>;


export type UpdateIsDemoValueMutation = { __typename?: 'mutation_root', update_trivia_games?: { __typename?: 'trivia_games_mutation_response', returning: Array<{ __typename?: 'trivia_games', is_demo: boolean, game_id: any }> } | null };

export type CategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type CategoriesQuery = { __typename?: 'query_root', categories: Array<{ __typename?: 'categories', sort_order_num?: number | null, parent_category_id?: any | null, category_name: string, category_id: any, archived: boolean }> };

export type GetCompilersListQueryVariables = Exact<{
  user_type_id?: InputMaybe<Scalars['Int']>;
  count?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type GetCompilersListQuery = { __typename?: 'query_root', trivia_users: Array<{ __typename?: 'trivia_users', firstname?: string | null, lastname?: string | null, trivia_user_id: any, email: string }>, trivia_users_aggregate: { __typename?: 'trivia_users_aggregate', aggregate?: { __typename?: 'trivia_users_aggregate_fields', count?: number | null } | null } };

export type GetFactcheckerByIdQueryVariables = Exact<{
  user_id?: InputMaybe<Scalars['uuid']>;
}>;


export type GetFactcheckerByIdQuery = { __typename?: 'query_root', trivia_users: Array<{ __typename?: 'trivia_users', email: string, firstname?: string | null, lastname?: string | null, trivia_user_id: any, image?: string | null, needs_review: { __typename?: 'questions_aggregate', aggregate?: { __typename?: 'questions_aggregate_fields', count?: number | null } | null }, rejected: { __typename?: 'questions_aggregate', aggregate?: { __typename?: 'questions_aggregate_fields', count?: number | null } | null }, factchecing_que: { __typename?: 'questions_aggregate', aggregate?: { __typename?: 'questions_aggregate_fields', count?: number | null } | null } }> };

export type GetFactcheckersListQueryVariables = Exact<{
  user_type_id?: InputMaybe<Scalars['Int']>;
  count?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type GetFactcheckersListQuery = { __typename?: 'query_root', trivia_users: Array<{ __typename?: 'trivia_users', firstname?: string | null, lastname?: string | null, trivia_user_id: any, email: string, accepted: { __typename?: 'questions_aggregate', aggregate?: { __typename?: 'questions_aggregate_fields', count?: number | null } | null }, rejected: { __typename?: 'questions_aggregate', aggregate?: { __typename?: 'questions_aggregate_fields', count?: number | null } | null }, question_factchecked: { __typename?: 'questions_aggregate', aggregate?: { __typename?: 'questions_aggregate_fields', count?: number | null } | null } }>, trivia_users_aggregate: { __typename?: 'trivia_users_aggregate', aggregate?: { __typename?: 'trivia_users_aggregate_fields', count?: number | null } | null } };

export type AnswerTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type AnswerTypesQuery = { __typename?: 'query_root', answer_types: Array<{ __typename?: 'answer_types', answer_type_id: number, answer_type_name: string }> };

export type FillRoundCtmQuestionsQueryVariables = Exact<{
  pointValue?: InputMaybe<Scalars['Int']>;
  keyword?: InputMaybe<Scalars['String']>;
  questionTypeId?: InputMaybe<Scalars['Int']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  category?: InputMaybe<Scalars['uuid']>;
  subCategory?: InputMaybe<Scalars['uuid']>;
  count?: InputMaybe<Scalars['Int']>;
  question_rating?: InputMaybe<Scalars['Int']>;
  game_id?: InputMaybe<Scalars['uuid']>;
  forUsedStatus?: InputMaybe<Scalars['String']>;
}>;


export type FillRoundCtmQuestionsQuery = { __typename?: 'query_root', fillCtmRoundQuestions?: Array<{ __typename?: 'FillCtmRoundQuestionsOutput', question_id?: string | null } | null> | null };

export type FillRoundFinalQuestionQueryVariables = Exact<{
  keyword?: InputMaybe<Scalars['String']>;
  questionTypeId?: InputMaybe<Scalars['Int']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  category?: InputMaybe<Scalars['uuid']>;
  subCategory?: InputMaybe<Scalars['uuid']>;
  question_rating?: InputMaybe<Scalars['Int']>;
  count?: InputMaybe<Scalars['Int']>;
}>;


export type FillRoundFinalQuestionQuery = { __typename?: 'query_root', fillFinalRoundQuestions?: Array<{ __typename?: 'FillFinalRoundQuestionsOutput', question_id?: string | null } | null> | null };

export type FillRoundQuestionQueryVariables = Exact<{
  questions?: InputMaybe<Array<InputMaybe<QuestionsData>> | InputMaybe<QuestionsData>>;
  roundId?: InputMaybe<Scalars['uuid']>;
}>;


export type FillRoundQuestionQuery = { __typename?: 'query_root', generateRoundQuestions?: { __typename?: 'Response', response?: boolean | null } | null };

export type FillRoundStandardQuestionsQueryVariables = Exact<{
  keyword?: InputMaybe<Scalars['String']>;
  questionTypeId?: InputMaybe<Scalars['Int']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  category?: InputMaybe<Scalars['uuid']>;
  subCategory?: InputMaybe<Scalars['uuid']>;
  count?: InputMaybe<Scalars['Int']>;
  question_rating?: InputMaybe<Scalars['Int']>;
  forRoundType?: InputMaybe<Scalars['String']>;
}>;


export type FillRoundStandardQuestionsQuery = { __typename?: 'query_root', fillRoundQuestions?: Array<{ __typename?: 'FillRoundQuestionsOutput', question_id?: string | null } | null> | null };

export type GameByPkQueryVariables = Exact<{
  game_id: Scalars['uuid'];
}>;


export type GameByPkQuery = { __typename?: 'query_root', trivia_games_by_pk?: { __typename?: 'trivia_games', category?: number | null, created_at?: any | null, description?: string | null, format_graphic_url?: string | null, game_id: any, keywords?: string | null, market?: string | null, promo_image_url?: string | null, rating?: string | null, theme_image_url?: string | null, title?: string | null, game_difficult_id?: number | null, game_template_id: string, gameStatusByGameStatus: { __typename?: 'game_status', id: number, name: string }, trivia_game_themes: Array<{ __typename?: 'trivia_game_themes', game_theme: { __typename?: 'game_themes', id: any, name: string } }>, trivia_game_template: { __typename?: 'trivia_game_templates', template_id: string, template_name: string }, trivia_game_rounds: Array<{ __typename?: 'trivia_game_rounds', created_at: any, id: any, round_id: any, round_order: number, trivia_round: { __typename?: 'trivia_rounds', created_at: any, name?: string | null, round_id: any, round_type: string, trivia_round_type: { __typename?: 'trivia_round_types', id: string, name: string } } }> } | null };

export type GameByPkRoundsQueryVariables = Exact<{
  game_id: Scalars['uuid'];
}>;


export type GameByPkRoundsQuery = { __typename?: 'query_root', trivia_games_by_pk?: { __typename?: 'trivia_games', trivia_game_rounds: Array<{ __typename?: 'trivia_game_rounds', created_at: any, id: any, round_id: any, round_order: number, trivia_round: { __typename?: 'trivia_rounds', created_at: any, name?: string | null, round_id: any, round_type: string, trivia_round_type: { __typename?: 'trivia_round_types', id: string, name: string } } }> } | null };

export type GameRoundsFragment = { __typename?: 'trivia_game_rounds', created_at: any, id: any, round_id: any, round_order: number, trivia_round: { __typename?: 'trivia_rounds', created_at: any, name?: string | null, round_id: any, round_type: string, trivia_round_type: { __typename?: 'trivia_round_types', id: string, name: string } } };

export type GameDifficultiesQueryVariables = Exact<{ [key: string]: never; }>;


export type GameDifficultiesQuery = { __typename?: 'query_root', game_difficulties: Array<{ __typename?: 'game_difficulties', game_difficult_id: number, game_difficult_name: string }> };

export type GameRatingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GameRatingsQuery = { __typename?: 'query_root', game_ratings: Array<{ __typename?: 'game_ratings', id: string, name: string }> };

export type GameTemplatesQueryVariables = Exact<{ [key: string]: never; }>;


export type GameTemplatesQuery = { __typename?: 'query_root', trivia_game_templates: Array<{ __typename?: 'trivia_game_templates', template_id: string, template_name: string, order?: number | null }> };

export type SelectedGameTemplateQueryVariables = Exact<{ [key: string]: never; }>;


export type SelectedGameTemplateQuery = { __typename?: 'query_root', selected_game_template?: { __typename?: 'trivia_game_templates', template_id: string, template_name: string } | null };

export type GameThemesQueryVariables = Exact<{ [key: string]: never; }>;


export type GameThemesQuery = { __typename?: 'query_root', game_themes: Array<{ __typename?: 'game_themes', id: any, name: string }> };

export type GameFormatsQueryVariables = Exact<{ [key: string]: never; }>;


export type GameFormatsQuery = { __typename?: 'query_root', trivia_game_templates: Array<{ __typename?: 'trivia_game_templates', template_id: string, template_name: string }> };

export type GameListQueryVariables = Exact<{
  status?: InputMaybe<Scalars['Int']>;
  template?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  creatorId?: InputMaybe<Scalars['uuid']>;
}>;


export type GameListQuery = { __typename?: 'query_root', trivia_games: Array<{ __typename?: 'trivia_games', title?: string | null, game_id: any, created_at?: any | null, trivia_game_themes: Array<{ __typename?: 'trivia_game_themes', game_theme: { __typename?: 'game_themes', id: any, name: string } }>, gameStatusByGameStatus: { __typename?: 'game_status', id: number, name: string } }>, trivia_games_aggregate: { __typename?: 'trivia_games_aggregate', aggregate?: { __typename?: 'trivia_games_aggregate_fields', count?: number | null } | null } };

export type GameScheduledDateQueryVariables = Exact<{
  gameId?: InputMaybe<Scalars['uuid']>;
}>;


export type GameScheduledDateQuery = { __typename?: 'query_root', trivia_events: Array<{ __typename?: 'trivia_events', date?: any | null }> };

export type GenerateBlankRoundQueryVariables = Exact<{
  roundTemplateId?: InputMaybe<Scalars['String']>;
  roundType?: InputMaybe<Scalars['String']>;
}>;


export type GenerateBlankRoundQuery = { __typename?: 'query_root', generateRound?: { __typename?: 'GenRound', id: any, title?: string | null, type_name: string } | null };

export type GenerateTwoColumnRoundQuestionsQueryVariables = Exact<{
  roundId?: InputMaybe<Scalars['String']>;
}>;


export type GenerateTwoColumnRoundQuestionsQuery = { __typename?: 'query_root', generateTwoColumnRoundQuestions?: { __typename?: 'GenRound', id: any, title?: string | null, type_name: string } | null };

export type RemoveRoundQuestionsMutationVariables = Exact<{
  round_id: Scalars['uuid'];
}>;


export type RemoveRoundQuestionsMutation = { __typename?: 'mutation_root', delete_trivia_round_questions?: { __typename?: 'trivia_round_questions_mutation_response', affected_rows: number } | null };

export type RemoveRoundQuestionsByIdsMutationVariables = Exact<{
  round_id: Scalars['uuid'];
  ids?: InputMaybe<Array<Scalars['uuid']> | Scalars['uuid']>;
}>;


export type RemoveRoundQuestionsByIdsMutation = { __typename?: 'mutation_root', delete_trivia_round_questions?: { __typename?: 'trivia_round_questions_mutation_response', affected_rows: number } | null };

export type RoundByPkQueryVariables = Exact<{
  id: Scalars['uuid'];
  includeJson?: Scalars['Boolean'];
}>;


export type RoundByPkQuery = { __typename?: 'query_root', trivia_rounds_by_pk?: { __typename?: 'trivia_rounds', created_at: any, name?: string | null, round_id: any, updated_at?: any | null, round_keywords?: string | null, trivia_round_themes: Array<{ __typename?: 'trivia_round_themes', game_theme: { __typename?: 'game_themes', id: any, name: string } }>, trivia_round_type: { __typename?: 'trivia_round_types', id: string, name: string }, trivia_round_questions: Array<{ __typename?: 'trivia_round_questions', id: any, answer_type_id: number, wager: boolean, wager_range_value?: string | null, question_order: number, answer_type: { __typename?: 'answer_types', answer_type_name: string }, question: { __typename?: 'questions', question_type_id: number, question_bonus_id?: number | null, question_id: any, point_value?: number | null, question_text?: string | null, question_image?: string | null, answer?: any | null, question_json?: any | null, question_type: { __typename?: 'question_types', question_type_id: number, question_type_name: string, question_type_short_name?: string | null }, category?: { __typename?: 'categories', category_id: any, category_name: string } | null, sub_category?: { __typename?: 'categories', category_name: string, category_id: any } | null } }>, trivia_game_rounds: Array<{ __typename?: 'trivia_game_rounds', game_id: any, round_id: any, round_order: number, trivia_game: { __typename?: 'trivia_games', game_template_id: string } }>, trivia_round_template: { __typename?: 'trivia_round_templates', template_id: string, template_name: string } } | null };

export type RoundQuestionsFragment = { __typename?: 'trivia_round_questions', id: any, answer_type_id: number, wager: boolean, wager_range_value?: string | null, question_order: number, question: { __typename?: 'questions', question_id: any, point_value?: number | null, question_text?: string | null, question_image?: string | null, answer?: any | null, question_json?: any | null, question_type: { __typename?: 'question_types', question_type_id: number, question_type_name: string, question_type_short_name?: string | null }, category?: { __typename?: 'categories', category_id: any, category_name: string } | null, sub_category?: { __typename?: 'categories', category_name: string, category_id: any } | null } };

export type GetScheduledGamesByDateQueryVariables = Exact<{
  date?: InputMaybe<Date_Comparison_Exp>;
  userId?: InputMaybe<Scalars['uuid']>;
}>;


export type GetScheduledGamesByDateQuery = { __typename?: 'query_root', trivia_events: Array<{ __typename?: 'trivia_events', event_type_id: number, game_format_id: number, trivia_game: { __typename?: 'trivia_games', game_id: any, game_difficult_id?: number | null, game_template_id: string, game_status: number } }> };

export type TriviaGameByIdQueryVariables = Exact<{
  game_id?: InputMaybe<Scalars['uuid']>;
  _eq?: InputMaybe<Scalars['String']>;
}>;


export type TriviaGameByIdQuery = { __typename?: 'query_root', trivia_games: Array<{ __typename?: 'trivia_games', created_at?: any | null, game_id: any, game_date?: any | null, title?: string | null, game_template_id: string, game_status: number, trivia_game_themes: Array<{ __typename?: 'trivia_game_themes', theme_id: any, game_theme: { __typename?: 'game_themes', name: string, id: any }, trivia_game: { __typename?: 'trivia_games', game_id: any, game_status: number, game_template_id: string, game_date?: any | null, title?: string | null, created_at?: any | null } }> }> };

export type TriviaGamesQueryVariables = Exact<{
  order?: InputMaybe<Order_By>;
  game_id_neq?: InputMaybe<Scalars['uuid']>;
  game_status?: InputMaybe<Scalars['Int']>;
  game_template_id?: InputMaybe<Scalars['String']>;
}>;


export type TriviaGamesQuery = { __typename?: 'query_root', trivia_games: Array<{ __typename?: 'trivia_games', game_date?: any | null, game_id: any, title?: string | null, created_at?: any | null, game_status: number, game_template_id: string, trivia_game_themes: Array<{ __typename?: 'trivia_game_themes', theme_id: any, game_theme_id: any, game_theme: { __typename?: 'game_themes', name: string, id: any } }>, trivia_game_template: { __typename?: 'trivia_game_templates', template_id: string, template_name: string }, trivia_game_rounds: Array<{ __typename?: 'trivia_game_rounds', trivia_round: { __typename?: 'trivia_rounds', trivia_round_questions: Array<{ __typename?: 'trivia_round_questions', question_id: any }> } }> }>, trivia_games_aggregate: { __typename?: 'trivia_games_aggregate', aggregate?: { __typename?: 'trivia_games_aggregate_fields', count?: number | null } | null } };

export type MarketsQueryVariables = Exact<{ [key: string]: never; }>;


export type MarketsQuery = { __typename?: 'query_root', markets: Array<{ __typename?: 'markets', language_id?: string | null, market_id: string, market_name: string }> };

export type MatureRatingQueryVariables = Exact<{ [key: string]: never; }>;


export type MatureRatingQuery = { __typename?: 'query_root', question_ratings: Array<{ __typename?: 'question_ratings', id: number, name: string }> };

export type QuestionTextSearchQueryVariables = Exact<{
  searchString?: InputMaybe<Scalars['String']>;
  questionTypeId?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type QuestionTextSearchQuery = { __typename?: 'query_root', questions: Array<{ __typename?: 'questions', question_text?: string | null, question_type: { __typename?: 'question_types', question_type_id: number, question_type_short_name?: string | null, question_type_name: string } }> };

export type RejectedQuestionsCountQueryVariables = Exact<{
  rejectionReasonName?: InputMaybe<Scalars['String']>;
  writerUserId?: InputMaybe<Scalars['uuid']>;
}>;


export type RejectedQuestionsCountQuery = { __typename?: 'query_root', questions_aggregate: { __typename?: 'questions_aggregate', aggregate?: { __typename?: 'questions_aggregate_fields', count?: number | null } | null } };

export type GetQuestionIdAndOrderQueryVariables = Exact<{
  roundId?: InputMaybe<Scalars['uuid']>;
}>;


export type GetQuestionIdAndOrderQuery = { __typename?: 'query_root', trivia_round_questions: Array<{ __typename?: 'trivia_round_questions', orderNumber: number, questionId: any, answerTypeId: number }> };

export type QuestionBonusesQueryVariables = Exact<{ [key: string]: never; }>;


export type QuestionBonusesQuery = { __typename?: 'query_root', question_bonuses: Array<{ __typename?: 'question_bonuses', question_bonus_id: number, question_bonus_name: string }> };

export type QuestionByIdQueryVariables = Exact<{
  question_id: Scalars['uuid'];
}>;


export type QuestionByIdQuery = { __typename?: 'query_root', questions: Array<{ __typename?: 'questions', approved_datetime?: any | null, approved_user_id?: any | null, category_id?: any | null, created_datetime: any, first_used_date?: any | null, host_note?: string | null, is_alcohol?: boolean | null, is_mature: boolean, last_used_date?: any | null, market_id: string, paid_invoice_id?: any | null, point_value?: number | null, question_data?: any | null, question_id: any, question_image?: string | null, question_json?: any | null, question_status_id?: number | null, question_text?: string | null, question_type_id: number, source_validation?: any | null, sub_category_id?: any | null, use_end_date?: any | null, use_start_date?: any | null, writer_user_id?: any | null, question_difficulty_id?: number | null, question_bonus_id?: number | null, source_primary?: string | null, source_secondary?: string | null, question_rating: number, is_used?: boolean | null, comment?: string | null, reason_id?: number | null, category?: { __typename?: 'categories', archived: boolean, category_id: any, category_name: string, parent_category_id?: any | null, sort_order_num?: number | null } | null, market: { __typename?: 'markets', language_id?: string | null, market_id: string, market_name: string }, question_type: { __typename?: 'question_types', question_type_id: number, question_type_name: string }, sub_category?: { __typename?: 'categories', archived: boolean, category_id: any, category_name: string, parent_category_id?: any | null, sort_order_num?: number | null } | null, question_difficulty?: { __typename?: 'question_difficulties', question_difficulty_id: number, question_difficulty_name: string } | null, question_tags: Array<{ __typename?: 'question_tags', tag: string }>, reports: Array<{ __typename?: 'reports', comment: string, app_name?: string | null, reason: { __typename?: 'report_reasons', reason_name: string, reason_id: number } }>, reason_name?: { __typename?: 'rejection_reasons', name: string } | null }> };

export type QuestionDifficultiesQueryVariables = Exact<{ [key: string]: never; }>;


export type QuestionDifficultiesQuery = { __typename?: 'query_root', question_difficulties: Array<{ __typename?: 'question_difficulties', question_difficulty_id: number, question_difficulty_name: string }> };

export type QuestionReportReasonsQueryVariables = Exact<{
  questionId?: InputMaybe<Scalars['uuid']>;
}>;


export type QuestionReportReasonsQuery = { __typename?: 'query_root', reports: Array<{ __typename?: 'reports', comment: string, reason: { __typename?: 'report_reasons', reason_id: number, reason_name: string } }> };

export type QuestionStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type QuestionStatusQuery = { __typename?: 'query_root', question_status: Array<{ __typename?: 'question_status', question_status_id: number, question_status_name: string }> };

export type QuestionTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type QuestionTypesQuery = { __typename?: 'query_root', question_types: Array<{ __typename?: 'question_types', question_type_id: number, question_type_name: string, question_type_short_name?: string | null }> };

export type QuestionByFilterQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Questions_Bool_Exp>;
  includeQuestionType?: Scalars['Boolean'];
}>;


export type QuestionByFilterQuery = { __typename?: 'query_root', questions: Array<{ __typename?: 'questions', question_id: any, question_text?: string | null, writer_user_id?: any | null, question_type?: { __typename?: 'question_types', question_type_name: string } }>, questions_aggregate: { __typename?: 'questions_aggregate', aggregate?: { __typename?: 'questions_aggregate_fields', count?: number | null } | null } };

export type QuestionsListFactcheckerQueryVariables = Exact<{
  statusId?: InputMaybe<Scalars['Int']>;
  approved_user_id?: InputMaybe<Scalars['uuid']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  count?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type QuestionsListFactcheckerQuery = { __typename?: 'query_root', questions: Array<{ __typename?: 'questions', approved_datetime?: any | null, category_id?: any | null, created_datetime: any, first_used_date?: any | null, host_note?: string | null, is_alcohol?: boolean | null, is_mature: boolean, last_used_date?: any | null, market_id: string, paid_invoice_id?: any | null, point_value?: number | null, question_data?: any | null, question_id: any, question_image?: string | null, question_json?: any | null, question_status_id?: number | null, question_text?: string | null, question_type_id: number, source_primary?: string | null, source_secondary?: string | null, source_tertiary?: string | null, source_validation?: any | null, sub_category_id?: any | null, use_end_date?: any | null, use_start_date?: any | null, writer_user_id?: any | null, approved_user_id?: any | null, rejection_reason_id?: number | null, question_difficulty_id?: number | null, question_bonus_id?: number | null, last_edited_datetime?: any | null, question_rating: number, is_used?: boolean | null, category?: { __typename?: 'categories', archived: boolean, category_id: any, category_name: string, parent_category_id?: any | null, sort_order_num?: number | null } | null, market: { __typename?: 'markets', language_id?: string | null, market_id: string, market_name: string }, question_type: { __typename?: 'question_types', question_type_id: number, question_type_name: string }, sub_category?: { __typename?: 'categories', archived: boolean, category_id: any, category_name: string, parent_category_id?: any | null, sort_order_num?: number | null } | null, question_difficulty?: { __typename?: 'question_difficulties', question_difficulty_id: number, question_difficulty_name: string } | null, question_tags: Array<{ __typename?: 'question_tags', question_id: any, tag: string }> }>, questions_aggregate: { __typename?: 'questions_aggregate', aggregate?: { __typename?: 'questions_aggregate_fields', count?: number | null } | null } };

export type QuestionsListRejectedQueryVariables = Exact<{
  writer_user_id: Scalars['uuid'];
}>;


export type QuestionsListRejectedQuery = { __typename?: 'query_root', questions: Array<{ __typename?: 'questions', question_id: any, question_text?: string | null, rejection_note?: string | null, rejection_reason?: { __typename?: 'rejection_reasons', rejection_reason_name: string, rejection_reason_id: number } | null }>, questions_aggregate: { __typename?: 'questions_aggregate', aggregate?: { __typename?: 'questions_aggregate_fields', count?: number | null } | null } };

export type QuestionsListQueryVariables = Exact<{
  writer_user_id: Scalars['uuid'];
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type QuestionsListQuery = { __typename?: 'query_root', questions: Array<{ __typename?: 'questions', question_id: any, question_text?: string | null }>, questions_aggregate: { __typename?: 'questions_aggregate', aggregate?: { __typename?: 'questions_aggregate_fields', count?: number | null } | null } };

export type RandomQuestionForRoundQueryVariables = Exact<{
  category?: InputMaybe<Scalars['uuid']>;
  point_value?: InputMaybe<Scalars['Int']>;
  question_type?: InputMaybe<Scalars['_text']>;
  sub_category?: InputMaybe<Scalars['uuid']>;
  market?: InputMaybe<Scalars['String']>;
  question_bonus_id?: InputMaybe<Scalars['Int']>;
  is_mature?: InputMaybe<Scalars['Boolean']>;
  tags?: InputMaybe<Scalars['_text']>;
  question_text?: InputMaybe<Scalars['String']>;
  game_template_id?: InputMaybe<Scalars['String']>;
  question_type_id?: InputMaybe<Scalars['Int']>;
  for_used_status?: InputMaybe<Scalars['String']>;
}>;


export type RandomQuestionForRoundQuery = { __typename?: 'query_root', random_question: Array<{ __typename?: 'questions', point_value?: number | null, question_id: any, category?: { __typename?: 'categories', sort_order_num?: number | null, parent_category_id?: any | null, category_name: string, category_id: any } | null, sub_category?: { __typename?: 'categories', parent_category_id?: any | null, sort_order_num?: number | null, category_name: string, category_id: any } | null, question_type: { __typename?: 'question_types', question_type_short_name?: string | null, question_type_name: string, question_type_id: number } }> };

export type RejectReasonsQueryVariables = Exact<{ [key: string]: never; }>;


export type RejectReasonsQuery = { __typename?: 'query_root', rejection_reasons: Array<{ __typename?: 'rejection_reasons', rejection_reason_id: number, rejection_reason_name: string }> };

export type RejectionReasonNameQueryVariables = Exact<{
  reasonId?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type RejectionReasonNameQuery = { __typename?: 'query_root', rejection_reasons: Array<{ __typename?: 'rejection_reasons', rejection_reason_name: string }> };

export type ReportReasonsQueryVariables = Exact<{ [key: string]: never; }>;


export type ReportReasonsQuery = { __typename?: 'query_root', report_reasons: Array<{ __typename?: 'report_reasons', report_reason_id: number, report_reason_name: string }> };

export type CompilerStatsQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['uuid']>;
  startDate?: InputMaybe<Scalars['timestamptz']>;
  endDate?: InputMaybe<Scalars['timestamptz']>;
}>;


export type CompilerStatsQuery = { __typename?: 'query_root', all_created_games: { __typename?: 'trivia_games_aggregate', aggregate?: { __typename?: 'trivia_games_aggregate_fields', count?: number | null } | null }, ready_for_scheduling: { __typename?: 'trivia_games_aggregate', aggregate?: { __typename?: 'trivia_games_aggregate_fields', count?: number | null } | null }, created_standard_games: { __typename?: 'trivia_games_aggregate', aggregate?: { __typename?: 'trivia_games_aggregate_fields', count?: number | null } | null } };

export type FactcheckerStatsCountQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['uuid']>;
  startDate?: InputMaybe<Scalars['timestamp']>;
  endDate?: InputMaybe<Scalars['timestamp']>;
  questionTypeId?: InputMaybe<Scalars['Int']>;
  questionStatusId?: InputMaybe<Scalars['Int']>;
}>;


export type FactcheckerStatsCountQuery = { __typename?: 'query_root', count: { __typename?: 'questions_aggregate', aggregate?: { __typename?: 'questions_aggregate_fields', count?: number | null } | null } };

export type FactcheckerStatsQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['uuid']>;
  startDate?: InputMaybe<Scalars['timestamp']>;
  endDate?: InputMaybe<Scalars['timestamp']>;
  questionTypeId?: InputMaybe<Scalars['Int']>;
}>;


export type FactcheckerStatsQuery = { __typename?: 'query_root', approved_questions: { __typename?: 'questions_aggregate', aggregate?: { __typename?: 'questions_aggregate_fields', count?: number | null } | null }, rejected_questions: { __typename?: 'questions_aggregate', aggregate?: { __typename?: 'questions_aggregate_fields', count?: number | null } | null }, needs_review: { __typename?: 'questions_aggregate', aggregate?: { __typename?: 'questions_aggregate_fields', count?: number | null } | null } };

export type FirstFactcheckedQuestionQueryVariables = Exact<{
  question_status_id?: InputMaybe<Scalars['Int']>;
  writerUserId?: InputMaybe<Scalars['uuid']>;
}>;


export type FirstFactcheckedQuestionQuery = { __typename?: 'query_root', questions: Array<{ __typename?: 'questions', approved_datetime?: any | null }> };

export type WriterStatsQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['uuid']>;
  startDate?: InputMaybe<Scalars['timestamp']>;
  endDate?: InputMaybe<Scalars['timestamp']>;
  questionTypeId?: InputMaybe<Scalars['Int']>;
}>;


export type WriterStatsQuery = { __typename?: 'query_root', questions_submitted: { __typename?: 'questions_aggregate', aggregate?: { __typename?: 'questions_aggregate_fields', count?: number | null } | null }, questions_published: { __typename?: 'questions_aggregate', aggregate?: { __typename?: 'questions_aggregate_fields', count?: number | null } | null }, questions_rejected: { __typename?: 'questions_aggregate', aggregate?: { __typename?: 'questions_aggregate_fields', count?: number | null } | null }, questions_needs_review: { __typename?: 'questions_aggregate', aggregate?: { __typename?: 'questions_aggregate_fields', count?: number | null } | null } };

export type TagNamesQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  searchText?: InputMaybe<Scalars['String']>;
  currentList?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type TagNamesQuery = { __typename?: 'query_root', question_tags_by_count: Array<{ __typename?: 'question_tags_by_count', tag?: string | null }> };

export type TriviaEventTypesQueryVariables = Exact<{
  event_name?: Scalars['Boolean'];
}>;


export type TriviaEventTypesQuery = { __typename?: 'query_root', trivia_event_types: Array<{ __typename?: 'trivia_event_types', event_type_id: number, event_type_name?: string }> };

export type TriviaEventsQueryVariables = Exact<{
  start?: InputMaybe<Scalars['date']>;
  end?: InputMaybe<Scalars['date']>;
  trivia_user_id?: InputMaybe<Scalars['uuid']>;
  event_name?: Scalars['Boolean'];
  is_demo?: Scalars['Boolean'];
}>;


export type TriviaEventsQuery = { __typename?: 'query_root', trivia_events: Array<{ __typename?: 'trivia_events', game_id: any, date?: any | null, event_id: any, event_type_id: number, trivia_event_type?: { __typename?: 'trivia_event_types', event_type_name: string, event_type_id: number }, trivia_game: { __typename?: 'trivia_games', game_status: number, game_date?: any | null, game_id: any, updated_at?: any | null, title?: string | null, created_at?: any | null, game_template_id: string, is_demo?: boolean, trivia_game_themes: Array<{ __typename?: 'trivia_game_themes', game_theme: { __typename?: 'game_themes', name: string, id: any } }>, trivia_game_template: { __typename?: 'trivia_game_templates', template_id: string, template_name: string } } }> };

export type GetGameIdByEventIdQueryVariables = Exact<{
  event_id?: InputMaybe<Scalars['uuid']>;
}>;


export type GetGameIdByEventIdQuery = { __typename?: 'query_root', trivia_events: Array<{ __typename?: 'trivia_events', game_id: any, game_format_id: number, trivia_event_type: { __typename?: 'trivia_event_types', event_type_name: string, event_type_id: number } }> };

export type EditLogEditDateTimeQueryVariables = Exact<{
  questionId?: InputMaybe<Scalars['uuid']>;
}>;


export type EditLogEditDateTimeQuery = { __typename?: 'query_root', edit_log: Array<{ __typename?: 'edit_log', edit_datetime: any }> };

export type FactcheckedQuestionsAggregateQueryVariables = Exact<{
  question_status_id?: InputMaybe<Scalars['Int']>;
  writerUserId?: InputMaybe<Scalars['uuid']>;
}>;


export type FactcheckedQuestionsAggregateQuery = { __typename?: 'query_root', questions_aggregate: { __typename?: 'questions_aggregate', aggregate?: { __typename?: 'questions_aggregate_fields', count?: number | null } | null } };

export type GetQuestionJsonQueryVariables = Exact<{
  questionId?: InputMaybe<Scalars['uuid']>;
}>;


export type GetQuestionJsonQuery = { __typename?: 'query_root', questions: Array<{ __typename?: 'questions', question_json?: any | null, question_text?: string | null, question_type_id: number }> };

export type GetQuestionsByStartEndDatesQueryVariables = Exact<{
  start?: InputMaybe<Scalars['timestamp']>;
  end?: InputMaybe<Scalars['timestamp']>;
  writerUserId?: InputMaybe<Scalars['uuid']>;
  questionTypeId?: InputMaybe<Scalars['Int']>;
}>;


export type GetQuestionsByStartEndDatesQuery = { __typename?: 'query_root', questions_aggregate: { __typename?: 'questions_aggregate', aggregate?: { __typename?: 'questions_aggregate_fields', count?: number | null } | null } };

export type GetQuestionJsonByTypeIdQueryVariables = Exact<{
  questionTypeId?: InputMaybe<Scalars['Int']>;
}>;


export type GetQuestionJsonByTypeIdQuery = { __typename?: 'query_root', questions: Array<{ __typename?: 'questions', question_id: any, question_json?: any | null }> };

export type QuestionReportReasonQueryVariables = Exact<{
  questionId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type QuestionReportReasonQuery = { __typename?: 'query_root', reports: Array<{ __typename?: 'reports', report_reason: { __typename?: 'report_reasons', report_reason_id: number, report_reason_name: string } }> };

export type QuestionCounInQueueQueryVariables = Exact<{
  questionStatusId?: InputMaybe<Scalars['Int']>;
}>;


export type QuestionCounInQueueQuery = { __typename?: 'query_root', questions_aggregate: { __typename?: 'questions_aggregate', aggregate?: { __typename?: 'questions_aggregate_fields', count?: number | null } | null } };

export type GetRoundCategoryQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRoundCategoryQuery = { __typename?: 'query_root', trivia_game_category: Array<{ __typename?: 'trivia_game_category', id: number, name: string }> };

export type GetGameKeywordsQueryVariables = Exact<{
  roundId?: InputMaybe<Scalars['uuid']>;
}>;


export type GetGameKeywordsQuery = { __typename?: 'query_root', trivia_rounds: Array<{ __typename?: 'trivia_rounds', round_keywords?: string | null }> };

export type GetUserDataQueryVariables = Exact<{
  triviaUserId?: InputMaybe<Scalars['uuid']>;
}>;


export type GetUserDataQuery = { __typename?: 'query_root', trivia_users: Array<{ __typename?: 'trivia_users', specialties?: string | null, lastname?: string | null, info_json?: any | null, image?: string | null, firstname?: string | null, email: string, topics?: string | null, created_at?: any | null }> };

export type RoundQuestionByQuestionIdQueryVariables = Exact<{
  questionId?: InputMaybe<Scalars['uuid']>;
  includeJson: Scalars['Boolean'];
}>;


export type RoundQuestionByQuestionIdQuery = { __typename?: 'query_root', trivia_round_questions: Array<{ __typename?: 'trivia_round_questions', id: any, round_id: any, question_order: number, answer_type_id: number, wager: boolean, wager_range_value?: string | null, answer_type: { __typename?: 'answer_types', answer_type_name: string }, question: { __typename?: 'questions', question_type_id: number, question_bonus_id?: number | null, question_id: any, point_value?: number | null, question_text?: string | null, answer?: any | null, question_json?: any | null, question_type: { __typename?: 'question_types', question_type_id: number, question_type_name: string, question_type_short_name?: string | null }, category?: { __typename?: 'categories', category_id: any, category_name: string } | null, sub_category?: { __typename?: 'categories', category_name: string, category_id: any } | null }, trivia_round: { __typename?: 'trivia_rounds', name?: string | null, round_type: string } }> };

export type RoundQuestionByRoundIdQueryVariables = Exact<{
  roundId?: InputMaybe<Scalars['uuid']>;
  json?: InputMaybe<Scalars['String']>;
  questionOrder?: InputMaybe<Scalars['Int']>;
}>;


export type RoundQuestionByRoundIdQuery = { __typename?: 'query_root', trivia_round_questions: Array<{ __typename?: 'trivia_round_questions', id: any, answer_type_id: number, question_order: number, question: { __typename?: 'questions', question_json?: any | null, question_image?: string | null, question_text?: string | null, question_id: any, question_type_id: number, answer?: any | null, category?: { __typename?: 'categories', category_id: any, category_name: string, parent_category_id?: any | null } | null, sub_category?: { __typename?: 'categories', category_id: any, category_name: string, parent_category_id?: any | null } | null, question_type: { __typename?: 'question_types', question_type_short_name?: string | null, question_type_id: number, question_type_name: string } }, trivia_round: { __typename?: 'trivia_rounds', round_type: string }, answer_type: { __typename?: 'answer_types', answer_type_name: string, answer_type_id: number } }> };

export type GetUserByIdQueryVariables = Exact<{
  user_id?: InputMaybe<Scalars['uuid']>;
}>;


export type GetUserByIdQuery = { __typename?: 'query_root', trivia_users: Array<{ __typename?: 'trivia_users', image?: string | null, firstname?: string | null, lastname?: string | null, email: string, specialties?: string | null, topics?: string | null, user_type: { __typename?: 'user_types', user_type_name: string } }> };

export type GetUsersQueryVariables = Exact<{
  user_type_id?: InputMaybe<Scalars['Int']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  statusId?: InputMaybe<Scalars['Int']>;
}>;


export type GetUsersQuery = { __typename?: 'query_root', trivia_users: Array<{ __typename?: 'trivia_users', email: string, firstname?: string | null, lastname?: string | null, trivia_user_id: any, user_type_id: number }> };

export type GetWriterByIdQueryVariables = Exact<{
  user_id?: InputMaybe<Scalars['uuid']>;
}>;


export type GetWriterByIdQuery = { __typename?: 'query_root', trivia_users: Array<{ __typename?: 'trivia_users', email: string, firstname?: string | null, lastname?: string | null, trivia_user_id: any, image?: string | null, needs_review: { __typename?: 'questions_aggregate', aggregate?: { __typename?: 'questions_aggregate_fields', count?: number | null } | null }, rejected: { __typename?: 'questions_aggregate', aggregate?: { __typename?: 'questions_aggregate_fields', count?: number | null } | null }, factchecing_que: { __typename?: 'questions_aggregate', aggregate?: { __typename?: 'questions_aggregate_fields', count?: number | null } | null } }> };

export type GetWritersListQueryVariables = Exact<{
  user_type_id?: InputMaybe<Scalars['Int']>;
  count?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type GetWritersListQuery = { __typename?: 'query_root', trivia_users: Array<{ __typename?: 'trivia_users', firstname?: string | null, lastname?: string | null, trivia_user_id: any, email: string, published: { __typename?: 'questions_aggregate', aggregate?: { __typename?: 'questions_aggregate_fields', count?: number | null } | null }, submitted: { __typename?: 'questions_aggregate', aggregate?: { __typename?: 'questions_aggregate_fields', count?: number | null } | null }, rejected: { __typename?: 'questions_aggregate', aggregate?: { __typename?: 'questions_aggregate_fields', count?: number | null } | null } }>, trivia_users_aggregate: { __typename?: 'trivia_users_aggregate', aggregate?: { __typename?: 'trivia_users_aggregate_fields', count?: number | null } | null } };

export const GameRoundsFragmentDoc = gql`
    fragment gameRounds on trivia_game_rounds {
  created_at
  id
  round_id
  round_order
  trivia_round {
    created_at
    name
    round_id
    round_type
    trivia_round_type {
      id
      name
    }
  }
}
    `;
export const RoundQuestionsFragmentDoc = gql`
    fragment roundQuestions on trivia_round_questions {
  id
  answer_type_id
  wager
  wager_range_value
  question {
    question_id
    question_type {
      question_type_id
      question_type_name
      question_type_short_name
    }
    point_value
    category {
      category_id
      category_name
    }
    sub_category {
      category_name
      category_id
    }
    question_text
    question_image
    answer: question_json(path: "answer")
    question_json: question_json @include(if: $includeJson)
  }
  question_order
}
    `;
export const AddProfileDocument = gql`
    mutation AddProfile($email: String, $user_type_id: Int, $password: String, $lastname: String, $firstname: String, $image: String) {
  insert_trivia_users(
    objects: {email: $email, user_type_id: $user_type_id, password: $password, lastname: $lastname, image: $image, firstname: $firstname}
  ) {
    affected_rows
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AddProfileGQL extends Apollo.Mutation<AddProfileMutation, AddProfileMutationVariables> {
    document = AddProfileDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ChangeUserStatusDocument = gql`
    mutation ChangeUserStatus($userId: uuid, $statusId: Int) {
  update_trivia_users(
    where: {trivia_user_id: {_eq: $userId}}
    _set: {status_id: $statusId}
  ) {
    returning {
      status_id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ChangeUserStatusGQL extends Apollo.Mutation<ChangeUserStatusMutation, ChangeUserStatusMutationVariables> {
    document = ChangeUserStatusDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteEventByIdDocument = gql`
    mutation deleteEventByID($_eq: uuid = "") {
  delete_trivia_events(where: {event_id: {_eq: $_eq}}) {
    returning {
      game_id
      trivia_game {
        game_status
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteEventByIdGQL extends Apollo.Mutation<DeleteEventByIdMutation, DeleteEventByIdMutationVariables> {
    document = DeleteEventByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddRoundsToGameDocument = gql`
    mutation AddRoundsToGame($gameRounds: [trivia_game_rounds_insert_input!]!) {
  insert_trivia_game_rounds(objects: $gameRounds) {
    affected_rows
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AddRoundsToGameGQL extends Apollo.Mutation<AddRoundsToGameMutation, AddRoundsToGameMutationVariables> {
    document = AddRoundsToGameDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ChangeAnswerTypeDocument = gql`
    mutation ChangeAnswerType($questionId: uuid, $answer_type_id: Int = 1) {
  update_trivia_round_questions(
    where: {question_id: {_eq: $questionId}}
    _set: {answer_type_id: $answer_type_id}
  ) {
    returning {
      question_id
      round_id
      answer_type_id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ChangeAnswerTypeGQL extends Apollo.Mutation<ChangeAnswerTypeMutation, ChangeAnswerTypeMutationVariables> {
    document = ChangeAnswerTypeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateGameDocument = gql`
    mutation CreateGame($game_id: uuid, $game_status: Int, $game_template_id: String!, $market: String = "usa", $rating: String = "standard", $theme: trivia_game_themes_arr_rel_insert_input = {data: {theme_id: "aa3808ee-aacf-4e8f-bd03-8365849fd013"}}, $creator_id: uuid = "") {
  insert_trivia_games(
    objects: {game_id: $game_id, game_status: $game_status, market: $market, rating: $rating, trivia_game_themes: $theme, game_template_id: $game_template_id, creator_id: $creator_id}
  ) {
    returning {
      game_id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateGameGQL extends Apollo.Mutation<CreateGameMutation, CreateGameMutationVariables> {
    document = CreateGameDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteGameByIdDocument = gql`
    mutation DeleteGameById($gameId: uuid = "") {
  delete_trivia_games(where: {game_id: {_eq: $gameId}, game_status: {_eq: 1}}) {
    affected_rows
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteGameByIdGQL extends Apollo.Mutation<DeleteGameByIdMutation, DeleteGameByIdMutationVariables> {
    document = DeleteGameByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EventGameMutationDocument = gql`
    mutation EventGameMutation($event_id: uuid = "", $new_game_id: uuid = "", $event_type_id: Int = 1, $_trivia_user_id: uuid = "") {
  update_trivia_events(
    where: {event_id: {_eq: $event_id}, trivia_user_id: {_eq: $_trivia_user_id}}
    _set: {game_id: $new_game_id, event_type_id: $event_type_id}
  ) {
    returning {
      game_id
      event_type_id
      trivia_game {
        title
        trivia_game_themes {
          game_theme {
            name
            id
          }
        }
        game_id
        created_at
        trivia_game_template {
          template_id
          template_name
        }
        game_date
        game_template_id
      }
      event_id
      date
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EventGameMutationGQL extends Apollo.Mutation<EventGameMutationMutation, EventGameMutationMutationVariables> {
    document = EventGameMutationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GenerateCtRoundDocument = gql`
    mutation GenerateCTRound {
  generate_bonus_round {
    id
    title
    type_name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GenerateCtRoundGQL extends Apollo.Mutation<GenerateCtRoundMutation, GenerateCtRoundMutationVariables> {
    document = GenerateCtRoundDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GenerateCtmRoundDocument = gql`
    mutation GenerateCTMRound {
  generate_ctm_round {
    id
    title
    type_name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GenerateCtmRoundGQL extends Apollo.Mutation<GenerateCtmRoundMutation, GenerateCtmRoundMutationVariables> {
    document = GenerateCtmRoundDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GenerateFinalRoundDocument = gql`
    mutation GenerateFinalRound {
  generate_final_round {
    id
    title
    type_name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GenerateFinalRoundGQL extends Apollo.Mutation<GenerateFinalRoundMutation, GenerateFinalRoundMutationVariables> {
    document = GenerateFinalRoundDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GenerateStandardRoundDocument = gql`
    mutation GenerateStandardRound {
  generate_standard_round {
    id
    title
    type_name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GenerateStandardRoundGQL extends Apollo.Mutation<GenerateStandardRoundMutation, GenerateStandardRoundMutationVariables> {
    document = GenerateStandardRoundDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GenerateWarfareRoundQuestionsDocument = gql`
    query GenerateWarfareRoundQuestions($roundId: String, $limit: Int, $questionTypeId: Int, $questionOrder: Int, $isWarfare: Boolean = false, $gameId: String = "") {
  generateWarfareRoundQuestions(
    args: {roundId: $roundId, limit: $limit, questionTypeId: $questionTypeId, questionOrder: $questionOrder, isWarfare: $isWarfare, gameId: $gameId}
  ) {
    id
    title
    type_name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GenerateWarfareRoundQuestionsGQL extends Apollo.Query<GenerateWarfareRoundQuestionsQuery, GenerateWarfareRoundQuestionsQueryVariables> {
    document = GenerateWarfareRoundQuestionsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GenerateWarfareRoundDocument = gql`
    mutation GenerateWarfareRound {
  generate_warfare_round {
    id
    title
    type_name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GenerateWarfareRoundGQL extends Apollo.Mutation<GenerateWarfareRoundMutation, GenerateWarfareRoundMutationVariables> {
    document = GenerateWarfareRoundDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RemoveGameRoundByPkDocument = gql`
    mutation RemoveGameRoundByPk($id: uuid!) {
  delete_trivia_game_rounds_by_pk(id: $id) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveGameRoundByPkGQL extends Apollo.Mutation<RemoveGameRoundByPkMutation, RemoveGameRoundByPkMutationVariables> {
    document = RemoveGameRoundByPkDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RemoveRoundDocument = gql`
    query RemoveRound($roundId: String) {
  triviaGameRoundDelete(args: {roundId: $roundId}) {
    response
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveRoundGQL extends Apollo.Query<RemoveRoundQuery, RemoveRoundQueryVariables> {
    document = RemoveRoundDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ReplaceGameThemesDocument = gql`
    mutation ReplaceGameThemes($gameId: uuid!, $themes: [trivia_game_themes_insert_input!]!) {
  delete_trivia_game_themes(where: {game_id: {_eq: $gameId}}) {
    affected_rows
  }
  insert_trivia_game_themes(objects: $themes) {
    affected_rows
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ReplaceGameThemesGQL extends Apollo.Mutation<ReplaceGameThemesMutation, ReplaceGameThemesMutationVariables> {
    document = ReplaceGameThemesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ReplaceRoundThemesDocument = gql`
    mutation ReplaceRoundThemes($roundId: uuid!, $themes: [trivia_round_themes_insert_input!]!) {
  delete_trivia_round_themes(where: {round_id: {_eq: $roundId}}) {
    affected_rows
  }
  insert_trivia_round_themes(objects: $themes) {
    affected_rows
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ReplaceRoundThemesGQL extends Apollo.Mutation<ReplaceRoundThemesMutation, ReplaceRoundThemesMutationVariables> {
    document = ReplaceRoundThemesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateAnswerTypesDocument = gql`
    mutation UpdateAnswerTypes($id: uuid!, $question_id: uuid, $answer_type_id: Int = 1) {
  update_trivia_round_questions(
    where: {id: {_eq: $id}, question_id: {_eq: $question_id}}
    _set: {answer_type_id: $answer_type_id}
  ) {
    affected_rows
    returning {
      id
      question_id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateAnswerTypesGQL extends Apollo.Mutation<UpdateAnswerTypesMutation, UpdateAnswerTypesMutationVariables> {
    document = UpdateAnswerTypesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateCtmLastRoundWagerDocument = gql`
    mutation UpdateCtmLastRoundWager($game_id: uuid!, $round_order: Int = 5) {
  update_trivia_round_questions(
    where: {trivia_round: {trivia_game_rounds: {game_id: {_eq: $game_id}, round_order: {_eq: $round_order}}}, wager: {_eq: true}}
    _set: {wager_range_value: "0 - 20"}
  ) {
    affected_rows
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateCtmLastRoundWagerGQL extends Apollo.Mutation<UpdateCtmLastRoundWagerMutation, UpdateCtmLastRoundWagerMutationVariables> {
    document = UpdateCtmLastRoundWagerDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateCtmWagerDocument = gql`
    mutation UpdateCtmWager($id: uuid!, $wager: String!, $is_wager: Boolean = true) {
  update_trivia_round_questions_by_pk(
    pk_columns: {id: $id}
    _set: {wager_range_value: $wager, wager: $is_wager}
  ) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateCtmWagerGQL extends Apollo.Mutation<UpdateCtmWagerMutation, UpdateCtmWagerMutationVariables> {
    document = UpdateCtmWagerDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateGameStatusDocument = gql`
    mutation updateGameStatus($change_object: trivia_games_set_input, $_eq: uuid) {
  update_trivia_games(where: {game_id: {_eq: $_eq}}, _set: $change_object) {
    returning {
      game_id
      game_status
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateGameStatusGQL extends Apollo.Mutation<UpdateGameStatusMutation, UpdateGameStatusMutationVariables> {
    document = UpdateGameStatusDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateGameDocument = gql`
    mutation UpdateGame($game_data: trivia_games_set_input, $id: uuid!) {
  update_trivia_games_by_pk(pk_columns: {game_id: $id}, _set: $game_data) {
    category
    created_at
    description
    format_graphic_url
    keywords
    market
    promo_image_url
    rating
    theme_image_url
    title
    trivia_game_themes {
      game_theme {
        id
        name
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateGameGQL extends Apollo.Mutation<UpdateGameMutation, UpdateGameMutationVariables> {
    document = UpdateGameDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateRoundQuestionDocument = gql`
    mutation UpdateRoundQuestion($question_id: uuid!, $id: uuid!) {
  update_trivia_round_questions_by_pk(
    pk_columns: {id: $id}
    _set: {question_id: $question_id}
  ) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateRoundQuestionGQL extends Apollo.Mutation<UpdateRoundQuestionMutation, UpdateRoundQuestionMutationVariables> {
    document = UpdateRoundQuestionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateRoundDocument = gql`
    mutation UpdateRound($round_data: trivia_rounds_set_input, $id: uuid!) {
  update_trivia_rounds_by_pk(pk_columns: {round_id: $id}, _set: $round_data) {
    round_id
    name
    created_at
    updated_at
    round_type
    trivia_round_themes {
      game_theme {
        id
        name
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateRoundGQL extends Apollo.Mutation<UpdateRoundMutation, UpdateRoundMutationVariables> {
    document = UpdateRoundDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InsertTriviaEventOneDocument = gql`
    mutation InsertTriviaEventOne($triviaUserId: uuid = "", $eventTypeId: Int = 1, $gameId: uuid = "", $date: date = "", $isDemo: Boolean! = false) {
  insert_trivia_events(
    objects: {trivia_user_id: $triviaUserId, event_type_id: $eventTypeId, game_id: $gameId, date: $date}
  ) {
    returning {
      event_id
      event_type_id
      game_id
      trivia_user_id
      date
      trivia_game {
        game_date
        created_at
        game_status
        title
        trivia_game_template {
          template_name
          template_id
        }
        is_demo @include(if: $isDemo)
        game_template_id
        trivia_game_themes {
          game_theme {
            id
            name
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class InsertTriviaEventOneGQL extends Apollo.Mutation<InsertTriviaEventOneMutation, InsertTriviaEventOneMutationVariables> {
    document = InsertTriviaEventOneDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ChangeQuestionTagsDocument = gql`
    mutation ChangeQuestionTags($objects: [question_tags_insert_input!]!, $question_id: uuid!) {
  delete_question_tags(where: {question_id: {_eq: $question_id}}) {
    affected_rows
  }
  insert_question_tags(objects: $objects) {
    affected_rows
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ChangeQuestionTagsGQL extends Apollo.Mutation<ChangeQuestionTagsMutation, ChangeQuestionTagsMutationVariables> {
    document = ChangeQuestionTagsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InsertQuestionDocument = gql`
    mutation InsertQuestion($source_primary: String, $source_secondary: String, $category_id: uuid, $point_value: Int, $created_datetime: timestamp, $market_id: String, $question_id: uuid, $question_json: jsonb, $question_text: String, $question_type_id: Int, $sub_category_id: uuid, $question_bonus_id: Int, $use_end_date: date = null, $use_start_date: date = null, $writer_user_id: uuid, $question_rating: Int = 1, $question_image: String = "", $question_status_id: Int, $question_difficulty_id: Int, $for_round_type: String = "") {
  insert_questions_one(
    object: {writer_user_id: $writer_user_id, use_start_date: $use_start_date, use_end_date: $use_end_date, sub_category_id: $sub_category_id, question_type_id: $question_type_id, question_text: $question_text, question_json: $question_json, question_id: $question_id, market_id: $market_id, question_bonus_id: $question_bonus_id, created_datetime: $created_datetime, point_value: $point_value, source_primary: $source_primary, source_secondary: $source_secondary, category_id: $category_id, question_rating: $question_rating, question_image: $question_image, question_status_id: $question_status_id, question_difficulty_id: $question_difficulty_id, for_round_type: $for_round_type}
    on_conflict: {constraint: trivia_question_pkey, update_columns: [writer_user_id, use_start_date, use_end_date, sub_category_id, question_type_id, question_text, question_json, market_id, is_mature, category_id, point_value, source_primary, source_secondary]}
  ) {
    writer_user_id
    question_id
    for_round_type
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class InsertQuestionGQL extends Apollo.Mutation<InsertQuestionMutation, InsertQuestionMutationVariables> {
    document = InsertQuestionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MarkQuestionForReviewDocument = gql`
    mutation MarkQuestionForReview($questionId: uuid!) {
  update_questions_by_pk(
    pk_columns: {question_id: $questionId}
    _set: {question_status_id: 2}
  ) {
    question_id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MarkQuestionForReviewGQL extends Apollo.Mutation<MarkQuestionForReviewMutation, MarkQuestionForReviewMutationVariables> {
    document = MarkQuestionForReviewDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ReportQuestionDocument = gql`
    mutation ReportQuestion($message: String = "", $questionId: uuid!, $reasonId: Int, $userId: uuid) {
  insert_reports_one(
    object: {app_name: "Trebek Admin", comment: $message, question_id: $questionId, report_reason_id: $reasonId, user_id: $userId}
  ) {
    report_reason_id
  }
  update_questions_by_pk(
    pk_columns: {question_id: $questionId}
    _set: {question_status_id: 4}
  ) {
    question_id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ReportQuestionGQL extends Apollo.Mutation<ReportQuestionMutation, ReportQuestionMutationVariables> {
    document = ReportQuestionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateQuestionApprovedUserIdDocument = gql`
    mutation UpdateQuestionApprovedUserId($question_id: uuid, $approved_user_id: uuid) {
  update_questions(
    where: {question_id: {_eq: $question_id}}
    _set: {approved_user_id: $approved_user_id}
  ) {
    returning {
      question_id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateQuestionApprovedUserIdGQL extends Apollo.Mutation<UpdateQuestionApprovedUserIdMutation, UpdateQuestionApprovedUserIdMutationVariables> {
    document = UpdateQuestionApprovedUserIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateQuestionDataDocument = gql`
    mutation UpdateQuestionData($data: questions_set_input, $question_id: uuid) {
  update_questions(where: {question_id: {_eq: $question_id}}, _set: $data) {
    returning {
      approved_datetime
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateQuestionDataGQL extends Apollo.Mutation<UpdateQuestionDataMutation, UpdateQuestionDataMutationVariables> {
    document = UpdateQuestionDataDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddRoundQuestionsDocument = gql`
    mutation AddRoundQuestions($objects: [trivia_round_questions_insert_input!]!) {
  insert_trivia_round_questions(objects: $objects) {
    affected_rows
    returning {
      question {
        question_type_id
        question_id
      }
      id
      question_order
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AddRoundQuestionsGQL extends Apollo.Mutation<AddRoundQuestionsMutation, AddRoundQuestionsMutationVariables> {
    document = AddRoundQuestionsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteRoundQuestionDocument = gql`
    mutation DeleteRoundQuestion($questionId: uuid!, $roundId: uuid = "") {
  delete_trivia_round_questions(
    where: {question_id: {_eq: $questionId}, round_id: {_eq: $roundId}}
  ) {
    returning {
      question_id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteRoundQuestionGQL extends Apollo.Mutation<DeleteRoundQuestionMutation, DeleteRoundQuestionMutationVariables> {
    document = DeleteRoundQuestionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateTriviaRoundQuestionsDocument = gql`
    mutation UpdateTriviaRoundQuestions($questionData: trivia_round_questions_set_input, $roundColumnId: uuid_comparison_exp) {
  update_trivia_round_questions(_set: $questionData, where: {id: $roundColumnId}) {
    affected_rows
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateTriviaRoundQuestionsGQL extends Apollo.Mutation<UpdateTriviaRoundQuestionsMutation, UpdateTriviaRoundQuestionsMutationVariables> {
    document = UpdateTriviaRoundQuestionsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateTriviaUserDocument = gql`
    mutation updateTriviaUser($userId: uuid = "", $userData: trivia_users_set_input) {
  update_trivia_users(where: {trivia_user_id: {_eq: $userId}}, _set: $userData) {
    returning {
      email
      firstname
      image
      lastname
      specialties
      topics
      user_type {
        user_type_name
      }
      phone_number
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateTriviaUserGQL extends Apollo.Mutation<UpdateTriviaUserMutation, UpdateTriviaUserMutationVariables> {
    document = UpdateTriviaUserDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateUserImageDocument = gql`
    mutation UpdateUserImage($userId: uuid, $image: String) {
  update_trivia_users(
    where: {trivia_user_id: {_eq: $userId}}
    _set: {image: $image}
  ) {
    returning {
      image
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateUserImageGQL extends Apollo.Mutation<UpdateUserImageMutation, UpdateUserImageMutationVariables> {
    document = UpdateUserImageDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateUserPasswordDocument = gql`
    mutation UpdateUserPassword($user_id: uuid, $currentPassword: String, $password: String = "") {
  update_trivia_users(
    where: {password: {_eq: $currentPassword}, trivia_user_id: {_eq: $user_id}}
    _set: {password: $password}
  ) {
    returning {
      password
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateUserPasswordGQL extends Apollo.Mutation<UpdateUserPasswordMutation, UpdateUserPasswordMutationVariables> {
    document = UpdateUserPasswordDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateIsDemoValueDocument = gql`
    mutation UpdateIsDemoValue($isDemo: Boolean = false, $gameId: uuid = "") {
  update_trivia_games(where: {game_id: {_eq: $gameId}}, _set: {is_demo: $isDemo}) {
    returning {
      is_demo
      game_id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateIsDemoValueGQL extends Apollo.Mutation<UpdateIsDemoValueMutation, UpdateIsDemoValueMutationVariables> {
    document = UpdateIsDemoValueDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CategoriesDocument = gql`
    query Categories {
  categories {
    sort_order_num
    parent_category_id
    category_name
    category_id
    archived
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CategoriesGQL extends Apollo.Query<CategoriesQuery, CategoriesQueryVariables> {
    document = CategoriesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCompilersListDocument = gql`
    query getCompilersList($user_type_id: Int, $count: Int = 1, $offset: Int) {
  trivia_users(
    where: {user_type_id: {_eq: $user_type_id}, _and: {status_id: {_eq: 0}}}
    limit: $count
    offset: $offset
    order_by: {created_at: desc}
  ) {
    firstname
    lastname
    trivia_user_id
    email
  }
  trivia_users_aggregate(
    where: {user_type_id: {_eq: $user_type_id}, _and: {status_id: {_eq: 0}}}
  ) {
    aggregate {
      count
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCompilersListGQL extends Apollo.Query<GetCompilersListQuery, GetCompilersListQueryVariables> {
    document = GetCompilersListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetFactcheckerByIdDocument = gql`
    query getFactcheckerById($user_id: uuid) {
  trivia_users(where: {trivia_user_id: {_eq: $user_id}}) {
    email
    firstname
    lastname
    trivia_user_id
    image
    needs_review: approved_questions_aggregate(
      where: {question_status: {question_status_id: {_eq: 2}}}
    ) {
      aggregate {
        count
      }
    }
    rejected: approved_questions_aggregate(
      where: {question_status: {question_status_id: {_eq: 1}}}
    ) {
      aggregate {
        count
      }
    }
    factchecing_que: approved_questions_aggregate(
      where: {question_status: {question_status_id: {_in: [1, 2, 3]}}}
    ) {
      aggregate {
        count
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetFactcheckerByIdGQL extends Apollo.Query<GetFactcheckerByIdQuery, GetFactcheckerByIdQueryVariables> {
    document = GetFactcheckerByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetFactcheckersListDocument = gql`
    query getFactcheckersList($user_type_id: Int, $count: Int = 1, $offset: Int) {
  trivia_users(
    where: {user_type_id: {_eq: $user_type_id}, _and: {status_id: {_eq: 0}}}
    limit: $count
    offset: $offset
    order_by: {created_at: desc}
  ) {
    firstname
    lastname
    trivia_user_id
    email
    accepted: approved_questions_aggregate(
      where: {question_status: {question_status_id: {_eq: 3}}}
    ) {
      aggregate {
        count
      }
    }
    rejected: approved_questions_aggregate(
      where: {question_status: {question_status_id: {_eq: 1}}}
    ) {
      aggregate {
        count
      }
    }
    question_factchecked: approved_questions_aggregate(
      where: {question_status: {question_status_id: {_in: [1, 3]}}}
    ) {
      aggregate {
        count
      }
    }
  }
  trivia_users_aggregate(
    where: {user_type_id: {_eq: 3}, _and: {status_id: {_eq: 0}}}
  ) {
    aggregate {
      count
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetFactcheckersListGQL extends Apollo.Query<GetFactcheckersListQuery, GetFactcheckersListQueryVariables> {
    document = GetFactcheckersListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AnswerTypesDocument = gql`
    query AnswerTypes {
  answer_types {
    answer_type_id
    answer_type_name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AnswerTypesGQL extends Apollo.Query<AnswerTypesQuery, AnswerTypesQueryVariables> {
    document = AnswerTypesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FillRoundCtmQuestionsDocument = gql`
    query FillRoundCtmQuestions($pointValue: Int, $keyword: String, $questionTypeId: Int, $tags: [String] = null, $category: uuid, $subCategory: uuid, $count: Int, $question_rating: Int = 1, $game_id: uuid = null, $forUsedStatus: String = "") {
  fillCtmRoundQuestions(
    args: {pointValue: $pointValue, keyword: $keyword, questionTypeId: $questionTypeId, tags: $tags, category: $category, subCategory: $subCategory, count: $count, question_rating: $question_rating, for_used_status: $forUsedStatus, game_id: $game_id}
  ) {
    question_id: _fill_ctm_round_search_wf
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class FillRoundCtmQuestionsGQL extends Apollo.Query<FillRoundCtmQuestionsQuery, FillRoundCtmQuestionsQueryVariables> {
    document = FillRoundCtmQuestionsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FillRoundFinalQuestionDocument = gql`
    query FillRoundFinalQuestion($keyword: String, $questionTypeId: Int, $tags: [String] = null, $category: uuid, $subCategory: uuid, $question_rating: Int, $count: Int) {
  fillFinalRoundQuestions(
    args: {keyword: $keyword, questionTypeId: $questionTypeId, tags: $tags, category: $category, subCategory: $subCategory, question_rating: $question_rating, count: $count}
  ) {
    question_id: _fill_default_final_round_search_wf
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class FillRoundFinalQuestionGQL extends Apollo.Query<FillRoundFinalQuestionQuery, FillRoundFinalQuestionQueryVariables> {
    document = FillRoundFinalQuestionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FillRoundQuestionDocument = gql`
    query FillRoundQuestion($questions: [QuestionsData], $roundId: uuid) {
  generateRoundQuestions(args: {roundId: $roundId, questions: $questions}) {
    response
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class FillRoundQuestionGQL extends Apollo.Query<FillRoundQuestionQuery, FillRoundQuestionQueryVariables> {
    document = FillRoundQuestionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FillRoundStandardQuestionsDocument = gql`
    query FillRoundStandardQuestions($keyword: String, $questionTypeId: Int, $tags: [String] = null, $category: uuid, $subCategory: uuid, $count: Int, $question_rating: Int = 1, $forRoundType: String) {
  fillRoundQuestions(
    args: {keyword: $keyword, questionTypeId: $questionTypeId, tags: $tags, category: $category, subCategory: $subCategory, count: $count, question_rating: $question_rating, for_round_type: $forRoundType}
  ) {
    question_id: _fill_default_round_search_wf
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class FillRoundStandardQuestionsGQL extends Apollo.Query<FillRoundStandardQuestionsQuery, FillRoundStandardQuestionsQueryVariables> {
    document = FillRoundStandardQuestionsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GameByPkDocument = gql`
    query GameByPk($game_id: uuid!) {
  trivia_games_by_pk(game_id: $game_id) {
    category
    created_at
    description
    format_graphic_url
    gameStatusByGameStatus {
      id
      name
    }
    game_id
    keywords
    market
    promo_image_url
    rating
    theme_image_url
    title
    trivia_game_themes {
      game_theme {
        id
        name
      }
    }
    trivia_game_template {
      template_id
      template_name
    }
    trivia_game_rounds(order_by: {round_order: asc}) {
      ...gameRounds
    }
    game_difficult_id
    game_template_id
  }
}
    ${GameRoundsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GameByPkGQL extends Apollo.Query<GameByPkQuery, GameByPkQueryVariables> {
    document = GameByPkDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GameByPkRoundsDocument = gql`
    query GameByPkRounds($game_id: uuid!) {
  trivia_games_by_pk(game_id: $game_id) {
    trivia_game_rounds(order_by: {round_order: asc}) {
      ...gameRounds
    }
  }
}
    ${GameRoundsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GameByPkRoundsGQL extends Apollo.Query<GameByPkRoundsQuery, GameByPkRoundsQueryVariables> {
    document = GameByPkRoundsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GameDifficultiesDocument = gql`
    query GameDifficulties {
  game_difficulties {
    game_difficult_id
    game_difficult_name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GameDifficultiesGQL extends Apollo.Query<GameDifficultiesQuery, GameDifficultiesQueryVariables> {
    document = GameDifficultiesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GameRatingsDocument = gql`
    query GameRatings {
  game_ratings {
    id
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GameRatingsGQL extends Apollo.Query<GameRatingsQuery, GameRatingsQueryVariables> {
    document = GameRatingsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GameTemplatesDocument = gql`
    query GameTemplates {
  trivia_game_templates(order_by: {order: asc}) {
    template_id
    template_name
    order
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GameTemplatesGQL extends Apollo.Query<GameTemplatesQuery, GameTemplatesQueryVariables> {
    document = GameTemplatesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SelectedGameTemplateDocument = gql`
    query SelectedGameTemplate {
  selected_game_template @client {
    template_id @client
    template_name @client
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SelectedGameTemplateGQL extends Apollo.Query<SelectedGameTemplateQuery, SelectedGameTemplateQueryVariables> {
    document = SelectedGameTemplateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GameThemesDocument = gql`
    query GameThemes {
  game_themes {
    id
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GameThemesGQL extends Apollo.Query<GameThemesQuery, GameThemesQueryVariables> {
    document = GameThemesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GameFormatsDocument = gql`
    query GameFormats {
  trivia_game_templates {
    template_id
    template_name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GameFormatsGQL extends Apollo.Query<GameFormatsQuery, GameFormatsQueryVariables> {
    document = GameFormatsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GameListDocument = gql`
    query GameList($status: Int, $template: String, $limit: Int, $offset: Int, $creatorId: uuid = "") {
  trivia_games(
    where: {game_status: {_eq: $status}, trivia_game_template: {template_id: {_eq: $template}}, creator_id: {_eq: $creatorId}}
    limit: $limit
    offset: $offset
    order_by: {created_at: desc}
  ) {
    title
    game_id
    created_at
    trivia_game_themes {
      game_theme {
        id
        name
      }
    }
    gameStatusByGameStatus {
      id
      name
    }
  }
  trivia_games_aggregate(
    where: {game_status: {_eq: $status}, trivia_game_template: {template_id: {_eq: $template}}, creator_id: {_eq: $creatorId}}
  ) {
    aggregate {
      count
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GameListGQL extends Apollo.Query<GameListQuery, GameListQueryVariables> {
    document = GameListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GameScheduledDateDocument = gql`
    query GameScheduledDate($gameId: uuid) {
  trivia_events(where: {game_id: {_eq: $gameId}}) {
    date
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GameScheduledDateGQL extends Apollo.Query<GameScheduledDateQuery, GameScheduledDateQueryVariables> {
    document = GameScheduledDateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GenerateBlankRoundDocument = gql`
    query GenerateBlankRound($roundTemplateId: String, $roundType: String) {
  generateRound(args: {roundTemplateId: $roundTemplateId, roundType: $roundType}) {
    id
    title
    type_name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GenerateBlankRoundGQL extends Apollo.Query<GenerateBlankRoundQuery, GenerateBlankRoundQueryVariables> {
    document = GenerateBlankRoundDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GenerateTwoColumnRoundQuestionsDocument = gql`
    query GenerateTwoColumnRoundQuestions($roundId: String) {
  generateTwoColumnRoundQuestions(args: {roundId: $roundId}) {
    id
    title
    type_name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GenerateTwoColumnRoundQuestionsGQL extends Apollo.Query<GenerateTwoColumnRoundQuestionsQuery, GenerateTwoColumnRoundQuestionsQueryVariables> {
    document = GenerateTwoColumnRoundQuestionsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RemoveRoundQuestionsDocument = gql`
    mutation RemoveRoundQuestions($round_id: uuid!) {
  delete_trivia_round_questions(where: {round_id: {_eq: $round_id}}) {
    affected_rows
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveRoundQuestionsGQL extends Apollo.Mutation<RemoveRoundQuestionsMutation, RemoveRoundQuestionsMutationVariables> {
    document = RemoveRoundQuestionsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RemoveRoundQuestionsByIdsDocument = gql`
    mutation RemoveRoundQuestionsByIds($round_id: uuid!, $ids: [uuid!]) {
  delete_trivia_round_questions(
    where: {round_id: {_eq: $round_id}, id: {_in: $ids}}
  ) {
    affected_rows
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveRoundQuestionsByIdsGQL extends Apollo.Mutation<RemoveRoundQuestionsByIdsMutation, RemoveRoundQuestionsByIdsMutationVariables> {
    document = RemoveRoundQuestionsByIdsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RoundByPkDocument = gql`
    query RoundByPk($id: uuid!, $includeJson: Boolean! = false) {
  trivia_rounds_by_pk(round_id: $id) {
    created_at
    trivia_round_themes {
      game_theme {
        id
        name
      }
    }
    name
    round_id
    trivia_round_type {
      id
      name
    }
    updated_at
    trivia_round_questions(order_by: {question_order: asc}) {
      ...roundQuestions
      answer_type {
        answer_type_name
      }
      question {
        question_type_id
        question_bonus_id
      }
    }
    trivia_game_rounds {
      game_id
      round_id
      trivia_game {
        game_template_id
      }
      round_order
    }
    trivia_round_template {
      template_id
      template_name
    }
    round_keywords
  }
}
    ${RoundQuestionsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class RoundByPkGQL extends Apollo.Query<RoundByPkQuery, RoundByPkQueryVariables> {
    document = RoundByPkDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetScheduledGamesByDateDocument = gql`
    query GetScheduledGamesByDate($date: date_comparison_exp, $userId: uuid = "") {
  trivia_events(where: {date: $date, trivia_user_id: {_eq: $userId}}) {
    event_type_id
    game_format_id
    trivia_game {
      game_id
      game_difficult_id
      game_template_id
      game_status
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetScheduledGamesByDateGQL extends Apollo.Query<GetScheduledGamesByDateQuery, GetScheduledGamesByDateQueryVariables> {
    document = GetScheduledGamesByDateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TriviaGameByIdDocument = gql`
    query TriviaGameById($game_id: uuid, $_eq: String = "") {
  trivia_games(where: {game_id: {_eq: $game_id}, game_template_id: {_eq: $_eq}}) {
    created_at
    game_id
    game_date
    title
    trivia_game_themes {
      theme_id
      game_theme {
        name
        id
      }
      trivia_game {
        game_id
        game_status
        game_template_id
        game_date
        title
        created_at
      }
    }
    game_template_id
    game_status
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TriviaGameByIdGQL extends Apollo.Query<TriviaGameByIdQuery, TriviaGameByIdQueryVariables> {
    document = TriviaGameByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TriviaGamesDocument = gql`
    query TriviaGames($order: order_by = asc, $game_id_neq: uuid, $game_status: Int = 4, $game_template_id: String = "") {
  trivia_games(
    order_by: {created_at: $order}
    where: {game_id: {_neq: $game_id_neq}, game_status: {_eq: $game_status}, game_template_id: {_eq: $game_template_id}}
  ) {
    game_date
    game_id
    title
    trivia_game_themes {
      game_theme {
        name
        id
      }
      theme_id
      game_theme_id
    }
    created_at
    game_status
    game_template_id
    trivia_game_template {
      template_id
      template_name
    }
    trivia_game_rounds {
      trivia_round {
        trivia_round_questions {
          question_id
        }
      }
    }
  }
  trivia_games_aggregate {
    aggregate {
      count(columns: game_id)
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TriviaGamesGQL extends Apollo.Query<TriviaGamesQuery, TriviaGamesQueryVariables> {
    document = TriviaGamesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MarketsDocument = gql`
    query Markets {
  markets {
    language_id
    market_id
    market_name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MarketsGQL extends Apollo.Query<MarketsQuery, MarketsQueryVariables> {
    document = MarketsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MatureRatingDocument = gql`
    query MatureRating {
  question_ratings {
    id
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MatureRatingGQL extends Apollo.Query<MatureRatingQuery, MatureRatingQueryVariables> {
    document = MatureRatingDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const QuestionTextSearchDocument = gql`
    query QuestionTextSearch($searchString: String = "", $questionTypeId: Int = 10, $limit: Int = 50) {
  questions(
    where: {question_text: {_ilike: $searchString}, question_type_id: {_eq: $questionTypeId}}
    limit: $limit
  ) {
    question_text
    question_type {
      question_type_id
      question_type_short_name
      question_type_name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class QuestionTextSearchGQL extends Apollo.Query<QuestionTextSearchQuery, QuestionTextSearchQueryVariables> {
    document = QuestionTextSearchDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RejectedQuestionsCountDocument = gql`
    query RejectedQuestionsCount($rejectionReasonName: String, $writerUserId: uuid = "") {
  questions_aggregate(
    where: {question_status_id: {_eq: 1}, writer_user_id: {_eq: $writerUserId}, rejection_reason: {rejection_reason_name: {_eq: $rejectionReasonName}}}
  ) {
    aggregate {
      count
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RejectedQuestionsCountGQL extends Apollo.Query<RejectedQuestionsCountQuery, RejectedQuestionsCountQueryVariables> {
    document = RejectedQuestionsCountDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetQuestionIdAndOrderDocument = gql`
    query GetQuestionIdAndOrder($roundId: uuid = "") {
  trivia_round_questions(where: {round_id: {_eq: $roundId}}) {
    orderNumber: question_order
    questionId: question_id
    answerTypeId: answer_type_id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetQuestionIdAndOrderGQL extends Apollo.Query<GetQuestionIdAndOrderQuery, GetQuestionIdAndOrderQueryVariables> {
    document = GetQuestionIdAndOrderDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const QuestionBonusesDocument = gql`
    query QuestionBonuses {
  question_bonuses {
    question_bonus_id
    question_bonus_name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class QuestionBonusesGQL extends Apollo.Query<QuestionBonusesQuery, QuestionBonusesQueryVariables> {
    document = QuestionBonusesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const QuestionByIdDocument = gql`
    query QuestionById($question_id: uuid!) {
  questions(where: {question_id: {_eq: $question_id}}) {
    approved_datetime
    approved_user_id
    category {
      archived
      category_id
      category_name
      parent_category_id
      sort_order_num
    }
    category_id
    created_datetime
    first_used_date
    host_note
    is_alcohol
    is_mature
    last_used_date
    market {
      language_id
      market_id
      market_name
    }
    market_id
    paid_invoice_id
    point_value
    question_data
    question_id
    question_image
    question_json
    question_status_id
    question_text
    question_type {
      question_type_id
      question_type_name
    }
    question_type_id
    source_validation
    sub_category {
      archived
      category_id
      category_name
      parent_category_id
      sort_order_num
    }
    sub_category_id
    use_end_date
    use_start_date
    writer_user_id
    question_difficulty_id
    question_bonus_id
    point_value
    source_primary
    source_secondary
    question_difficulty {
      question_difficulty_id
      question_difficulty_name
    }
    question_tags {
      tag
    }
    reports {
      comment
      app_name
      reason: report_reason {
        reason_name: report_reason_name
        reason_id: report_reason_id
      }
    }
    question_rating
    is_used
    comment: rejection_note
    reason_id: rejection_reason_id
    reason_name: rejection_reason {
      name: rejection_reason_name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class QuestionByIdGQL extends Apollo.Query<QuestionByIdQuery, QuestionByIdQueryVariables> {
    document = QuestionByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const QuestionDifficultiesDocument = gql`
    query QuestionDifficulties {
  question_difficulties {
    question_difficulty_id
    question_difficulty_name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class QuestionDifficultiesGQL extends Apollo.Query<QuestionDifficultiesQuery, QuestionDifficultiesQueryVariables> {
    document = QuestionDifficultiesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const QuestionReportReasonsDocument = gql`
    query QuestionReportReasons($questionId: uuid = "") {
  reports(where: {question_id: {_eq: $questionId}}) {
    comment
    reason: report_reason {
      reason_id: report_reason_id
      reason_name: report_reason_name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class QuestionReportReasonsGQL extends Apollo.Query<QuestionReportReasonsQuery, QuestionReportReasonsQueryVariables> {
    document = QuestionReportReasonsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const QuestionStatusDocument = gql`
    query QuestionStatus {
  question_status {
    question_status_id
    question_status_name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class QuestionStatusGQL extends Apollo.Query<QuestionStatusQuery, QuestionStatusQueryVariables> {
    document = QuestionStatusDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const QuestionTypesDocument = gql`
    query QuestionTypes {
  question_types {
    question_type_id
    question_type_name
    question_type_short_name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class QuestionTypesGQL extends Apollo.Query<QuestionTypesQuery, QuestionTypesQueryVariables> {
    document = QuestionTypesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const QuestionByFilterDocument = gql`
    query QuestionByFilter($limit: Int, $offset: Int, $where: questions_bool_exp, $includeQuestionType: Boolean! = false) {
  questions(
    where: $where
    limit: $limit
    offset: $offset
    order_by: {created_datetime: desc}
  ) {
    question_id
    question_text
    writer_user_id
    question_type @include(if: $includeQuestionType) {
      question_type_name
    }
  }
  questions_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class QuestionByFilterGQL extends Apollo.Query<QuestionByFilterQuery, QuestionByFilterQueryVariables> {
    document = QuestionByFilterDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const QuestionsListFactcheckerDocument = gql`
    query QuestionsListFactchecker($statusId: Int, $approved_user_id: uuid, $_is_null: Boolean = true, $count: Int = 1, $offset: Int) {
  questions(
    where: {question_status_id: {_eq: $statusId}, approved_user_id: {_eq: $approved_user_id, _is_null: $_is_null}}
    order_by: {last_edited_datetime: desc_nulls_last}
    limit: $count
    offset: $offset
  ) {
    category {
      archived
      category_id
      category_name
      parent_category_id
      sort_order_num
    }
    approved_datetime
    category_id
    created_datetime
    first_used_date
    host_note
    is_alcohol
    is_mature
    last_used_date
    market {
      language_id
      market_id
      market_name
    }
    market_id
    paid_invoice_id
    point_value
    question_data
    question_id
    question_image
    question_json
    question_status_id
    question_text
    question_type {
      question_type_id
      question_type_name
    }
    question_type_id
    source_primary
    source_secondary
    source_tertiary
    source_validation
    sub_category {
      archived
      category_id
      category_name
      parent_category_id
      sort_order_num
    }
    sub_category_id
    use_end_date
    use_start_date
    writer_user_id
    approved_user_id
    rejection_reason_id
    question_difficulty_id
    question_bonus_id
    last_edited_datetime
    question_difficulty {
      question_difficulty_id
      question_difficulty_name
    }
    question_tags {
      question_id
      tag
    }
    question_rating
    is_used
  }
  questions_aggregate(
    where: {question_status_id: {_eq: $statusId}, approved_user_id: {_eq: $approved_user_id, _is_null: $_is_null}}
  ) {
    aggregate {
      count
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class QuestionsListFactcheckerGQL extends Apollo.Query<QuestionsListFactcheckerQuery, QuestionsListFactcheckerQueryVariables> {
    document = QuestionsListFactcheckerDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const QuestionsListRejectedDocument = gql`
    query QuestionsListRejected($writer_user_id: uuid!) {
  questions(
    where: {writer_user_id: {_eq: $writer_user_id}, question_status_id: {_eq: 1}}
    order_by: {created_datetime: desc}
  ) {
    question_id
    question_text
    rejection_note
    rejection_reason {
      rejection_reason_name
      rejection_reason_id
    }
  }
  questions_aggregate(
    where: {writer_user_id: {_eq: $writer_user_id}, question_status_id: {_eq: 1}}
  ) {
    aggregate {
      count
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class QuestionsListRejectedGQL extends Apollo.Query<QuestionsListRejectedQuery, QuestionsListRejectedQueryVariables> {
    document = QuestionsListRejectedDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const QuestionsListDocument = gql`
    query QuestionsList($writer_user_id: uuid!, $limit: Int = 10, $offset: Int = 0) {
  questions(
    where: {writer_user_id: {_eq: $writer_user_id}, question_status_id: {_eq: 0}}
    limit: $limit
    offset: $offset
    order_by: {last_edited_datetime: desc}
  ) {
    question_id
    question_text
  }
  questions_aggregate(
    where: {writer_user_id: {_eq: $writer_user_id}, question_status_id: {_eq: 0}}
  ) {
    aggregate {
      count
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class QuestionsListGQL extends Apollo.Query<QuestionsListQuery, QuestionsListQueryVariables> {
    document = QuestionsListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RandomQuestionForRoundDocument = gql`
    query RandomQuestionForRound($category: uuid, $point_value: Int, $question_type: _text, $sub_category: uuid, $market: String, $question_bonus_id: Int, $is_mature: Boolean, $tags: _text, $question_text: String, $game_template_id: String, $question_type_id: Int, $for_used_status: String) {
  random_question: _get_random_question_for_round(
    args: {vcategory_id: $category, vpoint_value: $point_value, vquestion_type_short_name: $question_type, vsub_category_id: $sub_category, vmarket_id: $market, vquestion_bonus_id: $question_bonus_id, vis_mature: $is_mature, vtags: $tags, vgame_template_id: $game_template_id, vquestion_text: $question_text, vquestion_type_id: $question_type_id, vfor_used_status: $for_used_status}
  ) {
    point_value
    category {
      sort_order_num
      parent_category_id
      category_name
      category_id
    }
    sub_category {
      parent_category_id
      sort_order_num
      category_name
      category_id
    }
    question_type {
      question_type_short_name
      question_type_name
      question_type_id
    }
    question_id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RandomQuestionForRoundGQL extends Apollo.Query<RandomQuestionForRoundQuery, RandomQuestionForRoundQueryVariables> {
    document = RandomQuestionForRoundDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RejectReasonsDocument = gql`
    query RejectReasons {
  rejection_reasons {
    rejection_reason_id
    rejection_reason_name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RejectReasonsGQL extends Apollo.Query<RejectReasonsQuery, RejectReasonsQueryVariables> {
    document = RejectReasonsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RejectionReasonNameDocument = gql`
    query RejectionReasonName($reasonId: Int, $limit: Int = 1) {
  rejection_reasons(where: {rejection_reason_id: {_eq: $reasonId}}, limit: $limit) {
    rejection_reason_name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RejectionReasonNameGQL extends Apollo.Query<RejectionReasonNameQuery, RejectionReasonNameQueryVariables> {
    document = RejectionReasonNameDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ReportReasonsDocument = gql`
    query ReportReasons {
  report_reasons {
    report_reason_id
    report_reason_name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ReportReasonsGQL extends Apollo.Query<ReportReasonsQuery, ReportReasonsQueryVariables> {
    document = ReportReasonsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CompilerStatsDocument = gql`
    query CompilerStats($userId: uuid, $startDate: timestamptz, $endDate: timestamptz) {
  all_created_games: trivia_games_aggregate(
    where: {creator_id: {_eq: $userId}, created_at: {_gt: $startDate, _lt: $endDate}}
  ) {
    aggregate {
      count
    }
  }
  ready_for_scheduling: trivia_games_aggregate(
    where: {creator_id: {_eq: $userId}, created_at: {_gt: $startDate, _lt: $endDate}, game_status: {_eq: 1}}
  ) {
    aggregate {
      count
    }
  }
  created_standard_games: trivia_games_aggregate(
    where: {creator_id: {_eq: $userId}, created_at: {_gt: $startDate, _lt: $endDate}, game_template_id: {_eq: "default"}}
  ) {
    aggregate {
      count
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CompilerStatsGQL extends Apollo.Query<CompilerStatsQuery, CompilerStatsQueryVariables> {
    document = CompilerStatsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FactcheckerStatsCountDocument = gql`
    query FactcheckerStatsCount($userId: uuid, $startDate: timestamp, $endDate: timestamp, $questionTypeId: Int, $questionStatusId: Int) {
  count: questions_aggregate(
    where: {approved_user_id: {_eq: $userId}, last_edited_datetime: {_gt: $startDate, _lt: $endDate}, question_status_id: {_eq: $questionStatusId}, question_type_id: {_eq: $questionTypeId}, _and: {question_status_id: {_neq: 2}}}
  ) {
    aggregate {
      count
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class FactcheckerStatsCountGQL extends Apollo.Query<FactcheckerStatsCountQuery, FactcheckerStatsCountQueryVariables> {
    document = FactcheckerStatsCountDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FactcheckerStatsDocument = gql`
    query FactcheckerStats($userId: uuid, $startDate: timestamp, $endDate: timestamp, $questionTypeId: Int) {
  approved_questions: questions_aggregate(
    where: {approved_user_id: {_eq: $userId}, last_edited_datetime: {_gt: $startDate, _lt: $endDate}, question_status_id: {_eq: 3}, question_type_id: {_eq: $questionTypeId}}
  ) {
    aggregate {
      count
    }
  }
  rejected_questions: questions_aggregate(
    where: {approved_user_id: {_eq: $userId}, last_edited_datetime: {_gt: $startDate, _lt: $endDate}, question_status_id: {_eq: 1}, question_type_id: {_eq: $questionTypeId}}
  ) {
    aggregate {
      count
    }
  }
  needs_review: questions_aggregate(
    where: {question_status_id: {_eq: 2}, last_edited_datetime: {_gt: $startDate, _lt: $endDate}, question_type_id: {_eq: $questionTypeId}}
  ) {
    aggregate {
      count
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class FactcheckerStatsGQL extends Apollo.Query<FactcheckerStatsQuery, FactcheckerStatsQueryVariables> {
    document = FactcheckerStatsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FirstFactcheckedQuestionDocument = gql`
    query FirstFactcheckedQuestion($question_status_id: Int, $writerUserId: uuid = "") {
  questions(
    limit: 1
    order_by: {approved_datetime: asc}
    where: {question_status_id: {_eq: $question_status_id}, writer_user_id: {_eq: $writerUserId}}
  ) {
    approved_datetime
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class FirstFactcheckedQuestionGQL extends Apollo.Query<FirstFactcheckedQuestionQuery, FirstFactcheckedQuestionQueryVariables> {
    document = FirstFactcheckedQuestionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const WriterStatsDocument = gql`
    query WriterStats($userId: uuid, $startDate: timestamp, $endDate: timestamp, $questionTypeId: Int) {
  questions_submitted: questions_aggregate(
    where: {question_status: {question_status_id: {_in: [1, 2, 3]}}, writer_user_id: {_eq: $userId}, created_datetime: {_gt: $startDate, _lt: $endDate}, question_type_id: {_eq: $questionTypeId}}
  ) {
    aggregate {
      count
    }
  }
  questions_published: questions_aggregate(
    where: {question_status_id: {_eq: 3}, writer_user_id: {_eq: $userId}, approved_datetime: {_gt: $startDate, _lt: $endDate}, question_type_id: {_eq: $questionTypeId}}
  ) {
    aggregate {
      count
    }
  }
  questions_rejected: questions_aggregate(
    where: {question_status_id: {_eq: 1}, writer_user_id: {_eq: $userId}, last_edited_datetime: {_gt: $startDate, _lt: $endDate}, question_type_id: {_eq: $questionTypeId}}
  ) {
    aggregate {
      count
    }
  }
  questions_needs_review: questions_aggregate(
    where: {question_status_id: {_eq: 2}, writer_user_id: {_eq: $userId}, created_datetime: {_gt: $startDate, _lt: $endDate}, question_type_id: {_eq: $questionTypeId}}
  ) {
    aggregate {
      count
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class WriterStatsGQL extends Apollo.Query<WriterStatsQuery, WriterStatsQueryVariables> {
    document = WriterStatsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TagNamesDocument = gql`
    query TagNames($limit: Int = 10, $searchText: String = "%%", $currentList: [String!] = []) {
  question_tags_by_count(
    limit: $limit
    where: {tag: {_ilike: $searchText, _nin: $currentList}}
    order_by: {count: desc}
  ) {
    tag
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TagNamesGQL extends Apollo.Query<TagNamesQuery, TagNamesQueryVariables> {
    document = TagNamesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TriviaEventTypesDocument = gql`
    query TriviaEventTypes($event_name: Boolean! = false) {
  trivia_event_types {
    event_type_id
    event_type_name @include(if: $event_name)
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TriviaEventTypesGQL extends Apollo.Query<TriviaEventTypesQuery, TriviaEventTypesQueryVariables> {
    document = TriviaEventTypesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TriviaEventsDocument = gql`
    query TriviaEvents($start: date = null, $end: date = null, $trivia_user_id: uuid = "", $event_name: Boolean! = false, $is_demo: Boolean! = false) {
  trivia_events(
    where: {date: {_gte: $start, _lte: $end}, trivia_user_id: {_eq: $trivia_user_id}, trivia_game: {is_demo: {_eq: $is_demo}}}
  ) {
    game_id
    date
    event_id
    event_type_id
    trivia_event_type @include(if: $event_name) {
      event_type_name
      event_type_id
    }
    trivia_game {
      game_status
      game_date
      game_id
      updated_at
      title
      created_at
      game_template_id
      is_demo @include(if: $is_demo)
      trivia_game_themes {
        game_theme {
          name
          id
        }
      }
      trivia_game_template {
        template_id
        template_name
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TriviaEventsGQL extends Apollo.Query<TriviaEventsQuery, TriviaEventsQueryVariables> {
    document = TriviaEventsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetGameIdByEventIdDocument = gql`
    query GetGameIdByEventId($event_id: uuid) {
  trivia_events(where: {event_id: {_eq: $event_id}}) {
    game_id
    trivia_event_type {
      event_type_name
      event_type_id
    }
    game_format_id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetGameIdByEventIdGQL extends Apollo.Query<GetGameIdByEventIdQuery, GetGameIdByEventIdQueryVariables> {
    document = GetGameIdByEventIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EditLogEditDateTimeDocument = gql`
    query EditLogEditDateTime($questionId: uuid = "") {
  edit_log(where: {question_id: {_eq: $questionId}}) {
    edit_datetime
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EditLogEditDateTimeGQL extends Apollo.Query<EditLogEditDateTimeQuery, EditLogEditDateTimeQueryVariables> {
    document = EditLogEditDateTimeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FactcheckedQuestionsAggregateDocument = gql`
    query FactcheckedQuestionsAggregate($question_status_id: Int, $writerUserId: uuid = "") {
  questions_aggregate(
    where: {writer_user_id: {_eq: $writerUserId}, question_status_id: {_eq: $question_status_id}}
  ) {
    aggregate {
      count
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class FactcheckedQuestionsAggregateGQL extends Apollo.Query<FactcheckedQuestionsAggregateQuery, FactcheckedQuestionsAggregateQueryVariables> {
    document = FactcheckedQuestionsAggregateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetQuestionJsonDocument = gql`
    query getQuestionJson($questionId: uuid = "") {
  questions(where: {question_id: {_eq: $questionId}}) {
    question_json
    question_text
    question_type_id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetQuestionJsonGQL extends Apollo.Query<GetQuestionJsonQuery, GetQuestionJsonQueryVariables> {
    document = GetQuestionJsonDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetQuestionsByStartEndDatesDocument = gql`
    query GetQuestionsByStartEndDates($start: timestamp = "", $end: timestamp = "", $writerUserId: uuid = "", $questionTypeId: Int = null) {
  questions_aggregate(
    where: {created_datetime: {_gte: $start, _lte: $end}, writer_user_id: {_eq: $writerUserId}, question_type_id: {_eq: $questionTypeId}}
  ) {
    aggregate {
      count(distinct: true)
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetQuestionsByStartEndDatesGQL extends Apollo.Query<GetQuestionsByStartEndDatesQuery, GetQuestionsByStartEndDatesQueryVariables> {
    document = GetQuestionsByStartEndDatesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetQuestionJsonByTypeIdDocument = gql`
    query GetQuestionJsonByTypeId($questionTypeId: Int) {
  questions(where: {question_type_id: {_eq: $questionTypeId}}) {
    question_id
    question_json
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetQuestionJsonByTypeIdGQL extends Apollo.Query<GetQuestionJsonByTypeIdQuery, GetQuestionJsonByTypeIdQueryVariables> {
    document = GetQuestionJsonByTypeIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const QuestionReportReasonDocument = gql`
    query QuestionReportReason($questionId: uuid = "", $createdAt: timestamptz = "", $limit: Int = 1) {
  reports(
    where: {question_id: {_eq: $questionId}, created_at: {_lte: $createdAt}}
    limit: $limit
  ) {
    report_reason {
      report_reason_id
      report_reason_name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class QuestionReportReasonGQL extends Apollo.Query<QuestionReportReasonQuery, QuestionReportReasonQueryVariables> {
    document = QuestionReportReasonDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const QuestionCounInQueueDocument = gql`
    query QuestionCounInQueue($questionStatusId: Int) {
  questions_aggregate(where: {question_status_id: {_eq: $questionStatusId}}) {
    aggregate {
      count
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class QuestionCounInQueueGQL extends Apollo.Query<QuestionCounInQueueQuery, QuestionCounInQueueQueryVariables> {
    document = QuestionCounInQueueDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetRoundCategoryDocument = gql`
    query GetRoundCategory {
  trivia_game_category {
    id
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetRoundCategoryGQL extends Apollo.Query<GetRoundCategoryQuery, GetRoundCategoryQueryVariables> {
    document = GetRoundCategoryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetGameKeywordsDocument = gql`
    query GetGameKeywords($roundId: uuid) {
  trivia_rounds(where: {round_id: {_eq: $roundId}}) {
    round_keywords
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetGameKeywordsGQL extends Apollo.Query<GetGameKeywordsQuery, GetGameKeywordsQueryVariables> {
    document = GetGameKeywordsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetUserDataDocument = gql`
    query GetUserData($triviaUserId: uuid = "") {
  trivia_users(where: {trivia_user_id: {_eq: $triviaUserId}}) {
    specialties
    lastname
    info_json
    image
    firstname
    email
    topics
    created_at
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetUserDataGQL extends Apollo.Query<GetUserDataQuery, GetUserDataQueryVariables> {
    document = GetUserDataDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RoundQuestionByQuestionIdDocument = gql`
    query RoundQuestionByQuestionId($questionId: uuid, $includeJson: Boolean!) {
  trivia_round_questions(where: {question_id: {_eq: $questionId}}) {
    id
    round_id
    question_order
    answer_type_id
    wager
    wager_range_value
    answer_type {
      answer_type_name
    }
    question {
      question_type_id
      question_bonus_id
      question_id
      question_type {
        question_type_id
        question_type_name
        question_type_short_name
      }
      point_value
      category {
        category_id
        category_name
      }
      sub_category {
        category_name
        category_id
      }
      question_text
      answer: question_json(path: "answer")
      question_json: question_json @include(if: $includeJson)
    }
    trivia_round {
      name
      round_type
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RoundQuestionByQuestionIdGQL extends Apollo.Query<RoundQuestionByQuestionIdQuery, RoundQuestionByQuestionIdQueryVariables> {
    document = RoundQuestionByQuestionIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RoundQuestionByRoundIdDocument = gql`
    query RoundQuestionByRoundId($roundId: uuid, $json: String, $questionOrder: Int) {
  trivia_round_questions(
    where: {round_id: {_eq: $roundId}, question_order: {_eq: $questionOrder}}
  ) {
    question {
      question_json(path: $json)
      answer: question_json(path: "answer")
      question_image
      question_text
      category {
        category_id
        category_name
        parent_category_id
      }
      sub_category {
        category_id
        category_name
        parent_category_id
      }
      question_type {
        question_type_short_name
        question_type_id
        question_type_name
      }
      question_id
      question_type_id
      category {
        category_id
      }
    }
    trivia_round {
      round_type
    }
    answer_type {
      answer_type_name
      answer_type_id
    }
    id
    answer_type_id
    question_order
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RoundQuestionByRoundIdGQL extends Apollo.Query<RoundQuestionByRoundIdQuery, RoundQuestionByRoundIdQueryVariables> {
    document = RoundQuestionByRoundIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetUserByIdDocument = gql`
    query getUserById($user_id: uuid) {
  trivia_users(where: {trivia_user_id: {_eq: $user_id}}) {
    image
    firstname
    lastname
    user_type {
      user_type_name
    }
    email
    specialties
    topics
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetUserByIdGQL extends Apollo.Query<GetUserByIdQuery, GetUserByIdQueryVariables> {
    document = GetUserByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetUsersDocument = gql`
    query getUsers($user_type_id: Int, $firstName: String = null, $lastName: String = null, $statusId: Int) {
  trivia_users(
    where: {user_type_id: {_eq: $user_type_id}, firstname: {_ilike: $firstName}, lastname: {_ilike: $lastName}, status_id: {_eq: $statusId}}
  ) {
    email
    firstname
    lastname
    trivia_user_id
    user_type_id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetUsersGQL extends Apollo.Query<GetUsersQuery, GetUsersQueryVariables> {
    document = GetUsersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetWriterByIdDocument = gql`
    query getWriterById($user_id: uuid) {
  trivia_users(where: {trivia_user_id: {_eq: $user_id}}) {
    email
    firstname
    lastname
    trivia_user_id
    image
    needs_review: written_questions_aggregate(
      where: {question_status: {question_status_id: {_eq: 2}}}
    ) {
      aggregate {
        count
      }
    }
    rejected: written_questions_aggregate(
      where: {question_status: {question_status_id: {_eq: 1}}}
    ) {
      aggregate {
        count
      }
    }
    factchecing_que: written_questions_aggregate(
      where: {question_status: {question_status_id: {_in: [1, 2, 3]}}}
    ) {
      aggregate {
        count
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetWriterByIdGQL extends Apollo.Query<GetWriterByIdQuery, GetWriterByIdQueryVariables> {
    document = GetWriterByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetWritersListDocument = gql`
    query getWritersList($user_type_id: Int, $count: Int = 1, $offset: Int) {
  trivia_users(
    where: {user_type_id: {_eq: $user_type_id}, _and: {status_id: {_eq: 0}}}
    limit: $count
    offset: $offset
    order_by: {created_at: desc}
  ) {
    firstname
    lastname
    trivia_user_id
    email
    published: written_questions_aggregate(
      where: {question_status: {question_status_id: {_eq: 3}}}
    ) {
      aggregate {
        count
      }
    }
    submitted: written_questions_aggregate(
      where: {question_status: {question_status_id: {_eq: 2}}}
    ) {
      aggregate {
        count
      }
    }
    rejected: written_questions_aggregate(
      where: {question_status: {question_status_id: {_eq: 1}}}
    ) {
      aggregate {
        count
      }
    }
  }
  trivia_users_aggregate(
    where: {user_type_id: {_eq: $user_type_id}, _and: {status_id: {_eq: 0}}}
  ) {
    aggregate {
      count
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetWritersListGQL extends Apollo.Query<GetWritersListQuery, GetWritersListQueryVariables> {
    document = GetWritersListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }